/* */ 
"format global";
(function (global) {
  var babelHelpers = global.babelHelpers = {};

  babelHelpers.inherits = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };

  babelHelpers.defaults = function (obj, defaults) {
    var keys = Object.getOwnPropertyNames(defaults);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var value = Object.getOwnPropertyDescriptor(defaults, key);

      if (value && value.configurable && obj[key] === undefined) {
        Object.defineProperty(obj, key, value);
      }
    }

    return obj;
  };

  babelHelpers.createClass = (function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();

  babelHelpers.createDecoratedClass = (function () {
    function defineProperties(target, descriptors, initializers) {
      for (var i = 0; i < descriptors.length; i++) {
        var descriptor = descriptors[i];
        var decorators = descriptor.decorators;
        var key = descriptor.key;
        delete descriptor.key;
        delete descriptor.decorators;
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor || descriptor.initializer) descriptor.writable = true;

        if (decorators) {
          for (var f = 0; f < decorators.length; f++) {
            var decorator = decorators[f];

            if (typeof decorator === "function") {
              descriptor = decorator(target, key, descriptor) || descriptor;
            } else {
              throw new TypeError("The decorator for method " + descriptor.key + " is of the invalid type " + typeof decorator);
            }
          }

          if (descriptor.initializer !== undefined) {
            initializers[key] = descriptor;
            continue;
          }
        }

        Object.defineProperty(target, key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps, protoInitializers, staticInitializers) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps, protoInitializers);
      if (staticProps) defineProperties(Constructor, staticProps, staticInitializers);
      return Constructor;
    };
  })();

  babelHelpers.createDecoratedObject = function (descriptors) {
    var target = {};

    for (var i = 0; i < descriptors.length; i++) {
      var descriptor = descriptors[i];
      var decorators = descriptor.decorators;
      var key = descriptor.key;
      delete descriptor.key;
      delete descriptor.decorators;
      descriptor.enumerable = true;
      descriptor.configurable = true;
      if ("value" in descriptor || descriptor.initializer) descriptor.writable = true;

      if (decorators) {
        for (var f = 0; f < decorators.length; f++) {
          var decorator = decorators[f];

          if (typeof decorator === "function") {
            descriptor = decorator(target, key, descriptor) || descriptor;
          } else {
            throw new TypeError("The decorator for method " + descriptor.key + " is of the invalid type " + typeof decorator);
          }
        }
      }

      if (descriptor.initializer) {
        descriptor.value = descriptor.initializer.call(target);
      }

      Object.defineProperty(target, key, descriptor);
    }

    return target;
  };

  babelHelpers.defineDecoratedPropertyDescriptor = function (target, key, descriptors) {
    var _descriptor = descriptors[key];
    if (!_descriptor) return;
    var descriptor = {};

    for (var _key in _descriptor) descriptor[_key] = _descriptor[_key];

    descriptor.value = descriptor.initializer ? descriptor.initializer.call(target) : undefined;
    Object.defineProperty(target, key, descriptor);
  };

  babelHelpers.taggedTemplateLiteral = function (strings, raw) {
    return Object.freeze(Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw)
      }
    }));
  };

  babelHelpers.taggedTemplateLiteralLoose = function (strings, raw) {
    strings.raw = raw;
    return strings;
  };

  babelHelpers.toArray = function (arr) {
    return Array.isArray(arr) ? arr : Array.from(arr);
  };

  babelHelpers.toConsumableArray = function (arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    } else {
      return Array.from(arr);
    }
  };

  babelHelpers.slicedToArray = (function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  })();

  babelHelpers.slicedToArrayLoose = function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      var _arr = [];

      for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
        _arr.push(_step.value);

        if (i && _arr.length === i) break;
      }

      return _arr;
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };

  babelHelpers.objectWithoutProperties = function (obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  };

  babelHelpers.hasOwn = Object.prototype.hasOwnProperty;
  babelHelpers.slice = Array.prototype.slice;
  babelHelpers.bind = Function.prototype.bind;

  babelHelpers.defineProperty = function (obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  };

  babelHelpers.asyncToGenerator = function (fn) {
    return function () {
      var gen = fn.apply(this, arguments);
      return new Promise(function (resolve, reject) {
        var callNext = step.bind(null, "next");
        var callThrow = step.bind(null, "throw");

        function step(key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }

          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(callNext, callThrow);
          }
        }

        callNext();
      });
    };
  };

  babelHelpers.interopExportWildcard = function (obj, defaults) {
    var newObj = defaults({}, obj);
    delete newObj["default"];
    return newObj;
  };

  babelHelpers.interopRequireWildcard = function (obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj["default"] = obj;
      return newObj;
    }
  };

  babelHelpers.interopRequireDefault = function (obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  };

  babelHelpers._typeof = function (obj) {
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
  };

  babelHelpers._extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  babelHelpers.get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;

      if (getter === undefined) {
        return undefined;
      }

      return getter.call(receiver);
    }
  };

  babelHelpers.set = function set(object, property, value, receiver) {
    var desc = Object.getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent !== null) {
        set(parent, property, value, receiver);
      }
    } else if ("value" in desc && desc.writable) {
      desc.value = value;
    } else {
      var setter = desc.set;

      if (setter !== undefined) {
        setter.call(receiver, value);
      }
    }

    return value;
  };

  babelHelpers.newArrowCheck = function (innerThis, boundThis) {
    if (innerThis !== boundThis) {
      throw new TypeError("Cannot instantiate an arrow function");
    }
  };

  babelHelpers.classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  babelHelpers.objectDestructuringEmpty = function (obj) {
    if (obj == null) throw new TypeError("Cannot destructure undefined");
  };

  babelHelpers.temporalUndefined = {};

  babelHelpers.temporalAssertDefined = function (val, name, undef) {
    if (val === undef) {
      throw new ReferenceError(name + " is not defined - temporal dead zone");
    }

    return true;
  };

  babelHelpers.selfGlobal = typeof global === "undefined" ? self : global;
  babelHelpers.typeofReactElement = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 60103;

  babelHelpers.defaultProps = function (defaultProps, props) {
    if (defaultProps) {
      for (var propName in defaultProps) {
        if (typeof props[propName] === "undefined") {
          props[propName] = defaultProps[propName];
        }
      }
    }

    return props;
  };

  babelHelpers._instanceof = function (left, right) {
    if (right != null && right[Symbol.hasInstance]) {
      return right[Symbol.hasInstance](left);
    } else {
      return left instanceof right;
    }
  };

  babelHelpers.interopRequire = function (obj) {
    return obj && obj.__esModule ? obj["default"] : obj;
  };
})(typeof global === "undefined" ? self : global);

!function(e){function r(e,r,o){return 4===arguments.length?t.apply(this,arguments):void n(e,{declarative:!0,deps:r,declare:o})}function t(e,r,t,o){n(e,{declarative:!1,deps:r,executingRequire:t,execute:o})}function n(e,r){r.name=e,e in v||(v[e]=r),r.normalizedDeps=r.deps}function o(e,r){if(r[e.groupIndex]=r[e.groupIndex]||[],-1==g.call(r[e.groupIndex],e)){r[e.groupIndex].push(e);for(var t=0,n=e.normalizedDeps.length;n>t;t++){var a=e.normalizedDeps[t],u=v[a];if(u&&!u.evaluated){var d=e.groupIndex+(u.declarative!=e.declarative);if(void 0===u.groupIndex||u.groupIndex<d){if(void 0!==u.groupIndex&&(r[u.groupIndex].splice(g.call(r[u.groupIndex],u),1),0==r[u.groupIndex].length))throw new TypeError("Mixed dependency cycle detected");u.groupIndex=d}o(u,r)}}}}function a(e){var r=v[e];r.groupIndex=0;var t=[];o(r,t);for(var n=!!r.declarative==t.length%2,a=t.length-1;a>=0;a--){for(var u=t[a],i=0;i<u.length;i++){var s=u[i];n?d(s):l(s)}n=!n}}function u(e){return y[e]||(y[e]={name:e,dependencies:[],exports:{},importers:[]})}function d(r){if(!r.module){var t=r.module=u(r.name),n=r.module.exports,o=r.declare.call(e,function(e,r){if(t.locked=!0,"object"==typeof e)for(var o in e)n[o]=e[o];else n[e]=r;for(var a=0,u=t.importers.length;u>a;a++){var d=t.importers[a];if(!d.locked)for(var i=0;i<d.dependencies.length;++i)d.dependencies[i]===t&&d.setters[i](n)}return t.locked=!1,r},r.name);t.setters=o.setters,t.execute=o.execute;for(var a=0,i=r.normalizedDeps.length;i>a;a++){var l,s=r.normalizedDeps[a],c=v[s],f=y[s];f?l=f.exports:c&&!c.declarative?l=c.esModule:c?(d(c),f=c.module,l=f.exports):l=p(s),f&&f.importers?(f.importers.push(t),t.dependencies.push(f)):t.dependencies.push(null),t.setters[a]&&t.setters[a](l)}}}function i(e){var r,t=v[e];if(t)t.declarative?f(e,[]):t.evaluated||l(t),r=t.module.exports;else if(r=p(e),!r)throw new Error("Unable to load dependency "+e+".");return(!t||t.declarative)&&r&&r.__useDefault?r["default"]:r}function l(r){if(!r.module){var t={},n=r.module={exports:t,id:r.name};if(!r.executingRequire)for(var o=0,a=r.normalizedDeps.length;a>o;o++){var u=r.normalizedDeps[o],d=v[u];d&&l(d)}r.evaluated=!0;var c=r.execute.call(e,function(e){for(var t=0,n=r.deps.length;n>t;t++)if(r.deps[t]==e)return i(r.normalizedDeps[t]);throw new TypeError("Module "+e+" not declared as a dependency.")},t,n);c&&(n.exports=c),t=n.exports,t&&t.__esModule?r.esModule=t:r.esModule=s(t)}}function s(r){var t={};if(("object"==typeof r||"function"==typeof r)&&r!==e)if(m)for(var n in r)"default"!==n&&c(t,r,n);else{var o=r&&r.hasOwnProperty;for(var n in r)"default"===n||o&&!r.hasOwnProperty(n)||(t[n]=r[n])}return t["default"]=r,x(t,"__useDefault",{value:!0}),t}function c(e,r,t){try{var n;(n=Object.getOwnPropertyDescriptor(r,t))&&x(e,t,n)}catch(o){return e[t]=r[t],!1}}function f(r,t){var n=v[r];if(n&&!n.evaluated&&n.declarative){t.push(r);for(var o=0,a=n.normalizedDeps.length;a>o;o++){var u=n.normalizedDeps[o];-1==g.call(t,u)&&(v[u]?f(u,t):p(u))}n.evaluated||(n.evaluated=!0,n.module.execute.call(e))}}function p(e){if(I[e])return I[e];if("@node/"==e.substr(0,6))return D(e.substr(6));var r=v[e];if(!r)throw"Module "+e+" not present.";return a(e),f(e,[]),v[e]=void 0,r.declarative&&x(r.module.exports,"__esModule",{value:!0}),I[e]=r.declarative?r.module.exports:r.esModule}var v={},g=Array.prototype.indexOf||function(e){for(var r=0,t=this.length;t>r;r++)if(this[r]===e)return r;return-1},m=!0;try{Object.getOwnPropertyDescriptor({a:0},"a")}catch(h){m=!1}var x;!function(){try{Object.defineProperty({},"a",{})&&(x=Object.defineProperty)}catch(e){x=function(e,r,t){try{e[r]=t.value||t.get.call(e)}catch(n){}}}}();var y={},D="undefined"!=typeof System&&System._nodeRequire||"undefined"!=typeof require&&require.resolve&&"undefined"!=typeof process&&require,I={"@empty":{}};return function(e,n,o,a){return function(u){u(function(u){for(var d={_nodeRequire:D,register:r,registerDynamic:t,get:p,set:function(e,r){I[e]=r},newModule:function(e){return e}},i=0;i<n.length;i++)(function(e,r){r&&r.__esModule?I[e]=r:I[e]=s(r)})(n[i],arguments[i]);a(d);var l=p(e[0]);if(e.length>1)for(var i=1;i<e.length;i++)p(e[i]);return o?l["default"]:l})}}}("undefined"!=typeof self?self:global)

(["1"], [], false, function($__System) {
var require = this.require, exports = this.exports, module = this.module;
!function(e){function r(e,r){for(var n=e.split(".");n.length;)r=r[n.shift()];return r}function n(n){if("string"==typeof n)return r(n,e);if(!(n instanceof Array))throw new Error("Global exports must be a string or array.");for(var t={},o=!0,f=0;f<n.length;f++){var i=r(n[f],e);o&&(t["default"]=i,o=!1),t[n[f].split(".").pop()]=i}return t}function t(r){if(Object.keys)Object.keys(e).forEach(r);else for(var n in e)a.call(e,n)&&r(n)}function o(r){t(function(n){if(-1==l.call(s,n)){try{var t=e[n]}catch(o){s.push(n)}r(n,t)}})}var f,i=$__System,a=Object.prototype.hasOwnProperty,l=Array.prototype.indexOf||function(e){for(var r=0,n=this.length;n>r;r++)if(this[r]===e)return r;return-1},s=["_g","sessionStorage","localStorage","clipboardData","frames","frameElement","external","mozAnimationStartTime","webkitStorageInfo","webkitIndexedDB","mozInnerScreenY","mozInnerScreenX"];i.set("@@global-helpers",i.newModule({prepareGlobal:function(r,t,i){var a=e.define;e.define=void 0;var l;if(i){l={};for(var s in i)l[s]=e[s],e[s]=i[s]}return t||(f={},o(function(e,r){f[e]=r})),function(){var r;if(t)r=n(t);else{r={};var i,s;o(function(e,n){f[e]!==n&&"undefined"!=typeof n&&(r[e]=n,"undefined"!=typeof i?s||i===n||(s=!0):i=n)}),r=s?r:i}if(l)for(var u in l)e[u]=l[u];return e.define=a,r}}}))}("undefined"!=typeof self?self:global);
$__System.register('2', ['3', '4', '5', '6', '7', '8'], function (_export) {
  var d3, bootstrap, GlyphChart, ClassedGlyphChart, MeanderingGlyphChart, AttributionTargetChart, FootTrafficChart, Glyph, HexagonGlyph, ClassedGlyph, ClassedFocusedGlyph, initializeChart, _Array$from, customersGlyphCharts, scaleGlyphCharts, targetGlyphCharts, attributionGlyphCharts, footTrafficGlyphCharts, heroes, pinpointClassWeights, attributionClassWeights, heroClassWeights, footTrafficClassWeights, footTrafficFocusPoints;

  return {
    setters: [function (_2) {
      d3 = _2['default'];
    }, function (_3) {
      bootstrap = _3.bootstrap;
    }, function (_4) {
      GlyphChart = _4.GlyphChart;
      ClassedGlyphChart = _4.ClassedGlyphChart;
      MeanderingGlyphChart = _4.MeanderingGlyphChart;
      AttributionTargetChart = _4.AttributionTargetChart;
      FootTrafficChart = _4.FootTrafficChart;
    }, function (_5) {
      Glyph = _5.Glyph;
      HexagonGlyph = _5.HexagonGlyph;
      ClassedGlyph = _5.ClassedGlyph;
      ClassedFocusedGlyph = _5.ClassedFocusedGlyph;
    }, function (_6) {
      initializeChart = _6.initializeChart;
    }, function (_) {
      _Array$from = _['default'];
    }],
    execute: function () {
      'use strict';

      customersGlyphCharts = _Array$from(document.getElementsByClassName('glyph-chart--customers'));
      scaleGlyphCharts = _Array$from(document.getElementsByClassName('glyph-chart--scale'));
      targetGlyphCharts = _Array$from(document.getElementsByClassName('glyph-chart--target'));
      attributionGlyphCharts = _Array$from(document.getElementsByClassName('glyph-chart--attribution'));
      footTrafficGlyphCharts = _Array$from(document.getElementsByClassName('glyph-chart--foot-traffic'));
      heroes = _Array$from(document.getElementsByClassName('glyph-chart--hero'));
      pinpointClassWeights = [{ 'class': 'glyph', weight: 0.55 }, { 'class': 'glyph glyph--accent', weight: 0.45 }];
      attributionClassWeights = [{ 'class': 'glyph', weight: 0.45 }, { 'class': 'glyph glyph--accent', weight: 1.0 }];
      heroClassWeights = [{ 'class': 'glyph', weight: 0.2 }, { 'class': 'glyph glyph--red', weight: 0.4 }, { 'class': 'glyph glyph--blue', weight: 0.6 }, { 'class': 'glyph glyph--yellow', weight: 0.8 }, { 'class': 'glyph glyph--accent', weight: 1.0 }];
      footTrafficClassWeights = [{ 'class': 'glyph', weight: 0.2 }, { 'class': 'glyph glyph--red', weight: 0.4 }, { 'class': 'glyph glyph--blue', weight: 0.6 }, { 'class': 'glyph glyph--yellow', weight: 0.8 }, { 'class': 'glyph glyph--accent', weight: 1.0 }];
      footTrafficFocusPoints = [{ x: 25, y: 123 }, { x: 25, y: 123 }, { x: 50, y: 123 }, { x: 75, y: 123 }, { x: 75, y: 123 }];

      bootstrap(customersGlyphCharts, initializeChart, GlyphChart, d3, HexagonGlyph, 0.28, 4, -25);
      bootstrap(scaleGlyphCharts, initializeChart, GlyphChart, d3, Glyph, 0.28, 20, -5, 750);
      bootstrap(targetGlyphCharts, initializeChart, ClassedGlyphChart, d3, ClassedGlyph, pinpointClassWeights, 0.28, 20, -5, 750);
      bootstrap(attributionGlyphCharts, initializeChart, AttributionTargetChart, d3, ClassedGlyph, attributionClassWeights, 0.20, 40, -4, 750);
      bootstrap(footTrafficGlyphCharts, initializeChart, FootTrafficChart, d3, ClassedFocusedGlyph, footTrafficClassWeights, 0.15, 25, 0, 250, 0.0000001, footTrafficFocusPoints);
      bootstrap(heroes, initializeChart, MeanderingGlyphChart, d3, ClassedGlyph, heroClassWeights, 0.075, 25, 0, -40, 75);
    }
  };
});
$__System.register('9', [], function (_export) {
  'use strict';

  var phoneNumberconstraint, phoneNumberErrorMessage;

  _export('validatePhoneNumber', validatePhoneNumber);

  function validatePhoneNumber() {
    if (phoneNumberconstraint.test(this.value)) {
      return this.setCustomValidity('');
    }

    return this.setCustomValidity(phoneNumberErrorMessage);
  }

  return {
    setters: [],
    execute: function () {
      phoneNumberconstraint = new RegExp(/^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/);
      phoneNumberErrorMessage = 'Please use a valid phone number in the form of (555) 555 - 5555.';

      _export('phoneNumberErrorMessage', phoneNumberErrorMessage);
    }
  };
});
$__System.register('a', ['9'], function (_export) {
  'use strict';
  var validatePhoneNumber;

  _export('toggleDirtyClass', toggleDirtyClass);

  _export('setupDirtyInput', setupDirtyInput);

  _export('setupPhoneInputValidation', setupPhoneInputValidation);

  function toggleDirtyClass(element) {
    return element.srcElement.classList.toggle('dirty', true);
  }

  function setupDirtyInput(input) {
    input.addEventListener('blur', toggleDirtyClass);
    input.addEventListener('invalid', toggleDirtyClass);
    input.addEventListener('valid', toggleDirtyClass);
  }

  function setupPhoneInputValidation(phoneInput) {
    return phoneInput.addEventListener('input', validatePhoneNumber);
  }

  return {
    setters: [function (_) {
      validatePhoneNumber = _.validatePhoneNumber;
    }],
    execute: function () {}
  };
});
$__System.register('b', ['c', 'd'], function (_export) {
  'use strict';
  var postForm, trackEvent;

  _export('submitContactForm', submitContactForm);

  function submitContactForm(e) {
    e.preventDefault();

    if (this.checkValidity()) {
      var request = new XMLHttpRequest();

      trackEvent('Contact Form', 'submit');
      postForm(this, this.action, request)['catch'](function (err) {
        return console.error(err);
      }).then(function () {
        loadSuccessPage();
      });
    }

    return false;
  }

  function loadSuccessPage() {
    var formPage = document.querySelector('.contact-form-page');
    var formContainer = document.querySelector('.contact-form__form');
    var successContainer = document.querySelector('.contact-form__success');
    var transitionTiming = 800;

    formContainer.classList.add('contact-form--hide');
    successContainer.style.display = 'block';

    window.setTimeout(function () {
      formPage.style.height = successContainer.getBoundingClientRect().height + 'px';
      successContainer.classList.remove('contact-form--hide');
    }, transitionTiming);

    window.setTimeout(function () {
      formContainer.style.display = 'none';
    }, transitionTiming * 2);
  }
  return {
    setters: [function (_c) {
      postForm = _c.postForm;
    }, function (_d) {
      trackEvent = _d.trackEvent;
    }],
    execute: function () {}
  };
});
$__System.registerDynamic("e", ["f"], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  var _Object$defineProperty = $__require('f')["default"];
  exports["default"] = function(obj, key, value) {
    if (key in obj) {
      _Object$defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  };
  exports.__esModule = true;
  return module.exports;
});

$__System.registerDynamic("10", ["11", "12", "13", "14"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var $ = $__require('11'),
      toObject = $__require('12'),
      IObject = $__require('13');
  module.exports = $__require('14')(function() {
    var a = Object.assign,
        A = {},
        B = {},
        S = Symbol(),
        K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
      B[k] = k;
    });
    return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
  }) ? function assign(target, source) {
    var T = toObject(target),
        $$ = arguments,
        $$len = $$.length,
        index = 1,
        getKeys = $.getKeys,
        getSymbols = $.getSymbols,
        isEnum = $.isEnum;
    while ($$len > index) {
      var S = IObject($$[index++]),
          keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S),
          length = keys.length,
          j = 0,
          key;
      while (length > j)
        if (isEnum.call(S, key = keys[j++]))
          T[key] = S[key];
    }
    return T;
  } : Object.assign;
  return module.exports;
});

$__System.registerDynamic("15", ["16", "10"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var $export = $__require('16');
  $export($export.S + $export.F, 'Object', {assign: $__require('10')});
  return module.exports;
});

$__System.registerDynamic("17", ["15", "18"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  $__require('15');
  module.exports = $__require('18').Object.assign;
  return module.exports;
});

$__System.registerDynamic("19", ["17"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = {
    "default": $__require('17'),
    __esModule: true
  };
  return module.exports;
});

$__System.registerDynamic("1a", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  "format cjs";
  ;
  (function(factory) {
    if (typeof define === 'function' && define.amd) {
      define(factory);
    } else if (typeof exports === 'object') {
      module.exports = factory();
    } else {
      var OldCookies = window.Cookies;
      var api = window.Cookies = factory();
      api.noConflict = function() {
        window.Cookies = OldCookies;
        return api;
      };
    }
  }(function() {
    function extend() {
      var i = 0;
      var result = {};
      for (; i < arguments.length; i++) {
        var attributes = arguments[i];
        for (var key in attributes) {
          result[key] = attributes[key];
        }
      }
      return result;
    }
    function init(converter) {
      function api(key, value, attributes) {
        var result;
        if (typeof document === 'undefined') {
          return;
        }
        if (arguments.length > 1) {
          attributes = extend({path: '/'}, api.defaults, attributes);
          if (typeof attributes.expires === 'number') {
            var expires = new Date();
            expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
            attributes.expires = expires;
          }
          try {
            result = JSON.stringify(value);
            if (/^[\{\[]/.test(result)) {
              value = result;
            }
          } catch (e) {}
          if (!converter.write) {
            value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
          } else {
            value = converter.write(value, key);
          }
          key = encodeURIComponent(String(key));
          key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
          key = key.replace(/[\(\)]/g, escape);
          return (document.cookie = [key, '=', value, attributes.expires && '; expires=' + attributes.expires.toUTCString(), attributes.path && '; path=' + attributes.path, attributes.domain && '; domain=' + attributes.domain, attributes.secure ? '; secure' : ''].join(''));
        }
        if (!key) {
          result = {};
        }
        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var rdecode = /(%[0-9A-Z]{2})+/g;
        var i = 0;
        for (; i < cookies.length; i++) {
          var parts = cookies[i].split('=');
          var name = parts[0].replace(rdecode, decodeURIComponent);
          var cookie = parts.slice(1).join('=');
          if (cookie.charAt(0) === '"') {
            cookie = cookie.slice(1, -1);
          }
          try {
            cookie = converter.read ? converter.read(cookie, name) : converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);
            if (this.json) {
              try {
                cookie = JSON.parse(cookie);
              } catch (e) {}
            }
            if (key === name) {
              result = cookie;
              break;
            }
            if (!key) {
              result[name] = cookie;
            }
          } catch (e) {}
        }
        return result;
      }
      api.set = api;
      api.get = function(key) {
        return api(key);
      };
      api.getJSON = function() {
        return api.apply({json: true}, [].slice.call(arguments));
      };
      api.defaults = {};
      api.remove = function(key, attributes) {
        api(key, '', extend(attributes, {expires: -1}));
      };
      api.withConverter = init;
      return api;
    }
    return init(function() {});
  }));
  return module.exports;
});

$__System.registerDynamic("1b", ["1a"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = $__require('1a');
  return module.exports;
});

$__System.register('1c', ['1d', '1e', '1f'], function (_export) {
  var _get, _inherits, _classCallCheck, SubmitError;

  return {
    setters: [function (_d) {
      _get = _d['default'];
    }, function (_e) {
      _inherits = _e['default'];
    }, function (_f) {
      _classCallCheck = _f['default'];
    }],
    execute: function () {
      'use strict';

      SubmitError = (function (_Error) {
        _inherits(SubmitError, _Error);

        function SubmitError() {
          var message = arguments.length <= 0 || arguments[0] === undefined ? 'An error occurred while submitting a form' : arguments[0];

          _classCallCheck(this, SubmitError);

          _get(Object.getPrototypeOf(SubmitError.prototype), 'constructor', this).call(this, message);
          this.name = 'SumbitError';
        }

        return SubmitError;
      })(Error);

      _export('SubmitError', SubmitError);
    }
  };
});
$__System.register('c', ['19', '20', 'e', '1b', '1c'], function (_export) {
  var _Object$assign2, _Promise, _defineProperty, Cookies, SubmitError;

  function postForm(form, url, request) {
    return new _Promise(function (res, rej) {
      var csrftoken = Cookies.get('csrftoken');
      var data = getDataFromForm(form);
      var urlEncodedData = urlEcodeData(data);

      request.addEventListener('load', function (data) {
        return res(data);
      });
      request.addEventListener('error', function (err) {
        return rej(err);
      });

      request.open('POST', url, true);
      request.withCredentials = true;
      request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      request.setRequestHeader('X-CSRFToken', csrftoken);
      request.send(urlEncodedData);
    });
  }

  function getDataFromForm(form) {
    if (!form) {
      throw new SubmitError('Form element was not found! Form: ' + form);
    }
    var inputs = form.getElementsByTagName('input');
    var data = Array.prototype.reduce.call(inputs, function (acc, i) {
      return _Object$assign2(acc, _defineProperty({}, i.name, i.value));
    }, {});

    return data;
  }

  function urlEcodeData(data) {
    if (!data) {
      throw new SubmitError('No data was passed in to encode! Data: ' + data);
    }
    var urlEncodedDataPairs = [];

    for (var _name in data) {
      if (data.hasOwnProperty(_name)) {
        urlEncodedDataPairs.push(encodeURIComponent(_name) + '=' + encodeURIComponent(data[_name]));
      }
    }

    var urlEncodedData = urlEncodedDataPairs.join('&').replace(/%20/g, '+');
    return urlEncodedData;
  }

  return {
    setters: [function (_2) {
      _Object$assign2 = _2['default'];
    }, function (_) {
      _Promise = _['default'];
    }, function (_e) {
      _defineProperty = _e['default'];
    }, function (_b) {
      Cookies = _b;
    }, function (_c) {
      SubmitError = _c.SubmitError;
    }],
    execute: function () {
      'use strict';

      _export('postForm', postForm);

      _export('getDataFromForm', getDataFromForm);

      _export('urlEcodeData', urlEcodeData);
    }
  };
});
$__System.register('21', ['4', 'c'], function (_export) {
  'use strict';
  var bootstrap, postForm;

  _export('submitMailingListForm', submitMailingListForm);

  function submitMailingListForm(e) {
    e.preventDefault();

    if (this.checkValidity()) {
      var request = new XMLHttpRequest();

      return postForm(this, this.action, request)['catch'](function () {
        return showNotification(false);
      }).then(function () {
        return showNotification();
      });
    }
  }

  function showNotification() {
    var success = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

    var notification = document.querySelector('.footer .notification');
    var inputField = document.querySelector('.form--subscribe input[name="email"]');

    notification.classList.add(success ? 'success' : 'error');
    bootstrap(inputField, function (inputField) {
      return inputField.value = '';
    });
  }
  return {
    setters: [function (_) {
      bootstrap = _.bootstrap;
    }, function (_c) {
      postForm = _c.postForm;
    }],
    execute: function () {}
  };
});
$__System.register('22', ['4', '8', '21', 'a', 'b'], function (_export) {
  var bootstrap, _Array$from, submitMailingListForm, setupDirtyInput, setupPhoneInputValidation, submitContactForm, contactForms, inputs, phoneInputs, mailingListForm;

  return {
    setters: [function (_2) {
      bootstrap = _2.bootstrap;
    }, function (_) {
      _Array$from = _['default'];
    }, function (_3) {
      submitMailingListForm = _3.submitMailingListForm;
    }, function (_a) {
      setupDirtyInput = _a.setupDirtyInput;
      setupPhoneInputValidation = _a.setupPhoneInputValidation;
    }, function (_b) {
      submitContactForm = _b.submitContactForm;
    }],
    execute: function () {
      'use strict';

      contactForms = _Array$from(document.getElementsByClassName('form--contact-us'));
      inputs = contactForms.reduce(function (acc, form) {
        return acc.concat(_Array$from(form.getElementsByTagName('input')));
      }, []);
      phoneInputs = contactForms.reduce(function (acc, form) {
        return acc.concat(_Array$from(form.querySelectorAll('input[type="tel"]')));
      }, []);
      mailingListForm = _Array$from(document.getElementsByClassName('form--subscribe'));

      bootstrap(inputs, setupDirtyInput);
      bootstrap(phoneInputs, setupPhoneInputValidation);
      bootstrap(contactForms, function (form) {
        return form.addEventListener('submit', submitContactForm);
      });
      bootstrap(mailingListForm, function (mailingListForm) {
        return mailingListForm.addEventListener('submit', submitMailingListForm);
      });
    }
  };
});
$__System.register('23', ['4'], function (_export) {
  'use strict';

  var bootstrap;

  _export('addLogoInteractionHandler', addLogoInteractionHandler);

  _export('attachHamburgerHandler', attachHamburgerHandler);

  function addLogoInteractionHandler(logo) {
    var logoE = logo.querySelector('path.e');
    logoE.addEventListener('mouseenter', function () {
      logo.classList.add('logo--active');
    }, false);
  }

  function attachHamburgerHandler(hamburger, mobileNav) {
    hamburger.addEventListener('click', function (e) {
      e.preventDefault();
      hamburger.classList.toggle('hamburger--open');
      bootstrap(mobileNav, function (mobileNav) {
        return mobileNav.classList.toggle('navigation__mobile--open');
      });
    }, false);
  }

  return {
    setters: [function (_) {
      bootstrap = _.bootstrap;
    }],
    execute: function () {}
  };
});
$__System.register('24', ['8'], function (_export) {
  var _Array$from;

  function checkShadowHeader(header) {
    var pixelsScrolled = 5;

    if (window.pageYOffset > pixelsScrolled && !header.classList.contains('navigation--shadow')) {
      header.classList.add('navigation--shadow');
    }
    if (window.pageYOffset < pixelsScrolled && header.classList.contains('navigation--shadow')) {
      header.classList.remove('navigation--shadow');
    }
  }

  function onScroll() {
    // if scroll show header shadow
    var header = document.querySelector('nav.navigation');
    checkShadowHeader(header);
    checkHIWPlayOnViewport();
  }

  function checkHIWPlayOnViewport() {
    var hiwAnimations = _Array$from(document.querySelectorAll('[data-hiw-playonviewport="true"]'));

    if (hiwAnimations.length > 0) {
      hiwAnimations.forEach(function (hiwAnimation) {
        var animationClientRect = hiwAnimation.getBoundingClientRect();
        if (animationClientRect.top <= window.innerHeight * 0.60 && hiwAnimation.querySelectorAll('nav a')[0].getAttribute('data-handler') === 'true') {
          hiwAnimation.querySelectorAll('nav a')[0].click();
          hiwAnimation.setAttribute('data-hiw-playonviewport', 'false');
        }
      });
    }
  }
  return {
    setters: [function (_) {
      _Array$from = _['default'];
    }],
    execute: function () {
      'use strict';

      _export('checkShadowHeader', checkShadowHeader);

      _export('onScroll', onScroll);
    }
  };
});
$__System.register('25', ['4', '23', '24'], function (_export) {
  'use strict';
  var bootstrap, addLogoInteractionHandler, attachHamburgerHandler, onScroll, logo, hamburger, mobileNav;
  return {
    setters: [function (_) {
      bootstrap = _.bootstrap;
    }, function (_2) {
      addLogoInteractionHandler = _2.addLogoInteractionHandler;
      attachHamburgerHandler = _2.attachHamburgerHandler;
    }, function (_3) {
      onScroll = _3.onScroll;
    }],
    execute: function () {
      logo = document.querySelector('svg.logo');
      hamburger = document.querySelector('nav.navigation .hamburger');
      mobileNav = document.querySelector('nav.navigation__mobile');

      bootstrap(logo, addLogoInteractionHandler);
      bootstrap(hamburger, attachHamburgerHandler, mobileNav);
      bootstrap(window, function (el, event, callback) {
        return el.addEventListener(event, callback);
      }, 'scroll', onScroll);
    }
  };
});
$__System.register('26', ['d'], function (_export) {
  'use strict';

  var trackEvent;

  _export('attachMobileNavHandlers', attachMobileNavHandlers);

  _export('attachNavHandlers', attachNavHandlers);

  _export('attachCardHandlers', attachCardHandlers);

  _export('updateNav', updateNav);

  _export('removeCards', removeCards);

  function attachMobileNavHandlers(select) {
    document.querySelector('.dropdown__ui span').innerHTML = document.querySelector('.wizard__nav .tab:first-child span').innerText;

    select.addEventListener('blur', function () {
      addCards(select.options[select.options.selectedIndex].value);
    });
    select.addEventListener('change', function () {
      addCards(select.options[select.options.selectedIndex].value);
    });
  }

  function attachNavHandlers(anchor) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      if (!anchor.classList.contains('tab--current')) {
        addCards(anchor.getAttribute('data-role'));
      }
    });
  }

  function attachCardHandlers(card) {
    card.addEventListener('mouseenter', function () {
      card.classList.add('hover');
    });
    card.addEventListener('mouseleave', function () {
      card.classList.remove('hover');
    });
  }

  function updateNav(role) {
    document.querySelector('.wizard__nav .tab--current').classList.remove('tab--current');
    document.querySelector('.wizard__nav a[data-role=\'' + role + '\']').classList.add('tab--current');
    document.querySelector('.dropdown__ui span').innerHTML = document.querySelector('.wizard__nav--dropdown select option[value="' + role + '"]').innerText;
    trackEvent('Wizard', 'Click', 'Role', role);
  }

  function removeCards(callback) {
    var cards = document.querySelector('.wizard__cards--show');
    cards.classList.remove('wizard__cards--show');
    window.setTimeout(function () {
      cards.style.display = 'none';
      callback();
    }, 800);
  }

  function addCards(role) {
    var cards = document.querySelector('.wizard__cards--' + role);

    updateNav(role);
    removeCards(function () {
      cards.style.display = 'block';
      window.setTimeout(function () {
        cards.classList.add('wizard__cards--show');
      }, 100);
    });
  }
  return {
    setters: [function (_d) {
      trackEvent = _d.trackEvent;
    }],
    execute: function () {}
  };
});
$__System.register('27', ['4', '26'], function (_export) {
  'use strict';
  var bootstrap, utils, wizardNav;
  return {
    setters: [function (_) {
      bootstrap = _.bootstrap;
    }, function (_2) {
      utils = _2;
    }],
    execute: function () {
      wizardNav = document.querySelector('nav.wizard__nav');

      bootstrap(wizardNav, function (wizardNav) {
        var wizardMobileNavDropdown = document.querySelector('.wizard__nav--dropdown select');
        var wizardNavAnchors = wizardNav.querySelectorAll('a.tab');
        var wizardCards = document.querySelectorAll('.wizard .card');

        bootstrap(wizardNavAnchors, function (wizardNavAnchors) {
          Array.prototype.forEach.call(wizardNavAnchors, utils.attachNavHandlers);
        });
        bootstrap(wizardMobileNavDropdown, function (el) {
          utils.attachMobileNavHandlers(el);
        });
        bootstrap(wizardCards, function (wizardCards) {
          Array.prototype.forEach.call(wizardCards, utils.attachCardHandlers);
        });
      });
    }
  };
});
$__System.register('28', [], function (_export) {
  'use strict';

  _export('easeInOutQuad', easeInOutQuad);

  _export('easeScrollTo', easeScrollTo);

  function easeInOutQuad(t, b, c, d) {
    t /= d / 2;
    if (t < 1) {
      return c / 2 * t * t + b;
    }
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  }

  function easeScrollTo(to) {
    var body = document.querySelector('body');
    var from = body.scrollTop;
    var duration = 1200;
    var increment = 1000 / 60;
    var currentTime = 0;

    var animateScroll = function animateScroll() {
      currentTime += increment;
      var val = easeInOutQuad(currentTime, from, to, duration);
      window.scrollTo(0, val);
      if (currentTime < duration) {
        window.requestAnimationFrame(animateScroll);
      }
    };

    animateScroll();
  }

  return {
    setters: [],
    execute: function () {}
  };
});
$__System.register('29', ['4', '28'], function (_export) {
  'use strict';

  var bootstrap, easeScrollTo, wizard, arrow, navigation;

  function scrollOnClickHandler(el) {
    var navigationHeight = 0;

    bootstrap(navigation, function (navigation) {
      return navigationHeight = navigation.getBoundingClientRect().height;
    });
    el.addEventListener('click', function (e) {
      e.preventDefault();
      bootstrap(wizard.getBoundingClientRect().top - navigationHeight, easeScrollTo);
    });
  }

  return {
    setters: [function (_) {
      bootstrap = _.bootstrap;
    }, function (_2) {
      easeScrollTo = _2.easeScrollTo;
    }],
    execute: function () {
      wizard = document.querySelector('.layout[data-section="wizard"]');
      arrow = document.querySelector('.scroll-to');
      navigation = document.querySelector('nav.navigation');
      bootstrap(arrow, scrollOnClickHandler);
    }
  };
});
$__System.registerDynamic("2a", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  (function(window, factory) {
    'use strict';
    if (typeof define == 'function' && define.amd) {
      define(factory);
    } else if (typeof module == 'object' && module.exports) {
      module.exports = factory();
    } else {
      window.matchesSelector = factory();
    }
  }(window, function factory() {
    'use strict';
    var matchesMethod = (function() {
      var ElemProto = Element.prototype;
      if (ElemProto.matches) {
        return 'matches';
      }
      if (ElemProto.matchesSelector) {
        return 'matchesSelector';
      }
      var prefixes = ['webkit', 'moz', 'ms', 'o'];
      for (var i = 0; i < prefixes.length; i++) {
        var prefix = prefixes[i];
        var method = prefix + 'MatchesSelector';
        if (ElemProto[method]) {
          return method;
        }
      }
    })();
    return function matchesSelector(elem, selector) {
      return elem[matchesMethod](selector);
    };
  }));
  return module.exports;
});

$__System.registerDynamic("2b", ["2a"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = $__require('2a');
  return module.exports;
});

$__System.registerDynamic("2c", ["2b"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  "format cjs";
  (function(window, factory) {
    if (typeof define == 'function' && define.amd) {
      define(['desandro-matches-selector/matches-selector'], function(matchesSelector) {
        return factory(window, matchesSelector);
      });
    } else if (typeof module == 'object' && module.exports) {
      module.exports = factory(window, $__require('2b'));
    } else {
      window.fizzyUIUtils = factory(window, window.matchesSelector);
    }
  }(window, function factory(window, matchesSelector) {
    'use strict';
    var utils = {};
    utils.extend = function(a, b) {
      for (var prop in b) {
        a[prop] = b[prop];
      }
      return a;
    };
    utils.modulo = function(num, div) {
      return ((num % div) + div) % div;
    };
    utils.makeArray = function(obj) {
      var ary = [];
      if (Array.isArray(obj)) {
        ary = obj;
      } else if (obj && typeof obj.length == 'number') {
        for (var i = 0; i < obj.length; i++) {
          ary.push(obj[i]);
        }
      } else {
        ary.push(obj);
      }
      return ary;
    };
    utils.removeFrom = function(ary, obj) {
      var index = ary.indexOf(obj);
      if (index != -1) {
        ary.splice(index, 1);
      }
    };
    utils.getParent = function(elem, selector) {
      while (elem != document.body) {
        elem = elem.parentNode;
        if (matchesSelector(elem, selector)) {
          return elem;
        }
      }
    };
    utils.getQueryElement = function(elem) {
      if (typeof elem == 'string') {
        return document.querySelector(elem);
      }
      return elem;
    };
    utils.handleEvent = function(event) {
      var method = 'on' + event.type;
      if (this[method]) {
        this[method](event);
      }
    };
    utils.filterFindElements = function(elems, selector) {
      elems = utils.makeArray(elems);
      var ffElems = [];
      elems.forEach(function(elem) {
        if (!(elem instanceof HTMLElement)) {
          return;
        }
        if (!selector) {
          ffElems.push(elem);
          return;
        }
        if (matchesSelector(elem, selector)) {
          ffElems.push(elem);
        }
        var childElems = elem.querySelectorAll(selector);
        for (var i = 0; i < childElems.length; i++) {
          ffElems.push(childElems[i]);
        }
      });
      return ffElems;
    };
    utils.debounceMethod = function(_class, methodName, threshold) {
      var method = _class.prototype[methodName];
      var timeoutName = methodName + 'Timeout';
      _class.prototype[methodName] = function() {
        var timeout = this[timeoutName];
        if (timeout) {
          clearTimeout(timeout);
        }
        var args = arguments;
        var _this = this;
        this[timeoutName] = setTimeout(function() {
          method.apply(_this, args);
          delete _this[timeoutName];
        }, threshold || 100);
      };
    };
    utils.docReady = function(callback) {
      if (document.readyState == 'complete') {
        callback();
      } else {
        document.addEventListener('DOMContentLoaded', callback);
      }
    };
    utils.toDashed = function(str) {
      return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
        return $1 + '-' + $2;
      }).toLowerCase();
    };
    var console = window.console;
    utils.htmlInit = function(WidgetClass, namespace) {
      utils.docReady(function() {
        var dashedNamespace = utils.toDashed(namespace);
        var dataAttr = 'data-' + dashedNamespace;
        var dataAttrElems = document.querySelectorAll('[' + dataAttr + ']');
        var jsDashElems = document.querySelectorAll('.js-' + dashedNamespace);
        var elems = utils.makeArray(dataAttrElems).concat(utils.makeArray(jsDashElems));
        var dataOptionsAttr = dataAttr + '-options';
        var jQuery = window.jQuery;
        elems.forEach(function(elem) {
          var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
          var options;
          try {
            options = attr && JSON.parse(attr);
          } catch (error) {
            if (console) {
              console.error('Error parsing ' + dataAttr + ' on ' + elem.className + ': ' + error);
            }
            return;
          }
          var instance = new WidgetClass(elem, options);
          if (jQuery) {
            jQuery.data(elem, namespace, instance);
          }
        });
      });
    };
    return utils;
  }));
  return module.exports;
});

$__System.registerDynamic("2d", ["2c"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = $__require('2c');
  return module.exports;
});

$__System.registerDynamic("2e", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  (function(global, factory) {
    if (typeof define == 'function' && define.amd) {
      define(factory);
    } else if (typeof module == 'object' && module.exports) {
      module.exports = factory();
    } else {
      global.EvEmitter = factory();
    }
  }(this, function() {
    "use strict";
    function EvEmitter() {}
    var proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
      if (!eventName || !listener) {
        return;
      }
      var events = this._events = this._events || {};
      var listeners = events[eventName] = events[eventName] || [];
      if (listeners.indexOf(listener) == -1) {
        listeners.push(listener);
      }
      return this;
    };
    proto.once = function(eventName, listener) {
      if (!eventName || !listener) {
        return;
      }
      this.on(eventName, listener);
      var onceEvents = this._onceEvents = this._onceEvents || {};
      var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
      onceListeners[listener] = true;
      return this;
    };
    proto.off = function(eventName, listener) {
      var listeners = this._events && this._events[eventName];
      if (!listeners || !listeners.length) {
        return;
      }
      var index = listeners.indexOf(listener);
      if (index != -1) {
        listeners.splice(index, 1);
      }
      return this;
    };
    proto.emitEvent = function(eventName, args) {
      var listeners = this._events && this._events[eventName];
      if (!listeners || !listeners.length) {
        return;
      }
      var i = 0;
      var listener = listeners[i];
      args = args || [];
      var onceListeners = this._onceEvents && this._onceEvents[eventName];
      while (listener) {
        var isOnce = onceListeners && onceListeners[listener];
        if (isOnce) {
          this.off(eventName, listener);
          delete onceListeners[listener];
        }
        listener.apply(this, args);
        i += isOnce ? 0 : 1;
        listener = listeners[i];
      }
      return this;
    };
    return EvEmitter;
  }));
  return module.exports;
});

$__System.registerDynamic("2f", ["2e"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = $__require('2e');
  return module.exports;
});

$__System.registerDynamic("30", ["2f", "31"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  "format cjs";
  (function(window, factory) {
    if (typeof define == 'function' && define.amd) {
      define(['ev-emitter/ev-emitter', 'get-size/get-size'], factory);
    } else if (typeof module == 'object' && module.exports) {
      module.exports = factory($__require('2f'), $__require('31'));
    } else {
      window.Outlayer = {};
      window.Outlayer.Item = factory(window.EvEmitter, window.getSize);
    }
  }(window, function factory(EvEmitter, getSize) {
    'use strict';
    function isEmptyObj(obj) {
      for (var prop in obj) {
        return false;
      }
      prop = null;
      return true;
    }
    var docElemStyle = document.documentElement.style;
    var transitionProperty = typeof docElemStyle.transition == 'string' ? 'transition' : 'WebkitTransition';
    var transformProperty = typeof docElemStyle.transform == 'string' ? 'transform' : 'WebkitTransform';
    var transitionEndEvent = {
      WebkitTransition: 'webkitTransitionEnd',
      transition: 'transitionend'
    }[transitionProperty];
    var vendorProperties = {
      transform: transformProperty,
      transition: transitionProperty,
      transitionDuration: transitionProperty + 'Duration',
      transitionProperty: transitionProperty + 'Property'
    };
    function Item(element, layout) {
      if (!element) {
        return;
      }
      this.element = element;
      this.layout = layout;
      this.position = {
        x: 0,
        y: 0
      };
      this._create();
    }
    var proto = Item.prototype = Object.create(EvEmitter.prototype);
    proto.constructor = Item;
    proto._create = function() {
      this._transn = {
        ingProperties: {},
        clean: {},
        onEnd: {}
      };
      this.css({position: 'absolute'});
    };
    proto.handleEvent = function(event) {
      var method = 'on' + event.type;
      if (this[method]) {
        this[method](event);
      }
    };
    proto.getSize = function() {
      this.size = getSize(this.element);
    };
    proto.css = function(style) {
      var elemStyle = this.element.style;
      for (var prop in style) {
        var supportedProp = vendorProperties[prop] || prop;
        elemStyle[supportedProp] = style[prop];
      }
    };
    proto.getPosition = function() {
      var style = getComputedStyle(this.element);
      var isOriginLeft = this.layout._getOption('originLeft');
      var isOriginTop = this.layout._getOption('originTop');
      var xValue = style[isOriginLeft ? 'left' : 'right'];
      var yValue = style[isOriginTop ? 'top' : 'bottom'];
      var layoutSize = this.layout.size;
      var x = xValue.indexOf('%') != -1 ? (parseFloat(xValue) / 100) * layoutSize.width : parseInt(xValue, 10);
      var y = yValue.indexOf('%') != -1 ? (parseFloat(yValue) / 100) * layoutSize.height : parseInt(yValue, 10);
      x = isNaN(x) ? 0 : x;
      y = isNaN(y) ? 0 : y;
      x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
      y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;
      this.position.x = x;
      this.position.y = y;
    };
    proto.layoutPosition = function() {
      var layoutSize = this.layout.size;
      var style = {};
      var isOriginLeft = this.layout._getOption('originLeft');
      var isOriginTop = this.layout._getOption('originTop');
      var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
      var xProperty = isOriginLeft ? 'left' : 'right';
      var xResetProperty = isOriginLeft ? 'right' : 'left';
      var x = this.position.x + layoutSize[xPadding];
      style[xProperty] = this.getXValue(x);
      style[xResetProperty] = '';
      var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
      var yProperty = isOriginTop ? 'top' : 'bottom';
      var yResetProperty = isOriginTop ? 'bottom' : 'top';
      var y = this.position.y + layoutSize[yPadding];
      style[yProperty] = this.getYValue(y);
      style[yResetProperty] = '';
      this.css(style);
      this.emitEvent('layout', [this]);
    };
    proto.getXValue = function(x) {
      var isHorizontal = this.layout._getOption('horizontal');
      return this.layout.options.percentPosition && !isHorizontal ? ((x / this.layout.size.width) * 100) + '%' : x + 'px';
    };
    proto.getYValue = function(y) {
      var isHorizontal = this.layout._getOption('horizontal');
      return this.layout.options.percentPosition && isHorizontal ? ((y / this.layout.size.height) * 100) + '%' : y + 'px';
    };
    proto._transitionTo = function(x, y) {
      this.getPosition();
      var curX = this.position.x;
      var curY = this.position.y;
      var compareX = parseInt(x, 10);
      var compareY = parseInt(y, 10);
      var didNotMove = compareX === this.position.x && compareY === this.position.y;
      this.setPosition(x, y);
      if (didNotMove && !this.isTransitioning) {
        this.layoutPosition();
        return;
      }
      var transX = x - curX;
      var transY = y - curY;
      var transitionStyle = {};
      transitionStyle.transform = this.getTranslate(transX, transY);
      this.transition({
        to: transitionStyle,
        onTransitionEnd: {transform: this.layoutPosition},
        isCleaning: true
      });
    };
    proto.getTranslate = function(x, y) {
      var isOriginLeft = this.layout._getOption('originLeft');
      var isOriginTop = this.layout._getOption('originTop');
      x = isOriginLeft ? x : -x;
      y = isOriginTop ? y : -y;
      return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
    };
    proto.goTo = function(x, y) {
      this.setPosition(x, y);
      this.layoutPosition();
    };
    proto.moveTo = proto._transitionTo;
    proto.setPosition = function(x, y) {
      this.position.x = parseInt(x, 10);
      this.position.y = parseInt(y, 10);
    };
    proto._nonTransition = function(args) {
      this.css(args.to);
      if (args.isCleaning) {
        this._removeStyles(args.to);
      }
      for (var prop in args.onTransitionEnd) {
        args.onTransitionEnd[prop].call(this);
      }
    };
    proto.transition = function(args) {
      if (!parseFloat(this.layout.options.transitionDuration)) {
        this._nonTransition(args);
        return;
      }
      var _transition = this._transn;
      for (var prop in args.onTransitionEnd) {
        _transition.onEnd[prop] = args.onTransitionEnd[prop];
      }
      for (prop in args.to) {
        _transition.ingProperties[prop] = true;
        if (args.isCleaning) {
          _transition.clean[prop] = true;
        }
      }
      if (args.from) {
        this.css(args.from);
        var h = this.element.offsetHeight;
        h = null;
      }
      this.enableTransition(args.to);
      this.css(args.to);
      this.isTransitioning = true;
    };
    function toDashedAll(str) {
      return str.replace(/([A-Z])/g, function($1) {
        return '-' + $1.toLowerCase();
      });
    }
    var transitionProps = 'opacity,' + toDashedAll(transformProperty);
    proto.enableTransition = function() {
      if (this.isTransitioning) {
        return;
      }
      this.css({
        transitionProperty: transitionProps,
        transitionDuration: this.layout.options.transitionDuration
      });
      this.element.addEventListener(transitionEndEvent, this, false);
    };
    proto.onwebkitTransitionEnd = function(event) {
      this.ontransitionend(event);
    };
    proto.onotransitionend = function(event) {
      this.ontransitionend(event);
    };
    var dashedVendorProperties = {'-webkit-transform': 'transform'};
    proto.ontransitionend = function(event) {
      if (event.target !== this.element) {
        return;
      }
      var _transition = this._transn;
      var propertyName = dashedVendorProperties[event.propertyName] || event.propertyName;
      delete _transition.ingProperties[propertyName];
      if (isEmptyObj(_transition.ingProperties)) {
        this.disableTransition();
      }
      if (propertyName in _transition.clean) {
        this.element.style[event.propertyName] = '';
        delete _transition.clean[propertyName];
      }
      if (propertyName in _transition.onEnd) {
        var onTransitionEnd = _transition.onEnd[propertyName];
        onTransitionEnd.call(this);
        delete _transition.onEnd[propertyName];
      }
      this.emitEvent('transitionEnd', [this]);
    };
    proto.disableTransition = function() {
      this.removeTransitionStyles();
      this.element.removeEventListener(transitionEndEvent, this, false);
      this.isTransitioning = false;
    };
    proto._removeStyles = function(style) {
      var cleanStyle = {};
      for (var prop in style) {
        cleanStyle[prop] = '';
      }
      this.css(cleanStyle);
    };
    var cleanTransitionStyle = {
      transitionProperty: '',
      transitionDuration: ''
    };
    proto.removeTransitionStyles = function() {
      this.css(cleanTransitionStyle);
    };
    proto.removeElem = function() {
      this.element.parentNode.removeChild(this.element);
      this.css({display: ''});
      this.emitEvent('remove', [this]);
    };
    proto.remove = function() {
      if (!transitionProperty || !parseFloat(this.layout.options.transitionDuration)) {
        this.removeElem();
        return;
      }
      this.once('transitionEnd', function() {
        this.removeElem();
      });
      this.hide();
    };
    proto.reveal = function() {
      delete this.isHidden;
      this.css({display: ''});
      var options = this.layout.options;
      var onTransitionEnd = {};
      var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
      onTransitionEnd[transitionEndProperty] = this.onRevealTransitionEnd;
      this.transition({
        from: options.hiddenStyle,
        to: options.visibleStyle,
        isCleaning: true,
        onTransitionEnd: onTransitionEnd
      });
    };
    proto.onRevealTransitionEnd = function() {
      if (!this.isHidden) {
        this.emitEvent('reveal');
      }
    };
    proto.getHideRevealTransitionEndProperty = function(styleProperty) {
      var optionStyle = this.layout.options[styleProperty];
      if (optionStyle.opacity) {
        return 'opacity';
      }
      for (var prop in optionStyle) {
        return prop;
      }
    };
    proto.hide = function() {
      this.isHidden = true;
      this.css({display: ''});
      var options = this.layout.options;
      var onTransitionEnd = {};
      var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
      onTransitionEnd[transitionEndProperty] = this.onHideTransitionEnd;
      this.transition({
        from: options.visibleStyle,
        to: options.hiddenStyle,
        isCleaning: true,
        onTransitionEnd: onTransitionEnd
      });
    };
    proto.onHideTransitionEnd = function() {
      if (this.isHidden) {
        this.css({display: 'none'});
        this.emitEvent('hide');
      }
    };
    proto.destroy = function() {
      this.css({
        position: '',
        left: '',
        right: '',
        top: '',
        bottom: '',
        transition: '',
        transform: ''
      });
    };
    return Item;
  }));
  return module.exports;
});

$__System.registerDynamic("32", ["2f", "31", "2d", "30"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  "format cjs";
  (function(window, factory) {
    'use strict';
    if (typeof define == 'function' && define.amd) {
      define(['ev-emitter/ev-emitter', 'get-size/get-size', 'fizzy-ui-utils/utils', './item'], function(EvEmitter, getSize, utils, Item) {
        return factory(window, EvEmitter, getSize, utils, Item);
      });
    } else if (typeof module == 'object' && module.exports) {
      module.exports = factory(window, $__require('2f'), $__require('31'), $__require('2d'), $__require('30'));
    } else {
      window.Outlayer = factory(window, window.EvEmitter, window.getSize, window.fizzyUIUtils, window.Outlayer.Item);
    }
  }(window, function factory(window, EvEmitter, getSize, utils, Item) {
    'use strict';
    var console = window.console;
    var jQuery = window.jQuery;
    var noop = function() {};
    var GUID = 0;
    var instances = {};
    function Outlayer(element, options) {
      var queryElement = utils.getQueryElement(element);
      if (!queryElement) {
        if (console) {
          console.error('Bad element for ' + this.constructor.namespace + ': ' + (queryElement || element));
        }
        return;
      }
      this.element = queryElement;
      if (jQuery) {
        this.$element = jQuery(this.element);
      }
      this.options = utils.extend({}, this.constructor.defaults);
      this.option(options);
      var id = ++GUID;
      this.element.outlayerGUID = id;
      instances[id] = this;
      this._create();
      var isInitLayout = this._getOption('initLayout');
      if (isInitLayout) {
        this.layout();
      }
    }
    Outlayer.namespace = 'outlayer';
    Outlayer.Item = Item;
    Outlayer.defaults = {
      containerStyle: {position: 'relative'},
      initLayout: true,
      originLeft: true,
      originTop: true,
      resize: true,
      resizeContainer: true,
      transitionDuration: '0.4s',
      hiddenStyle: {
        opacity: 0,
        transform: 'scale(0.001)'
      },
      visibleStyle: {
        opacity: 1,
        transform: 'scale(1)'
      }
    };
    var proto = Outlayer.prototype;
    utils.extend(proto, EvEmitter.prototype);
    proto.option = function(opts) {
      utils.extend(this.options, opts);
    };
    proto._getOption = function(option) {
      var oldOption = this.constructor.compatOptions[option];
      return oldOption && this.options[oldOption] !== undefined ? this.options[oldOption] : this.options[option];
    };
    Outlayer.compatOptions = {
      initLayout: 'isInitLayout',
      horizontal: 'isHorizontal',
      layoutInstant: 'isLayoutInstant',
      originLeft: 'isOriginLeft',
      originTop: 'isOriginTop',
      resize: 'isResizeBound',
      resizeContainer: 'isResizingContainer'
    };
    proto._create = function() {
      this.reloadItems();
      this.stamps = [];
      this.stamp(this.options.stamp);
      utils.extend(this.element.style, this.options.containerStyle);
      var canBindResize = this._getOption('resize');
      if (canBindResize) {
        this.bindResize();
      }
    };
    proto.reloadItems = function() {
      this.items = this._itemize(this.element.children);
    };
    proto._itemize = function(elems) {
      var itemElems = this._filterFindItemElements(elems);
      var Item = this.constructor.Item;
      var items = [];
      for (var i = 0; i < itemElems.length; i++) {
        var elem = itemElems[i];
        var item = new Item(elem, this);
        items.push(item);
      }
      return items;
    };
    proto._filterFindItemElements = function(elems) {
      return utils.filterFindElements(elems, this.options.itemSelector);
    };
    proto.getItemElements = function() {
      return this.items.map(function(item) {
        return item.element;
      });
    };
    proto.layout = function() {
      this._resetLayout();
      this._manageStamps();
      var layoutInstant = this._getOption('layoutInstant');
      var isInstant = layoutInstant !== undefined ? layoutInstant : !this._isLayoutInited;
      this.layoutItems(this.items, isInstant);
      this._isLayoutInited = true;
    };
    proto._init = proto.layout;
    proto._resetLayout = function() {
      this.getSize();
    };
    proto.getSize = function() {
      this.size = getSize(this.element);
    };
    proto._getMeasurement = function(measurement, size) {
      var option = this.options[measurement];
      var elem;
      if (!option) {
        this[measurement] = 0;
      } else {
        if (typeof option == 'string') {
          elem = this.element.querySelector(option);
        } else if (option instanceof HTMLElement) {
          elem = option;
        }
        this[measurement] = elem ? getSize(elem)[size] : option;
      }
    };
    proto.layoutItems = function(items, isInstant) {
      items = this._getItemsForLayout(items);
      this._layoutItems(items, isInstant);
      this._postLayout();
    };
    proto._getItemsForLayout = function(items) {
      return items.filter(function(item) {
        return !item.isIgnored;
      });
    };
    proto._layoutItems = function(items, isInstant) {
      this._emitCompleteOnItems('layout', items);
      if (!items || !items.length) {
        return;
      }
      var queue = [];
      items.forEach(function(item) {
        var position = this._getItemLayoutPosition(item);
        position.item = item;
        position.isInstant = isInstant || item.isLayoutInstant;
        queue.push(position);
      }, this);
      this._processLayoutQueue(queue);
    };
    proto._getItemLayoutPosition = function() {
      return {
        x: 0,
        y: 0
      };
    };
    proto._processLayoutQueue = function(queue) {
      queue.forEach(function(obj) {
        this._positionItem(obj.item, obj.x, obj.y, obj.isInstant);
      }, this);
    };
    proto._positionItem = function(item, x, y, isInstant) {
      if (isInstant) {
        item.goTo(x, y);
      } else {
        item.moveTo(x, y);
      }
    };
    proto._postLayout = function() {
      this.resizeContainer();
    };
    proto.resizeContainer = function() {
      var isResizingContainer = this._getOption('resizeContainer');
      if (!isResizingContainer) {
        return;
      }
      var size = this._getContainerSize();
      if (size) {
        this._setContainerMeasure(size.width, true);
        this._setContainerMeasure(size.height, false);
      }
    };
    proto._getContainerSize = noop;
    proto._setContainerMeasure = function(measure, isWidth) {
      if (measure === undefined) {
        return;
      }
      var elemSize = this.size;
      if (elemSize.isBorderBox) {
        measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight + elemSize.borderLeftWidth + elemSize.borderRightWidth : elemSize.paddingBottom + elemSize.paddingTop + elemSize.borderTopWidth + elemSize.borderBottomWidth;
      }
      measure = Math.max(measure, 0);
      this.element.style[isWidth ? 'width' : 'height'] = measure + 'px';
    };
    proto._emitCompleteOnItems = function(eventName, items) {
      var _this = this;
      function onComplete() {
        _this.dispatchEvent(eventName + 'Complete', null, [items]);
      }
      var count = items.length;
      if (!items || !count) {
        onComplete();
        return;
      }
      var doneCount = 0;
      function tick() {
        doneCount++;
        if (doneCount == count) {
          onComplete();
        }
      }
      items.forEach(function(item) {
        item.once(eventName, tick);
      });
    };
    proto.dispatchEvent = function(type, event, args) {
      var emitArgs = event ? [event].concat(args) : args;
      this.emitEvent(type, emitArgs);
      if (jQuery) {
        this.$element = this.$element || jQuery(this.element);
        if (event) {
          var $event = jQuery.Event(event);
          $event.type = type;
          this.$element.trigger($event, args);
        } else {
          this.$element.trigger(type, args);
        }
      }
    };
    proto.ignore = function(elem) {
      var item = this.getItem(elem);
      if (item) {
        item.isIgnored = true;
      }
    };
    proto.unignore = function(elem) {
      var item = this.getItem(elem);
      if (item) {
        delete item.isIgnored;
      }
    };
    proto.stamp = function(elems) {
      elems = this._find(elems);
      if (!elems) {
        return;
      }
      this.stamps = this.stamps.concat(elems);
      elems.forEach(this.ignore, this);
    };
    proto.unstamp = function(elems) {
      elems = this._find(elems);
      if (!elems) {
        return;
      }
      elems.forEach(function(elem) {
        utils.removeFrom(this.stamps, elem);
        this.unignore(elem);
      }, this);
    };
    proto._find = function(elems) {
      if (!elems) {
        return;
      }
      if (typeof elems == 'string') {
        elems = this.element.querySelectorAll(elems);
      }
      elems = utils.makeArray(elems);
      return elems;
    };
    proto._manageStamps = function() {
      if (!this.stamps || !this.stamps.length) {
        return;
      }
      this._getBoundingRect();
      this.stamps.forEach(this._manageStamp, this);
    };
    proto._getBoundingRect = function() {
      var boundingRect = this.element.getBoundingClientRect();
      var size = this.size;
      this._boundingRect = {
        left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
        top: boundingRect.top + size.paddingTop + size.borderTopWidth,
        right: boundingRect.right - (size.paddingRight + size.borderRightWidth),
        bottom: boundingRect.bottom - (size.paddingBottom + size.borderBottomWidth)
      };
    };
    proto._manageStamp = noop;
    proto._getElementOffset = function(elem) {
      var boundingRect = elem.getBoundingClientRect();
      var thisRect = this._boundingRect;
      var size = getSize(elem);
      var offset = {
        left: boundingRect.left - thisRect.left - size.marginLeft,
        top: boundingRect.top - thisRect.top - size.marginTop,
        right: thisRect.right - boundingRect.right - size.marginRight,
        bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
      };
      return offset;
    };
    proto.handleEvent = utils.handleEvent;
    proto.bindResize = function() {
      window.addEventListener('resize', this);
      this.isResizeBound = true;
    };
    proto.unbindResize = function() {
      window.removeEventListener('resize', this);
      this.isResizeBound = false;
    };
    proto.onresize = function() {
      this.resize();
    };
    utils.debounceMethod(Outlayer, 'onresize', 100);
    proto.resize = function() {
      if (!this.isResizeBound || !this.needsResizeLayout()) {
        return;
      }
      this.layout();
    };
    proto.needsResizeLayout = function() {
      var size = getSize(this.element);
      var hasSizes = this.size && size;
      return hasSizes && size.innerWidth !== this.size.innerWidth;
    };
    proto.addItems = function(elems) {
      var items = this._itemize(elems);
      if (items.length) {
        this.items = this.items.concat(items);
      }
      return items;
    };
    proto.appended = function(elems) {
      var items = this.addItems(elems);
      if (!items.length) {
        return;
      }
      this.layoutItems(items, true);
      this.reveal(items);
    };
    proto.prepended = function(elems) {
      var items = this._itemize(elems);
      if (!items.length) {
        return;
      }
      var previousItems = this.items.slice(0);
      this.items = items.concat(previousItems);
      this._resetLayout();
      this._manageStamps();
      this.layoutItems(items, true);
      this.reveal(items);
      this.layoutItems(previousItems);
    };
    proto.reveal = function(items) {
      this._emitCompleteOnItems('reveal', items);
      if (!items || !items.length) {
        return;
      }
      items.forEach(function(item) {
        item.reveal();
      });
    };
    proto.hide = function(items) {
      this._emitCompleteOnItems('hide', items);
      if (!items || !items.length) {
        return;
      }
      items.forEach(function(item) {
        item.hide();
      });
    };
    proto.revealItemElements = function(elems) {
      var items = this.getItems(elems);
      this.reveal(items);
    };
    proto.hideItemElements = function(elems) {
      var items = this.getItems(elems);
      this.hide(items);
    };
    proto.getItem = function(elem) {
      for (var i = 0; i < this.items.length; i++) {
        var item = this.items[i];
        if (item.element == elem) {
          return item;
        }
      }
    };
    proto.getItems = function(elems) {
      elems = utils.makeArray(elems);
      var items = [];
      elems.forEach(function(elem) {
        var item = this.getItem(elem);
        if (item) {
          items.push(item);
        }
      }, this);
      return items;
    };
    proto.remove = function(elems) {
      var removeItems = this.getItems(elems);
      this._emitCompleteOnItems('remove', removeItems);
      if (!removeItems || !removeItems.length) {
        return;
      }
      removeItems.forEach(function(item) {
        item.remove();
        utils.removeFrom(this.items, item);
      }, this);
    };
    proto.destroy = function() {
      var style = this.element.style;
      style.height = '';
      style.position = '';
      style.width = '';
      this.items.forEach(function(item) {
        item.destroy();
      });
      this.unbindResize();
      var id = this.element.outlayerGUID;
      delete instances[id];
      delete this.element.outlayerGUID;
      if (jQuery) {
        jQuery.removeData(this.element, this.constructor.namespace);
      }
    };
    Outlayer.data = function(elem) {
      elem = utils.getQueryElement(elem);
      var id = elem && elem.outlayerGUID;
      return id && instances[id];
    };
    Outlayer.create = function(namespace, options) {
      var Layout = subclass(Outlayer);
      Layout.defaults = utils.extend({}, Outlayer.defaults);
      utils.extend(Layout.defaults, options);
      Layout.compatOptions = utils.extend({}, Outlayer.compatOptions);
      Layout.namespace = namespace;
      Layout.data = Outlayer.data;
      Layout.Item = subclass(Item);
      utils.htmlInit(Layout, namespace);
      if (jQuery && jQuery.bridget) {
        jQuery.bridget(namespace, Layout);
      }
      return Layout;
    };
    function subclass(Parent) {
      function SubClass() {
        Parent.apply(this, arguments);
      }
      SubClass.prototype = Object.create(Parent.prototype);
      SubClass.prototype.constructor = SubClass;
      return SubClass;
    }
    Outlayer.Item = Item;
    return Outlayer;
  }));
  return module.exports;
});

$__System.registerDynamic("33", ["32"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = $__require('32');
  return module.exports;
});

$__System.registerDynamic("34", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  "format cjs";
  (function(window, factory) {
    'use strict';
    if (typeof define == 'function' && define.amd) {
      define(function() {
        return factory();
      });
    } else if (typeof module == 'object' && module.exports) {
      module.exports = factory();
    } else {
      window.getSize = factory();
    }
  })(window, function factory() {
    'use strict';
    function getStyleSize(value) {
      var num = parseFloat(value);
      var isValid = value.indexOf('%') == -1 && !isNaN(num);
      return isValid && num;
    }
    function noop() {}
    var logError = typeof console == 'undefined' ? noop : function(message) {
      console.error(message);
    };
    var measurements = ['paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'borderBottomWidth'];
    var measurementsLength = measurements.length;
    function getZeroSize() {
      var size = {
        width: 0,
        height: 0,
        innerWidth: 0,
        innerHeight: 0,
        outerWidth: 0,
        outerHeight: 0
      };
      for (var i = 0; i < measurementsLength; i++) {
        var measurement = measurements[i];
        size[measurement] = 0;
      }
      return size;
    }
    function getStyle(elem) {
      var style = getComputedStyle(elem);
      if (!style) {
        logError('Style returned ' + style + '. Are you running this code in a hidden iframe on Firefox? ' + 'See http://bit.ly/getsizebug1');
      }
      return style;
    }
    var isSetup = false;
    var isBoxSizeOuter;
    function setup() {
      if (isSetup) {
        return;
      }
      isSetup = true;
      var div = document.createElement('div');
      div.style.width = '200px';
      div.style.padding = '1px 2px 3px 4px';
      div.style.borderStyle = 'solid';
      div.style.borderWidth = '1px 2px 3px 4px';
      div.style.boxSizing = 'border-box';
      var body = document.body || document.documentElement;
      body.appendChild(div);
      var style = getStyle(div);
      getSize.isBoxSizeOuter = isBoxSizeOuter = getStyleSize(style.width) == 200;
      body.removeChild(div);
    }
    function getSize(elem) {
      setup();
      if (typeof elem == 'string') {
        elem = document.querySelector(elem);
      }
      if (!elem || typeof elem != 'object' || !elem.nodeType) {
        return;
      }
      var style = getStyle(elem);
      if (style.display == 'none') {
        return getZeroSize();
      }
      var size = {};
      size.width = elem.offsetWidth;
      size.height = elem.offsetHeight;
      var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
      for (var i = 0; i < measurementsLength; i++) {
        var measurement = measurements[i];
        var value = style[measurement];
        var num = parseFloat(value);
        size[measurement] = !isNaN(num) ? num : 0;
      }
      var paddingWidth = size.paddingLeft + size.paddingRight;
      var paddingHeight = size.paddingTop + size.paddingBottom;
      var marginWidth = size.marginLeft + size.marginRight;
      var marginHeight = size.marginTop + size.marginBottom;
      var borderWidth = size.borderLeftWidth + size.borderRightWidth;
      var borderHeight = size.borderTopWidth + size.borderBottomWidth;
      var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
      var styleWidth = getStyleSize(style.width);
      if (styleWidth !== false) {
        size.width = styleWidth + (isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
      }
      var styleHeight = getStyleSize(style.height);
      if (styleHeight !== false) {
        size.height = styleHeight + (isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
      }
      size.innerWidth = size.width - (paddingWidth + borderWidth);
      size.innerHeight = size.height - (paddingHeight + borderHeight);
      size.outerWidth = size.width + marginWidth;
      size.outerHeight = size.height + marginHeight;
      return size;
    }
    return getSize;
  });
  return module.exports;
});

$__System.registerDynamic("31", ["34"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = $__require('34');
  return module.exports;
});

$__System.registerDynamic("35", ["33", "31"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  "format cjs";
  (function(window, factory) {
    if (typeof define == 'function' && define.amd) {
      define(['outlayer/outlayer', 'get-size/get-size'], factory);
    } else if (typeof module == 'object' && module.exports) {
      module.exports = factory($__require('33'), $__require('31'));
    } else {
      window.Masonry = factory(window.Outlayer, window.getSize);
    }
  }(window, function factory(Outlayer, getSize) {
    'use strict';
    var Masonry = Outlayer.create('masonry');
    Masonry.compatOptions.fitWidth = 'isFitWidth';
    Masonry.prototype._resetLayout = function() {
      this.getSize();
      this._getMeasurement('columnWidth', 'outerWidth');
      this._getMeasurement('gutter', 'outerWidth');
      this.measureColumns();
      this.colYs = [];
      for (var i = 0; i < this.cols; i++) {
        this.colYs.push(0);
      }
      this.maxY = 0;
    };
    Masonry.prototype.measureColumns = function() {
      this.getContainerWidth();
      if (!this.columnWidth) {
        var firstItem = this.items[0];
        var firstItemElem = firstItem && firstItem.element;
        this.columnWidth = firstItemElem && getSize(firstItemElem).outerWidth || this.containerWidth;
      }
      var columnWidth = this.columnWidth += this.gutter;
      var containerWidth = this.containerWidth + this.gutter;
      var cols = containerWidth / columnWidth;
      var excess = columnWidth - containerWidth % columnWidth;
      var mathMethod = excess && excess < 1 ? 'round' : 'floor';
      cols = Math[mathMethod](cols);
      this.cols = Math.max(cols, 1);
    };
    Masonry.prototype.getContainerWidth = function() {
      var isFitWidth = this._getOption('fitWidth');
      var container = isFitWidth ? this.element.parentNode : this.element;
      var size = getSize(container);
      this.containerWidth = size && size.innerWidth;
    };
    Masonry.prototype._getItemLayoutPosition = function(item) {
      item.getSize();
      var remainder = item.size.outerWidth % this.columnWidth;
      var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
      var colSpan = Math[mathMethod](item.size.outerWidth / this.columnWidth);
      colSpan = Math.min(colSpan, this.cols);
      var colGroup = this._getColGroup(colSpan);
      var minimumY = Math.min.apply(Math, colGroup);
      var shortColIndex = colGroup.indexOf(minimumY);
      var position = {
        x: this.columnWidth * shortColIndex,
        y: minimumY
      };
      var setHeight = minimumY + item.size.outerHeight;
      var setSpan = this.cols + 1 - colGroup.length;
      for (var i = 0; i < setSpan; i++) {
        this.colYs[shortColIndex + i] = setHeight;
      }
      return position;
    };
    Masonry.prototype._getColGroup = function(colSpan) {
      if (colSpan < 2) {
        return this.colYs;
      }
      var colGroup = [];
      var groupCount = this.cols + 1 - colSpan;
      for (var i = 0; i < groupCount; i++) {
        var groupColYs = this.colYs.slice(i, i + colSpan);
        colGroup[i] = Math.max.apply(Math, groupColYs);
      }
      return colGroup;
    };
    Masonry.prototype._manageStamp = function(stamp) {
      var stampSize = getSize(stamp);
      var offset = this._getElementOffset(stamp);
      var isOriginLeft = this._getOption('originLeft');
      var firstX = isOriginLeft ? offset.left : offset.right;
      var lastX = firstX + stampSize.outerWidth;
      var firstCol = Math.floor(firstX / this.columnWidth);
      firstCol = Math.max(0, firstCol);
      var lastCol = Math.floor(lastX / this.columnWidth);
      lastCol -= lastX % this.columnWidth ? 0 : 1;
      lastCol = Math.min(this.cols - 1, lastCol);
      var isOriginTop = this._getOption('originTop');
      var stampMaxY = (isOriginTop ? offset.top : offset.bottom) + stampSize.outerHeight;
      for (var i = firstCol; i <= lastCol; i++) {
        this.colYs[i] = Math.max(stampMaxY, this.colYs[i]);
      }
    };
    Masonry.prototype._getContainerSize = function() {
      this.maxY = Math.max.apply(Math, this.colYs);
      var size = {height: this.maxY};
      if (this._getOption('fitWidth')) {
        size.width = this._getContainerFitWidth();
      }
      return size;
    };
    Masonry.prototype._getContainerFitWidth = function() {
      var unusedCols = 0;
      var i = this.cols;
      while (--i) {
        if (this.colYs[i] !== 0) {
          break;
        }
        unusedCols++;
      }
      return (this.cols - unusedCols) * this.columnWidth - this.gutter;
    };
    Masonry.prototype.needsResizeLayout = function() {
      var previousWidth = this.containerWidth;
      this.getContainerWidth();
      return previousWidth != this.containerWidth;
    };
    return Masonry;
  }));
  return module.exports;
});

$__System.registerDynamic("36", ["35"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = $__require('35');
  return module.exports;
});

$__System.register('37', ['4', '36'], function (_export) {
  'use strict';
  var bootstrap, Masonry, grid;
  return {
    setters: [function (_2) {
      bootstrap = _2.bootstrap;
    }, function (_) {
      Masonry = _['default'];
    }],
    execute: function () {
      grid = document.querySelector('.masonry-grid');

      bootstrap(grid, function (grid) {
        var msnry = new Masonry(grid, {
          itemSelector: '.tile',
          columnWidth: 280,
          gutter: 20,
          transitionDuration: 0,
          initLayout: false
        });

        msnry.once('layoutComplete', function () {
          grid.classList.add('load');
        });

        return msnry.layout();
      });
    }
  };
});
$__System.registerDynamic("38", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  "format cjs";
  (function(root, factory) {
    if (typeof define === "function" && define.amd) {
      define(factory);
    } else if (typeof module === "object" && module.exports) {
      module.exports = factory();
    } else {
      root.bodymovin = factory();
    }
  }(window, function() {
    function roundValues(t) {
      bm_rnd = t ? Math.round : function(t) {
        return t;
      };
    }
    function roundTo2Decimals(t) {
      return Math.round(1e4 * t) / 1e4;
    }
    function roundTo3Decimals(t) {
      return Math.round(100 * t) / 100;
    }
    function styleDiv(t) {
      t.style.position = "absolute", t.style.top = 0, t.style.left = 0, t.style.display = "block", t.style.transformOrigin = t.style.webkitTransformOrigin = "0 0", t.style.backfaceVisibility = t.style.webkitBackfaceVisibility = "visible", t.style.transformStyle = t.style.webkitTransformStyle = t.style.mozTransformStyle = "preserve-3d";
    }
    function styleUnselectableDiv(t) {
      t.style.userSelect = "none", t.style.MozUserSelect = "none", t.style.webkitUserSelect = "none", t.style.oUserSelect = "none";
    }
    function BMEnterFrameEvent(t, e, s, i) {
      this.type = t, this.currentTime = e, this.totalTime = s, this.direction = 0 > i ? -1 : 1;
    }
    function BMCompleteEvent(t, e) {
      this.type = t, this.direction = 0 > e ? -1 : 1;
    }
    function BMCompleteLoopEvent(t, e, s, i) {
      this.type = t, this.currentLoop = e, this.totalLoops = s, this.direction = 0 > i ? -1 : 1;
    }
    function BMSegmentStartEvent(t, e, s) {
      this.type = t, this.firstFrame = e, this.totalFrames = s;
    }
    function BMDestroyEvent(t, e) {
      this.type = t, this.target = e;
    }
    function _addEventListener(t, e) {
      this._cbs[t] || (this._cbs[t] = []), this._cbs[t].push(e);
    }
    function _removeEventListener(t, e) {
      if (e) {
        if (this._cbs[t]) {
          for (var s = 0,
              i = this._cbs[t].length; i > s; )
            this._cbs[t][s] === e && (this._cbs[t].splice(s, 1), s -= 1, i -= 1), s += 1;
          this._cbs[t].length || (this._cbs[t] = null);
        }
      } else
        this._cbs[t] = null;
    }
    function _triggerEvent(t, e) {
      if (this._cbs[t])
        for (var s = this._cbs[t].length,
            i = 0; s > i; i++)
          this._cbs[t][i](e);
    }
    function randomString(t, e) {
      void 0 === e && (e = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890");
      var s,
          i = "";
      for (s = t; s > 0; --s)
        i += e[Math.round(Math.random() * (e.length - 1))];
      return i;
    }
    function HSVtoRGB(t, e, s) {
      var i,
          a,
          r,
          n,
          o,
          h,
          l,
          p;
      switch (1 === arguments.length && (e = t.s, s = t.v, t = t.h), n = Math.floor(6 * t), o = 6 * t - n, h = s * (1 - e), l = s * (1 - o * e), p = s * (1 - (1 - o) * e), n % 6) {
        case 0:
          i = s, a = p, r = h;
          break;
        case 1:
          i = l, a = s, r = h;
          break;
        case 2:
          i = h, a = s, r = p;
          break;
        case 3:
          i = h, a = l, r = s;
          break;
        case 4:
          i = p, a = h, r = s;
          break;
        case 5:
          i = s, a = h, r = l;
      }
      return [Math.round(255 * i), Math.round(255 * a), Math.round(255 * r)];
    }
    function RGBtoHSV(t, e, s) {
      1 === arguments.length && (e = t.g, s = t.b, t = t.r);
      var i,
          a = Math.max(t, e, s),
          r = Math.min(t, e, s),
          n = a - r,
          o = 0 === a ? 0 : n / a,
          h = a / 255;
      switch (a) {
        case r:
          i = 0;
          break;
        case t:
          i = e - s + n * (s > e ? 6 : 0), i /= 6 * n;
          break;
        case e:
          i = s - t + 2 * n, i /= 6 * n;
          break;
        case s:
          i = t - e + 4 * n, i /= 6 * n;
      }
      return [i, o, h];
    }
    function addSaturationToRGB(t, e) {
      var s = RGBtoHSV(t[0], t[1], t[2]);
      return s[1] += e, s[1] > 1 ? s[1] = 1 : s[1] <= 0 && (s[1] = 0), HSVtoRGB(s[0], s[1], s[2]);
    }
    function addBrightnessToRGB(t, e) {
      var s = RGBtoHSV(t[0], t[1], t[2]);
      return s[2] += e, s[2] > 1 ? s[2] = 1 : s[2] < 0 && (s[2] = 0), HSVtoRGB(s[0], s[1], s[2]);
    }
    function addHueToRGB(t, e) {
      var s = RGBtoHSV(t[0], t[1], t[2]);
      return s[0] += e / 360, s[0] > 1 ? s[0] -= 1 : s[0] < 0 && (s[0] += 1), HSVtoRGB(s[0], s[1], s[2]);
    }
    function componentToHex(t) {
      var e = t.toString(16);
      return 1 == e.length ? "0" + e : e;
    }
    function fillToRgba(t, e) {
      if (!cachedColors[t]) {
        var s = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
        cachedColors[t] = parseInt(s[1], 16) + "," + parseInt(s[2], 16) + "," + parseInt(s[3], 16);
      }
      return "rgba(" + cachedColors[t] + "," + e + ")";
    }
    function RenderedFrame(t, e) {
      this.tr = t, this.o = e;
    }
    function LetterProps(t, e, s, i, a, r) {
      this.o = t, this.sw = e, this.sc = s, this.fc = i, this.m = a, this.props = r;
    }
    function iterateDynamicProperties(t) {
      var e,
          s = this.dynamicProperties;
      for (e = 0; s > e; e += 1)
        this.dynamicProperties[e].getValue(t);
    }
    function reversePath(t, e) {
      var s,
          i,
          a = [],
          r = [],
          n = [],
          o = {},
          h = 0;
      e && (a[0] = t.o[0], r[0] = t.i[0], n[0] = t.v[0], h = 1), i = t.i.length;
      var l = i - 1;
      for (s = h; i > s; s += 1)
        a.push(t.o[l]), r.push(t.i[l]), n.push(t.v[l]), l -= 1;
      return o.i = a, o.o = r, o.v = n, o;
    }
    function Matrix() {}
    function matrixManagerFunction() {
      var t = new Matrix,
          e = function(e, s, i, a, r) {
            return t.reset().translate(a, r).rotate(e).scale(s, i).toCSS();
          },
          s = function(t) {
            return e(t.tr.r[2], t.tr.s[0], t.tr.s[1], t.tr.p[0], t.tr.p[1]);
          };
      return {getMatrix: s};
    }
    function createElement(t, e, s) {
      if (!e) {
        var i = Object.create(t.prototype, s),
            a = {};
        return i && "[object Function]" === a.toString.call(i.init) && i.init(), i;
      }
      e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.prototype.parent = t.prototype;
    }
    function extendPrototype(t, e) {
      for (var s in t.prototype)
        t.prototype.hasOwnProperty(s) && (e.prototype[s] = t.prototype[s]);
    }
    function bezFunction() {
      function t(t, e, s, i, a, r) {
        var n = t * i + e * a + s * r - a * i - r * t - s * e;
        return n > -1e-4 && 1e-4 > n;
      }
      function e(e, s, i, a, r, n, o, h, l) {
        return t(e, s, a, r, o, h) && t(e, i, a, n, o, l);
      }
      function s(t) {
        this.segmentLength = 0, this.points = new Array(t);
      }
      function i(t, e) {
        this.partialLength = t, this.point = e;
      }
      function a(t, e) {
        var s = e.segments,
            i = s.length,
            a = bm_floor((i - 1) * t),
            r = t * e.addedLength,
            n = 0;
        if (r == s[a].l)
          return s[a].p;
        for (var o = s[a].l > r ? -1 : 1,
            h = !0; h; )
          s[a].l <= r && s[a + 1].l > r ? (n = (r - s[a].l) / (s[a + 1].l - s[a].l), h = !1) : a += o, (0 > a || a >= i - 1) && (h = !1);
        return s[a].p + (s[a + 1].p - s[a].p) * n;
      }
      function r() {
        this.pt1 = new Array(2), this.pt2 = new Array(2), this.pt3 = new Array(2), this.pt4 = new Array(2);
      }
      function n(t, e, s, i, n, o, h) {
        var l = new r;
        n = 0 > n ? 0 : n;
        var p = a(n, h);
        o = o > 1 ? 1 : o;
        var m,
            f = a(o, h),
            d = t.length,
            c = 1 - p,
            u = 1 - f;
        for (m = 0; d > m; m += 1)
          l.pt1[m] = c * c * c * t[m] + (p * c * c + c * p * c + c * c * p) * s[m] + (p * p * c + c * p * p + p * c * p) * i[m] + p * p * p * e[m], l.pt3[m] = c * c * u * t[m] + (p * c * u + c * p * u + c * c * f) * s[m] + (p * p * u + c * p * f + p * c * f) * i[m] + p * p * f * e[m], l.pt4[m] = c * u * u * t[m] + (p * u * u + c * f * u + c * u * f) * s[m] + (p * f * u + c * f * f + p * u * f) * i[m] + p * f * f * e[m], l.pt2[m] = u * u * u * t[m] + (f * u * u + u * f * u + u * u * f) * s[m] + (f * f * u + u * f * f + f * u * f) * i[m] + f * f * f * e[m];
        return l;
      }
      var o = (Math, function() {
        function t(t, e) {
          this.l = t, this.p = e;
        }
        var e = {};
        return function(s, i, a, r) {
          var n = (s.join("_") + "_" + i.join("_") + "_" + a.join("_") + "_" + r.join("_")).replace(/\./g, "p");
          if (e[n])
            return e[n];
          var o,
              h,
              l,
              p,
              m,
              f,
              d = defaultCurveSegments,
              c = 0,
              u = [],
              y = [],
              v = {
                addedLength: 0,
                segments: []
              };
          for (l = a.length, o = 0; d > o; o += 1) {
            for (m = o / (d - 1), f = 0, h = 0; l > h; h += 1)
              p = bm_pow(1 - m, 3) * s[h] + 3 * bm_pow(1 - m, 2) * m * a[h] + 3 * (1 - m) * bm_pow(m, 2) * r[h] + bm_pow(m, 3) * i[h], u[h] = p, null !== y[h] && (f += bm_pow(u[h] - y[h], 2)), y[h] = u[h];
            f && (f = bm_sqrt(f), c += f), v.segments.push(new t(c, m));
          }
          return v.addedLength = c, e[n] = v, v;
        };
      }()),
          h = function() {
            var e = {};
            return function(a) {
              var r = a.s,
                  n = a.e,
                  o = a.to,
                  h = a.ti,
                  l = (r.join("_") + "_" + n.join("_") + "_" + o.join("_") + "_" + h.join("_")).replace(/\./g, "p");
              if (e[l])
                return void(a.bezierData = e[l]);
              var p,
                  m,
                  f,
                  d,
                  c,
                  u,
                  y,
                  v = defaultCurveSegments,
                  g = 0,
                  b = null;
              2 === r.length && (r[0] != n[0] || r[1] != n[1]) && t(r[0], r[1], n[0], n[1], r[0] + o[0], r[1] + o[1]) && t(r[0], r[1], n[0], n[1], n[0] + h[0], n[1] + h[1]) && (v = 2);
              var E = new s(v);
              for (f = o.length, p = 0; v > p; p += 1) {
                for (y = new Array(f), c = p / (v - 1), u = 0, m = 0; f > m; m += 1)
                  d = bm_pow(1 - c, 3) * r[m] + 3 * bm_pow(1 - c, 2) * c * (r[m] + o[m]) + 3 * (1 - c) * bm_pow(c, 2) * (n[m] + h[m]) + bm_pow(c, 3) * n[m], y[m] = d, null !== b && (u += bm_pow(y[m] - b[m], 2));
                u = bm_sqrt(u), g += u, E.points[p] = new i(u, y), b = y;
              }
              E.segmentLength = g, a.bezierData = E, e[l] = E;
            };
          }();
      return {
        getBezierLength: o,
        getNewSegment: n,
        buildBezierData: h,
        pointOnLine2D: t,
        pointOnLine3D: e
      };
    }
    function dataFunctionManager() {
      function t(a, n, o) {
        var h,
            l,
            p,
            m,
            f,
            d,
            c,
            u,
            y = a.length;
        for (m = 0; y > m; m += 1)
          if (h = a[m], "ks" in h && !h.completed) {
            if (h.completed = !0, h.tt && (a[m - 1].td = h.tt), l = [], p = -1, h.hasMask) {
              var v = h.masksProperties;
              for (d = v.length, f = 0; d > f; f += 1)
                if (v[f].pt.k.i)
                  i(v[f].pt.k);
                else
                  for (u = v[f].pt.k.length, c = 0; u > c; c += 1)
                    v[f].pt.k[c].s && i(v[f].pt.k[c].s[0]), v[f].pt.k[c].e && i(v[f].pt.k[c].e[0]);
            }
            0 === h.ty ? (h.layers = e(h.refId, n), t(h.layers, n, o)) : 4 === h.ty ? s(h.shapes, !1) : 5 == h.ty && r(h, o);
          }
      }
      function e(t, e) {
        for (var s = 0,
            i = e.length; i > s; ) {
          if (e[s].id === t)
            return JSON.parse(JSON.stringify(e[s].layers));
          s += 1;
        }
      }
      function s(t, e) {
        var a,
            r,
            n,
            o = t.length,
            h = e ? e : !1;
        for (a = o - 1; a >= 0; a -= 1)
          if ("tm" == t[a].ty && (h = !0), "sh" == t[a].ty)
            if (t[a].trimmed = h, t[a].ks.k.i)
              i(t[a].ks.k);
            else
              for (n = t[a].ks.k.length, r = 0; n > r; r += 1)
                t[a].ks.k[r].s && i(t[a].ks.k[r].s[0]), t[a].ks.k[r].e && i(t[a].ks.k[r].e[0]);
          else
            "gr" == t[a].ty ? s(t[a].it, h) : ("el" == t[a].ty || "rc" == t[a].ty) && (t[a].trimmed = h);
      }
      function i(t) {
        var e,
            s = t.i.length;
        for (e = 0; s > e; e += 1)
          t.i[e][0] += t.v[e][0], t.i[e][1] += t.v[e][1], t.o[e][0] += t.v[e][0], t.o[e][1] += t.v[e][1];
      }
      function a(e, s) {
        t(e.layers, e.assets, s);
      }
      function r(t, e) {
        var s,
            i,
            a,
            r,
            n,
            o,
            h,
            l = [],
            p = t.t.d,
            m = 0,
            f = t.t.m.g,
            d = 0,
            c = 0,
            u = 0,
            y = [],
            v = 0,
            g = 0,
            b = e.getFontByName(p.f),
            E = 0,
            P = b.fStyle.split(" "),
            k = "normal",
            S = "normal";
        for (i = P.length, s = 0; i > s; s += 1)
          "italic" === P[s].toLowerCase() ? S = "italic" : "bold" === P[s].toLowerCase() ? k = "700" : "black" === P[s].toLowerCase() ? k = "900" : "medium" === P[s].toLowerCase() ? k = "500" : "regular" === P[s].toLowerCase() || "normal" === P[s].toLowerCase() ? k = "400" : ("light" === P[s].toLowerCase() || "thin" === P[s].toLowerCase()) && (k = "200");
        if (p.fWeight = k, p.fStyle = S, i = p.t.length, p.sz) {
          var C = p.sz[0],
              x = -1;
          for (s = 0; i > s; s += 1)
            a = !1, " " === p.t.charAt(s) ? x = s : 13 === p.t.charCodeAt(s) && (v = 0, a = !0), e.chars ? (h = e.getCharData(p.t.charAt(s), b.fStyle, b.fFamily), E = a ? 0 : h.w * p.s / 100) : E = e.measureText(p.t.charAt(s), p.f, p.s), v + E > C ? (-1 === x ? (p.t = p.t.substr(0, s) + "\r" + p.t.substr(s), i += 1) : (s = x, p.t = p.t.substr(0, s) + "\r" + p.t.substr(s + 1)), x = -1, v = 0) : v += E;
          i = p.t.length;
        }
        for (v = 0, E = 0, s = 0; i > s; s += 1)
          if (a = !1, " " === p.t.charAt(s) ? r = " " : 13 === p.t.charCodeAt(s) ? (y.push(v), g = v > g ? v : g, v = 0, r = "", a = !0, u += 1) : r = p.t.charAt(s), e.chars ? (h = e.getCharData(p.t.charAt(s), b.fStyle, e.getFontByName(p.f).fFamily), E = a ? 0 : h.w * p.s / 100) : E = e.measureText(r, p.f, p.s), v += E, l.push({
            l: E,
            an: E,
            add: d,
            n: a,
            anIndexes: [],
            val: r,
            line: u
          }), 2 == f) {
            if (d += E, "" == r || " " == r || s == i - 1) {
              for (("" == r || " " == r) && (d -= E); s >= c; )
                l[c].an = d, l[c].ind = m, l[c].extra = E, c += 1;
              m += 1, d = 0;
            }
          } else if (3 == f) {
            if (d += E, "" == r || s == i - 1) {
              for ("" == r && (d -= E); s >= c; )
                l[c].an = d, l[c].ind = m, l[c].extra = E, c += 1;
              d = 0, m += 1;
            }
          } else
            l[m].ind = m, l[m].extra = 0, m += 1;
        if (p.l = l, g = v > g ? v : g, y.push(v), p.sz)
          p.boxWidth = p.sz[0], t.t.d.justifyOffset = 0;
        else
          switch (p.boxWidth = g, p.j) {
            case 1:
              t.t.d.justifyOffset = -p.boxWidth;
              break;
            case 2:
              t.t.d.justifyOffset = -p.boxWidth / 2;
              break;
            default:
              t.t.d.justifyOffset = 0;
          }
        p.lineWidths = y;
        var w = t.t.a;
        o = w.length;
        var D,
            T,
            M = [];
        for (n = 0; o > n; n += 1) {
          for (w[n].a.sc && (p.strokeColorAnim = !0), w[n].a.sw && (p.strokeWidthAnim = !0), (w[n].a.fc || w[n].a.fh || w[n].a.fs || w[n].a.fb) && (p.fillColorAnim = !0), T = 0, D = w[n].s.b, s = 0; i > s; s += 1)
            l[s].anIndexes[n] = T, (1 == D && "" != l[s].val || 2 == D && "" != l[s].val && " " != l[s].val || 3 == D && (l[s].n || " " == l[s].val || s == i - 1) || 4 == D && (l[s].n || s == i - 1)) && (1 === w[n].s.rn && M.push(T), T += 1);
          t.t.a[n].s.totalChars = T;
          var I,
              F = -1;
          if (1 === w[n].s.rn)
            for (s = 0; i > s; s += 1)
              F != l[s].anIndexes[n] && (F = l[s].anIndexes[n], I = M.splice(Math.floor(Math.random() * M.length), 1)[0]), l[s].anIndexes[n] = I;
        }
        0 !== o || "m" in t.t.p || (t.singleShape = !0), p.yOffset = 1.2 * p.s, p.ascent = b.ascent * p.s / 100;
      }
      var n = {};
      return n.completeData = a, n;
    }
    function ExpressionComp() {}
    function ShapeInterface() {}
    function LayerInterface() {}
    function SVGRenderer(t) {
      this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.globalData = {frameNum: -1}, this.elements = [], this.destroyed = !1;
    }
    function CanvasRenderer(t, e) {
      this.animationItem = t, this.renderConfig = {
        clearCanvas: e && e.clearCanvas || !0,
        context: e && e.context || null,
        scaleMode: e && e.scaleMode || "fit"
      }, this.renderConfig.dpr = e && e.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = e && e.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {frameNum: -1}, this.contextData = {
        saved: new Array(15),
        savedOp: new Array(15),
        cArrPos: 0,
        cTr: new Matrix,
        cO: 1
      };
      var s,
          i = 15;
      for (s = 0; i > s; s += 1)
        this.contextData.saved[s] = new Array(16);
      this.elements = [], this.transformMat = new Matrix;
    }
    function HybridRenderer(t) {
      this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.globalData = {frameNum: -1}, this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null;
    }
    function MaskElement(t, e, s) {
      this.dynamicProperties = [], this.data = t, this.element = e, this.globalData = s, this.paths = [], this.storedData = [], this.masksProperties = this.data.masksProperties, this.viewData = new Array(this.masksProperties.length), this.maskElement = null, this.firstFrame = !0;
      var i,
          a,
          r,
          n,
          o,
          h,
          l,
          p,
          m = (this.element.maskedElement, this.globalData.defs),
          f = this.masksProperties.length,
          d = this.masksProperties,
          c = 0,
          u = [],
          y = randomString(10),
          v = "clipPath",
          g = "clip-path";
      for (i = 0; f > i; i++)
        if (("a" !== d[i].mode && "n" !== d[i].mode || d[i].inv) && (v = "mask", g = "mask"), "s" != d[i].mode && "i" != d[i].mode || 0 != c || (o = document.createElementNS(svgNS, "rect"), o.setAttribute("fill", "#ffffff"), o.setAttribute("x", "0"), o.setAttribute("y", "0"), o.setAttribute("width", "100%"), o.setAttribute("height", "100%"), u.push(o)), "n" != d[i].mode && d[i].cl !== !1) {
          if (c += 1, a = document.createElementNS(svgNS, "path"), d[i].cl ? "s" == d[i].mode ? a.setAttribute("fill", "#000000") : a.setAttribute("fill", "#ffffff") : (a.setAttribute("fill", "none"), "s" == d[i].mode ? a.setAttribute("fill", "#000000") : a.setAttribute("fill", "#ffffff"), a.setAttribute("stroke-width", "1"), a.setAttribute("stroke-miterlimit", "10")), a.setAttribute("clip-rule", "nonzero"), 0 !== d[i].x.k) {
            v = "mask", g = "mask", p = PropertyFactory.getProp(this.element, d[i].x, 0, null, this.dynamicProperties);
            var b = "fi_" + randomString(10);
            h = document.createElementNS(svgNS, "filter"), h.setAttribute("id", b), l = document.createElementNS(svgNS, "feMorphology"), l.setAttribute("operator", "dilate"), l.setAttribute("in", "SourceGraphic"), l.setAttribute("radius", "0"), h.appendChild(l), m.appendChild(h), "s" == d[i].mode ? a.setAttribute("stroke", "#000000") : a.setAttribute("stroke", "#ffffff");
          } else
            l = null, p = null;
          if (this.storedData[i] = {
            elem: a,
            x: p,
            expan: l,
            lastPath: "",
            lastOperator: "",
            filterId: b,
            lastRadius: 0
          }, "i" == d[i].mode) {
            n = u.length;
            var E = document.createElementNS(svgNS, "g");
            for (r = 0; n > r; r += 1)
              E.appendChild(u[r]);
            var P = document.createElementNS(svgNS, "mask");
            P.setAttribute("mask-type", "alpha"), P.setAttribute("id", y + "_" + c), P.appendChild(a), m.appendChild(P), E.setAttribute("mask", "url(#" + y + "_" + c + ")"), u.length = 0, u.push(E);
          } else
            u.push(a);
          d[i].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[i] = {
            elem: a,
            lastPath: "",
            prop: PropertyFactory.getShapeProp(this.element, d[i], 3, this.dynamicProperties, null)
          }, this.viewData[i].prop.k || this.drawPath(d[i], this.viewData[i].prop.v, this.viewData[i]);
        } else
          this.viewData[i] = {prop: PropertyFactory.getShapeProp(this.element, d[i], 3, this.dynamicProperties, null)};
      for (this.maskElement = document.createElementNS(svgNS, v), f = u.length, i = 0; f > i; i += 1)
        this.maskElement.appendChild(u[i]);
      this.maskElement.setAttribute("id", y), c > 0 && this.element.maskedElement.setAttribute(g, "url(#" + y + ")"), m.appendChild(this.maskElement);
    }
    function SliderEffect(t, e, s) {
      this.p = PropertyFactory.getProp(e, t.v, 0, 0, s);
    }
    function AngleEffect(t, e, s) {
      this.p = PropertyFactory.getProp(e, t.v, 0, 0, s);
    }
    function ColorEffect(t, e, s) {
      this.p = PropertyFactory.getProp(e, t.v, 1, 1 / 255, s);
    }
    function PointEffect(t, e, s) {
      this.p = PropertyFactory.getProp(e, t.v, 1, 0, s);
    }
    function CheckboxEffect(t, e, s) {
      this.p = PropertyFactory.getProp(e, t.v, 1, 0, s);
    }
    function EffectsManager(t, e, s) {
      this.data = t, this.element = e;
      var i = t.ef;
      this.effectElements = [];
      var a,
          r,
          n = i.length;
      for (a = 0; n > a; a++)
        switch (i[a].ty) {
          case 0:
            r = new SliderEffect(i[a], e, s), this.effectElements.push(r.proxyFunction.bind(r));
            break;
          case 1:
            r = new AngleEffect(i[a], e, s), this.effectElements.push(r.proxyFunction.bind(r));
            break;
          case 2:
            r = new ColorEffect(i[a], e, s), this.effectElements.push(r.proxyFunction.bind(r));
            break;
          case 3:
            r = new PointEffect(i[a], e, s), this.effectElements.push(r.proxyFunction.bind(r));
            break;
          case 4:
            r = new CheckboxEffect(i[a], e, s), this.effectElements.push(r.proxyFunction.bind(r));
        }
    }
    function BaseElement() {}
    function SVGBaseElement(t, e, s, i, a) {
      this.globalData = s, this.comp = i, this.data = t, this.matteElement = null, this.parentContainer = e, this.layerId = a ? a.layerId : "ly_" + randomString(10), this.placeholder = a, this.init();
    }
    function ITextElement(t, e, s, i) {}
    function SVGTextElement(t, e, s, i, a) {
      this.textSpans = [], this.renderType = "svg", this.parent.constructor.call(this, t, e, s, i, a);
    }
    function ICompElement(t, e, s, i, a) {
      this.parent.constructor.call(this, t, e, s, i, a), this.layers = t.layers, this.isSvg = !0, this.data.tm && (this.tm = PropertyFactory.getProp(this, this.data.tm, 0, s.frameRate, this.dynamicProperties));
    }
    function IImageElement(t, e, s, i, a) {
      this.assetData = s.getAssetData(t.refId), this.path = s.getPath(), this.parent.constructor.call(this, t, e, s, i, a);
    }
    function IShapeElement(t, e, s, i, a) {
      this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.viewData = [], this.shapesContainer = document.createElementNS(svgNS, "g"), this.parent.constructor.call(this, t, e, s, i, a);
    }
    function ISolidElement(t, e, s, i, a) {
      this.parent.constructor.call(this, t, e, s, i, a);
    }
    function CVBaseElement(t, e, s) {
      this.globalData = s, this.data = t, this.comp = e, this.canvasContext = s.canvasContext, this.init();
    }
    function CVCompElement(t, e, s) {
      this.parent.constructor.call(this, t, e, s), this.layers = t.layers, this.data.tm && (this.tm = PropertyFactory.getProp(this, this.data.tm, 0, s.frameRate, this.dynamicProperties));
    }
    function CVImageElement(t, e, s) {
      this.animationItem = s.renderer.animationItem, this.assetData = this.animationItem.getAssetData(t.refId), this.path = this.animationItem.getPath(), this.parent.constructor.call(this, t, e, s), this.animationItem.pendingElements += 1;
    }
    function CVMaskElement(t, e, s) {
      this.data = t, this.element = e, this.globalData = s, this.dynamicProperties = [], this.masksProperties = this.data.masksProperties, this.ctx = this.element.canvasContext, this.viewData = new Array(this.masksProperties.length);
      var i,
          a = this.masksProperties.length;
      for (i = 0; a > i; i++)
        this.viewData[i] = PropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3, this.dynamicProperties, null);
    }
    function CVShapeElement(t, e, s) {
      this.shapes = [], this.stylesList = [], this.viewData = [], this.shapesData = t.shapes, this.firstFrame = !0, this.parent.constructor.call(this, t, e, s);
    }
    function CVSolidElement(t, e, s) {
      this.parent.constructor.call(this, t, e, s);
    }
    function CVTextElement(t, e, s) {
      this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
        fill: "rgba(0,0,0,0)",
        stroke: "rgba(0,0,0,0)",
        sWidth: 0,
        fValue: ""
      }, this.parent.constructor.call(this, t, e, s);
    }
    function HBaseElement(t, e, s, i, a) {
      this.globalData = s, this.comp = i, this.data = t, this.matteElement = null, this.parentContainer = e, this.layerId = a ? a.layerId : "ly_" + randomString(10), this.placeholder = a, this.init();
    }
    function HSolidElement(t, e, s, i, a) {
      this.parent.constructor.call(this, t, e, s, i, a);
    }
    function HCompElement(t, e, s, i, a) {
      this.parent.constructor.call(this, t, e, s, i, a), this.layers = t.layers, this.isSvg = !1, this.data.tm && (this.tm = PropertyFactory.getProp(this, this.data.tm, 0, s.frameRate, this.dynamicProperties)), this.data.hasMask && (this.isSvg = !0);
    }
    function HShapeElement(t, e, s, i, a) {
      this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.viewData = [], this.parent.constructor.call(this, t, e, s, i, a);
    }
    function HTextElement(t, e, s, i, a) {
      this.textSpans = [], this.textPaths = [], this.currentBBox = {
        x: 999999,
        y: -999999,
        h: 0,
        w: 0
      }, this.renderType = "svg", this.isMasked = !1, this.parent.constructor.call(this, t, e, s, i, a);
    }
    function HImageElement(t, e, s, i, a) {
      this.assetData = s.getAssetData(t.refId), this.path = s.getPath(), this.parent.constructor.call(this, t, e, s, i, a);
    }
    function HCameraElement(t, e, s, i, a) {
      if (this.parent.constructor.call(this, t, e, s, i, a), this.pe = PropertyFactory.getProp(this, t.pe, 0, 0, this.dynamicProperties), t.ks.p.s ? (this.px = PropertyFactory.getProp(this, t.ks.p.x, 1, 0, this.dynamicProperties), this.py = PropertyFactory.getProp(this, t.ks.p.y, 1, 0, this.dynamicProperties), this.pz = PropertyFactory.getProp(this, t.ks.p.z, 1, 0, this.dynamicProperties)) : this.p = PropertyFactory.getProp(this, t.ks.p, 1, 0, this.dynamicProperties), t.ks.a && (this.a = PropertyFactory.getProp(this, t.ks.a, 1, 0, this.dynamicProperties)), t.ks.or.k.length) {
        var r,
            n = t.ks.or.k.length;
        for (r = 0; n > r; r += 1)
          t.ks.or.k[r].to = null, t.ks.or.k[r].ti = null;
      }
      this.or = PropertyFactory.getProp(this, t.ks.or, 1, degToRads, this.dynamicProperties), this.or.sh = !0, this.rx = PropertyFactory.getProp(this, t.ks.rx, 0, degToRads, this.dynamicProperties), this.ry = PropertyFactory.getProp(this, t.ks.ry, 0, degToRads, this.dynamicProperties), this.rz = PropertyFactory.getProp(this, t.ks.rz, 0, degToRads, this.dynamicProperties), this.mat = new Matrix;
    }
    var svgNS = "http://www.w3.org/2000/svg",
        subframeEnabled = !0,
        isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
        cachedColors = {},
        bm_rounder = Math.round,
        bm_rnd,
        bm_pow = Math.pow,
        bm_sqrt = Math.sqrt,
        bm_abs = Math.abs,
        bm_floor = Math.floor,
        bm_max = Math.max,
        bm_min = Math.min,
        BMMath = {
          pow: bm_pow,
          random: Math.random
        },
        defaultCurveSegments = 75,
        degToRads = Math.PI / 180;
    roundValues(!1);
    var rgbToHex = function() {
      var t,
          e,
          s = [];
      for (t = 0; 256 > t; t += 1)
        e = t.toString(16), s[t] = 1 == e.length ? "0" + e : e;
      return function(t, e, i) {
        return 0 > t && (t = 0), 0 > e && (e = 0), 0 > i && (i = 0), "#" + s[t] + s[e] + s[i];
      };
    }(),
        fillColorToString = function() {
          var t = [];
          return function(e, s) {
            return void 0 !== s && (e[3] = s), t[e[0]] || (t[e[0]] = {}), t[e[0]][e[1]] || (t[e[0]][e[1]] = {}), t[e[0]][e[1]][e[2]] || (t[e[0]][e[1]][e[2]] = {}), t[e[0]][e[1]][e[2]][e[3]] || (t[e[0]][e[1]][e[2]][e[3]] = "rgba(" + e.join(",") + ")"), t[e[0]][e[1]][e[2]][e[3]];
          };
        }(),
        Matrix = function() {
          function t() {
            return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
          }
          function e(t) {
            if (0 === t)
              return this;
            var e = Math.cos(t),
                s = Math.sin(t);
            return this._t(e, -s, 0, 0, s, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
          }
          function s(t) {
            if (0 === t)
              return this;
            var e = Math.cos(t),
                s = Math.sin(t);
            return this._t(1, 0, 0, 0, 0, e, -s, 0, 0, s, e, 0, 0, 0, 0, 1);
          }
          function i(t) {
            if (0 === t)
              return this;
            var e = Math.cos(t),
                s = Math.sin(t);
            return this._t(e, 0, s, 0, 0, 1, 0, 0, -s, 0, e, 0, 0, 0, 0, 1);
          }
          function a(t) {
            if (0 === t)
              return this;
            var e = Math.cos(t),
                s = Math.sin(t);
            return this._t(e, -s, 0, 0, s, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
          }
          function r(t, e) {
            return this._t(1, e, t, 1, 0, 0);
          }
          function n(t, e) {
            return this.shear(Math.tan(t), Math.tan(e));
          }
          function o(t, e) {
            var s = Math.cos(e),
                i = Math.sin(e);
            return this._t(s, i, 0, 0, -i, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, Math.tan(t), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(s, -i, 0, 0, i, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
          }
          function h(t, e, s) {
            return s = isNaN(s) ? 1 : s, 1 == t && 1 == e && 1 == s ? this : this._t(t, 0, 0, 0, 0, e, 0, 0, 0, 0, s, 0, 0, 0, 0, 1);
          }
          function l(t, e, s, i, a, r, n, o, h, l, p, m, f, d, c, u) {
            return this.props[0] = t, this.props[1] = e, this.props[2] = s, this.props[3] = i, this.props[4] = a, this.props[5] = r, this.props[6] = n, this.props[7] = o, this.props[8] = h, this.props[9] = l, this.props[10] = p, this.props[11] = m, this.props[12] = f, this.props[13] = d, this.props[14] = c, this.props[15] = u, this;
          }
          function p(t, e, s) {
            return s = isNaN(s) ? 0 : s, 0 !== t || 0 !== e || 0 !== s ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t, e, s, 1) : this;
          }
          function m(t, e, s, i, a, r, n, o, h, l, p, m, f, d, c, u) {
            if (1 === t && 0 === e && 0 === s && 0 === i && 0 === a && 1 === r && 0 === n && 0 === o && 0 === h && 0 === l && 1 === p && 0 === m)
              return (0 !== f || 0 !== d || 0 !== c) && (this.props[12] = this.props[12] * t + this.props[13] * a + this.props[14] * h + this.props[15] * f, this.props[13] = this.props[12] * e + this.props[13] * r + this.props[14] * l + this.props[15] * d, this.props[14] = this.props[12] * s + this.props[13] * n + this.props[14] * p + this.props[15] * c, this.props[15] = this.props[12] * i + this.props[13] * o + this.props[14] * m + this.props[15] * u), this;
            var y = this.props[0],
                v = this.props[1],
                g = this.props[2],
                b = this.props[3],
                E = this.props[4],
                P = this.props[5],
                k = this.props[6],
                S = this.props[7],
                C = this.props[8],
                x = this.props[9],
                w = this.props[10],
                D = this.props[11],
                T = this.props[12],
                M = this.props[13],
                I = this.props[14],
                F = this.props[15];
            return this.props[0] = y * t + v * a + g * h + b * f, this.props[1] = y * e + v * r + g * l + b * d, this.props[2] = y * s + v * n + g * p + b * c, this.props[3] = y * i + v * o + g * m + b * u, this.props[4] = E * t + P * a + k * h + S * f, this.props[5] = E * e + P * r + k * l + S * d, this.props[6] = E * s + P * n + k * p + S * c, this.props[7] = E * i + P * o + k * m + S * u, this.props[8] = C * t + x * a + w * h + D * f, this.props[9] = C * e + x * r + w * l + D * d, this.props[10] = C * s + x * n + w * p + D * c, this.props[11] = C * i + x * o + w * m + D * u, this.props[12] = T * t + M * a + I * h + F * f, this.props[13] = T * e + M * r + I * l + F * d, this.props[14] = T * s + M * n + I * p + F * c, this.props[15] = T * i + M * o + I * m + F * u, this;
          }
          function f(t) {
            var e;
            for (e = 0; 16 > e; e += 1)
              t.props[e] = this.props[e];
          }
          function d(t) {
            var e;
            for (e = 0; 16 > e; e += 1)
              this.props[e] = t[e];
          }
          function c(t, e, s) {
            return {
              x: t * this.props[0] + e * this.props[4] + s * this.props[8] + this.props[12],
              y: t * this.props[1] + e * this.props[5] + s * this.props[9] + this.props[13],
              z: t * this.props[2] + e * this.props[6] + s * this.props[10] + this.props[14]
            };
          }
          function u(t, e, s) {
            return t * this.props[0] + e * this.props[4] + s * this.props[8] + this.props[12];
          }
          function y(t, e, s) {
            return t * this.props[1] + e * this.props[5] + s * this.props[9] + this.props[13];
          }
          function v(t, e, s) {
            return t * this.props[2] + e * this.props[6] + s * this.props[10] + this.props[14];
          }
          function g(t, e, s) {
            return [t * this.props[0] + e * this.props[4] + s * this.props[8] + this.props[12], t * this.props[1] + e * this.props[5] + s * this.props[9] + this.props[13], t * this.props[2] + e * this.props[6] + s * this.props[10] + this.props[14]];
          }
          function b(t, e) {
            return bm_rnd(t * this.props[0] + e * this.props[4] + this.props[12]) + "," + bm_rnd(t * this.props[1] + e * this.props[5] + this.props[13]);
          }
          function E() {
            return [this.props[0], this.props[1], this.props[2], this.props[3], this.props[4], this.props[5], this.props[6], this.props[7], this.props[8], this.props[9], this.props[10], this.props[11], this.props[12], this.props[13], this.props[14], this.props[15]];
          }
          function P() {
            return isSafari ? "matrix3d(" + roundTo2Decimals(this.props[0]) + "," + roundTo2Decimals(this.props[1]) + "," + roundTo2Decimals(this.props[2]) + "," + roundTo2Decimals(this.props[3]) + "," + roundTo2Decimals(this.props[4]) + "," + roundTo2Decimals(this.props[5]) + "," + roundTo2Decimals(this.props[6]) + "," + roundTo2Decimals(this.props[7]) + "," + roundTo2Decimals(this.props[8]) + "," + roundTo2Decimals(this.props[9]) + "," + roundTo2Decimals(this.props[10]) + "," + roundTo2Decimals(this.props[11]) + "," + roundTo2Decimals(this.props[12]) + "," + roundTo2Decimals(this.props[13]) + "," + roundTo2Decimals(this.props[14]) + "," + roundTo2Decimals(this.props[15]) + ")" : (this.cssParts[1] = this.props.join(","), this.cssParts.join(""));
          }
          function k() {
            return "matrix(" + this.props[0] + "," + this.props[1] + "," + this.props[4] + "," + this.props[5] + "," + this.props[12] + "," + this.props[13] + ")";
          }
          function S() {
            return "" + this.toArray();
          }
          return function() {
            this.reset = t, this.rotate = e, this.rotateX = s, this.rotateY = i, this.rotateZ = a, this.skew = n, this.skewFromAxis = o, this.shear = r, this.scale = h, this.setTransform = l, this.translate = p, this.transform = m, this.applyToPoint = c, this.applyToX = u, this.applyToY = y, this.applyToZ = v, this.applyToPointArray = g, this.applyToPointStringified = b, this.toArray = E, this.toCSS = P, this.to2dCSS = k, this.toString = S, this.clone = f, this.cloneFromProps = d, this._t = this.transform, this.props = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1], this.cssParts = ["matrix3d(", "", ")"];
          };
        }();
    !function(t, e) {
      function s(s, l, p) {
        var d = [];
        l = 1 == l ? {entropy: !0} : l || {};
        var g = n(r(l.entropy ? [s, h(t)] : null == s ? o() : s, 3), d),
            b = new i(d),
            E = function() {
              for (var t = b.g(f),
                  e = u,
                  s = 0; y > t; )
                t = (t + s) * m, e *= m, s = b.g(1);
              for (; t >= v; )
                t /= 2, e /= 2, s >>>= 1;
              return (t + s) / e;
            };
        return E.int32 = function() {
          return 0 | b.g(4);
        }, E.quick = function() {
          return b.g(4) / 4294967296;
        }, E["double"] = E, n(h(b.S), t), (l.pass || p || function(t, s, i, r) {
          return r && (r.S && a(r, b), t.state = function() {
            return a(b, {});
          }), i ? (e[c] = t, s) : t;
        })(E, g, "global" in l ? l.global : this == e, l.state);
      }
      function i(t) {
        var e,
            s = t.length,
            i = this,
            a = 0,
            r = i.i = i.j = 0,
            n = i.S = [];
        for (s || (t = [s++]); m > a; )
          n[a] = a++;
        for (a = 0; m > a; a++)
          n[a] = n[r = g & r + t[a % s] + (e = n[a])], n[r] = e;
        (i.g = function(t) {
          for (var e,
              s = 0,
              a = i.i,
              r = i.j,
              n = i.S; t--; )
            e = n[a = g & a + 1], s = s * m + n[g & (n[a] = n[r = g & r + e]) + (n[r] = e)];
          return i.i = a, i.j = r, s;
        })(m);
      }
      function a(t, e) {
        return e.i = t.i, e.j = t.j, e.S = t.S.slice(), e;
      }
      function r(t, e) {
        var s,
            i = [],
            a = typeof t;
        if (e && "object" == a)
          for (s in t)
            try {
              i.push(r(t[s], e - 1));
            } catch (n) {}
        return i.length ? i : "string" == a ? t : t + "\x00";
      }
      function n(t, e) {
        for (var s,
            i = t + "",
            a = 0; a < i.length; )
          e[g & a] = g & (s ^= 19 * e[g & a]) + i.charCodeAt(a++);
        return h(e);
      }
      function o() {
        try {
          if (l)
            return h(l.randomBytes(m));
          var e = new Uint8Array(m);
          return (p.crypto || p.msCrypto).getRandomValues(e), h(e);
        } catch (s) {
          var i = p.navigator,
              a = i && i.plugins;
          return [+new Date, p, a, p.screen, h(t)];
        }
      }
      function h(t) {
        return String.fromCharCode.apply(0, t);
      }
      var l,
          p = this,
          m = 256,
          f = 6,
          d = 52,
          c = "random",
          u = e.pow(m, f),
          y = e.pow(2, d),
          v = 2 * y,
          g = m - 1;
      e["seed" + c] = s, n(e.random(), t);
    }([], BMMath);
    var BezierFactory = function() {
      function t(t, e, s, i, a) {
        var r = a || ("bez_" + t + "_" + e + "_" + s + "_" + i).replace(/\./g, "p");
        if (p[r])
          return p[r];
        var n = new h([t, e, s, i]);
        return p[r] = n, n;
      }
      function e(t, e) {
        return 1 - 3 * e + 3 * t;
      }
      function s(t, e) {
        return 3 * e - 6 * t;
      }
      function i(t) {
        return 3 * t;
      }
      function a(t, a, r) {
        return ((e(a, r) * t + s(a, r)) * t + i(a)) * t;
      }
      function r(t, a, r) {
        return 3 * e(a, r) * t * t + 2 * s(a, r) * t + i(a);
      }
      function n(t, e, s, i, r) {
        var n,
            o,
            h = 0;
        do
          o = e + (s - e) / 2, n = a(o, i, r) - t, n > 0 ? s = o : e = o;
 while (Math.abs(n) > d && ++h < c);
        return o;
      }
      function o(t, e, s, i) {
        for (var n = 0; m > n; ++n) {
          var o = r(e, s, i);
          if (0 === o)
            return e;
          var h = a(e, s, i) - t;
          e -= h / o;
        }
        return e;
      }
      function h(t) {
        this._p = t, this._mSampleValues = v ? new Float32Array(u) : new Array(u), this._precomputed = !1, this.get = this.get.bind(this);
      }
      var l = {};
      l.getBezierEasing = t;
      var p = {},
          m = 4,
          f = .001,
          d = 1e-7,
          c = 10,
          u = 11,
          y = 1 / (u - 1),
          v = "function" == typeof Float32Array;
      return h.prototype = {
        get: function(t) {
          var e = this._p[0],
              s = this._p[1],
              i = this._p[2],
              r = this._p[3];
          return this._precomputed || this._precompute(), e === s && i === r ? t : 0 === t ? 0 : 1 === t ? 1 : a(this._getTForX(t), s, r);
        },
        _precompute: function() {
          var t = this._p[0],
              e = this._p[1],
              s = this._p[2],
              i = this._p[3];
          this._precomputed = !0, (t !== e || s !== i) && this._calcSampleValues();
        },
        _calcSampleValues: function() {
          for (var t = this._p[0],
              e = this._p[2],
              s = 0; u > s; ++s)
            this._mSampleValues[s] = a(s * y, t, e);
        },
        _getTForX: function(t) {
          for (var e = this._p[0],
              s = this._p[2],
              i = this._mSampleValues,
              a = 0,
              h = 1,
              l = u - 1; h !== l && i[h] <= t; ++h)
            a += y;
          --h;
          var p = (t - i[h]) / (i[h + 1] - i[h]),
              m = a + p * y,
              d = r(m, e, s);
          return d >= f ? o(t, m, e, s) : 0 === d ? m : n(t, a, a + y, e, s);
        }
      }, l;
    }(),
        MatrixManager = matrixManagerFunction;
    !function() {
      for (var t = 0,
          e = ["ms", "moz", "webkit", "o"],
          s = 0; s < e.length && !window.requestAnimationFrame; ++s)
        window.requestAnimationFrame = window[e[s] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[e[s] + "CancelAnimationFrame"] || window[e[s] + "CancelRequestAnimationFrame"];
      window.requestAnimationFrame || (window.requestAnimationFrame = function(e, s) {
        var i = (new Date).getTime(),
            a = Math.max(0, 16 - (i - t)),
            r = window.setTimeout(function() {
              e(i + a);
            }, a);
        return t = i + a, r;
      }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function(t) {
        clearTimeout(t);
      });
    }();
    var bez = bezFunction(),
        dataManager = dataFunctionManager(),
        FontManager = function() {
          function t(t, e) {
            var s = document.createElement("span");
            s.style.fontFamily = e;
            var i = document.createElement("span");
            i.innerHTML = "giItT1WQy@!-/#", s.style.position = "absolute", s.style.left = "-10000px", s.style.top = "-10000px", s.style.fontSize = "300px", s.style.fontVariant = "normal", s.style.fontStyle = "normal", s.style.fontWeight = "normal", s.style.letterSpacing = "0", s.appendChild(i), document.body.appendChild(s);
            var a = i.offsetWidth;
            return i.style.fontFamily = t + ", " + e, {
              node: i,
              w: a,
              parent: s
            };
          }
          function e() {
            var t,
                s,
                i,
                a = this.fonts.length,
                r = a;
            for (t = 0; a > t; t += 1)
              if (this.fonts[t].loaded)
                r -= 1;
              else if ("t" === this.fonts[t].fOrigin) {
                if (window.Typekit && window.Typekit.load && 0 === this.typekitLoaded) {
                  this.typekitLoaded = 1;
                  try {
                    Typekit.load({
                      async: !0,
                      active: function() {
                        this.typekitLoaded = 2;
                      }.bind(this)
                    });
                  } catch (n) {}
                }
                2 === this.typekitLoaded && (this.fonts[t].loaded = !0);
              } else
                "n" === this.fonts[t].fOrigin ? this.fonts[t].loaded = !0 : (s = this.fonts[t].monoCase.node, i = this.fonts[t].monoCase.w, s.offsetWidth !== i ? (r -= 1, this.fonts[t].loaded = !0) : (s = this.fonts[t].sansCase.node, i = this.fonts[t].sansCase.w, s.offsetWidth !== i && (r -= 1, this.fonts[t].loaded = !0)), this.fonts[t].loaded && (this.fonts[t].sansCase.parent.parentNode.removeChild(this.fonts[t].sansCase.parent), this.fonts[t].monoCase.parent.parentNode.removeChild(this.fonts[t].monoCase.parent)));
            0 !== r && Date.now() - this.initTime < h ? setTimeout(e.bind(this), 20) : setTimeout(function() {
              this.loaded = !0;
            }.bind(this), 0);
          }
          function s(t, e) {
            var s = document.createElementNS(svgNS, "text");
            s.style.fontSize = "100px", s.style.fontFamily = e.fFamily, s.textContent = "1", e.fClass ? (s.style.fontFamily = "inherit", s.className = e.fClass) : s.style.fontFamily = e.fFamily, t.appendChild(s);
            var i = document.createElement("canvas").getContext("2d");
            return i.font = "100px " + e.fFamily, i;
          }
          function i(i, a) {
            if (!i)
              return void(this.loaded = !0);
            if (this.chars)
              return this.loaded = !0, void(this.fonts = i.list);
            var r,
                n = i.list,
                o = n.length;
            for (r = 0; o > r; r += 1) {
              if (n[r].loaded = !1, n[r].monoCase = t(n[r].fFamily, "monospace"), n[r].sansCase = t(n[r].fFamily, "sans-serif"), n[r].fPath) {
                if ("p" === n[r].fOrigin) {
                  var h = document.createElement("style");
                  h.type = "text/css", h.innerHTML = "@font-face {font-family: " + n[r].fFamily + "; font-style: normal; src: url('" + n[r].fPath + "');}", a.appendChild(h);
                } else if ("g" === n[r].fOrigin) {
                  var l = document.createElement("link");
                  l.type = "text/css", l.rel = "stylesheet", l.href = n[r].fPath, a.appendChild(l);
                } else if ("t" === n[r].fOrigin) {
                  var p = document.createElement("script");
                  p.setAttribute("src", n[r].fPath), a.appendChild(p);
                }
              } else
                n[r].loaded = !0;
              n[r].helper = s(a, n[r]), this.fonts.push(n[r]);
            }
            e.bind(this)();
          }
          function a(t) {
            if (t) {
              this.chars || (this.chars = []);
              var e,
                  s,
                  i,
                  a = t.length,
                  r = this.chars.length;
              for (e = 0; a > e; e += 1) {
                for (s = 0, i = !1; r > s; )
                  this.chars[s].style === t[e].style && this.chars[s].fFamily === t[e].fFamily && this.chars[s].ch === t[e].ch && (i = !0), s += 1;
                i || (this.chars.push(t[e]), r += 1);
              }
            }
          }
          function r(t, e, s) {
            for (var i = 0,
                a = this.chars.length; a > i; ) {
              if (this.chars[i].ch === t && this.chars[i].style === e && this.chars[i].fFamily === s)
                return this.chars[i];
              i += 1;
            }
          }
          function n(t, e, s) {
            var i = this.getFontByName(e),
                a = i.helper;
            return a.measureText(t).width * s / 100;
          }
          function o(t) {
            for (var e = 0,
                s = this.fonts.length; s > e; ) {
              if (this.fonts[e].fName === t)
                return this.fonts[e];
              e += 1;
            }
            return "sans-serif";
          }
          var h = 5e3,
              l = function() {
                this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.loaded = !1, this.initTime = Date.now();
              };
          return l.prototype.addChars = a, l.prototype.addFonts = i, l.prototype.getCharData = r, l.prototype.getFontByName = o, l.prototype.measureText = n, l;
        }(),
        ExpressionManager = function() {
          function sum(t, e) {
            var s = typeof t,
                i = typeof e;
            if (!("number" !== s && "boolean" !== s || "number" !== i && "boolean" !== i))
              return t + e;
            if ("object" === s && ("number" === i || "boolean" === i))
              return t[0] = t[0] + e, t;
            if (("number" === s || "boolean" === s) && "object" === i)
              return e[0] = t + e[0], e;
            if ("object" === s && "object" === i) {
              for (var a = 0,
                  r = t.length,
                  n = e.length,
                  o = []; r > a || n > a; )
                o[a] = "number" == typeof t[a] && "number" == typeof e[a] ? t[a] + e[a] : t[a] || e[a], a += 1;
              return o;
            }
            return 0;
          }
          function sub(t, e) {
            var s = typeof t,
                i = typeof e;
            if (!("number" !== s && "boolean" !== s || "number" !== i && "boolean" !== i))
              return t - e;
            if ("object" === s && ("number" === i || "boolean" === i))
              return t[0] = t[0] - e, t;
            if (("number" === s || "boolean" === s) && "object" === i)
              return e[0] = t - e[0], e;
            if ("object" === s && "object" === i) {
              for (var a = 0,
                  r = t.length,
                  n = e.length,
                  o = []; r > a || n > a; )
                o[a] = "number" == typeof t[a] && "number" == typeof e[a] ? t[a] - e[a] : t[a] || e[a], a += 1;
              return o;
            }
            return 0;
          }
          function mul(t, e) {
            var s = typeof t,
                i = typeof e;
            if (!("number" !== s && "boolean" !== s || "number" !== i && "boolean" !== i))
              return t * e;
            var a,
                r;
            if ("object" === s && ("number" === i || "boolean" === i)) {
              for (r = t.length, arr = Array.apply(null, {length: r}), a = 0; r > a; a += 1)
                arr[a] = t[a] * e;
              return arr;
            }
            if (("number" === s || "boolean" === s) && "object" === i) {
              for (r = e.length, arr = Array.apply(null, {length: r}), a = 0; r > a; a += 1)
                arr[a] = t * e[a];
              return arr;
            }
            return 0;
          }
          function div(t, e) {
            var s = typeof t,
                i = typeof e;
            if (!("number" !== s && "boolean" !== s || "number" !== i && "boolean" !== i))
              return t / e;
            var a,
                r;
            if ("object" === s && ("number" === i || "boolean" === i)) {
              for (r = t.length, arr = Array.apply(null, {length: r}), a = 0; r > a; a += 1)
                arr[a] = t[a] / e;
              return arr;
            }
            if (("number" === s || "boolean" === s) && "object" === i) {
              for (r = e.length, arr = Array.apply(null, {length: r}), a = 0; r > a; a += 1)
                arr[a] = t / e[a];
              return arr;
            }
            return 0;
          }
          function clamp(t, e, s) {
            if (e > s) {
              var i = s;
              s = e, e = i;
            }
            return Math.min(Math.max(t, e), s);
          }
          function radiansToDegrees(t) {
            return t / degToRads;
          }
          function length(t, e) {
            var s,
                i = t.length,
                a = 0;
            for (s = 0; i > s; s += 1)
              a += Math.pow(e[s] - t[s], 2);
            return Math.sqrt(a);
          }
          function linear(t, e, s, i, a) {
            if (e >= t)
              return i;
            if (t >= s)
              return a;
            var r = t / (s - e);
            if (!i.length)
              return i + (a - i) * r;
            var n,
                o = i.length,
                h = Array.apply(null, {length: o});
            for (n = 0; o > n; n += 1)
              h[n] = i[n] + (a[n] - i[n]) * r;
            return h;
          }
          function seedRandom(t) {
            BMMath.seedrandom(t);
          }
          function random(t, e) {
            if (void 0 === e && (void 0 === t ? (t = 0, e = 1) : (e = t, t = void 0)), e.length) {
              var s,
                  i = e.length;
              t || (t = Array.apply(null, {length: i}));
              var a = Array.apply(null, {length: i}),
                  r = BMMath.random();
              for (s = 0; i > s; s += 1)
                a[s] = t[s] + r * (e[s] - t[s]);
              return a;
            }
            void 0 === t && (t = 0);
            var n = BMMath.random();
            return t + n * (e - t);
          }
          function initiateExpression(elem, data) {
            function effect(t) {
              return elem.effectsManager.getEffect(t);
            }
            function nearestKey(t) {
              var e,
                  s,
                  i = data.k.length;
              if (data.k.length && "number" != typeof data.k[0])
                for (e = 0; i > e; e += 1) {
                  if (t === data.k[e].t) {
                    s = e + 1;
                    break;
                  }
                  if (t < data.k[e].t) {
                    s = e + 1;
                    break;
                  }
                  if (t > data.k[e].t && e === i - 1) {
                    s = i;
                    break;
                  }
                }
              else
                s = 0;
              var a = {};
              return a.index = s, a;
            }
            function key(t) {
              if (!data.k.length || "number" == typeof data.k[0])
                return {time: 0};
              t -= 1;
              var e,
                  s = {time: data.k[t].t / thisComp.globalData.frameRate};
              e = t === data.k.length - 1 ? data.k[t - 1].e : data.k[t].s;
              var i,
                  a = e.length;
              for (i = 0; a > i; i += 1)
                s[i] = e[i];
              return s;
            }
            function hasParentGetter() {}
            function execute() {
              seedRandom(0), "textSelector" === this.type && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), transform || (transform = elem.transform), !content && elem.content && (content = elem.content.bind(elem)), this.getPreValue && this.getPreValue(), value = this.pv, time = this.comp.renderedFrame / this.comp.globalData.frameRate, bindedFn();
              var t,
                  e;
              if (this.mult)
                if ("number" == typeof this.v)
                  this.v *= this.mult;
                else
                  for (e = this.v.length, value === this.v && (this.v = 2 === e ? [value[0], value[1]] : [value[0], value[1], value[2]]), t = 0; e > t; t += 1)
                    this.v[t] *= this.mult;
              if ("number" == typeof this.v)
                this.lastValue !== this.v && (this.lastValue = this.v, this.mdf = !0);
              else if (this.v.i)
                this.mdf = !0;
              else
                for (e = this.v.length, t = 0; e > t; t += 1)
                  this.v[t] !== this.lastValue[t] && (this.lastValue[t] = this.v[t], this.mdf = !0);
            }
            var val = data.x,
                transform,
                content,
                effect,
                thisComp = elem.comp;
            elem.comp.frameDuration = 1 / thisComp.globalData.frameRate;
            var inPoint = elem.data.ip / thisComp.globalData.frameRate,
                outPoint = elem.data.op / thisComp.globalData.frameRate,
                thisLayer = elem,
                fnStr = "var fn = function(){" + val + ";this.v = $bm_rt;}";
            eval(fnStr);
            var bindedFn = fn.bind(this),
                numKeys = data.k ? data.k.length : 0,
                wiggle = function(t, e) {
                  var s,
                      i,
                      a = this.pv.length ? this.pv.length : 1,
                      r = Array.apply(null, {len: a});
                  for (i = 0; a > i; i += 1)
                    r[i] = 0;
                  t = 5;
                  var n = Math.floor(time * t);
                  for (s = 0, i = 0; n > s; ) {
                    for (i = 0; a > i; i += 1)
                      r[i] += -e + 2 * e * BMMath.random();
                    s += 1;
                  }
                  var o = time * t,
                      h = o - Math.floor(o),
                      l = Array.apply({length: a});
                  for (i = 0; a > i; i += 1)
                    l[i] = this.pv[i] + r[i] + (-e + 2 * e * BMMath.random()) * h;
                  return l;
                }.bind(this),
                loopIn = function(t, e, s) {
                  if (!this.k)
                    return this.pv;
                  var i = time * thisComp.globalData.frameRate,
                      a = this.keyframes,
                      r = a[0].t;
                  if (i >= r)
                    return this.pv;
                  var n,
                      o;
                  s ? (n = e ? Math.abs(thisComp.globalData.frameRate * e) : Math.max(0, this.elem.data.op - r), o = r + n) : ((!e || e > a.length - 1) && (e = a.length - 1), o = a[e].t, n = o - r);
                  var h,
                      l,
                      p;
                  if ("pingpong" === t) {
                    var m = Math.floor((r - i) / n);
                    if (m % 2 === 0)
                      return this.getValueAtTime((r - i) % n + r);
                  } else {
                    if ("offset" === t) {
                      var f = this.getValueAtTime(r),
                          d = this.getValueAtTime(o),
                          c = this.getValueAtTime(n - (r - i) % n + r),
                          u = Math.floor((r - i) / n) + 1;
                      if (this.pv.length) {
                        for (p = new Array(f.length), l = p.length, h = 0; l > h; h += 1)
                          p[h] = c[h] - (d[h] - f[h]) * u;
                        return p;
                      }
                      return c - (d - f) * u;
                    }
                    if ("continue" === t) {
                      var y = this.getValueAtTime(r),
                          v = this.getValueAtTime(r + .001);
                      if (this.pv.length) {
                        for (p = new Array(y.length), l = p.length, h = 0; l > h; h += 1)
                          p[h] = y[h] + (y[h] - v[h]) * (r - i) / 5e-4;
                        return p;
                      }
                      return y + (y - v) * (r - i) / 5e-4;
                    }
                  }
                  return this.getValueAtTime(n - (r - i) % n + r);
                }.bind(this),
                loopInDuration = function(t, e) {
                  return loopIn(t, e, !0);
                }.bind(this),
                loopOut = function(t, e, s) {
                  if (!this.k)
                    return this.pv;
                  var i = time * thisComp.globalData.frameRate,
                      a = this.keyframes,
                      r = a[a.length - 1].t;
                  if (r >= i)
                    return this.pv;
                  var n,
                      o;
                  s ? (n = e ? Math.abs(r - thisComp.globalData.frameRate * e) : Math.max(0, r - this.elem.data.ip), o = r - n) : ((!e || e > a.length - 1) && (e = a.length - 1), o = a[a.length - 1 - e].t, n = r - o);
                  var h,
                      l,
                      p;
                  if ("pingpong" === t) {
                    var m = Math.floor((i - o) / n);
                    if (m % 2 !== 0)
                      return this.getValueAtTime(n - (i - o) % n + o);
                  } else {
                    if ("offset" === t) {
                      var f = this.getValueAtTime(o),
                          d = this.getValueAtTime(r),
                          c = this.getValueAtTime((i - o) % n + o),
                          u = Math.floor((i - o) / n);
                      if (this.pv.length) {
                        for (p = new Array(f.length), l = p.length, h = 0; l > h; h += 1)
                          p[h] = (d[h] - f[h]) * u + c[h];
                        return p;
                      }
                      return (d - f) * u + c;
                    }
                    if ("continue" === t) {
                      var y = this.getValueAtTime(r),
                          v = this.getValueAtTime(r - .001);
                      if (this.pv.length) {
                        for (p = new Array(y.length), l = p.length, h = 0; l > h; h += 1)
                          p[h] = y[h] + (y[h] - v[h]) * (i - r) / 5e-4;
                        return p;
                      }
                      return y + (y - v) * (i - r) / 5e-4;
                    }
                  }
                  return this.getValueAtTime((i - o) % n + o);
                }.bind(this),
                loopOutDuration = function(t, e) {
                  return loopOut(t, e, !0);
                }.bind(this),
                valueAtTime = function(t) {
                  return this.getValueAtTime(t * thisComp.globalData.frameRate);
                }.bind(this),
                velocityAtTime = function(t) {
                  return this.getVelocityAtTime(t * thisComp.globalData.frameRate);
                }.bind(this);
            Object.defineProperty(this, "hasParent", {get: hasParentGetter});
            var time,
                value,
                textIndex,
                textTotal,
                selectorValue,
                index = elem.data.ind + 1,
                hasParent = !(!elem.hierarchy || !elem.hierarchy.length);
            return execute;
          }
          var ob = {};
          return ob.initiateExpression = initiateExpression, ob;
        }();
    !function() {
      ExpressionComp.prototype.layer = function(t) {
        for (var e = 0,
            s = this.layers.length; s > e; ) {
          if (this.layers[e].nm === t)
            return this.elements[e];
          e += 1;
        }
      }, ExpressionComp.prototype.pixelAspect = 1;
    }(), ShapeInterface.prototype.fillInterface = function(t) {
      var e = {
        get color() {
          return t.c.k && t.c.getValue(), [t.c.pv[0], t.c.pv[1], t.c.pv[2]];
        },
        get opacity() {
          return t.o.k && t.o.getValue(), t.o.pv;
        }
      };
      return e;
    }, ShapeInterface.prototype.strokeInterface = function(t, e) {
      var s = {
        get color() {
          return e.c.k && e.c.getValue(), [e.c.pv[0], e.c.pv[1], e.c.pv[2]];
        },
        get opacity() {
          return e.o.k && e.o.getValue(), e.o.pv;
        },
        get strokeWidth() {
          return e.w.k && e.w.getValue(), e.w.pv;
        },
        dashOb: {},
        get dash() {
          var s,
              i = e.d,
              a = t.d,
              r = a.length;
          for (s = 0; r > s; s += 1)
            i.dataProps[s].p.k && i.dataProps[s].p.getValue(), this.dashOb[a[s].nm] = i.dataProps[s].p.v;
          return this.dashOb;
        }
      };
      return s;
    }, ShapeInterface.prototype.shapeInterface = function(t) {
      var e = {get shape() {
          return t.sh.k && t.sh.getValue(), t.sh.pv;
        }};
      return e;
    }, ShapeInterface.prototype.ellipseInterface = function(t) {
      var e = {
        get size() {
          return t.sh.s.k && t.sh.s.getValue(), [t.sh.s.pv[0], t.sh.s.pv[1]];
        },
        get position() {
          return t.sh.p.k && t.sh.p.getValue(), [t.sh.p.pv[0], t.sh.p.pv[1]];
        }
      };
      return e;
    }, ShapeInterface.prototype.rectangleInterface = function(t) {
      var e = "tm" === t.sh.ty ? t.sh.prop : t.sh,
          s = {
            get size() {
              return e.s.k && e.s.getValue(), [e.s.pv[0], e.s.pv[1]];
            },
            get position() {
              return e.p.k && e.p.getValue(), [e.p.pv[0], e.p.pv[1]];
            },
            get roundness() {
              return e.r.k && e.r.getValue(), e.r.pv;
            }
          };
      return s;
    }, ShapeInterface.prototype.trimInterface = function(t) {
      var e = {
        get start() {
          return t.tr.s.k && t.tr.s.getValue(), t.tr.s.pv;
        },
        get end() {
          return t.tr.e.k && t.tr.e.getValue(), t.tr.e.pv;
        },
        get offset() {
          return t.tr.o.k && t.tr.o.getValue(), t.tr.o.pv;
        }
      };
      return e;
    }, ShapeInterface.prototype.transformInterface = function(t) {
      var e = {
        get opacity() {
          return t.transform.mProps.o.k && t.transform.mProps.o.getValue(), t.transform.mProps.o.pv;
        },
        get position() {
          return t.transform.mProps.p.k && t.transform.mProps.p.getValue(), [t.transform.mProps.p.pv[0], t.transform.mProps.p.pv[1]];
        },
        get anchorPoint() {
          return t.transform.mProps.a.k && t.transform.mProps.a.getValue(), [t.transform.mProps.a.pv[0], t.transform.mProps.a.pv[1]];
        },
        get scale() {
          return t.transform.mProps.s.k && t.transform.mProps.s.getValue(), [t.transform.mProps.s.pv[0], t.transform.mProps.s.pv[1]];
        },
        get rotation() {
          return t.transform.mProps.r.k && t.transform.mProps.r.getValue(), t.transform.mProps.r.pv;
        },
        get skew() {
          return t.transform.mProps.sk.k && t.transform.mProps.sk.getValue(), t.transform.mProps.sk.pv;
        },
        get skewAxis() {
          return t.transform.mProps.sa.k && t.transform.mProps.sa.getValue(), t.transform.mProps.sa.pv;
        }
      };
      return e;
    }, ShapeInterface.prototype.groupInterface = function(t, e, s) {
      var i,
          a,
          r = [],
          n = t.length;
      for (i = 0; n > i; i += 1)
        "gr" === t[i].ty ? (a = {}, this.groupInterface(t[i].it, e[i].it, a), r.push(a)) : "sh" === t[i].ty ? (a = this.shapeInterface(e[i]), r.push(a)) : "fl" === t[i].ty ? (a = this.fillInterface(e[i]), r.push(a)) : "st" === t[i].ty ? (a = this.strokeInterface(t[i], e[i]), r.push(a)) : "el" === t[i].ty ? (a = this.ellipseInterface(e[i]), r.push(a)) : "rc" === t[i].ty ? (a = this.rectangleInterface(e[i]), r.push(a)) : "tr" === t[i].ty ? s.transform = this.transformInterface(e[i]) : "tm" === t[i].ty ? (a = this.trimInterface(e[i]), r.push(a)) : r.push("");
      s.content = function(e) {
        var s,
            i = t.length;
        for (s = 0; i > s; s += 1)
          if (t[s].nm === e)
            return r[s];
      };
    }, ShapeInterface.prototype.buildExpressionInterface = function() {
      this.groupInterface(this.shapesData, this.viewData, this);
    }, LayerInterface.prototype.toWorld = function(t) {
      if (this.hierarchy && this.hierarchy.length) {
        var e,
            s = new Matrix,
            i = this.hierarchy.length;
        for (this.finalTransform.mProp.applyToMatrix(s, !1), e = 0; i > e; e += 1)
          this.hierarchy[e].finalTransform.mProp.applyToMatrix(s, !0);
        var a = s.applyToPointArray(t[0], t[1], t[2] || 0);
        return a;
      }
      return t;
    }, LayerInterface.prototype.effect = function(t) {
      console.log(this.effectsManager), console.log(t);
    };
    var PropertyFactory = function() {
      function t(t) {
        for (var e,
            s,
            i = 0,
            a = this.keyframes.length - 1,
            r = 1,
            n = !0,
            o = 0,
            h = "object" == typeof this.pv ? [this.pv.length] : 0; n; ) {
          if (e = this.keyframes[i], s = this.keyframes[i + 1], i == a - 1 && t >= s.t - o) {
            e.h && (e = s);
            break;
          }
          if (s.t - o > t)
            break;
          a - 1 > i ? i += r : n = !1;
        }
        var l,
            p,
            m,
            f,
            d,
            c = 0;
        if (e.to) {
          e.bezierData || bez.buildBezierData(e);
          var u = e.bezierData;
          if (t >= s.t - o || t < e.t - o) {
            var y = t >= s.t - o ? u.points.length - 1 : 0;
            for (p = u.points[y].point.length, l = 0; p > l; l += 1)
              h[l] = u.points[y].point[l];
          } else {
            e.__fnct ? d = e.__fnct : (d = BezierFactory.getBezierEasing(e.o.x, e.o.y, e.i.x, e.i.y, e.n).get, e.__fnct = d), m = d((t - (e.t - o)) / (s.t - o - (e.t - o)));
            var v,
                g = u.segmentLength * m,
                b = 0;
            for (r = 1, n = !0, f = u.points.length; n; ) {
              if (b += u.points[c].partialLength * r, 0 === g || 0 === m || c == u.points.length - 1) {
                for (p = u.points[c].point.length, l = 0; p > l; l += 1)
                  h[l] = u.points[c].point[l];
                break;
              }
              if (g >= b && g < b + u.points[c + 1].partialLength) {
                for (v = (g - b) / u.points[c + 1].partialLength, p = u.points[c].point.length, l = 0; p > l; l += 1)
                  h[l] = u.points[c].point[l] + (u.points[c + 1].point[l] - u.points[c].point[l]) * v;
                break;
              }
              f - 1 > c && 1 == r || c > 0 && -1 == r ? c += r : n = !1;
            }
          }
        } else {
          var E,
              P,
              k,
              S,
              C,
              x = !1;
          for (a = e.s.length, i = 0; a > i; i += 1) {
            if (1 !== e.h && (e.o.x instanceof Array ? (x = !0, e.__fnct || (e.__fnct = []), e.__fnct[i] || (E = e.o.x[i] || e.o.x[0], P = e.o.y[i] || e.o.y[0], k = e.i.x[i] || e.i.x[0], S = e.i.y[i] || e.i.y[0])) : (x = !1, e.__fnct || (E = e.o.x, P = e.o.y, k = e.i.x, S = e.i.y)), x ? e.__fnct[i] ? d = e.__fnct[i] : (d = BezierFactory.getBezierEasing(E, P, k, S).get, e.__fnct[i] = d) : e.__fnct ? d = e.__fnct : (d = BezierFactory.getBezierEasing(E, P, k, S).get, e.__fnct = d), m = t >= s.t - o ? 1 : t < e.t - o ? 0 : d((t - (e.t - o)) / (s.t - o - (e.t - o)))), this.sh && 1 !== e.h) {
              var w = e.s[i],
                  D = e.e[i];
              -180 > w - D ? w += 360 : w - D > 180 && (w -= 360), C = w + (D - w) * m;
            } else
              C = 1 === e.h ? e.s[i] : e.s[i] + (e.e[i] - e.s[i]) * m;
            1 === a ? h = C : h[i] = C;
          }
        }
        return h;
      }
      function e(t) {
        var e,
            s = .01,
            i = this.getValueAtTime(t),
            a = this.getValueAtTime(t + s);
        if (i.length) {
          e = Array.apply(null, {length: i.length});
          var r;
          for (r = 0; r < i.length; r += 1)
            e[r] = this.elem.globalData.frameRate * ((a[r] - i[r]) / s);
        } else
          e = (a - i) / s;
        return e;
      }
      function s() {
        if (this.elem.globalData.frameId !== this.frameId) {
          this.mdf = !1, this.frameId = this.elem.globalData.frameId;
          var t = this.comp.renderedFrame - this.offsetTime;
          if (t === this.lastFrame || this.lastFrame !== y && (this.lastFrame >= this.keyframes[this.keyframes.length - 1].t - this.offsetTime && t >= this.keyframes[this.keyframes.length - 1].t - this.offsetTime || this.lastFrame < this.keyframes[0].t - this.offsetTime && t < this.keyframes[0].t - this.offsetTime))
            ;
          else {
            for (var e,
                s,
                i = 0,
                a = this.keyframes.length - 1,
                r = 1,
                n = !0; n; ) {
              if (e = this.keyframes[i], s = this.keyframes[i + 1], i == a - 1 && t >= s.t - this.offsetTime) {
                e.h && (e = s);
                break;
              }
              if (s.t - this.offsetTime > t)
                break;
              a - 1 > i ? i += r : n = !1;
            }
            var o,
                h,
                l,
                p,
                m,
                f = 0;
            if (e.to) {
              e.bezierData || bez.buildBezierData(e);
              var d = e.bezierData;
              if (t >= s.t - this.offsetTime || t < e.t - this.offsetTime) {
                var c = t >= s.t - this.offsetTime ? d.points.length - 1 : 0;
                for (h = d.points[c].point.length, o = 0; h > o; o += 1)
                  this.v[o] = this.mult ? d.points[c].point[o] * this.mult : d.points[c].point[o], this.pv[o] = d.points[c].point[o], this.lastPValue[o] !== this.pv[o] && (this.mdf = !0, this.lastPValue[o] = this.pv[o]);
              } else {
                e.__fnct ? m = e.__fnct : (m = BezierFactory.getBezierEasing(e.o.x, e.o.y, e.i.x, e.i.y, e.n).get, e.__fnct = m), l = m((t - (e.t - this.offsetTime)) / (s.t - this.offsetTime - (e.t - this.offsetTime)));
                var u,
                    v = d.segmentLength * l,
                    g = 0;
                for (r = 1, n = !0, p = d.points.length; n; ) {
                  if (g += d.points[f].partialLength * r, 0 === v || 0 === l || f == d.points.length - 1) {
                    for (h = d.points[f].point.length, o = 0; h > o; o += 1)
                      this.v[o] = this.mult ? d.points[f].point[o] * this.mult : d.points[f].point[o], this.pv[o] = d.points[f].point[o], this.lastPValue[o] !== this.pv[o] && (this.mdf = !0, this.lastPValue[o] = this.pv[o]);
                    break;
                  }
                  if (v >= g && v < g + d.points[f + 1].partialLength) {
                    for (u = (v - g) / d.points[f + 1].partialLength, h = d.points[f].point.length, o = 0; h > o; o += 1)
                      this.v[o] = this.mult ? (d.points[f].point[o] + (d.points[f + 1].point[o] - d.points[f].point[o]) * u) * this.mult : d.points[f].point[o] + (d.points[f + 1].point[o] - d.points[f].point[o]) * u, this.pv[o] = d.points[f].point[o] + (d.points[f + 1].point[o] - d.points[f].point[o]) * u, this.lastPValue[o] !== this.pv[o] && (this.mdf = !0, this.lastPValue[o] = this.pv[o]);
                    break;
                  }
                  p - 1 > f && 1 == r || f > 0 && -1 == r ? f += r : n = !1;
                }
              }
            } else {
              var b,
                  E,
                  P,
                  k,
                  S,
                  C = !1;
              for (a = e.s.length, i = 0; a > i; i += 1) {
                if (1 !== e.h && (e.o.x instanceof Array ? (C = !0, e.__fnct || (e.__fnct = []), e.__fnct[i] || (b = e.o.x[i] || e.o.x[0], E = e.o.y[i] || e.o.y[0], P = e.i.x[i] || e.i.x[0], k = e.i.y[i] || e.i.y[0])) : (C = !1, e.__fnct || (b = e.o.x, E = e.o.y, P = e.i.x, k = e.i.y)), C ? e.__fnct[i] ? m = e.__fnct[i] : (m = BezierFactory.getBezierEasing(b, E, P, k).get, e.__fnct[i] = m) : e.__fnct ? m = e.__fnct : (m = BezierFactory.getBezierEasing(b, E, P, k).get, e.__fnct = m), l = t >= s.t - this.offsetTime ? 1 : t < e.t - this.offsetTime ? 0 : m((t - (e.t - this.offsetTime)) / (s.t - this.offsetTime - (e.t - this.offsetTime)))), this.sh && 1 !== e.h) {
                  var x = e.s[i],
                      w = e.e[i];
                  -180 > x - w ? x += 360 : x - w > 180 && (x -= 360), S = x + (w - x) * l;
                } else
                  S = 1 === e.h ? e.s[i] : e.s[i] + (e.e[i] - e.s[i]) * l;
                1 === a ? (this.v = this.mult ? S * this.mult : S, this.pv = S, this.lastPValue != this.pv && (this.mdf = !0, this.lastPValue = this.pv)) : (this.v[i] = this.mult ? S * this.mult : S, this.pv[i] = S, this.lastPValue[i] !== this.pv[i] && (this.mdf = !0, this.lastPValue[i] = this.pv[i]));
              }
            }
          }
          this.lastFrame = t;
        }
      }
      function i() {
        this.mdf = !1;
        var t = this.comp.renderedFrame - this.offsetTime;
        if (this.lastFrame !== y && (this.lastFrame < this.keyframes[0].t - this.offsetTime && t < this.keyframes[0].t - this.offsetTime || this.lastFrame > this.keyframes[this.keyframes.length - 1].t - this.offsetTime && t > this.keyframes[this.keyframes.length - 1].t - this.offsetTime))
          ;
        else {
          var e,
              s,
              i;
          if (t < this.keyframes[0].t - this.offsetTime)
            this.mdf = !0, e = this.keyframes[0].s[0], i = !0;
          else if (t > this.keyframes[this.keyframes.length - 1].t - this.offsetTime)
            this.mdf = !0, e = 1 === this.keyframes[this.keyframes.length - 2].h ? this.keyframes[this.keyframes.length - 2].s[0] : this.keyframes[this.keyframes.length - 2].e[0], i = !0;
          else {
            this.mdf = !0;
            for (var a,
                r,
                n,
                o,
                h,
                l,
                p = 0,
                m = this.keyframes.length - 1,
                f = 1,
                d = !0; d && (a = this.keyframes[p], r = this.keyframes[p + 1], !(r.t - this.offsetTime > t && 1 == f)); )
              m - 1 > p && 1 == f || p > 0 && -1 == f ? p += f : d = !1;
            var c;
            if (1 !== a.h) {
              var u;
              a.__fnct ? u = a.__fnct : (u = BezierFactory.getBezierEasing(a.o.x, a.o.y, a.i.x, a.i.y).get, a.__fnct = u), c = t >= r.t - this.offsetTime ? 1 : t < a.t - this.offsetTime ? 0 : u((t - (a.t - this.offsetTime)) / (r.t - this.offsetTime - (a.t - this.offsetTime))), s = a.e[0];
            }
            e = a.s[0], i = 1 === a.h;
          }
          for (o = this.v.i.length, l = e.i[0].length, n = 0; o > n; n += 1)
            for (h = 0; l > h; h += 1)
              i ? (this.v.i[n][h] = e.i[n][h], this.v.o[n][h] = e.o[n][h], this.v.v[n][h] = e.v[n][h], this.pv.i[n][h] = e.i[n][h], this.pv.o[n][h] = e.o[n][h], this.pv.v[n][h] = e.v[n][h]) : (this.v.i[n][h] = e.i[n][h] + (s.i[n][h] - e.i[n][h]) * c, this.v.o[n][h] = e.o[n][h] + (s.o[n][h] - e.o[n][h]) * c, this.v.v[n][h] = e.v[n][h] + (s.v[n][h] - e.v[n][h]) * c, this.pv.i[n][h] = e.i[n][h] + (s.i[n][h] - e.i[n][h]) * c, this.pv.o[n][h] = e.o[n][h] + (s.o[n][h] - e.o[n][h]) * c, this.pv.v[n][h] = e.v[n][h] + (s.v[n][h] - e.v[n][h]) * c);
        }
        this.lastFrame = t;
      }
      function a(t, e) {
        this.getExpression = ExpressionManager.initiateExpression, e.x && (this.k = !0, this.x = !0, this.getValue && (this.getPreValue = this.getValue), this.getValue = this.getExpression(t, e));
      }
      function r(t, e, s) {
        this.mult = s, this.v = s ? e.k * s : e.k, this.pv = e.k, this.mdf = !1, this.comp = t.comp, this.k = !1, a.bind(this)(t, e);
      }
      function n(t, e, s) {
        this.mult = s, this.data = e, this.mdf = !1, this.comp = t.comp, this.k = !1, a.bind(this)(t, e), this.v = new Array(e.k.length), this.pv = new Array(e.k.length), this.lastValue = new Array(e.k.length);
        var i,
            r = e.k.length;
        for (i = 0; r > i; i += 1)
          this.v[i] = s ? e.k[i] * s : e.k[i], this.pv[i] = e.k[i];
      }
      function o(i, r, n) {
        this.keyframes = r.k, this.offsetTime = i.data.st, this.lastValue = -99999, this.lastPValue = -99999, this.frameId = -1, this.k = !0, this.data = r, this.mult = n, this.elem = i, this.comp = i.comp, this.lastFrame = y, this.v = n ? r.k[0].s[0] * n : r.k[0].s[0], this.pv = r.k[0].s[0], this.getValue = s, this.getValueAtTime = t, this.getVelocityAtTime = e, a.bind(this)(i, r);
      }
      function h(i, r, n) {
        var o,
            h,
            l,
            p,
            m,
            f = r.k.length;
        for (o = 0; f - 1 > o; o += 1)
          r.k[o].to && r.k[o].s && r.k[o].e && (h = r.k[o].s, l = r.k[o].e, p = r.k[o].to, m = r.k[o].ti, (2 == h.length && bez.pointOnLine2D(h[0], h[1], l[0], l[1], h[0] + p[0], h[1] + p[1]) && bez.pointOnLine2D(h[0], h[1], l[0], l[1], l[0] + m[0], l[1] + m[1]) || bez.pointOnLine3D(h[0], h[1], h[2], l[0], l[1], l[2], h[0] + p[0], h[1] + p[1], h[2] + p[2]) && bez.pointOnLine3D(h[0], h[1], h[2], l[0], l[1], l[2], l[0] + m[0], l[1] + m[1], l[2] + m[2])) && (r.k[o].to = null, r.k[o].ti = null));
        this.keyframes = r.k, this.offsetTime = i.data.st, this.k = !0, this.mult = n, this.elem = i, this.comp = i.comp, this.getValue = s, this.getValueAtTime = t, this.getVelocityAtTime = e, this.frameId = -1, this.v = new Array(r.k[0].s.length), this.pv = new Array(r.k[0].s.length), this.lastValue = new Array(r.k[0].s.length), this.lastPValue = new Array(r.k[0].s.length), this.lastFrame = y, a.bind(this)(i, r);
      }
      function l(t, e, s, i, a) {
        var l;
        if (2 === s)
          l = new v(t, e, a);
        else if (7 === s)
          l = new P(t, e, a);
        else if (e.k.length)
          if ("number" == typeof e.k[0])
            l = new n(t, e, i);
          else
            switch (s) {
              case 0:
                l = new o(t, e, i);
                break;
              case 1:
                l = new h(t, e, i);
            }
        else
          l = new r(t, e, i);
        return (l.k || l.x) && a.push(l), l;
      }
      function p() {
        return this.v;
      }
      function m(t, e, s) {
        this.comp = t.comp, this.k = !1, this.mdf = !1, this.closed = 3 === s ? e.cl : e.closed, this.numNodes = 3 === s ? e.pt.k.v.length : e.ks.k.v.length, this.v = 3 === s ? e.pt.k : e.ks.k;
        var i = 3 === s ? e.pt : e.ks;
        this.getValue = p, this.pv = this.v, a.bind(this)(t, i);
      }
      function f(t, e, s) {
        this.comp = t.comp, this.offsetTime = t.data.st, this.getValue = i, this.keyframes = 3 === s ? e.pt.k : e.ks.k, this.k = !0, this.closed = 3 === s ? e.cl : e.closed;
        var r,
            n = this.keyframes[0].s[0].i.length,
            o = this.keyframes[0].s[0].i[0].length;
        for (this.numNodes = n, this.v = {
          i: new Array(n),
          o: new Array(n),
          v: new Array(n)
        }, this.pv = {
          i: new Array(n),
          o: new Array(n),
          v: new Array(n)
        }, r = 0; n > r; r += 1)
          this.v.i[r] = new Array(o), this.v.o[r] = new Array(o), this.v.v[r] = new Array(o), this.pv.i[r] = new Array(o), this.pv.o[r] = new Array(o), this.pv.v[r] = new Array(o);
        this.lastFrame = y;
        var h = 3 === s ? e.pt : e.ks;
        a.bind(this)(t, h);
      }
      function d(t, e, s, i, a) {
        var r;
        if (3 === s || 4 === s) {
          var n = 3 === s ? e.pt.k : e.ks.k;
          r = n.length ? new f(t, e, s) : new m(t, e, s);
        } else
          5 === s ? r = new E(t, e) : 6 === s ? r = new g(t, e) : 7 === s && (r = new b(t, e));
        var o = !1;
        if (a)
          for (var h = 0,
              l = a.length; l > h; ) {
            if (!a[h].closed) {
              o = !0;
              break;
            }
            h += 1;
          }
        return o && (r = new k(r, a)), r.k && i.push(r), r;
      }
      function c(t, e, s, i) {
        return new S(t, e, s, i);
      }
      function u(t, e, s) {
        switch (e.t) {
          case 0:
            return new x(t, e, s);
          case 1:
            return new C(t, e);
        }
      }
      var y = -999999,
          v = function() {
            function t() {
              return this.p.k && this.getValue(), this.p.pv;
            }
            function e() {
              return this.a.k && this.getValue(), this.a.pv;
            }
            function s() {
              return this.or.k && this.getValue(), this.or.pv;
            }
            function i() {
              return this.r.k && this.getValue(), this.r.pv;
            }
            function a() {
              return this.s.k && this.getValue(), this.s.pv;
            }
            function r() {
              return this.o.k && this.o.getValue(), this.o.pv;
            }
            function n() {
              return this.sk.k && this.sk.getValue(), this.sk.pv;
            }
            function o() {
              return this.sa.k && this.sa.getValue(), this.sa.pv;
            }
            function h(t, e) {
              var s,
                  i = this.dynamicProperties.length;
              if (e) {
                for (s = 0; i > s; s += 1)
                  this.dynamicProperties[s].getValue(), this.dynamicProperties[s].mdf && (this.mdf = !0);
                this.a && t.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && t.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.r ? t.rotate(-this.r.v) : t.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? t.translate(this.px.v, this.py.v, -this.pz.v) : t.translate(this.px.v, this.py.v, 0) : t.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
              } else
                this.a && t.translate(-this.a.pv[0], -this.a.pv[1], this.a.pv[2]), this.s && t.scale(this.s.pv[0], this.s.pv[1], this.s.pv[2]), this.r ? t.rotate(-this.r.pv) : t.rotateZ(-this.rz.pv).rotateY(this.ry.pv).rotateX(this.rx.pv).rotateZ(-this.or.pv[2]).rotateY(this.or.pv[1]).rotateX(this.or.pv[0]), this.data.p.s ? this.data.p.z ? t.translate(this.px.pv, this.py.pv, -this.pz.pv) : t.translate(this.px.pv, this.py.pv, 0) : t.translate(this.p.pv[0], this.p.pv[1], -this.p.pv[2]);
            }
            function p() {
              if (this.elem.globalData.frameId !== this.frameId) {
                this.mdf = !1, this.frameId = this.elem.globalData.frameId;
                var t,
                    e = this.dynamicProperties.length;
                for (t = 0; e > t; t += 1)
                  this.dynamicProperties[t].getValue(), this.dynamicProperties[t].mdf && (this.mdf = !0);
                this.mdf && (this.v.reset(), this.a && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r ? this.v.rotate(-this.r.v) : this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]));
              }
            }
            function m() {
              this.inverted = !0, this.iv = new Matrix, this.k || (this.data.p.s ? this.iv.translate(this.px.v, this.py.v, -this.pz.v) : this.iv.translate(this.p.v[0], this.p.v[1], -this.p.v[2]), this.r ? this.iv.rotate(-this.r.v) : this.iv.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.s && this.iv.scale(this.s.v[0], this.s.v[1], 1), this.a && this.iv.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]));
            }
            return function(f, d, c) {
              this.elem = f, this.frameId = -1, this.dynamicProperties = [], this.mdf = !1, this.data = d, this.getValue = p, this.applyToMatrix = h, this.setInverted = m, this.v = new Matrix, d.p.s ? (this.px = l(f, d.p.x, 0, 0, this.dynamicProperties), this.py = l(f, d.p.y, 0, 0, this.dynamicProperties), d.p.z && (this.pz = l(f, d.p.z, 0, 0, this.dynamicProperties))) : this.p = l(f, d.p, 1, 0, this.dynamicProperties), d.r ? this.r = l(f, d.r, 0, degToRads, this.dynamicProperties) : d.rx && (this.rx = l(f, d.rx, 0, degToRads, this.dynamicProperties), this.ry = l(f, d.ry, 0, degToRads, this.dynamicProperties), this.rz = l(f, d.rz, 0, degToRads, this.dynamicProperties), this.or = l(f, d.or, 0, degToRads, this.dynamicProperties)), d.sk && (this.sk = l(f, d.sk, 0, degToRads, this.dynamicProperties), this.sa = l(f, d.sa, 0, degToRads, this.dynamicProperties)), d.a && (this.a = l(f, d.a, 1, 0, this.dynamicProperties)), d.s && (this.s = l(f, d.s, 1, .01, this.dynamicProperties)), this.o = d.o ? l(f, d.o, 0, .01, c) : {
                mdf: !1,
                v: 1
              }, this.dynamicProperties.length ? c.push(this) : (this.a && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r ? this.v.rotate(-this.r.v) : this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? d.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2])), Object.defineProperty(this, "position", {get: t}), Object.defineProperty(this, "orientation", {get: s}), Object.defineProperty(this, "anchorPoint", {get: e}), Object.defineProperty(this, "rotation", {get: i}), Object.defineProperty(this, "scale", {get: a}), Object.defineProperty(this, "opacity", {get: r}), Object.defineProperty(this, "skew", {get: n}), Object.defineProperty(this, "skewAxis", {get: o});
            };
          }(),
          g = function() {
            function t() {
              var t = this.p.v[0],
                  e = this.p.v[1],
                  i = this.s.v[0] / 2,
                  a = this.s.v[1] / 2;
              2 !== this.d && 3 !== this.d ? (this.v.v[0] = [t, e - a], this.v.i[0] = [t - i * s, e - a], this.v.o[0] = [t + i * s, e - a], this.v.v[1] = [t + i, e], this.v.i[1] = [t + i, e - a * s], this.v.o[1] = [t + i, e + a * s], this.v.v[2] = [t, e + a], this.v.i[2] = [t + i * s, e + a], this.v.o[2] = [t - i * s, e + a], this.v.v[3] = [t - i, e], this.v.i[3] = [t - i, e + a * s], this.v.o[3] = [t - i, e - a * s]) : (this.v.v[0] = [t, e - a], this.v.o[0] = [t - i * s, e - a], this.v.i[0] = [t + i * s, e - a], this.v.v[1] = [t - i, e], this.v.o[1] = [t - i, e + a * s], this.v.i[1] = [t - i, e - a * s], this.v.v[2] = [t, e + a], this.v.o[2] = [t + i * s, e + a], this.v.i[2] = [t - i * s, e + a], this.v.v[3] = [t + i, e], this.v.o[3] = [t + i, e - a * s], this.v.i[3] = [t + i, e + a * s]);
            }
            function e(t) {
              var e,
                  s = this.dynamicProperties.length;
              if (this.elem.globalData.frameId !== this.frameId) {
                for (this.mdf = !1, this.frameId = this.elem.globalData.frameId, e = 0; s > e; e += 1)
                  this.dynamicProperties[e].getValue(t), this.dynamicProperties[e].mdf && (this.mdf = !0);
                this.mdf && this.convertEllToPath();
              }
            }
            var s = .5519;
            return function(s, i) {
              this.v = {
                v: new Array(4),
                i: new Array(4),
                o: new Array(4),
                c: !0
              }, this.numNodes = 4, this.d = i.d, this.dynamicProperties = [], i.closed = !0, this.closed = !0, this.elem = s, this.comp = s.comp, this.frameId = -1, this.mdf = !1, this.getValue = e, this.convertEllToPath = t, this.p = l(s, i.p, 1, 0, this.dynamicProperties), this.s = l(s, i.s, 1, 0, this.dynamicProperties), this.dynamicProperties.length ? this.k = !0 : this.convertEllToPath();
            };
          }(),
          b = function() {
            function t() {
              var t = Math.floor(this.pt.v),
                  e = 2 * Math.PI / t;
              this.v.v.length = t, this.v.i.length = t, this.v.o.length = t;
              var s,
                  i = this.or.v,
                  a = this.os.v,
                  r = 2 * Math.PI * i / (4 * t),
                  n = -Math.PI / 2,
                  o = 3 === this.data.d ? -1 : 1;
              for (n += this.r.v, s = 0; t > s; s += 1) {
                var h = i * Math.cos(n),
                    l = i * Math.sin(n),
                    p = 0 === h && 0 === l ? 0 : l / Math.sqrt(h * h + l * l),
                    m = 0 === h && 0 === l ? 0 : -h / Math.sqrt(h * h + l * l);
                h += +this.p.v[0], l += +this.p.v[1], this.v.v[s] = [h, l], this.v.i[s] = [h + p * r * a * o, l + m * r * a * o], this.v.o[s] = [h - p * r * a * o, l - m * r * a * o], n += e * o;
              }
              this.numNodes = t;
            }
            function e() {
              var t = 2 * Math.floor(this.pt.v),
                  e = 2 * Math.PI / t;
              this.v.v.length = t, this.v.i.length = t, this.v.o.length = t;
              var s,
                  i,
                  a,
                  r,
                  n = !0,
                  o = this.or.v,
                  h = this.ir.v,
                  l = this.os.v,
                  p = this.is.v,
                  m = 2 * Math.PI * o / (2 * t),
                  f = 2 * Math.PI * h / (2 * t),
                  d = -Math.PI / 2;
              d += this.r.v;
              var c = 3 === this.data.d ? -1 : 1;
              for (s = 0; t > s; s += 1) {
                i = n ? o : h, a = n ? l : p, r = n ? m : f;
                var u = i * Math.cos(d),
                    y = i * Math.sin(d),
                    v = 0 === u && 0 === y ? 0 : y / Math.sqrt(u * u + y * y),
                    g = 0 === u && 0 === y ? 0 : -u / Math.sqrt(u * u + y * y);
                u += +this.p.v[0], y += +this.p.v[1], this.v.v[s] = [u, y], this.v.i[s] = [u + v * r * a * c, y + g * r * a * c], this.v.o[s] = [u - v * r * a * c, y - g * r * a * c], n = !n, d += e * c;
              }
              this.numNodes = t;
            }
            function s() {
              if (this.elem.globalData.frameId !== this.frameId) {
                this.mdf = !1, this.frameId = this.elem.globalData.frameId;
                var t,
                    e = this.dynamicProperties.length;
                for (t = 0; e > t; t += 1)
                  this.dynamicProperties[t].getValue(), this.dynamicProperties[t].mdf && (this.mdf = !0);
                this.mdf && this.convertToPath();
              }
            }
            return function(i, a) {
              this.v = {
                v: [],
                i: [],
                o: [],
                c: !0
              }, this.elem = i, this.comp = i.comp, this.data = a, this.frameId = -1, this.d = a.d, this.dynamicProperties = [], this.mdf = !1, a.closed = !0, this.closed = !0, this.getValue = s, 1 === a.sy ? (this.ir = l(i, a.ir, 0, 0, this.dynamicProperties), this.is = l(i, a.is, 0, .01, this.dynamicProperties), this.convertToPath = e) : this.convertToPath = t, this.pt = l(i, a.pt, 0, 0, this.dynamicProperties), this.p = l(i, a.p, 1, 0, this.dynamicProperties), this.r = l(i, a.r, 0, degToRads, this.dynamicProperties), this.or = l(i, a.or, 0, 0, this.dynamicProperties), this.os = l(i, a.os, 0, .01, this.dynamicProperties), this.dynamicProperties.length ? this.k = !0 : this.convertToPath();
            };
          }(),
          E = function() {
            function t(t) {
              if (this.elem.globalData.frameId !== this.frameId) {
                this.mdf = !1, this.frameId = this.elem.globalData.frameId;
                var e,
                    s = this.dynamicProperties.length;
                for (e = 0; s > e; e += 1)
                  this.dynamicProperties[e].getValue(t), this.dynamicProperties[e].mdf && (this.mdf = !0);
                this.mdf && this.convertRectToPath();
              }
            }
            function e() {
              var t = this.p.v[0],
                  e = this.p.v[1],
                  s = this.s.v[0] / 2,
                  i = this.s.v[1] / 2,
                  a = bm_min(s, i, this.r.v),
                  r = a * (1 - .5519);
              2 === this.d || 1 === this.d ? (this.v.v[0] = [t + s, e - i + a], this.v.o[0] = this.v.v[0], this.v.i[0] = [t + s, e - i + r], this.v.v[1] = [t + s, e + i - a], this.v.o[1] = [t + s, e + i - r], this.v.i[1] = this.v.v[1], this.v.v[2] = [t + s - a, e + i], this.v.o[2] = this.v.v[2], this.v.i[2] = [t + s - r, e + i], this.v.v[3] = [t - s + a, e + i], this.v.o[3] = [t - s + r, e + i], this.v.i[3] = this.v.v[3], this.v.v[4] = [t - s, e + i - a], this.v.o[4] = this.v.v[4], this.v.i[4] = [t - s, e + i - r], this.v.v[5] = [t - s, e - i + a], this.v.o[5] = [t - s, e - i + r], this.v.i[5] = this.v.v[5], this.v.v[6] = [t - s + a, e - i], this.v.o[6] = this.v.v[6], this.v.i[6] = [t - s + r, e - i], this.v.v[7] = [t + s - a, e - i], this.v.o[7] = [t + s - r, e - i], this.v.i[7] = this.v.v[7]) : (this.v.v[0] = [t + s, e - i + a], this.v.o[0] = [t + s, e - i + r], this.v.i[0] = this.v.v[0], this.v.v[1] = [t + s - a, e - i], this.v.o[1] = this.v.v[1], this.v.i[1] = [t + s - r, e - i], this.v.v[2] = [t - s + a, e - i], this.v.o[2] = [t - s + r, e - i], this.v.i[2] = this.v.v[2], this.v.v[3] = [t - s, e - i + a], this.v.o[3] = this.v.v[3], this.v.i[3] = [t - s, e - i + r], this.v.v[4] = [t - s, e + i - a], this.v.o[4] = [t - s, e + i - r], this.v.i[4] = this.v.v[4], this.v.v[5] = [t - s + a, e + i], this.v.o[5] = this.v.v[5], this.v.i[5] = [t - s + r, e + i], this.v.v[6] = [t + s - a, e + i], this.v.o[6] = [t + s - r, e + i], this.v.i[6] = this.v.v[6], this.v.v[7] = [t + s, e + i - a], this.v.o[7] = this.v.v[7], this.v.i[7] = [t + s, e + i - r]);
            }
            return function(s, i) {
              this.v = {
                v: new Array(8),
                i: new Array(8),
                o: new Array(8),
                c: !0
              }, this.numNodes = 8, this.elem = s, this.comp = s.comp, this.frameId = -1, this.d = i.d, this.dynamicProperties = [], this.mdf = !1, i.closed = !0, this.closed = !0, this.getValue = t, this.convertRectToPath = e, this.p = l(s, i.p, 1, 0, this.dynamicProperties), this.s = l(s, i.s, 1, 0, this.dynamicProperties), this.r = l(s, i.r, 0, 0, this.dynamicProperties), this.dynamicProperties.length ? this.k = !0 : this.convertRectToPath();
            };
          }(),
          P = function() {
            function t(t) {
              if (this.elem.globalData.frameId !== this.frameId || t) {
                this.mdf = !1, this.frameId = this.elem.globalData.frameId;
                var e,
                    s = this.dynamicProperties.length;
                for (e = 0; s > e; e += 1)
                  this.dynamicProperties[e].getValue(), this.dynamicProperties[e].mdf && (this.mdf = !0);
                if (this.mdf || t) {
                  var i = this.o.v % 360 / 360;
                  if (0 === i && 0 === this.s.v && 1 == this.e.v)
                    return void(this.isTrimming = !1);
                  this.isTrimming = !0, 0 > i && (i += 1);
                  var a = this.s.v + i,
                      r = this.e.v + i;
                  if (a > r) {
                    var n = a;
                    a = r, r = n;
                  }
                  this.sValue = a, this.eValue = r, this.oValue = i;
                }
              }
            }
            return function(e, s) {
              this.elem = e, this.frameId = -1, this.dynamicProperties = [], this.sValue = 0, this.eValue = 0, this.oValue = 0, this.mdf = !1, this.getValue = t, this.k = !1, this.isTrimming = !1, this.comp = e.comp, this.s = l(e, s.s, 0, .01, this.dynamicProperties), this.e = l(e, s.e, 0, .01, this.dynamicProperties), this.o = l(e, s.o, 0, 0, this.dynamicProperties), this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
            };
          }(),
          k = function() {
            function t(t, e) {
              this.totalLength = 0;
              var s,
                  i = t.v,
                  a = t.o,
                  r = t.i,
                  n = i.length;
              for (s = 0; n - 1 > s; s += 1)
                this.lengths[s] = bez.getBezierLength(i[s], i[s + 1], a[s], r[s + 1]), this.totalLength += this.lengths[s].addedLength;
              e && (this.lengths[s] = bez.getBezierLength(i[s], i[0], a[s], r[0]), this.totalLength += this.lengths[s].addedLength);
            }
            function e(t, e, s, i, a) {
              this.nextO[this.segmentCount] = e, this.nextI[this.segmentCount + 1] = s, this.nextV[this.segmentCount + 1] = i, this.pathStarted ? this.nextV[this.segmentCount] = t : (this.pathStarted = !0, this.v.s[this.segmentCount] = t), this.segmentCount += 1;
            }
            function s(t) {
              this.mdf = t ? !0 : !1, this.prop.k && this.prop.getValue();
              var e = 0,
                  s = this.trims.length;
              for (this.pathStarted = !1; s > e; ) {
                if (this.trims[e].mdf) {
                  this.mdf = !0;
                  break;
                }
                e += 1;
              }
              if (this.mdf = this.prop.mdf ? !0 : this.mdf, this.mdf) {
                this.nextO.length = 0, this.nextI.length = 0, this.nextV.length = 0, this.v.s.length = 0;
                var i = this.prop.closed;
                this.getSegmentsLength(this.prop.v, i);
                var a,
                    r,
                    n,
                    o,
                    h,
                    l,
                    p = this.prop.v,
                    m = this.trims.length;
                for (a = 0; m > a; a += 1)
                  if (this.trims[a].isTrimming) {
                    if (r = this.trims[a].eValue, n = this.trims[a].sValue, o = this.trims[a].oValue, r === n)
                      return this.v.v = this.nextV, this.v.o = this.nextO, void(this.v.i = this.nextI);
                    1 >= r ? (this.segments[0].s = this.totalLength * n, this.segments[0].e = this.totalLength * r, this.segments[1].vl = !1) : n >= 1 ? (this.segments[0].s = this.totalLength * (n - 1), this.segments[0].e = this.totalLength * (r - 1), this.segments[1].vl = !1) : (this.segments[0].s = this.totalLength * n, this.segments[0].e = this.totalLength, this.segments[1].s = 0, this.segments[1].e = this.totalLength * (r - 1), this.segments[1].vl = !0), this.v.v = p.v, this.v.o = p.o, this.v.i = p.i, l = this.v.v.length;
                    var f = 0,
                        d = 0;
                    s = this.segments[1].vl ? 2 : 1;
                    var c;
                    for (this.segmentCount = 0, e = 0; s > e; e += 1) {
                      for (f = 0, h = 1; l > h; h++)
                        if (d = this.lengths[h - 1].addedLength, f + d < this.segments[e].s)
                          f += d;
                        else {
                          if (f > this.segments[e].e)
                            break;
                          this.segments[e].s <= f && this.segments[e].e >= f + d ? this.addSegment(this.v.v[h - 1], this.v.o[h - 1], this.v.i[h], this.v.v[h], this.lengths[h - 1]) : (c = bez.getNewSegment(this.v.v[h - 1], this.v.v[h], this.v.o[h - 1], this.v.i[h], (this.segments[e].s - f) / d, (this.segments[e].e - f) / d, this.lengths[h - 1]), this.addSegment(c.pt1, c.pt3, c.pt4, c.pt2)), f += d;
                        }
                      i !== !1 ? f <= this.segments[e].e && (d = this.lengths[h - 1].addedLength, this.segments[e].s <= f && this.segments[e].e >= f + d ? this.addSegment(this.v.v[h - 1], this.v.o[h - 1], this.v.i[0], this.v.v[0], this.lengths[h - 1]) : (c = bez.getNewSegment(this.v.v[h - 1], this.v.v[0], this.v.o[h - 1], this.v.i[0], (this.segments[e].s - f) / d, (this.segments[e].e - f) / d, this.lengths[h - 1]), this.addSegment(c.pt1, c.pt3, c.pt4, c.pt2))) : this.pathStarted = !1;
                    }
                    i = !1;
                  } else
                    this.v.v = p.v, this.v.o = p.o, this.v.i = p.i;
                this.nextV.length ? (this.v.v = this.nextV, this.v.o = this.nextO, this.v.i = this.nextI) : this.v.s.length = 0, this.v.c = i;
              }
            }
            return function(i, a) {
              this.trims = [], this.k = !1, this.mdf = !1, this.ty = "tm", this.pathStarted = !1, this.segments = [{
                s: 0,
                e: 0,
                vl: !0
              }, {
                s: 0,
                e: 0,
                vl: !1
              }], this.nextO = [], this.nextV = [], this.nextI = [], this.v = {
                i: null,
                o: null,
                v: null,
                s: [],
                c: !1
              };
              var r,
                  n = a.length;
              for (r = 0; n > r; r += 1)
                a[r].closed || (this.k = a[r].trimProp.k ? !0 : this.k, this.trims.push(a[r].trimProp));
              this.prop = i, this.prop.numNodes ? (n = this.prop.numNodes - 1, n += this.prop.closed ? 1 : 0, this.lengths = new Array(n)) : this.lengths = [], this.k = i.k ? !0 : this.k, this.totalLength = 0, this.getValue = s, this.addSegment = e, this.getSegmentsLength = t, this.k || (this.prop.getValue(), this.getValue(!0));
            };
          }(),
          S = function() {
            function t(t) {
              var e = 0,
                  s = this.dataProps.length;
              if (this.elem.globalData.frameId !== this.frameId || t) {
                for (this.mdf = !1, this.frameId = this.elem.globalData.frameId; s > e; ) {
                  if (this.dataProps[e].p.mdf) {
                    this.mdf = !0;
                    break;
                  }
                  e += 1;
                }
                if (this.mdf || t)
                  for ("svg" === this.renderer && (this.dasharray = ""), e = 0; s > e; e += 1)
                    "o" != this.dataProps[e].n ? "svg" === this.renderer ? this.dasharray += " " + this.dataProps[e].p.v : this.dasharray[e] = this.dataProps[e].p.v : this.dashoffset = this.dataProps[e].p.v;
              }
            }
            return function(e, s, i, a) {
              this.elem = e, this.frameId = -1, this.dataProps = new Array(s.length), this.renderer = i, this.mdf = !1, this.k = !1, this.dasharray = "svg" === this.renderer ? "" : new Array(s.length - 1), this.dashoffset = 0;
              var r,
                  n,
                  o = s.length;
              for (r = 0; o > r; r += 1)
                n = l(e, s[r].v, 0, 0, a), this.k = n.k ? !0 : this.k, this.dataProps[r] = {
                  n: s[r].n,
                  p: n
                };
              this.getValue = t, this.k ? a.push(this) : this.getValue(!0);
            };
          }(),
          C = function() {
            function t(t, e) {
              return this.textIndex = t + 1, this.textTotal = e, this.getValue(), this.v;
            }
            return function(e, s) {
              this.pv = 1, this.comp = e.comp, this.mult = .01, this.type = "textSelector", this.textTotal = s.totalChars, this.selectorValue = 100, this.lastValue = [1, 1, 1], a.bind(this)(e, s), this.getMult = t;
            };
          }(),
          x = function() {
            function t() {
              if (this.dynamicProperties.length) {
                var t,
                    e = this.dynamicProperties.length;
                for (t = 0; e > t; t += 1)
                  this.dynamicProperties[t].getValue();
              }
              var s = this.data.totalChars,
                  i = 2 === this.data.r ? 1 : 100 / s,
                  a = this.o.v / i,
                  r = this.s.v / i + a,
                  n = this.e.v / i + a;
              if (r > n) {
                var o = r;
                r = n, n = o;
              }
              this.finalS = r, this.finalE = n;
            }
            function e(t) {
              var e = BezierFactory.getBezierEasing(this.ne.v / 100, 0, 1 - this.xe.v / 100, 1).get,
                  r = 0,
                  n = this.finalS,
                  o = this.finalE,
                  h = this.data.sh;
              if (2 == h)
                r = o === n ? t >= o ? 1 : 0 : s(0, i(.5 / (o - n) + (t - n) / (o - n), 1)), r = e(r);
              else if (3 == h)
                r = o === n ? t >= o ? 0 : 1 : 1 - s(0, i(.5 / (o - n) + (t - n) / (o - n), 1)), r = e(r);
              else if (4 == h)
                o === n ? r = t >= o ? 0 : 1 : (r = s(0, i(.5 / (o - n) + (t - n) / (o - n), 1)), .5 > r ? r *= 2 : r = 1 - r);
              else if (5 == h)
                if (o === n)
                  r = t >= o ? 0 : 1;
                else {
                  var l = o - n;
                  r = -4 / (l * l) * t * t + 4 / l * t;
                }
              else
                6 == h ? r = o === n ? t >= o ? 0 : 1 : (1 + (Math.cos(Math.PI + 2 * Math.PI * (t - n) / (o - n)) + 0)) / 2 : t >= a(n) && (r = 0 > t - n ? 1 - (n - t) : s(0, i(o - t, 1)));
              return r * this.a.v;
            }
            var s = Math.max,
                i = Math.min,
                a = Math.floor;
            return function(s, i, a) {
              this.mdf = !1, this.k = !1, this.data = i, this.dynamicProperties = [], this.getValue = t, this.getMult = e, this.comp = s.comp, this.finalS = 0, this.finalE = 0, this.s = l(s, i.s || {k: 0}, 0, 0, this.dynamicProperties), this.e = "e" in i ? l(s, i.e, 0, 0, this.dynamicProperties) : {v: 2 === i.r ? i.totalChars : 100}, this.o = l(s, i.o || {k: 0}, 0, 0, this.dynamicProperties), this.xe = l(s, i.xe || {k: 0}, 0, 0, this.dynamicProperties), this.ne = l(s, i.ne || {k: 0}, 0, 0, this.dynamicProperties), this.a = l(s, i.a, 0, .01, this.dynamicProperties), this.dynamicProperties.length ? a.push(this) : this.getValue();
            };
          }(),
          w = {};
      return w.getProp = l, w.getShapeProp = d, w.getDashProp = c, w.getTextSelectorProp = u, w;
    }();
    SVGRenderer.prototype.createItem = function(t, e, s, i) {
      switch (t.ty) {
        case 2:
          return this.createImage(t, e, s, i);
        case 0:
          return this.createComp(t, e, s, i);
        case 1:
          return this.createSolid(t, e, s, i);
        case 4:
          return this.createShape(t, e, s, i);
        case 5:
          return this.createText(t, e, s, i);
        case 99:
          return this.createPlaceHolder(t, e);
      }
      return this.createBase(t, e, s);
    }, SVGRenderer.prototype.buildItems = function(t, e, s, i, a) {
      var r,
          n = t.length;
      s || (s = this.elements), e || (e = this.animationItem.container), i || (i = this);
      var o;
      for (r = n - 1; r >= 0; r--)
        s[r] = this.createItem(t[r], e, i, a), 0 === t[r].ty && (o = [], this.buildItems(t[r].layers, s[r].getDomElement(), o, s[r], s[r].placeholder), s[r].setElements(o)), t[r].td && s[r + 1].setMatte(s[r].layerId);
    }, SVGRenderer.prototype.includeLayers = function(t, e, s) {
      var i,
          a = t.length;
      s || (s = this.elements), e || (e = this.animationItem.container);
      var r,
          n,
          o,
          h = s.length;
      for (i = 0; a > i; i += 1)
        for (r = 0; h > r; ) {
          if (s[r].data.id == t[i].id) {
            o = s[r], s[r] = this.createItem(t[i], e, this, o), 0 === t[i].ty && (n = [], this.buildItems(t[i].layers, s[r].getDomElement(), n, s[r], s[i].placeholder), s[r].setElements(n));
            break;
          }
          r += 1;
        }
      for (i = 0; a > i; i += 1)
        t[i].td && s[i + 1].setMatte(s[i].layerId);
    }, SVGRenderer.prototype.createBase = function(t, e, s, i) {
      return new SVGBaseElement(t, e, this.globalData, s, i);
    }, SVGRenderer.prototype.createPlaceHolder = function(t, e) {
      return new PlaceHolderElement(t, e, this.globalData);
    }, SVGRenderer.prototype.createShape = function(t, e, s, i) {
      return new IShapeElement(t, e, this.globalData, s, i);
    }, SVGRenderer.prototype.createText = function(t, e, s, i) {
      return new SVGTextElement(t, e, this.globalData, s, i);
    }, SVGRenderer.prototype.createImage = function(t, e, s, i) {
      return new IImageElement(t, e, this.globalData, s, i);
    }, SVGRenderer.prototype.createComp = function(t, e, s, i) {
      return new ICompElement(t, e, this.globalData, s, i);
    }, SVGRenderer.prototype.createSolid = function(t, e, s, i) {
      return new ISolidElement(t, e, this.globalData, s, i);
    }, SVGRenderer.prototype.configAnimation = function(t) {
      this.animationItem.container = document.createElementNS(svgNS, "svg"), this.animationItem.container.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.animationItem.container.setAttribute("width", t.w), this.animationItem.container.setAttribute("height", t.h), this.animationItem.container.setAttribute("viewBox", "0 0 " + t.w + " " + t.h), this.animationItem.container.setAttribute("preserveAspectRatio", "xMidYMid meet"), this.animationItem.container.style.width = "100%", this.animationItem.container.style.height = "100%", this.animationItem.container.style.transform = "translate3d(0,0,0)", this.animationItem.container.style.transformOrigin = this.animationItem.container.style.mozTransformOrigin = this.animationItem.container.style.webkitTransformOrigin = this.animationItem.container.style["-webkit-transform"] = "0px 0px 0px", this.animationItem.wrapper.appendChild(this.animationItem.container);
      var e = document.createElementNS(svgNS, "defs");
      this.globalData.defs = e, this.animationItem.container.appendChild(e), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getPath = this.animationItem.getPath.bind(this.animationItem), this.globalData.elementLoaded = this.animationItem.elementLoaded.bind(this.animationItem), this.globalData.frameId = 0, this.globalData.compSize = {
        w: t.w,
        h: t.h
      }, this.globalData.frameRate = t.fr;
      var s = document.createElementNS(svgNS, "clipPath"),
          i = document.createElementNS(svgNS, "rect");
      i.setAttribute("width", t.w), i.setAttribute("height", t.h), i.setAttribute("x", 0), i.setAttribute("y", 0);
      var a = "animationMask_" + randomString(10);
      s.setAttribute("id", a), s.appendChild(i);
      var r = document.createElementNS(svgNS, "g");
      r.setAttribute("clip-path", "url(#" + a + ")"), this.animationItem.container.appendChild(r), e.appendChild(s), this.animationItem.container = r, this.layers = t.layers, this.globalData.fontManager = new FontManager, this.globalData.fontManager.addChars(t.chars), this.globalData.fontManager.addFonts(t.fonts, e);
    }, SVGRenderer.prototype.buildStage = function(t, e, s) {
      var i,
          a,
          r = e.length;
      for (s || (s = this.elements), i = r - 1; i >= 0; i--)
        a = e[i], void 0 !== a.parent && this.buildItemParenting(a, s[i], e, a.parent, s, !0), 0 === a.ty && this.buildStage(s[i].getComposingElement(), a.layers, s[i].getElements());
    }, SVGRenderer.prototype.buildItemParenting = function(t, e, s, i, a, r) {
      t.parents || (t.parents = []), r && e.resetHierarchy();
      for (var n = 0,
          o = s.length; o > n; )
        s[n].ind == i && (e.getHierarchy().push(a[n]), void 0 !== s[n].parent && this.buildItemParenting(t, e, s, s[n].parent, a, !1)), n += 1;
    }, SVGRenderer.prototype.destroy = function() {
      this.animationItem.wrapper.innerHTML = "", this.animationItem.container = null, this.globalData.defs = null;
      var t,
          e = this.layers.length;
      for (t = 0; e > t; t++)
        this.elements[t].destroy();
      this.elements.length = 0, this.destroyed = !0;
    }, SVGRenderer.prototype.updateContainerSize = function() {}, SVGRenderer.prototype.renderFrame = function(t) {
      if (this.renderedFrame != t && !this.destroyed) {
        null === t ? t = this.renderedFrame : this.renderedFrame = t, this.globalData.frameNum = t, this.globalData.frameId += 1;
        var e,
            s = this.layers.length;
        for (e = 0; s > e; e++)
          this.elements[e].prepareFrame(t - this.layers[e].st);
        for (e = 0; s > e; e++)
          this.elements[e].renderFrame();
      }
    }, SVGRenderer.prototype.hide = function() {
      this.animationItem.container.style.display = "none";
    }, SVGRenderer.prototype.show = function() {
      this.animationItem.container.style.display = "block";
    }, extendPrototype(ExpressionComp, SVGRenderer), CanvasRenderer.prototype.createItem = function(t, e) {
      switch (t.ty) {
        case 0:
          return this.createComp(t, e);
        case 1:
          return this.createSolid(t, e);
        case 2:
          return this.createImage(t, e);
        case 4:
          return this.createShape(t, e);
        case 5:
          return this.createText(t, e);
        case 99:
          return this.createPlaceHolder(t, e);
        default:
          return this.createBase(t, e);
      }
      return this.createBase(t, e);
    }, CanvasRenderer.prototype.buildItems = function(t, e, s) {
      e || (e = this.elements), s || (s = this);
      var i,
          a = t.length;
      for (i = 0; a > i; i++)
        if (e[i] = this.createItem(t[i], s), 0 === t[i].ty) {
          var r = [];
          this.buildItems(t[i].layers, r, e[i]), e[e.length - 1].setElements(r);
        }
    }, CanvasRenderer.prototype.includeLayers = function(t, e, s) {
      var i,
          a = t.length;
      s || (s = this.elements);
      var r,
          n,
          o = s.length;
      for (i = 0; a > i; i += 1)
        for (r = 0; o > r; ) {
          if (s[r].data.id == t[i].id) {
            s[r] = this.createItem(t[i], this), 0 === t[i].ty && (n = [], this.buildItems(t[i].layers, n, s[r]), s[r].setElements(n));
            break;
          }
          r += 1;
        }
    }, CanvasRenderer.prototype.createBase = function(t, e) {
      return new CVBaseElement(t, e, this.globalData);
    }, CanvasRenderer.prototype.createShape = function(t, e) {
      return new CVShapeElement(t, e, this.globalData);
    }, CanvasRenderer.prototype.createText = function(t, e) {
      return new CVTextElement(t, e, this.globalData);
    }, CanvasRenderer.prototype.createPlaceHolder = function(t) {
      return new PlaceHolderElement(t, null, this.globalData);
    }, CanvasRenderer.prototype.createImage = function(t, e) {
      return new CVImageElement(t, e, this.globalData);
    }, CanvasRenderer.prototype.createComp = function(t, e) {
      return new CVCompElement(t, e, this.globalData);
    }, CanvasRenderer.prototype.createSolid = function(t, e) {
      return new CVSolidElement(t, e, this.globalData);
    }, CanvasRenderer.prototype.ctxTransform = function(t) {
      if (1 !== t[0] || 0 !== t[1] || 0 !== t[4] || 1 !== t[5] || 0 !== t[12] || 0 !== t[13]) {
        if (!this.renderConfig.clearCanvas)
          return void this.canvasContext.transform(t[0], t[1], t[4], t[5], t[12], t[13]);
        this.transformMat.cloneFromProps(t), this.transformMat.transform(this.contextData.cTr.props[0], this.contextData.cTr.props[1], this.contextData.cTr.props[2], this.contextData.cTr.props[3], this.contextData.cTr.props[4], this.contextData.cTr.props[5], this.contextData.cTr.props[6], this.contextData.cTr.props[7], this.contextData.cTr.props[8], this.contextData.cTr.props[9], this.contextData.cTr.props[10], this.contextData.cTr.props[11], this.contextData.cTr.props[12], this.contextData.cTr.props[13], this.contextData.cTr.props[14], this.contextData.cTr.props[15]), this.contextData.cTr.cloneFromProps(this.transformMat.props);
        var e = this.contextData.cTr.props;
        this.canvasContext.setTransform(e[0], e[1], e[4], e[5], e[12], e[13]);
      }
    }, CanvasRenderer.prototype.ctxOpacity = function(t) {
      if (1 !== t) {
        if (!this.renderConfig.clearCanvas)
          return void(this.canvasContext.globalAlpha *= 0 > t ? 0 : t);
        this.contextData.cO *= 0 > t ? 0 : t, this.canvasContext.globalAlpha = this.contextData.cO;
      }
    }, CanvasRenderer.prototype.reset = function() {
      return this.renderConfig.clearCanvas ? (this.contextData.cArrPos = 0, this.contextData.cTr.reset(), void(this.contextData.cO = 1)) : void this.canvasContext.restore();
    }, CanvasRenderer.prototype.save = function(t) {
      if (!this.renderConfig.clearCanvas)
        return void this.canvasContext.save();
      t && this.canvasContext.save();
      var e = this.contextData.cTr.props;
      (null === this.contextData.saved[this.contextData.cArrPos] || void 0 === this.contextData.saved[this.contextData.cArrPos]) && (this.contextData.saved[this.contextData.cArrPos] = new Array(16));
      var s,
          i = this.contextData.saved[this.contextData.cArrPos];
      for (s = 0; 16 > s; s += 1)
        i[s] = e[s];
      this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO, this.contextData.cArrPos += 1;
    }, CanvasRenderer.prototype.restore = function(t) {
      if (!this.renderConfig.clearCanvas)
        return void this.canvasContext.restore();
      t && this.canvasContext.restore(), this.contextData.cArrPos -= 1;
      var e,
          s = this.contextData.saved[this.contextData.cArrPos],
          i = this.contextData.cTr.props;
      for (e = 0; 16 > e; e += 1)
        i[e] = s[e];
      this.canvasContext.setTransform(s[0], s[1], s[4], s[5], s[12], s[13]), s = this.contextData.savedOp[this.contextData.cArrPos], this.contextData.cO = s, this.canvasContext.globalAlpha = s;
    }, CanvasRenderer.prototype.configAnimation = function(t) {
      this.animationItem.wrapper ? (this.animationItem.container = document.createElement("canvas"), this.animationItem.container.style.width = "100%", this.animationItem.container.style.height = "100%", this.animationItem.container.style.transformOrigin = this.animationItem.container.style.mozTransformOrigin = this.animationItem.container.style.webkitTransformOrigin = this.animationItem.container.style["-webkit-transform"] = "0px 0px 0px", this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d")) : this.canvasContext = this.renderConfig.context, this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.totalFrames = Math.floor(t.tf), this.globalData.compWidth = t.w, this.globalData.compHeight = t.h, this.globalData.frameRate = t.fr, this.globalData.frameId = 0, this.layers = t.layers, this.transformCanvas = {}, this.transformCanvas.w = t.w, this.transformCanvas.h = t.h, this.updateContainerSize(), this.globalData.fontManager = new FontManager, this.globalData.fontManager.addChars(t.chars), this.globalData.fontManager.addFonts(t.fonts, document);
    }, CanvasRenderer.prototype.updateContainerSize = function() {
      var t,
          e;
      if (this.animationItem.wrapper && this.animationItem.container ? (t = this.animationItem.wrapper.offsetWidth, e = this.animationItem.wrapper.offsetHeight, this.animationItem.container.setAttribute("width", t * this.renderConfig.dpr), this.animationItem.container.setAttribute("height", e * this.renderConfig.dpr)) : (t = this.canvasContext.canvas.width * this.renderConfig.dpr, e = this.canvasContext.canvas.height * this.renderConfig.dpr), "fit" == this.renderConfig.scaleMode) {
        var s = t / e,
            i = this.transformCanvas.w / this.transformCanvas.h;
        i > s ? (this.transformCanvas.sx = t / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = t / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = (e - this.transformCanvas.h * (t / this.transformCanvas.w)) / 2 * this.renderConfig.dpr) : (this.transformCanvas.sx = e / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = e / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = (t - this.transformCanvas.w * (e / this.transformCanvas.h)) / 2 * this.renderConfig.dpr, this.transformCanvas.ty = 0);
      } else
        this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0;
      this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1], this.globalData.cWidth = t, this.globalData.cHeight = e;
    }, CanvasRenderer.prototype.buildStage = function(t, e, s) {
      s || (s = this.elements);
      var i,
          a,
          r = e.length;
      for (i = r - 1; i >= 0; i--)
        a = e[i], void 0 !== a.parent && this.buildItemHierarchy(a, s[i], e, a.parent, s, !0), 0 == a.ty && this.buildStage(null, a.layers, s[i].getElements());
    }, CanvasRenderer.prototype.buildItemHierarchy = function(t, e, s, i, a, r) {
      var n = 0,
          o = s.length;
      for (r && e.resetHierarchy(); o > n; )
        s[n].ind === i && (e.getHierarchy().push(a[n]), void 0 !== s[n].parent && this.buildItemHierarchy(t, e, s, s[n].parent, a, !1)), n += 1;
    }, CanvasRenderer.prototype.destroy = function() {
      this.renderConfig.clearCanvas && (this.animationItem.wrapper.innerHTML = "");
      var t,
          e = this.layers.length;
      for (t = e - 1; t >= 0; t -= 1)
        this.elements[t].destroy();
      this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
    }, CanvasRenderer.prototype.renderFrame = function(t) {
      if (!(this.renderedFrame == t && this.renderConfig.clearCanvas === !0 || this.destroyed || null === t)) {
        this.renderedFrame = t, this.globalData.frameNum = t - this.animationItem.firstFrame, this.globalData.frameId += 1, this.renderConfig.clearCanvas === !0 ? (this.reset(), this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h)) : this.save(), this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip();
        var e,
            s = this.layers.length;
        for (e = 0; s > e; e++)
          this.elements[e].prepareFrame(t - this.layers[e].st);
        for (e = s - 1; e >= 0; e -= 1)
          this.elements[e].renderFrame();
        this.renderConfig.clearCanvas !== !0 && this.restore();
      }
    }, CanvasRenderer.prototype.hide = function() {
      this.animationItem.container.style.display = "none";
    }, CanvasRenderer.prototype.show = function() {
      this.animationItem.container.style.display = "block";
    }, extendPrototype(ExpressionComp, CanvasRenderer), HybridRenderer.prototype.createItem = function(t, e, s, i) {
      switch (t.ty) {
        case 2:
          return this.createImage(t, e, s, i);
        case 0:
          return this.createComp(t, e, s, i);
        case 1:
          return this.createSolid(t, e, s, i);
        case 4:
          return this.createShape(t, e, s, i);
        case 5:
          return this.createText(t, e, s, i);
        case 13:
          return this.createCamera(t, e, s, i);
        case 99:
          return this.createPlaceHolder(t, e);
      }
      return this.createBase(t, e, s);
    }, HybridRenderer.prototype.buildItems = function(t, e, s, i, a) {
      var r,
          n = t.length;
      s || (s = this.elements), i || (i = this);
      var o,
          h,
          l = !1;
      for (r = n - 1; r >= 0; r--)
        e ? s[r] = this.createItem(t[r], e, i, a) : t[r].ddd ? (l || (l = !0, o = this.getThreeDContainer()), s[r] = this.createItem(t[r], o, i, a)) : (l = !1, s[r] = this.createItem(t[r], this.animationItem.resizerElem, i, a)), 0 === t[r].ty && (h = [], this.buildItems(t[r].layers, s[r].getDomElement(), h, s[r], s[r].placeholder), s[r].setElements(h)), t[r].td && s[r + 1].setMatte(s[r].layerId);
      if (this.currentContainer = this.animationItem.resizerElem, !e && this.threeDElements.length)
        if (this.camera)
          this.camera.setup();
        else {
          var p = this.globalData.compSize.w,
              m = this.globalData.compSize.h;
          for (n = this.threeDElements.length, r = 0; n > r; r += 1)
            this.threeDElements[0][r].style.perspective = this.threeDElements[0][r].style.webkitPerspective = Math.sqrt(Math.pow(p, 2) + Math.pow(m, 2)) + "px";
        }
    }, HybridRenderer.prototype.includeLayers = function(t, e, s) {
      var i,
          a = t.length;
      s || (s = this.elements), e || (e = this.currentContainer);
      var r,
          n,
          o,
          h = s.length;
      for (i = 0; a > i; i += 1)
        if (t[i].id)
          for (r = 0; h > r; )
            s[r].data.id == t[i].id && (o = s[r], s[r] = this.createItem(t[i], e, this, o), 0 === t[i].ty && (n = [], this.buildItems(t[i].layers, s[r].getDomElement(), n, s[r], s[i].placeholder), s[r].setElements(n))), r += 1;
        else {
          var l = this.createItem(t[i], e, this);
          s.push(l), 0 === t[i].ty && (n = [], this.buildItems(t[i].layers, l.getDomElement(), n, l), l.setElements(n));
        }
      for (i = 0; a > i; i += 1)
        t[i].td && s[i + 1].setMatte(s[i].layerId);
    }, HybridRenderer.prototype.createBase = function(t, e, s, i) {
      return new SVGBaseElement(t, e, this.globalData, s, i);
    }, HybridRenderer.prototype.createPlaceHolder = function(t, e) {
      return new PlaceHolderElement(t, e, this.globalData);
    }, HybridRenderer.prototype.createShape = function(t, e, s, i) {
      return s.isSvg ? new IShapeElement(t, e, this.globalData, s, i) : new HShapeElement(t, e, this.globalData, s, i);
    }, HybridRenderer.prototype.createText = function(t, e, s, i) {
      return s.isSvg ? new SVGTextElement(t, e, this.globalData, s, i) : new HTextElement(t, e, this.globalData, s, i);
    }, HybridRenderer.prototype.createCamera = function(t, e, s, i) {
      return this.camera = new HCameraElement(t, e, this.globalData, s, i), this.camera;
    }, HybridRenderer.prototype.createImage = function(t, e, s, i) {
      return s.isSvg ? new IImageElement(t, e, this.globalData, s, i) : new HImageElement(t, e, this.globalData, s, i);
    }, HybridRenderer.prototype.createComp = function(t, e, s, i) {
      return s.isSvg ? new ICompElement(t, e, this.globalData, s, i) : new HCompElement(t, e, this.globalData, s, i);
    }, HybridRenderer.prototype.createSolid = function(t, e, s, i) {
      return s.isSvg ? new ISolidElement(t, e, this.globalData, s, i) : new HSolidElement(t, e, this.globalData, s, i);
    }, HybridRenderer.prototype.getThreeDContainer = function() {
      var t = document.createElement("div");
      styleDiv(t), t.style.width = this.globalData.compSize.w + "px", t.style.height = this.globalData.compSize.h + "px", t.style.transformOrigin = t.style.mozTransformOrigin = t.style.webkitTransformOrigin = "50% 50%";
      var e = document.createElement("div");
      return styleDiv(e), e.style.transform = e.style.webkitTransform = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)", t.appendChild(e), this.animationItem.resizerElem.appendChild(t), this.threeDElements.push([t, e]), e;
    }, HybridRenderer.prototype.configAnimation = function(t) {
      var e = document.createElement("div"),
          s = this.animationItem.wrapper;
      e.style.width = t.w + "px", e.style.height = t.h + "px", this.animationItem.resizerElem = e, styleDiv(e), e.style.transformStyle = e.style.webkitTransformStyle = e.style.mozTransformStyle = "flat", s.appendChild(e), e.style.overflow = "hidden";
      var i = document.createElementNS(svgNS, "svg");
      i.setAttribute("width", "1"), i.setAttribute("height", "1"), styleDiv(i), this.animationItem.resizerElem.appendChild(i);
      var a = document.createElementNS(svgNS, "defs");
      i.appendChild(a), this.globalData.defs = a, this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getPath = this.animationItem.getPath.bind(this.animationItem), this.globalData.elementLoaded = this.animationItem.elementLoaded.bind(this.animationItem), this.globalData.frameId = 0, this.globalData.compSize = {
        w: t.w,
        h: t.h
      }, this.globalData.frameRate = t.fr, this.layers = t.layers, this.globalData.fontManager = new FontManager, this.globalData.fontManager.addChars(t.chars), this.globalData.fontManager.addFonts(t.fonts, i), this.updateContainerSize();
    }, HybridRenderer.prototype.buildStage = function(t, e, s) {
      var i,
          a,
          r = e.length;
      for (s || (s = this.elements), i = r - 1; i >= 0; i--)
        a = e[i], void 0 !== a.parent && this.buildItemParenting(a, s[i], e, a.parent, s, !0), 0 === a.ty && this.buildStage(s[i].getComposingElement(), a.layers, s[i].getElements());
    }, HybridRenderer.prototype.buildItemParenting = function(t, e, s, i, a, r) {
      t.parents || (t.parents = []), r && e.resetHierarchy();
      for (var n = 0,
          o = s.length; o > n; )
        s[n].ind == i && (e.getHierarchy().push(a[n]), 13 === e.data.ty && a[n].finalTransform.mProp.setInverted(), void 0 !== s[n].parent && this.buildItemParenting(t, e, s, s[n].parent, a, !1)), n += 1;
    }, HybridRenderer.prototype.destroy = function() {
      this.animationItem.wrapper.innerHTML = "", this.animationItem.container = null, this.globalData.defs = null;
      var t,
          e = this.layers.length;
      for (t = 0; e > t; t++)
        this.elements[t].destroy();
      this.elements.length = 0, this.destroyed = !0;
    }, HybridRenderer.prototype.updateContainerSize = function() {
      var t,
          e,
          s,
          i,
          a = this.animationItem.wrapper.offsetWidth,
          r = this.animationItem.wrapper.offsetHeight,
          n = a / r,
          o = this.globalData.compSize.w / this.globalData.compSize.h;
      o > n ? (t = a / this.globalData.compSize.w, e = a / this.globalData.compSize.w, s = 0, i = (r - this.globalData.compSize.h * (a / this.globalData.compSize.w)) / 2) : (t = r / this.globalData.compSize.h, e = r / this.globalData.compSize.h, s = (a - this.globalData.compSize.w * (r / this.globalData.compSize.h)) / 2, i = 0), this.animationItem.resizerElem.style.transform = this.animationItem.resizerElem.style.webkitTransform = "matrix3d(" + t + ",0,0,0,0," + e + ",0,0,0,0,1,0," + s + "," + i + ",0,1)";
    }, HybridRenderer.prototype.renderFrame = function(t) {
      if (this.renderedFrame != t && !this.destroyed) {
        null === t ? t = this.renderedFrame : this.renderedFrame = t, this.globalData.frameNum = t, this.globalData.frameId += 1;
        var e,
            s = this.layers.length;
        for (e = 0; s > e; e++)
          this.elements[e].prepareFrame(t - this.layers[e].st);
        for (e = 0; s > e; e++)
          this.elements[e].renderFrame();
      }
    }, HybridRenderer.prototype.hide = function() {
      this.animationItem.resizerElem.style.display = "none";
    }, HybridRenderer.prototype.show = function() {
      this.animationItem.resizerElem.style.display = "block";
    }, extendPrototype(ExpressionComp, HybridRenderer), MaskElement.prototype.getMaskProperty = function(t) {
      return this.viewData[t].prop;
    }, MaskElement.prototype.prepareFrame = function() {
      var t,
          e = this.dynamicProperties.length;
      for (t = 0; e > t; t += 1)
        this.dynamicProperties[t].getValue();
    }, MaskElement.prototype.renderFrame = function() {
      var t,
          e = this.masksProperties.length;
      for (t = 0; e > t; t++)
        if ("n" !== this.masksProperties[t].mode && this.masksProperties[t].cl !== !1 && ((this.viewData[t].prop.mdf || this.firstFrame) && this.drawPath(this.masksProperties[t], this.viewData[t].prop.v, this.viewData[t]), this.storedData[t].x && (this.storedData[t].x.mdf || this.firstFrame))) {
          var s = this.storedData[t].expan;
          this.storedData[t].x.v < 0 ? ("erode" !== this.storedData[t].lastOperator && (this.storedData[t].lastOperator = "erode", this.storedData[t].elem.setAttribute("filter", "url(#" + this.storedData[t].filterId + ")")), s.setAttribute("radius", -this.storedData[t].x.v)) : ("dilate" !== this.storedData[t].lastOperator && (this.storedData[t].lastOperator = "dilate", this.storedData[t].elem.setAttribute("filter", null)), this.storedData[t].elem.setAttribute("stroke-width", 2 * this.storedData[t].x.v));
        }
      this.firstFrame = !1;
    }, MaskElement.prototype.getMaskelement = function() {
      return this.maskElement;
    }, MaskElement.prototype.createLayerSolidPath = function() {
      var t = "M0,0 ";
      return t += " h" + this.globalData.compSize.w, t += " v" + this.globalData.compSize.h, t += " h-" + this.globalData.compSize.w, t += " v-" + this.globalData.compSize.h + " ";
    }, MaskElement.prototype.drawPath = function(t, e, s) {
      var i,
          a,
          r = "";
      for (a = e.v.length, i = 1; a > i; i += 1)
        1 == i && (r += " M" + bm_rnd(e.v[0][0]) + "," + bm_rnd(e.v[0][1])), r += " C" + bm_rnd(e.o[i - 1][0]) + "," + bm_rnd(e.o[i - 1][1]) + " " + bm_rnd(e.i[i][0]) + "," + bm_rnd(e.i[i][1]) + " " + bm_rnd(e.v[i][0]) + "," + bm_rnd(e.v[i][1]);
      t.cl && (r += " C" + bm_rnd(e.o[i - 1][0]) + "," + bm_rnd(e.o[i - 1][1]) + " " + bm_rnd(e.i[0][0]) + "," + bm_rnd(e.i[0][1]) + " " + bm_rnd(e.v[0][0]) + "," + bm_rnd(e.v[0][1])), s.lastPath !== r && (t.inv ? s.elem.setAttribute("d", this.solidPath + r) : s.elem.setAttribute("d", r), s.lastPath = r);
    }, MaskElement.prototype.getMask = function(t) {
      for (var e = 0,
          s = this.masksProperties.length; s > e; ) {
        if (this.masksProperties[e].nm === t)
          return {maskPath: this.viewData[e].prop.pv};
        e += 1;
      }
    }, MaskElement.prototype.destroy = function() {
      this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.paths = null, this.masksProperties = null;
    }, SliderEffect.prototype.proxyFunction = function() {
      return this.p.k && this.p.getValue(), this.p.v;
    }, AngleEffect.prototype.proxyFunction = SliderEffect.prototype.proxyFunction, ColorEffect.prototype.proxyFunction = SliderEffect.prototype.proxyFunction, PointEffect.prototype.proxyFunction = SliderEffect.prototype.proxyFunction, CheckboxEffect.prototype.proxyFunction = SliderEffect.prototype.proxyFunction, EffectsManager.prototype.getEffect = function(t) {
      for (var e = this.data.ef,
          s = 0,
          i = e.length; i > s; ) {
        if (e[s].nm === t)
          return this.effectElements[s];
        s += 1;
      }
    }, BaseElement.prototype.checkMasks = function() {
      if (!this.data.hasMask)
        return !1;
      for (var t = 0,
          e = this.data.masksProperties.length; e > t; ) {
        if ("n" !== this.data.masksProperties[t].mode && this.data.masksProperties[t].cl !== !1)
          return !0;
        t += 1;
      }
      return !1;
    }, BaseElement.prototype.prepareFrame = function(t) {
      this.data.ip - this.data.st <= t && this.data.op - this.data.st > t ? this.isVisible !== !0 && (this.isVisible = !0, this.firstFrame = !0, this.data.hasMask && (this.maskManager.firstFrame = !0)) : this.isVisible !== !1 && (this.isVisible = !1);
      var e,
          s = this.dynamicProperties.length;
      for (e = 0; s > e; e += 1)
        this.dynamicProperties[e].getValue(t);
      return this.data.hasMask && this.maskManager.prepareFrame(t), this.currentFrameNum = t, this.isVisible;
    }, BaseElement.prototype.init = function() {
      this.hidden = !1, this.firstFrame = !0, this.isVisible = !1, this.dynamicProperties = [], this.currentFrameNum = -99999, this.lastNum = -99999, this.data.ef && (this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties), this.effect = this.effectsManager.getEffect.bind(this.effectsManager)), this.finalTransform = {
        mProp: PropertyFactory.getProp(this, this.data.ks, 2, null, this.dynamicProperties),
        matMdf: !1,
        opMdf: !1,
        mat: new Matrix,
        opacity: 1
      }, this.finalTransform.op = this.finalTransform.mProp.o, this.transform = this.finalTransform.mProp, this.createElements(), this.data.hasMask && this.addMasks(this.data);
    }, BaseElement.prototype.getType = function() {
      return this.type;
    }, BaseElement.prototype.resetHierarchy = function() {
      this.hierarchy ? this.hierarchy.length = 0 : this.hierarchy = [];
    }, BaseElement.prototype.getHierarchy = function() {
      return this.hierarchy || (this.hierarchy = []), this.hierarchy;
    }, BaseElement.prototype.getLayerSize = function() {
      return 5 === this.data.ty ? {
        w: this.data.textData.width,
        h: this.data.textData.height
      } : {
        w: this.data.width,
        h: this.data.height
      };
    }, BaseElement.prototype.hide = function() {}, BaseElement.prototype.mHelper = new Matrix, BaseElement.prototype.mask = function(t) {
      return this.maskManager.getMask(t);
    }, extendPrototype(LayerInterface, BaseElement), Object.defineProperty(BaseElement.prototype, "anchorPoint", {get: function() {
        return this.finalTransform.mProp.anchorPoint;
      }}), createElement(BaseElement, SVGBaseElement), SVGBaseElement.prototype.appendNodeToParent = function(t) {
      if (this.placeholder) {
        var e = this.placeholder.phElement;
        e.parentNode.insertBefore(t, e);
      } else
        this.parentContainer.appendChild(t);
    }, SVGBaseElement.prototype.createElements = function() {
      if (this.data.td) {
        if (3 == this.data.td)
          this.layerElement = document.createElementNS(svgNS, "mask"), this.layerElement.setAttribute("id", this.layerId), this.layerElement.setAttribute("mask-type", "luminance"), this.globalData.defs.appendChild(this.layerElement);
        else if (2 == this.data.td) {
          var t = document.createElementNS(svgNS, "mask");
          t.setAttribute("id", this.layerId), t.setAttribute("mask-type", "alpha");
          var e = document.createElementNS(svgNS, "g");
          t.appendChild(e), this.layerElement = document.createElementNS(svgNS, "g");
          var s = document.createElementNS(svgNS, "filter"),
              i = randomString(10);
          s.setAttribute("id", i), s.setAttribute("filterUnits", "objectBoundingBox"), s.setAttribute("x", "0%"), s.setAttribute("y", "0%"), s.setAttribute("width", "100%"), s.setAttribute("height", "100%");
          var a = document.createElementNS(svgNS, "feComponentTransfer");
          a.setAttribute("in", "SourceGraphic"), s.appendChild(a);
          var r = document.createElementNS(svgNS, "feFuncA");
          r.setAttribute("type", "table"), r.setAttribute("tableValues", "1.0 0.0"), a.appendChild(r), this.globalData.defs.appendChild(s);
          var n = document.createElementNS(svgNS, "rect");
          n.setAttribute("width", "100%"), n.setAttribute("height", "100%"), n.setAttribute("x", "0"), n.setAttribute("y", "0"), n.setAttribute("fill", "#ffffff"), n.setAttribute("opacity", "0"), e.setAttribute("filter", "url(#" + i + ")"), e.appendChild(n), e.appendChild(this.layerElement), this.globalData.defs.appendChild(t);
        } else {
          this.layerElement = document.createElementNS(svgNS, "g");
          var o = document.createElementNS(svgNS, "mask");
          o.setAttribute("id", this.layerId), o.setAttribute("mask-type", "alpha"), o.appendChild(this.layerElement), this.globalData.defs.appendChild(o);
        }
        this.data.hasMask && (this.maskedElement = this.layerElement);
      } else
        this.data.hasMask ? (this.layerElement = document.createElementNS(svgNS, "g"), this.data.tt ? (this.matteElement = document.createElementNS(svgNS, "g"), this.matteElement.appendChild(this.layerElement), this.appendNodeToParent(this.matteElement)) : this.appendNodeToParent(this.layerElement), this.maskedElement = this.layerElement) : this.data.tt ? (this.matteElement = document.createElementNS(svgNS, "g"), this.matteElement.setAttribute("id", this.layerId), this.appendNodeToParent(this.matteElement), this.layerElement = this.matteElement) : this.layerElement = this.parentContainer;
      !this.data.ln || 4 !== this.data.ty && 0 !== this.data.ty || (this.layerElement === this.parentContainer && (this.layerElement = document.createElementNS(svgNS, "g"), this.appendNodeToParent(this.layerElement)), this.layerElement.setAttribute("id", this.data.ln)), 0 !== this.data.ty || !this.finalTransform.op.k && 1 === this.finalTransform.op.p || this.layerElement !== this.parentContainer || (this.layerElement = document.createElementNS(svgNS, "g"), this.appendNodeToParent(this.layerElement)), this.layerElement !== this.parentContainer && (this.placeholder = null);
    }, SVGBaseElement.prototype.renderFrame = function(t) {
      if (3 === this.data.ty)
        return !1;
      if (this.currentFrameNum === this.lastNum || !this.isVisible)
        return this.isVisible;
      this.lastNum = this.currentFrameNum, this.data.hasMask && this.maskManager.renderFrame(), this.finalTransform.opMdf = this.finalTransform.op.mdf, this.finalTransform.matMdf = this.finalTransform.mProp.mdf, this.finalTransform.opacity = this.finalTransform.op.v, this.firstFrame && (this.finalTransform.opMdf = !0, this.finalTransform.matMdf = !0);
      var e,
          s = this.finalTransform.mat;
      if (this.hierarchy) {
        var i,
            a = this.hierarchy.length;
        for (e = this.finalTransform.mProp.v.props, s.cloneFromProps(e), i = 0; a > i; i += 1)
          this.finalTransform.matMdf = this.hierarchy[i].finalTransform.mProp.mdf ? !0 : this.finalTransform.matMdf, e = this.hierarchy[i].finalTransform.mProp.v.props, s.transform(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]);
      } else
        this.isVisible && (t ? (e = this.finalTransform.mProp.v.props, s.cloneFromProps(e)) : s.cloneFromProps(this.finalTransform.mProp.v.props));
      return t && (e = t.mat.props, s.transform(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]), this.finalTransform.opacity *= t.opacity, this.finalTransform.opMdf = t.opMdf ? !0 : this.finalTransform.opMdf, this.finalTransform.matMdf = t.matMdf ? !0 : this.finalTransform.matMdf), this.data.hasMask ? (this.finalTransform.matMdf && this.layerElement.setAttribute("transform", s.to2dCSS()), this.finalTransform.opMdf && this.layerElement.setAttribute("opacity", this.finalTransform.opacity)) : 0 === this.data.ty && this.finalTransform.opMdf && (this.finalTransform.op.k || 1 !== this.finalTransform.op.p) && (this.layerElement.setAttribute("opacity", this.finalTransform.opacity), this.finalTransform.opacity = 1), this.isVisible;
    }, SVGBaseElement.prototype.destroy = function() {
      this.layerElement = null, this.parentContainer = null, this.matteElement && (this.matteElement = null), this.maskManager && this.maskManager.destroy();
    }, SVGBaseElement.prototype.getDomElement = function() {
      return this.layerElement;
    }, SVGBaseElement.prototype.addMasks = function(t) {
      this.maskManager = new MaskElement(t, this, this.globalData);
    }, SVGBaseElement.prototype.setMatte = function(t) {
      this.matteElement && this.matteElement.setAttribute("mask", "url(#" + t + ")");
    }, SVGBaseElement.prototype.hide = function() {}, ITextElement.prototype.init = function() {
      this.parent.init.call(this), this.lettersChangedFlag = !1;
      var t = this.data;
      this.renderedLetters = Array.apply(null, {length: t.t.d.l.length}), this.viewData = {m: {a: PropertyFactory.getProp(this, t.t.m.a, 1, 0, this.dynamicProperties)}};
      var e = this.data.t;
      if (e.a.length) {
        this.viewData.a = Array.apply(null, {length: e.a.length});
        var s,
            i,
            a,
            r = e.a.length;
        for (s = 0; r > s; s += 1)
          a = e.a[s], i = {
            a: {},
            s: {}
          }, "r" in a.a && (i.a.r = PropertyFactory.getProp(this, a.a.r, 0, degToRads, this.dynamicProperties)), "rx" in a.a && (i.a.rx = PropertyFactory.getProp(this, a.a.rx, 0, degToRads, this.dynamicProperties)), "ry" in a.a && (i.a.ry = PropertyFactory.getProp(this, a.a.ry, 0, degToRads, this.dynamicProperties)), "sk" in a.a && (i.a.sk = PropertyFactory.getProp(this, a.a.sk, 0, degToRads, this.dynamicProperties)), "sa" in a.a && (i.a.sa = PropertyFactory.getProp(this, a.a.sa, 0, degToRads, this.dynamicProperties)), "s" in a.a && (i.a.s = PropertyFactory.getProp(this, a.a.s, 1, .01, this.dynamicProperties)), "a" in a.a && (i.a.a = PropertyFactory.getProp(this, a.a.a, 1, 0, this.dynamicProperties)), "o" in a.a && (i.a.o = PropertyFactory.getProp(this, a.a.o, 0, .01, this.dynamicProperties)), "p" in a.a && (i.a.p = PropertyFactory.getProp(this, a.a.p, 1, 0, this.dynamicProperties)), "sw" in a.a && (i.a.sw = PropertyFactory.getProp(this, a.a.sw, 0, 0, this.dynamicProperties)), "sc" in a.a && (i.a.sc = PropertyFactory.getProp(this, a.a.sc, 1, 0, this.dynamicProperties)), "fc" in a.a && (i.a.fc = PropertyFactory.getProp(this, a.a.fc, 1, 0, this.dynamicProperties)), "fh" in a.a && (i.a.fh = PropertyFactory.getProp(this, a.a.fh, 0, 0, this.dynamicProperties)), "fs" in a.a && (i.a.fs = PropertyFactory.getProp(this, a.a.fs, 0, .01, this.dynamicProperties)), "fb" in a.a && (i.a.fb = PropertyFactory.getProp(this, a.a.fb, 0, .01, this.dynamicProperties)), "t" in a.a && (i.a.t = PropertyFactory.getProp(this, a.a.t, 0, 0, this.dynamicProperties)), i.s = PropertyFactory.getTextSelectorProp(this, a.s, this.dynamicProperties), i.s.t = a.s.t, this.viewData.a[s] = i;
      } else
        this.viewData.a = [];
      e.p && "m" in e.p ? (this.viewData.p = {
        f: PropertyFactory.getProp(this, e.p.f, 0, 0, this.dynamicProperties),
        l: PropertyFactory.getProp(this, e.p.l, 0, 0, this.dynamicProperties),
        r: e.p.r,
        m: this.maskManager.getMaskProperty(e.p.m)
      }, this.maskPath = !0) : this.maskPath = !1;
    }, ITextElement.prototype.createPathShape = function(t, e) {
      var s,
          i,
          a,
          r,
          n = e.length,
          o = "";
      for (s = 0; n > s; s += 1) {
        for (a = e[s].ks.k.i.length, r = e[s].ks.k, i = 1; a > i; i += 1)
          1 == i && (o += " M" + t.applyToPointStringified(r.v[0][0], r.v[0][1])), o += " C" + t.applyToPointStringified(r.o[i - 1][0], r.o[i - 1][1]) + " " + t.applyToPointStringified(r.i[i][0], r.i[i][1]) + " " + t.applyToPointStringified(r.v[i][0], r.v[i][1]);
        o += " C" + t.applyToPointStringified(r.o[i - 1][0], r.o[i - 1][1]) + " " + t.applyToPointStringified(r.i[0][0], r.i[0][1]) + " " + t.applyToPointStringified(r.v[0][0], r.v[0][1]), o += "z";
      }
      return o;
    }, ITextElement.prototype.getMeasures = function() {
      var t,
          e,
          s,
          i,
          a = this.mHelper,
          r = this.renderType,
          n = this.data,
          o = n.t.d,
          h = o.l;
      if (this.maskPath) {
        var l = this.viewData.p.m;
        if (!this.viewData.p.n || this.viewData.p.mdf) {
          var p = l.v;
          this.viewData.p.r && (p = reversePath(p, l.closed));
          var m = {
            tLength: 0,
            segments: []
          };
          i = p.v.length - 1;
          var f,
              d = 0;
          for (s = 0; i > s; s += 1)
            f = {
              s: p.v[s],
              e: p.v[s + 1],
              to: [p.o[s][0] - p.v[s][0], p.o[s][1] - p.v[s][1]],
              ti: [p.i[s + 1][0] - p.v[s + 1][0], p.i[s + 1][1] - p.v[s + 1][1]]
            }, bez.buildBezierData(f), m.tLength += f.bezierData.segmentLength, m.segments.push(f), d += f.bezierData.segmentLength;
          s = i, l.closed && (f = {
            s: p.v[s],
            e: p.v[0],
            to: [p.o[s][0] - p.v[s][0], p.o[s][1] - p.v[s][1]],
            ti: [p.i[0][0] - p.v[0][0], p.i[0][1] - p.v[0][1]]
          }, bez.buildBezierData(f), m.tLength += f.bezierData.segmentLength, m.segments.push(f), d += f.bezierData.segmentLength), this.viewData.p.pi = m;
        }
        var c,
            u,
            y,
            m = this.viewData.p.pi,
            v = this.viewData.p.f.v,
            g = 0,
            b = 1,
            E = 0,
            P = !0,
            k = m.segments;
        if (0 > v && l.closed)
          for (m.tLength < Math.abs(v) && (v = -Math.abs(v) % m.tLength), g = k.length - 1, y = k[g].bezierData.points, b = y.length - 1; 0 > v; )
            v += y[b].partialLength, b -= 1, 0 > b && (g -= 1, y = k[g].bezierData.points, b = y.length - 1);
        y = k[g].bezierData.points, u = y[b - 1], c = y[b];
        var S,
            C,
            x = c.partialLength;
      }
      i = h.length, t = 0, e = 0;
      var w,
          D,
          T,
          M,
          I,
          F = 1.2 * n.t.d.s * .714,
          A = !0,
          V = this.viewData,
          N = Array.apply(null, {length: i});
      this.lettersChangedFlag = !1, M = V.a.length;
      var L,
          B,
          _,
          H,
          R,
          z,
          O,
          j,
          G,
          W,
          X,
          q,
          Y,
          Z,
          J,
          U,
          K = -1,
          Q = v,
          $ = g,
          tt = b,
          et = -1,
          st = 0;
      for (s = 0; i > s; s += 1)
        if (a.reset(), z = 1, h[s].n)
          t = 0, e += o.yOffset, e += A ? 1 : 0, v = Q, A = !1, st = 0, this.maskPath && (g = $, b = tt, y = k[g].bezierData.points, u = y[b - 1], c = y[b], x = c.partialLength, E = 0), N[s] = this.emptyProp;
        else {
          if (this.maskPath) {
            if (et !== h[s].line) {
              switch (o.j) {
                case 1:
                  v += d - o.lineWidths[h[s].line];
                  break;
                case 2:
                  v += (d - o.lineWidths[h[s].line]) / 2;
              }
              et = h[s].line;
            }
            K !== h[s].ind && (h[K] && (v += h[K].extra), v += h[s].an / 2, K = h[s].ind), v += V.m.a.v[0] * h[s].an / 200;
            var it = 0;
            for (T = 0; M > T; T += 1)
              w = V.a[T].a, "p" in w && (D = V.a[T].s, B = D.getMult(h[s].anIndexes[T]), it += B.length ? w.p.v[0] * B[0] : w.p.v[0] * B);
            for (P = !0; P; )
              E + x >= v + it || !y ? (S = (v + it - E) / c.partialLength, H = u.point[0] + (c.point[0] - u.point[0]) * S, R = u.point[1] + (c.point[1] - u.point[1]) * S, a.translate(0, -(V.m.a.v[1] * F / 100) + e), P = !1) : y && (E += c.partialLength, b += 1, b >= y.length && (b = 0, g += 1, k[g] ? y = k[g].bezierData.points : l.closed ? (b = 0, g = 0, y = k[g].bezierData.points) : (E -= c.partialLength, y = null)), y && (u = c, c = y[b], x = c.partialLength));
            _ = h[s].an / 2 - h[s].add, a.translate(-_, 0, 0);
          } else
            _ = h[s].an / 2 - h[s].add, a.translate(-_, 0, 0), a.translate(-V.m.a.v[0] * h[s].an / 200, -V.m.a.v[1] * F / 100, 0);
          for (st += h[s].l / 2, T = 0; M > T; T += 1)
            w = V.a[T].a, "t" in w && (D = V.a[T].s, B = D.getMult(h[s].anIndexes[T]), this.maskPath ? v += B.length ? w.t * B[0] : w.t * B : t += B.length ? w.t.v * B[0] : w.t.v * B);
          for (st += h[s].l / 2, o.strokeWidthAnim && (j = n.t.d.sw || 0), o.strokeColorAnim && (O = n.t.d.sc ? [n.t.d.sc[0], n.t.d.sc[1], n.t.d.sc[2]] : [0, 0, 0]), o.fillColorAnim && (G = [n.t.d.fc[0], n.t.d.fc[1], n.t.d.fc[2]]), T = 0; M > T; T += 1)
            w = V.a[T].a, "a" in w && (D = V.a[T].s, B = D.getMult(h[s].anIndexes[T]), B.length ? a.translate(-w.a.v[0] * B[0], -w.a.v[1] * B[1], w.a.v[2] * B[2]) : a.translate(-w.a.v[0] * B, -w.a.v[1] * B, w.a.v[2] * B));
          for (T = 0; M > T; T += 1)
            w = V.a[T].a, "s" in w && (D = V.a[T].s, B = D.getMult(h[s].anIndexes[T]), B.length ? a.scale(1 + (w.s.v[0] - 1) * B[0], 1 + (w.s.v[1] - 1) * B[1], 1) : a.scale(1 + (w.s.v[0] - 1) * B, 1 + (w.s.v[1] - 1) * B, 1));
          for (T = 0; M > T; T += 1) {
            if (w = V.a[T].a, D = V.a[T].s, B = D.getMult(h[s].anIndexes[T]), "sk" in w && (B.length ? a.skewFromAxis(-w.sk.v * B[0], w.sa.v * B[1]) : a.skewFromAxis(-w.sk.v * B, w.sa.v * B)), "r" in w && a.rotateZ(B.length ? -w.r.v * B[2] : -w.r.v * B), "ry" in w && a.rotateY(B.length ? w.ry.v * B[1] : w.ry.v * B), "rx" in w && a.rotateX(B.length ? w.rx.v * B[0] : w.rx.v * B), "o" in w && (z += B.length ? (w.o.v * B[0] - z) * B[0] : (w.o.v * B - z) * B), o.strokeWidthAnim && "sw" in w && (j += B.length ? w.sw.v * B[0] : w.sw.v * B), o.strokeColorAnim && "sc" in w)
              for (W = 0; 3 > W; W += 1)
                O[W] = Math.round(B.length ? O[W] + (w.sc.v[W] - O[W]) * B[0] : O[W] + (w.sc.v[W] - O[W]) * B);
            if (o.fillColorAnim) {
              if ("fc" in w)
                for (W = 0; 3 > W; W += 1)
                  G[W] = Math.round(B.length ? G[W] + (w.fc.v[W] - G[W]) * B[0] : G[W] + (w.fc.v[W] - G[W]) * B);
              "fh" in w && (G = B.length ? addHueToRGB(G, w.fh.v * B[0]) : addHueToRGB(G, w.fh.v * B)), "fs" in w && (G = B.length ? addSaturationToRGB(G, w.fs.v * B[0]) : addSaturationToRGB(G, w.fs.v * B)), "fb" in w && (G = B.length ? addBrightnessToRGB(G, w.fb.v * B[0]) : addBrightnessToRGB(G, w.fb.v * B));
            }
          }
          for (T = 0; M > T; T += 1)
            w = V.a[T].a, "p" in w && (D = V.a[T].s, B = D.getMult(h[s].anIndexes[T]), this.maskPath ? B.length ? a.translate(0, w.p.v[1] * B[0], -w.p.v[2] * B[1]) : a.translate(0, w.p.v[1] * B, -w.p.v[2] * B) : B.length ? a.translate(w.p.v[0] * B[0], w.p.v[1] * B[1], -w.p.v[2] * B[2]) : a.translate(w.p.v[0] * B, w.p.v[1] * B, -w.p.v[2] * B));
          if (o.strokeWidthAnim && (X = 0 > j ? 0 : j), o.strokeColorAnim && (q = "rgb(" + O[0] + "," + O[1] + "," + O[2] + ")"), o.fillColorAnim && (Y = "rgb(" + G[0] + "," + G[1] + "," + G[2] + ")"), this.maskPath) {
            if (n.t.p.p) {
              C = (c.point[1] - u.point[1]) / (c.point[0] - u.point[0]);
              var at = 180 * Math.atan(C) / Math.PI;
              c.point[0] < u.point[0] && (at += 180), a.rotate(-at * Math.PI / 180);
            }
            a.translate(H, R, 0), a.translate(V.m.a.v[0] * h[s].an / 200, V.m.a.v[1] * F / 100, 0), v -= V.m.a.v[0] * h[s].an / 200, h[s + 1] && K !== h[s + 1].ind && (v += h[s].an / 2, v += o.tr / 1e3 * n.t.d.s);
          } else {
            switch (a.translate(t, e, 0), o.ps && a.translate(o.ps[0], o.ps[1] + o.ascent, 0), o.j) {
              case 1:
                a.translate(o.justifyOffset + (o.boxWidth - o.lineWidths[h[s].line]), 0, 0);
                break;
              case 2:
                a.translate(o.justifyOffset + (o.boxWidth - o.lineWidths[h[s].line]) / 2, 0, 0);
            }
            a.translate(_, 0, 0), a.translate(V.m.a.v[0] * h[s].an / 200, V.m.a.v[1] * F / 100, 0), t += h[s].l + o.tr / 1e3 * n.t.d.s;
          }
          "html" === r ? Z = a.toCSS() : "svg" === r ? Z = a.to2dCSS() : J = [a.props[0], a.props[1], a.props[2], a.props[3], a.props[4], a.props[5], a.props[6], a.props[7], a.props[8], a.props[9], a.props[10], a.props[11], a.props[12], a.props[13], a.props[14], a.props[15]], U = z, L = this.renderedLetters[s], !L || L.o === U && L.sw === X && L.sc === q && L.fc === Y ? "svg" !== r && "html" !== r || L && L.m === Z ? "canvas" !== r || L && L.props[0] === J[0] && L.props[1] === J[1] && L.props[4] === J[4] && L.props[5] === J[5] && L.props[12] === J[12] && L.props[13] === J[13] ? I = L : (this.lettersChangedFlag = !0, I = new LetterProps(U, X, q, Y, null, J)) : (this.lettersChangedFlag = !0, I = new LetterProps(U, X, q, Y, Z)) : (this.lettersChangedFlag = !0, I = new LetterProps(U, X, q, Y, Z, J)), this.renderedLetters[s] = I;
        }
    }, ITextElement.prototype.emptyProp = new LetterProps, createElement(SVGBaseElement, SVGTextElement), SVGTextElement.prototype.init = ITextElement.prototype.init, SVGTextElement.prototype.createPathShape = ITextElement.prototype.createPathShape, SVGTextElement.prototype.getMeasures = ITextElement.prototype.getMeasures, SVGTextElement.prototype.createElements = function() {
      this.parent.createElements.call(this);
      var t = this.data.t.d;
      this.innerElem = document.createElementNS(svgNS, "g"), t.fc ? this.innerElem.setAttribute("fill", "rgb(" + t.fc[0] + "," + t.fc[1] + "," + t.fc[2] + ")") : this.innerElem.setAttribute("fill", "rgba(0,0,0,0)"), t.sc && (this.innerElem.setAttribute("stroke", "rgb(" + t.sc[0] + "," + t.sc[1] + "," + t.sc[2] + ")"), this.innerElem.setAttribute("stroke-width", t.sw)), this.innerElem.setAttribute("font-size", t.s);
      var e = this.globalData.fontManager.getFontByName(t.f);
      if (e.fClass)
        this.innerElem.setAttribute("class", e.fClass);
      else {
        this.innerElem.setAttribute("font-family", e.fFamily);
        var s = t.fWeight,
            i = t.fStyle;
        this.innerElem.setAttribute("font-style", i), this.innerElem.setAttribute("font-weight", s);
      }
      var a,
          r;
      this.layerElement === this.parentContainer ? this.appendNodeToParent(this.innerElem) : this.layerElement.appendChild(this.innerElem);
      var n = t.l;
      if (r = n.length) {
        var o,
            h,
            l = this.mHelper,
            p = "",
            m = this.data.singleShape;
        if (m)
          var f = 0,
              d = 0,
              c = t.lineWidths,
              u = t.boxWidth,
              y = !0;
        for (a = 0; r > a; a += 1) {
          if (this.globalData.fontManager.chars ? m && 0 !== a || (o = document.createElementNS(svgNS, "path")) : o = document.createElementNS(svgNS, "text"), o.setAttribute("stroke-linecap", "butt"), o.setAttribute("stroke-linejoin", "round"), o.setAttribute("stroke-miterlimit", "4"), m && n[a].n && (f = 0, d += t.yOffset, d += y ? 1 : 0, y = !1), l.reset(), this.globalData.fontManager.chars && l.scale(t.s / 100, t.s / 100), m) {
            switch (t.ps && l.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j) {
              case 1:
                l.translate(t.justifyOffset + (u - c[n[a].line]), 0, 0);
                break;
              case 2:
                l.translate(t.justifyOffset + (u - c[n[a].line]) / 2, 0, 0);
            }
            l.translate(f, d, 0);
          }
          if (this.globalData.fontManager.chars) {
            var v,
                g = this.globalData.fontManager.getCharData(t.t.charAt(a), e.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily);
            v = g ? g.data : null, v && v.shapes && (h = v.shapes[0].it, m || (p = ""), p += this.createPathShape(l, h), m || o.setAttribute("d", p)), m || this.innerElem.appendChild(o);
          } else
            o.textContent = n[a].val, o.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.innerElem.appendChild(o), m && o.setAttribute("transform", l.to2dCSS());
          m && (f += n[a].l), this.textSpans.push(o);
        }
        m && this.globalData.fontManager.chars && (o.setAttribute("d", p), this.innerElem.appendChild(o));
      }
    }, SVGTextElement.prototype.hide = function() {
      this.hidden || (this.innerElem.style.display = "none", this.hidden = !0);
    }, SVGTextElement.prototype.renderFrame = function(t) {
      var e = this.parent.renderFrame.call(this, t);
      if (e === !1)
        return void this.hide();
      if (this.hidden && (this.hidden = !1, this.innerElem.style.display = "block"), this.data.hasMask || (this.finalTransform.matMdf && this.innerElem.setAttribute("transform", this.finalTransform.mat.to2dCSS()), this.finalTransform.opMdf && this.innerElem.setAttribute("opacity", this.finalTransform.opacity)), !this.data.singleShape && (this.getMeasures(), this.lettersChangedFlag)) {
        var s,
            i,
            a = this.renderedLetters,
            r = this.data.t.d.l;
        i = r.length;
        var n;
        for (s = 0; i > s; s += 1)
          r[s].n || (n = a[s], this.textSpans[s].setAttribute("transform", n.m), this.textSpans[s].setAttribute("opacity", n.o), n.sw && this.textSpans[s].setAttribute("stroke-width", n.sw), n.sc && this.textSpans[s].setAttribute("stroke", n.sc), n.fc && this.textSpans[s].setAttribute("fill", n.fc));
        this.firstFrame && (this.firstFrame = !1);
      }
    }, SVGTextElement.prototype.destroy = function() {
      this.parent.destroy.call(), this.innerElem = null;
    };
    var PlaceHolderElement = function(t, e, s) {
      if (this.data = t, this.globalData = s, e) {
        this.parentContainer = e;
        var i = document.createElementNS(svgNS, "g");
        i.setAttribute("id", this.data.id), e.appendChild(i), this.phElement = i;
      }
      this.layerId = "ly_" + randomString(10);
    };
    PlaceHolderElement.prototype.prepareFrame = function() {}, PlaceHolderElement.prototype.renderFrame = function() {}, PlaceHolderElement.prototype.draw = function() {}, createElement(SVGBaseElement, ICompElement), extendPrototype(ExpressionComp, ICompElement), ICompElement.prototype.getComposingElement = function() {
      return this.layerElement;
    }, ICompElement.prototype.hide = function() {
      if (!this.hidden) {
        var t,
            e = this.elements.length;
        for (t = 0; e > t; t += 1)
          this.elements[t].hide();
        this.hidden = !0;
      }
    }, ICompElement.prototype.prepareFrame = function(t) {
      if (this.parent.prepareFrame.call(this, t), this.isVisible !== !1) {
        var e = t;
        this.tm && (e = this.tm.v, e === this.data.op && (e = this.data.op - 1)), this.renderedFrame = e;
        var s,
            i = this.elements.length;
        for (s = 0; i > s; s += 1)
          this.elements[s].prepareFrame(e - this.layers[s].st);
      }
    }, ICompElement.prototype.renderFrame = function(t) {
      var e,
          s = this.parent.renderFrame.call(this, t),
          i = this.layers.length;
      if (s === !1)
        return void this.hide();
      for (this.hidden = !1, e = 0; i > e; e += 1)
        this.data.hasMask ? this.elements[e].renderFrame() : this.elements[e].renderFrame(this.finalTransform);
      this.firstFrame && (this.firstFrame = !1);
    }, ICompElement.prototype.setElements = function(t) {
      this.elements = t;
    }, ICompElement.prototype.getElements = function() {
      return this.elements;
    }, ICompElement.prototype.destroy = function() {
      this.parent.destroy.call();
      var t,
          e = this.layers.length;
      for (t = 0; e > t; t += 1)
        this.elements[t].destroy();
    }, createElement(SVGBaseElement, IImageElement), IImageElement.prototype.createElements = function() {
      var t = this,
          e = function() {
            t.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t.path + t.assetData.p), t.maskedElement = t.innerElem;
          },
          s = new Image;
      s.addEventListener("load", e, !1), s.addEventListener("error", e, !1), s.src = this.path + this.assetData.p, this.parent.createElements.call(this), this.innerElem = document.createElementNS(svgNS, "image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.layerElement === this.parentContainer ? this.appendNodeToParent(this.innerElem) : this.layerElement.appendChild(this.innerElem), this.data.ln && this.innerElem.setAttribute("id", this.data.ln);
    }, IImageElement.prototype.hide = function() {
      this.hidden || (this.innerElem.setAttribute("visibility", "hidden"), this.hidden = !0);
    }, IImageElement.prototype.renderFrame = function(t) {
      var e = this.parent.renderFrame.call(this, t);
      return e === !1 ? void this.hide() : (this.hidden && (this.hidden = !1, this.innerElem.setAttribute("visibility", "visible")), this.data.hasMask || ((this.finalTransform.matMdf || this.firstFrame) && this.innerElem.setAttribute("transform", this.finalTransform.mat.to2dCSS()), (this.finalTransform.opMdf || this.firstFrame) && this.innerElem.setAttribute("opacity", this.finalTransform.opacity)), void(this.firstFrame && (this.firstFrame = !1)));
    }, IImageElement.prototype.destroy = function() {
      this.parent.destroy.call(), this.innerElem = null;
    }, createElement(SVGBaseElement, IShapeElement), IShapeElement.prototype.lcEnum = {
      1: "butt",
      2: "round",
      3: "butt"
    }, IShapeElement.prototype.ljEnum = {
      1: "miter",
      2: "round",
      3: "butt"
    }, IShapeElement.prototype.transformHelper = {
      opacity: 1,
      mat: new Matrix,
      matMdf: !1,
      opMdf: !1
    }, IShapeElement.prototype.createElements = function() {
      this.parent.createElements.call(this), this.searchShapes(this.shapesData, this.viewData, this.dynamicProperties, []), this.layerElement.appendChild(this.shapesContainer), styleUnselectableDiv(this.layerElement), styleUnselectableDiv(this.shapesContainer), this.buildExpressionInterface();
    }, IShapeElement.prototype.searchShapes = function(t, e, s, i) {
      var a,
          r,
          n,
          o = t.length - 1,
          h = [],
          l = [];
      for (a = o; a >= 0; a -= 1)
        if ("fl" == t[a].ty || "st" == t[a].ty) {
          e[a] = {};
          var p;
          if (e[a].c = PropertyFactory.getProp(this, t[a].c, 1, null, s), e[a].o = PropertyFactory.getProp(this, t[a].o, 0, .01, s), "st" == t[a].ty) {
            if (p = document.createElementNS(svgNS, "g"), p.style.strokeLinecap = this.lcEnum[t[a].lc] || "round", p.style.strokeLinejoin = this.ljEnum[t[a].lj] || "round", p.style.fillOpacity = 0, 1 == t[a].lj && (p.style.strokeMiterlimit = t[a].ml), e[a].c.k || (p.style.stroke = "rgb(" + e[a].c.v[0] + "," + e[a].c.v[1] + "," + e[a].c.v[2] + ")"), e[a].o.k || (p.style.strokeOpacity = e[a].o.v), e[a].w = PropertyFactory.getProp(this, t[a].w, 0, null, s), e[a].w.k || (p.style.strokeWidth = e[a].w.v), t[a].d) {
              var m = PropertyFactory.getDashProp(this, t[a].d, "svg", s);
              m.k || (p.style.strokeDasharray = m.dasharray, p.style.strokeDashoffset = m.dashoffset), e[a].d = m;
            }
          } else
            p = document.createElementNS(svgNS, "path"), e[a].c.k || (p.style.fill = "rgb(" + e[a].c.v[0] + "," + e[a].c.v[1] + "," + e[a].c.v[2] + ")"), e[a].o.k || (p.style.fillOpacity = e[a].o.v);
          this.shapesContainer.appendChild(p), this.stylesList.push({
            pathElement: p,
            type: t[a].ty,
            d: "",
            ld: "",
            mdf: !1
          }), e[a].style = this.stylesList[this.stylesList.length - 1], h.push(e[a].style);
        } else if ("gr" == t[a].ty)
          e[a] = {it: []}, this.searchShapes(t[a].it, e[a].it, s, i);
        else if ("tr" == t[a].ty)
          e[a] = {
            transform: {
              mat: new Matrix,
              opacity: 1,
              matMdf: !1,
              opMdf: !1,
              op: PropertyFactory.getProp(this, t[a].o, 0, .01, s),
              mProps: PropertyFactory.getProp(this, t[a], 2, null, s)
            },
            elements: []
          };
        else if ("sh" == t[a].ty || "rc" == t[a].ty || "el" == t[a].ty || "sr" == t[a].ty) {
          e[a] = {
            elements: [],
            styles: [],
            lStr: ""
          };
          var f = 4;
          "rc" == t[a].ty ? f = 5 : "el" == t[a].ty ? f = 6 : "sr" == t[a].ty && (f = 7), i.length && (t[a].trimmed = !0), e[a].sh = PropertyFactory.getShapeProp(this, t[a], f, s, i), n = this.stylesList.length;
          var d,
              c = !1,
              u = !1;
          for (r = 0; n > r; r += 1)
            this.stylesList[r].closed || ("st" === this.stylesList[r].type ? (c = !0, d = document.createElementNS(svgNS, "path"), this.stylesList[r].pathElement.appendChild(d), e[a].elements.push({
              ty: this.stylesList[r].type,
              el: d
            })) : (u = !0, e[a].elements.push({
              ty: this.stylesList[r].type,
              st: this.stylesList[r]
            })));
          e[a].st = c, e[a].fl = u;
        } else if ("tm" == t[a].ty) {
          var y = {
            closed: !1,
            trimProp: PropertyFactory.getProp(this, t[a], 7, null, s)
          };
          e[a] = {tr: y.trimProp}, i.push(y), l.push(y);
        }
      for (o = h.length, a = 0; o > a; a += 1)
        h[a].closed = !0;
      for (o = l.length, a = 0; o > a; a += 1)
        l[a].closed = !0;
    }, IShapeElement.prototype.renderFrame = function(t) {
      var e = this.parent.renderFrame.call(this, t);
      return e === !1 ? void this.hide() : (this.hidden = !1, this.finalTransform.matMdf && !this.data.hasMask && this.shapesContainer.setAttribute("transform", this.finalTransform.mat.to2dCSS()), this.transformHelper.opacity = this.finalTransform.opacity, this.transformHelper.matMdf = !1, this.transformHelper.opMdf = this.finalTransform.opMdf, void this.renderShape(this.transformHelper, null, null, !0));
    }, IShapeElement.prototype.hide = function() {
      if (!this.hidden) {
        var t,
            e = this.stylesList.length;
        for (t = e - 1; t >= 0; t -= 1)
          "0" !== this.stylesList[t].ld && (this.stylesList[t].ld = "0", this.stylesList[t].pathElement.style.display = "none", this.stylesList[t].pathElement.parentNode && (this.stylesList[t].parent = this.stylesList[t].pathElement.parentNode));
        this.hidden = !0;
      }
    }, IShapeElement.prototype.renderShape = function(t, e, s, i) {
      var a,
          r;
      if (!e)
        for (e = this.shapesData, r = this.stylesList.length, a = 0; r > a; a += 1)
          this.stylesList[a].d = "", this.stylesList[a].mdf = !1;
      s || (s = this.viewData), r = e.length - 1;
      var n,
          o;
      for (n = t, a = r; a >= 0; a -= 1)
        if ("tr" == e[a].ty) {
          n = s[a].transform;
          var h = s[a].transform.mProps.v.props;
          if (n.matMdf = n.mProps.mdf, n.opMdf = n.op.mdf, o = n.mat, o.cloneFromProps(h), t) {
            var l = t.mat.props;
            n.opacity = t.opacity, n.opacity *= s[a].transform.op.v, n.matMdf = t.matMdf ? !0 : n.matMdf, n.opMdf = t.opMdf ? !0 : n.opMdf, o.transform(l[0], l[1], l[2], l[3], l[4], l[5], l[6], l[7], l[8], l[9], l[10], l[11], l[12], l[13], l[14], l[15]);
          } else
            n.opacity = n.op.o;
        } else
          "sh" == e[a].ty || "el" == e[a].ty || "rc" == e[a].ty || "sr" == e[a].ty ? this.renderPath(e[a], s[a], n) : "fl" == e[a].ty ? this.renderFill(e[a], s[a], n) : "st" == e[a].ty ? this.renderStroke(e[a], s[a], n) : "gr" == e[a].ty ? this.renderShape(n, e[a].it, s[a].it) : "tm" == e[a].ty;
      if (i) {
        for (r = this.stylesList.length, a = 0; r > a; a += 1)
          "0" === this.stylesList[a].ld && (this.stylesList[a].ld = "1", this.stylesList[a].pathElement.style.display = "block"), "fl" === this.stylesList[a].type && (this.stylesList[a].mdf || this.firstFrame) && this.stylesList[a].pathElement.setAttribute("d", this.stylesList[a].d);
        this.firstFrame && (this.firstFrame = !1);
      }
    }, IShapeElement.prototype.renderPath = function(t, e, s) {
      var i,
          a,
          r = e.sh.v,
          n = "";
      if (r.v) {
        i = r.v.length;
        var o = s.matMdf || e.sh.mdf || this.firstFrame;
        if (o) {
          var h = r.s ? r.s : [];
          for (a = 1; i > a; a += 1)
            h[a - 1] ? n += " M" + s.mat.applyToPointStringified(h[a - 1][0], h[a - 1][1]) : 1 == a && (n += " M" + s.mat.applyToPointStringified(r.v[0][0], r.v[0][1])), n += " C" + s.mat.applyToPointStringified(r.o[a - 1][0], r.o[a - 1][1]) + " " + s.mat.applyToPointStringified(r.i[a][0], r.i[a][1]) + " " + s.mat.applyToPointStringified(r.v[a][0], r.v[a][1]);
          1 == i && (n += h[0] ? " M" + s.mat.applyToPointStringified(h[0][0], h[0][1]) : " M" + s.mat.applyToPointStringified(r.v[0][0], r.v[0][1])), i && t.closed && (!t.trimmed || r.c) && (n += " C" + s.mat.applyToPointStringified(r.o[a - 1][0], r.o[a - 1][1]) + " " + s.mat.applyToPointStringified(r.i[0][0], r.i[0][1]) + " " + s.mat.applyToPointStringified(r.v[0][0], r.v[0][1]), n += "z"), e.lStr = n;
        } else
          n = e.lStr;
        for (i = e.elements.length, a = 0; i > a; a += 1)
          "st" === e.elements[a].ty ? (s.matMdf || e.sh.mdf || this.firstFrame) && e.elements[a].el.setAttribute("d", n) : (e.elements[a].st.mdf = o ? !0 : e.elements[a].st.mdf, e.elements[a].st.d += n);
      }
    }, IShapeElement.prototype.renderFill = function(t, e, s) {
      var i = e.style;
      (e.c.mdf || this.firstFrame) && (i.pathElement.style.fill = "rgb(" + bm_floor(e.c.v[0]) + "," + bm_floor(e.c.v[1]) + "," + bm_floor(e.c.v[2]) + ")"), (e.o.mdf || s.opMdf || this.firstFrame) && (i.pathElement.style.fillOpacity = e.o.v * s.opacity);
    }, IShapeElement.prototype.renderStroke = function(t, e, s) {
      var i = e.style,
          a = e.d;
      a && a.k && (a.mdf || this.firstFrame) && (i.pathElement.style.strokeDasharray = a.dasharray, i.pathElement.style.strokeDashoffset = a.dashoffset), (e.c.mdf || this.firstFrame) && (i.pathElement.style.stroke = "rgb(" + bm_floor(e.c.v[0]) + "," + bm_floor(e.c.v[1]) + "," + bm_floor(e.c.v[2]) + ")"), (e.o.mdf || s.opMdf || this.firstFrame) && (i.pathElement.style.strokeOpacity = e.o.v * s.opacity), (e.w.mdf || this.firstFrame) && (i.pathElement.style.strokeWidth = e.w.v);
    }, IShapeElement.prototype.destroy = function() {
      this.parent.destroy.call(), this.shapeData = null, this.viewData = null, this.parentContainer = null, this.placeholder = null;
    }, extendPrototype(ShapeInterface, IShapeElement), createElement(SVGBaseElement, ISolidElement), ISolidElement.prototype.createElements = function() {
      this.parent.createElements.call(this);
      var t = document.createElementNS(svgNS, "rect");
      t.setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.layerElement === this.parentContainer ? this.appendNodeToParent(t) : this.layerElement.appendChild(t), this.data.ln && this.innerElem.setAttribute("id", this.data.ln), this.innerElem = t;
    }, ISolidElement.prototype.hide = IImageElement.prototype.hide, ISolidElement.prototype.renderFrame = IImageElement.prototype.renderFrame, ISolidElement.prototype.destroy = IImageElement.prototype.destroy, createElement(BaseElement, CVBaseElement), CVBaseElement.prototype.createElements = function() {}, CVBaseElement.prototype.renderFrame = function(t) {
      if (3 === this.data.ty)
        return !1;
      if (!this.isVisible)
        return this.isVisible;
      this.finalTransform.opMdf = this.finalTransform.op.mdf, this.finalTransform.matMdf = this.finalTransform.mProp.mdf, this.finalTransform.opacity = this.finalTransform.op.v;
      var e,
          s = this.finalTransform.mat;
      if (this.hierarchy) {
        var i,
            a = this.hierarchy.length;
        for (e = this.finalTransform.mProp.v.props, s.cloneFromProps(e), i = 0; a > i; i += 1)
          this.finalTransform.matMdf = this.hierarchy[i].finalTransform.mProp.mdf ? !0 : this.finalTransform.matMdf, e = this.hierarchy[i].finalTransform.mProp.v.props, s.transform(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]);
      } else
        t ? (e = this.finalTransform.mProp.v.props, s.cloneFromProps(e)) : s.cloneFromProps(this.finalTransform.mProp.v.props);
      return t && (e = t.mat.props, s.transform(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]), this.finalTransform.opacity *= t.opacity, this.finalTransform.opMdf = t.opMdf ? !0 : this.finalTransform.opMdf, this.finalTransform.matMdf = t.matMdf ? !0 : this.finalTransform.matMdf), this.data.hasMask && (this.globalData.renderer.save(!0), this.maskManager.renderFrame(s)), this.isVisible;
    }, CVBaseElement.prototype.getCurrentAnimData = function() {
      return this.currentAnimData;
    }, CVBaseElement.prototype.addMasks = function(t) {
      this.maskManager = new CVMaskElement(t, this, this.globalData);
    }, CVBaseElement.prototype.destroy = function() {
      this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager && this.maskManager.destroy();
    }, CVBaseElement.prototype.mHelper = new Matrix, createElement(CVBaseElement, CVCompElement), CVCompElement.prototype.prepareFrame = function(t) {
      if (this.parent.prepareFrame.call(this, t), this.isVisible !== !1) {
        var e = t;
        this.tm && (e = this.tm.v, e === this.data.op && (e = this.data.op - 1)), this.renderedFrame = e;
        var s,
            i = this.elements.length;
        for (s = 0; i > s; s += 1)
          this.elements[s].prepareFrame(e - this.layers[s].st);
      }
    }, CVCompElement.prototype.renderFrame = function(t) {
      if (this.parent.renderFrame.call(this, t) !== !1) {
        var e,
            s = this.layers.length;
        for (e = s - 1; e >= 0; e -= 1)
          this.elements[e].renderFrame(this.finalTransform);
        this.data.hasMask && this.globalData.renderer.restore(!0), this.firstFrame && (this.firstFrame = !1);
      }
    }, CVCompElement.prototype.setElements = function(t) {
      this.elements = t;
    }, CVCompElement.prototype.getElements = function() {
      return this.elements;
    }, CVCompElement.prototype.destroy = function() {
      var t,
          e = this.layers.length;
      for (t = e - 1; t >= 0; t -= 1)
        this.elements[t].destroy();
      this.layers = null, this.elements = null, this.parent.destroy.call();
    }, createElement(CVBaseElement, CVImageElement), CVImageElement.prototype.createElements = function() {
      var t = this,
          e = function() {
            t.animationItem.elementLoaded();
          },
          s = function() {
            t.failed = !0, t.animationItem.elementLoaded();
          };
      this.img = new Image, this.img.addEventListener("load", e, !1), this.img.addEventListener("error", s, !1), this.img.src = this.path + this.assetData.p, this.parent.createElements.call(this);
    }, CVImageElement.prototype.renderFrame = function(t) {
      if (!this.failed && this.parent.renderFrame.call(this, t) !== !1) {
        var e = this.canvasContext;
        this.globalData.renderer.save();
        var s = this.finalTransform.mat.props;
        this.globalData.renderer.ctxTransform(s), this.globalData.renderer.ctxOpacity(this.finalTransform.opacity), e.drawImage(this.img, 0, 0), this.globalData.renderer.restore(this.data.hasMask), this.firstFrame && (this.firstFrame = !1);
      }
    }, CVImageElement.prototype.destroy = function() {
      this.img = null, this.animationItem = null, this.parent.destroy.call();
    }, CVMaskElement.prototype.getMaskProperty = function(t) {
      return this.viewData[t];
    }, CVMaskElement.prototype.prepareFrame = function(t) {
      var e,
          s = this.dynamicProperties.length;
      for (e = 0; s > e; e += 1)
        this.dynamicProperties[e].getValue(t);
    }, CVMaskElement.prototype.renderFrame = function(t) {
      var e,
          s,
          i,
          a,
          r,
          n = this.ctx,
          o = this.data.masksProperties.length,
          h = !1;
      for (e = 0; o > e; e++)
        if ("n" !== this.masksProperties[e].mode) {
          h === !1 && (n.beginPath(), h = !0), this.masksProperties[e].inv && (n.moveTo(0, 0), n.lineTo(this.globalData.compWidth, 0), n.lineTo(this.globalData.compWidth, this.globalData.compHeight), n.lineTo(0, this.globalData.compHeight), n.lineTo(0, 0)), r = this.viewData[e].v, s = t.applyToPointArray(r.v[0][0], r.v[0][1], 0), n.moveTo(s[0], s[1]);
          var l,
              p = r.v.length;
          for (l = 1; p > l; l++)
            s = t.applyToPointArray(r.o[l - 1][0], r.o[l - 1][1], 0), i = t.applyToPointArray(r.i[l][0], r.i[l][1], 0), a = t.applyToPointArray(r.v[l][0], r.v[l][1], 0), n.bezierCurveTo(s[0], s[1], i[0], i[1], a[0], a[1]);
          s = t.applyToPointArray(r.o[l - 1][0], r.o[l - 1][1], 0), i = t.applyToPointArray(r.i[0][0], r.i[0][1], 0), a = t.applyToPointArray(r.v[0][0], r.v[0][1], 0), n.bezierCurveTo(s[0], s[1], i[0], i[1], a[0], a[1]);
        }
      h && n.clip();
    }, CVMaskElement.prototype.getMask = function(t) {
      for (var e = 0,
          s = this.masksProperties.length; s > e; ) {
        if (this.masksProperties[e].nm === t)
          return {maskPath: this.viewData[e].pv};
        e += 1;
      }
    }, CVMaskElement.prototype.destroy = function() {
      this.ctx = null;
    }, createElement(CVBaseElement, CVShapeElement), CVShapeElement.prototype.lcEnum = {
      1: "butt",
      2: "round",
      3: "butt"
    }, CVShapeElement.prototype.ljEnum = {
      1: "miter",
      2: "round",
      3: "butt"
    }, CVShapeElement.prototype.transformHelper = {
      opacity: 1,
      mat: new Matrix,
      matMdf: !1,
      opMdf: !1
    }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createElements = function() {
      this.parent.createElements.call(this), this.searchShapes(this.shapesData, this.viewData, this.dynamicProperties, []), this.buildExpressionInterface();
    }, CVShapeElement.prototype.searchShapes = function(t, e, s, i) {
      var a,
          r,
          n,
          o,
          h = t.length - 1,
          l = [],
          p = [];
      for (a = h; a >= 0; a -= 1)
        if ("fl" == t[a].ty || "st" == t[a].ty) {
          if (o = {
            type: t[a].ty,
            elements: []
          }, e[a] = {}, e[a].c = PropertyFactory.getProp(this, t[a].c, 1, null, s), e[a].c.k || (o.co = "rgb(" + bm_floor(e[a].c.v[0]) + "," + bm_floor(e[a].c.v[1]) + "," + bm_floor(e[a].c.v[2]) + ")"), e[a].o = PropertyFactory.getProp(this, t[a].o, 0, .01, s), "st" == t[a].ty && (o.lc = this.lcEnum[t[a].lc] || "round", o.lj = this.ljEnum[t[a].lj] || "round", 1 == t[a].lj && (o.ml = t[a].ml), e[a].w = PropertyFactory.getProp(this, t[a].w, 0, null, s), e[a].w.k || (o.wi = e[a].w.v), t[a].d)) {
            var m = PropertyFactory.getDashProp(this, t[a].d, "canvas", s);
            e[a].d = m, e[a].d.k || (o.da = e[a].d.dasharray, o["do"] = e[a].d.dashoffset);
          }
          this.stylesList.push(o), e[a].style = o, l.push(e[a].style);
        } else if ("gr" == t[a].ty)
          e[a] = {it: []}, this.searchShapes(t[a].it, e[a].it, s, i);
        else if ("tr" == t[a].ty)
          e[a] = {
            transform: {
              mat: new Matrix,
              opacity: 1,
              matMdf: !1,
              opMdf: !1,
              op: PropertyFactory.getProp(this, t[a].o, 0, .01, s),
              mProps: PropertyFactory.getProp(this, t[a], 2, null, s)
            },
            elements: []
          };
        else if ("sh" == t[a].ty || "rc" == t[a].ty || "el" == t[a].ty || "sr" == t[a].ty) {
          e[a] = {
            nodes: [],
            trNodes: [],
            tr: [0, 0, 0, 0, 0, 0]
          };
          var f = 4;
          "rc" == t[a].ty ? f = 5 : "el" == t[a].ty ? f = 6 : "sr" == t[a].ty && (f = 7), i.length && (t[a].trimmed = !0), e[a].sh = PropertyFactory.getShapeProp(this, t[a], f, s, i), n = this.stylesList.length;
          var d = !1,
              c = !1;
          for (r = 0; n > r; r += 1)
            this.stylesList[r].closed || (this.stylesList[r].elements.push(e[a]), "st" === this.stylesList[r].type ? d = !0 : c = !0);
          e[a].st = d, e[a].fl = c;
        } else if ("tm" == t[a].ty) {
          var u = {
            closed: !1,
            trimProp: PropertyFactory.getProp(this, t[a], 7, null, s)
          };
          i.push(u), p.push(u);
        }
      for (h = l.length, a = 0; h > a; a += 1)
        l[a].closed = !0;
      for (h = p.length, a = 0; h > a; a += 1)
        p[a].closed = !0;
    }, CVShapeElement.prototype.renderFrame = function(t) {
      this.parent.renderFrame.call(this, t) !== !1 && (this.transformHelper.mat.reset(), this.transformHelper.opacity = this.finalTransform.opacity, this.transformHelper.matMdf = !1, this.transformHelper.opMdf = this.finalTransform.opMdf, this.renderShape(this.transformHelper, null, null, !0), this.data.hasMask && this.globalData.renderer.restore(!0));
    }, CVShapeElement.prototype.renderShape = function(t, e, s, i) {
      var a,
          r;
      if (!e)
        for (e = this.shapesData, r = this.stylesList.length, a = 0; r > a; a += 1)
          this.stylesList[a].d = "", this.stylesList[a].mdf = !1;
      s || (s = this.viewData), r = e.length - 1;
      var n,
          o;
      for (n = t, a = r; a >= 0; a -= 1)
        if ("tr" == e[a].ty) {
          n = s[a].transform;
          var h = s[a].transform.mProps.v.props;
          if (n.matMdf = n.mProps.mdf, n.opMdf = n.op.mdf, o = n.mat, o.cloneFromProps(h), t) {
            var l = t.mat.props;
            n.opacity = t.opacity, n.opacity *= s[a].transform.op.v, n.matMdf = t.matMdf ? !0 : n.matMdf, n.opMdf = t.opMdf ? !0 : n.opMdf, o.transform(l[0], l[1], l[2], l[3], l[4], l[5], l[6], l[7], l[8], l[9], l[10], l[11], l[12], l[13], l[14], l[15]);
          } else
            n.opacity = n.op.o;
        } else
          "sh" == e[a].ty || "el" == e[a].ty || "rc" == e[a].ty || "sr" == e[a].ty ? this.renderPath(e[a], s[a], n) : "fl" == e[a].ty ? this.renderFill(e[a], s[a], n) : "st" == e[a].ty ? this.renderStroke(e[a], s[a], n) : "gr" == e[a].ty ? this.renderShape(n, e[a].it, s[a].it) : "tm" == e[a].ty;
      if (i) {
        r = this.stylesList.length;
        var p,
            m,
            f,
            d,
            c,
            u,
            y,
            v = this.globalData.renderer,
            g = this.globalData.canvasContext;
        for (v.save(), v.ctxTransform(this.finalTransform.mat.props), a = 0; r > a; a += 1)
          if (y = this.stylesList[a].type, "st" !== y || 0 !== this.stylesList[a].wi) {
            for (v.save(), c = this.stylesList[a].elements, m = c.length, "st" === y ? (g.strokeStyle = this.stylesList[a].co, g.lineWidth = this.stylesList[a].wi, g.lineCap = this.stylesList[a].lc, g.lineJoin = this.stylesList[a].lj, g.miterLimit = this.stylesList[a].ml || 0) : g.fillStyle = this.stylesList[a].co, v.ctxOpacity(this.stylesList[a].coOp), "st" !== y && g.beginPath(), p = 0; m > p; p += 1) {
              for ("st" === y && (g.beginPath(), this.stylesList[a].da ? (g.setLineDash(this.stylesList[a].da), g.lineDashOffset = this.stylesList[a]["do"], this.globalData.isDashed = !0) : this.globalData.isDashed && (g.setLineDash(this.dashResetter), this.globalData.isDashed = !1)), u = c[p].trNodes, d = u.length, f = 0; d > f; f += 1)
                "m" == u[f].t ? g.moveTo(u[f].p[0], u[f].p[1]) : "c" == u[f].t ? g.bezierCurveTo(u[f].p1[0], u[f].p1[1], u[f].p2[0], u[f].p2[1], u[f].p3[0], u[f].p3[1]) : g.closePath();
              "st" === y && g.stroke();
            }
            "st" !== y && g.fill(), v.restore();
          }
        v.restore(), this.firstFrame && (this.firstFrame = !1);
      }
    }, CVShapeElement.prototype.renderPath = function(t, e, s) {
      var i,
          a,
          r = e.sh.v;
      if (r.v) {
        i = r.v.length;
        var n = s.matMdf || e.sh.mdf || this.firstFrame;
        if (n) {
          var o = e.trNodes;
          o.length = 0;
          var h = r.s ? r.s : [];
          for (a = 1; i > a; a += 1)
            h[a - 1] ? o.push({
              t: "m",
              p: s.mat.applyToPointArray(h[a - 1][0], h[a - 1][1], 0)
            }) : 1 == a && o.push({
              t: "m",
              p: s.mat.applyToPointArray(r.v[0][0], r.v[0][1], 0)
            }), o.push({
              t: "c",
              p1: s.mat.applyToPointArray(r.o[a - 1][0], r.o[a - 1][1], 0),
              p2: s.mat.applyToPointArray(r.i[a][0], r.i[a][1], 0),
              p3: s.mat.applyToPointArray(r.v[a][0], r.v[a][1], 0)
            });
          if (1 == i && o.push(h[0] ? {
            t: "m",
            p: s.mat.applyToPointArray(h[0][0], h[0][1], 0)
          } : {
            t: "m",
            p: s.mat.applyToPointArray(r.v[0][0], r.v[0][1], 0)
          }), i && t.closed && (!t.trimmed || r.c) && (o.push({
            t: "c",
            p1: s.mat.applyToPointArray(r.o[a - 1][0], r.o[a - 1][1], 0),
            p2: s.mat.applyToPointArray(r.i[0][0], r.i[0][1], 0),
            p3: s.mat.applyToPointArray(r.v[0][0], r.v[0][1], 0)
          }), o.push({t: "z"})), e.st)
            for (a = 0; 16 > a; a += 1)
              e.tr[a] = s.mat.props[a];
          e.trNodes = o;
        }
      }
    }, CVShapeElement.prototype.renderFill = function(t, e, s) {
      var i = e.style;
      (e.c.mdf || this.firstFrame) && (i.co = "rgb(" + bm_floor(e.c.v[0]) + "," + bm_floor(e.c.v[1]) + "," + bm_floor(e.c.v[2]) + ")"), (e.o.mdf || s.opMdf || this.firstFrame) && (i.coOp = e.o.v * s.opacity);
    }, CVShapeElement.prototype.renderStroke = function(t, e, s) {
      var i = e.style,
          a = e.d;
      a && (a.mdf || this.firstFrame) && (i.da = a.dasharray, i["do"] = a.dashoffset), (e.c.mdf || this.firstFrame) && (i.co = "rgb(" + bm_floor(e.c.v[0]) + "," + bm_floor(e.c.v[1]) + "," + bm_floor(e.c.v[2]) + ")"), (e.o.mdf || s.opMdf || this.firstFrame) && (i.coOp = e.o.v * s.opacity), (e.w.mdf || this.firstFrame) && (i.wi = e.w.v);
    }, CVShapeElement.prototype.destroy = function() {
      this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.viewData.length = 0, this.parent.destroy.call();
    }, extendPrototype(ShapeInterface, CVShapeElement), createElement(CVBaseElement, CVSolidElement), CVSolidElement.prototype.renderFrame = function(t) {
      if (this.parent.renderFrame.call(this, t) !== !1) {
        var e = this.canvasContext;
        this.globalData.renderer.save();
        var s = this.finalTransform.mat.props;
        this.globalData.renderer.ctxTransform(s), this.globalData.renderer.ctxOpacity(this.finalTransform.opacity), e.fillStyle = this.data.sc, e.fillRect(0, 0, this.data.sw, this.data.sh), this.globalData.renderer.restore(this.data.hasMask), this.firstFrame && (this.firstFrame = !1);
      }
    }, createElement(CVBaseElement, CVTextElement), CVTextElement.prototype.init = ITextElement.prototype.init, CVTextElement.prototype.getMeasures = ITextElement.prototype.getMeasures, CVTextElement.prototype.getMult = ITextElement.prototype.getMult, CVTextElement.prototype.tHelper = document.createElement("canvas").getContext("2d"), CVTextElement.prototype.createElements = function() {
      this.parent.createElements.call(this);
      var t = this.data.t.d,
          e = !1;
      t.fc ? (e = !0, this.values.fill = "rgb(" + t.fc[0] + "," + t.fc[1] + "," + t.fc[2] + ")") : this.values.fill = "rgba(0,0,0,0)", this.fill = e;
      var s = !1;
      t.sc && (s = !0, this.values.stroke = "rgb(" + t.sc[0] + "," + t.sc[1] + "," + t.sc[2] + ")", this.values.sWidth = t.sw);
      var i,
          a,
          r = this.globalData.fontManager.getFontByName(t.f),
          n = t.l,
          o = this.mHelper;
      this.stroke = s, this.values.fValue = t.s + "px " + this.globalData.fontManager.getFontByName(t.f).fFamily, a = t.t.length, this.tHelper.font = this.values.fValue;
      var h,
          l,
          p,
          m,
          f,
          d,
          c,
          u,
          y,
          v,
          g = this.data.singleShape;
      if (g)
        var b = 0,
            E = 0,
            P = t.lineWidths,
            k = t.boxWidth,
            S = !0;
      for (i = 0; a > i; i += 1) {
        h = this.globalData.fontManager.getCharData(t.t.charAt(i), r.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily);
        var l;
        if (l = h ? h.data : null, o.reset(), g && n[i].n && (b = 0, E += t.yOffset, E += S ? 1 : 0, S = !1), l && l.shapes) {
          if (f = l.shapes[0].it, c = f.length, o.scale(t.s / 100, t.s / 100), g) {
            switch (t.ps && o.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j) {
              case 1:
                o.translate(t.justifyOffset + (k - P[n[i].line]), 0, 0);
                break;
              case 2:
                o.translate(t.justifyOffset + (k - P[n[i].line]) / 2, 0, 0);
            }
            o.translate(b, E, 0);
          }
          for (y = new Array(c), d = 0; c > d; d += 1) {
            for (m = f[d].ks.k.i.length, u = f[d].ks.k, v = [], p = 1; m > p; p += 1)
              1 == p && v.push(o.applyToX(u.v[0][0], u.v[0][1], 0), o.applyToY(u.v[0][0], u.v[0][1], 0)), v.push(o.applyToX(u.o[p - 1][0], u.o[p - 1][1], 0), o.applyToY(u.o[p - 1][0], u.o[p - 1][1], 0), o.applyToX(u.i[p][0], u.i[p][1], 0), o.applyToY(u.i[p][0], u.i[p][1], 0), o.applyToX(u.v[p][0], u.v[p][1], 0), o.applyToY(u.v[p][0], u.v[p][1], 0));
            v.push(o.applyToX(u.o[p - 1][0], u.o[p - 1][1], 0), o.applyToY(u.o[p - 1][0], u.o[p - 1][1], 0), o.applyToX(u.i[0][0], u.i[0][1], 0), o.applyToY(u.i[0][0], u.i[0][1], 0), o.applyToX(u.v[0][0], u.v[0][1], 0), o.applyToY(u.v[0][0], u.v[0][1], 0)), y[d] = v;
          }
        } else
          y = [];
        g && (b += n[i].l), this.textSpans.push({elem: y});
      }
    }, CVTextElement.prototype.renderFrame = function(t) {
      if (this.parent.renderFrame.call(this, t) !== !1) {
        var e = this.canvasContext,
            s = this.finalTransform.mat.props;
        this.globalData.renderer.save(), this.globalData.renderer.ctxTransform(s), this.globalData.renderer.ctxOpacity(this.finalTransform.opacity), e.font = this.values.fValue, e.lineCap = "butt", e.lineJoin = "miter", e.miterLimit = 4, this.data.singleShape || this.getMeasures();
        var i,
            a,
            r,
            n,
            o,
            h,
            l = this.renderedLetters,
            p = this.data.t.d.l;
        a = p.length;
        var m,
            f,
            d,
            c = null,
            u = null,
            y = null;
        for (i = 0; a > i; i += 1)
          if (!p[i].n) {
            if (m = l[i], m && (this.globalData.renderer.save(), this.globalData.renderer.ctxTransform(m.props), this.globalData.renderer.ctxOpacity(m.o)), this.fill) {
              for (m && m.fc ? c !== m.fc && (c = m.fc, e.fillStyle = m.fc) : c !== this.values.fill && (c = this.values.fill, e.fillStyle = this.values.fill), f = this.textSpans[i].elem, n = f.length, this.globalData.canvasContext.beginPath(), r = 0; n > r; r += 1)
                for (d = f[r], h = d.length, this.globalData.canvasContext.moveTo(d[0], d[1]), o = 2; h > o; o += 6)
                  this.globalData.canvasContext.bezierCurveTo(d[o], d[o + 1], d[o + 2], d[o + 3], d[o + 4], d[o + 5]);
              this.globalData.canvasContext.closePath(), this.globalData.canvasContext.fill();
            }
            if (this.stroke) {
              for (m && m.sw ? y !== m.sw && (y = m.sw, e.lineWidth = m.sw) : y !== this.values.sWidth && (y = this.values.sWidth, e.lineWidth = this.values.sWidth), m && m.sc ? u !== m.sc && (u = m.sc, e.strokeStyle = m.sc) : u !== this.values.stroke && (u = this.values.stroke, e.strokeStyle = this.values.stroke), f = this.textSpans[i].elem, n = f.length, this.globalData.canvasContext.beginPath(), r = 0; n > r; r += 1)
                for (d = f[r], h = d.length, this.globalData.canvasContext.moveTo(d[0], d[1]), o = 2; h > o; o += 6)
                  this.globalData.canvasContext.bezierCurveTo(d[o], d[o + 1], d[o + 2], d[o + 3], d[o + 4], d[o + 5]);
              this.globalData.canvasContext.closePath(), this.globalData.canvasContext.stroke();
            }
            m && this.globalData.renderer.restore();
          }
        this.globalData.renderer.restore(this.data.hasMask), this.firstFrame && (this.firstFrame = !1);
      }
    }, createElement(BaseElement, HBaseElement), HBaseElement.prototype.appendNodeToParent = function(t) {
      if (this.placeholder) {
        var e = this.placeholder.phElement;
        e.parentNode.insertBefore(t, e);
      } else
        this.parentContainer.appendChild(t);
    }, HBaseElement.prototype.createElements = function() {
      this.data.hasMask ? (this.layerElement = document.createElementNS(svgNS, "svg"), this.appendNodeToParent(this.layerElement), this.maskedElement = this.layerElement) : this.layerElement = this.parentContainer, !this.data.ln || 4 !== this.data.ty && 0 !== this.data.ty || (this.layerElement === this.parentContainer && (this.layerElement = document.createElementNS(svgNS, "g"), this.appendNodeToParent(this.layerElement)), this.layerElement.setAttribute("id", this.data.ln)), this.layerElement !== this.parentContainer && (this.placeholder = null);
    }, HBaseElement.prototype.renderFrame = function(t) {
      if (3 === this.data.ty)
        return !1;
      if (this.currentFrameNum === this.lastNum || !this.isVisible)
        return this.isVisible;
      this.lastNum = this.currentFrameNum, this.data.hasMask && this.maskManager.renderFrame(), this.finalTransform.opMdf = this.finalTransform.op.mdf, this.finalTransform.matMdf = this.finalTransform.mProp.mdf, this.finalTransform.opacity = this.finalTransform.op.v, this.firstFrame && (this.finalTransform.opMdf = !0, this.finalTransform.matMdf = !0);
      var e,
          s = this.finalTransform.mat;
      if (this.hierarchy) {
        var i,
            a = this.hierarchy.length;
        for (e = this.finalTransform.mProp.v.props, s.cloneFromProps(e), i = 0; a > i; i += 1)
          this.finalTransform.matMdf = this.hierarchy[i].finalTransform.mProp.mdf ? !0 : this.finalTransform.matMdf, e = this.hierarchy[i].finalTransform.mProp.v.props, s.transform(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]);
      } else
        this.isVisible && this.finalTransform.matMdf && (t ? (e = this.finalTransform.mProp.v.props, s.cloneFromProps(e)) : s.cloneFromProps(this.finalTransform.mProp.v.props));
      return t && (e = t.mat.props, s.cloneFromProps(e), this.finalTransform.opacity *= t.opacity, this.finalTransform.opMdf = t.opMdf ? !0 : this.finalTransform.opMdf, this.finalTransform.matMdf = t.matMdf ? !0 : this.finalTransform.matMdf), this.finalTransform.matMdf && (this.layerElement.style.transform = this.layerElement.style.webkitTransform = s.toCSS()), this.finalTransform.opMdf && (this.layerElement.style.opacity = this.finalTransform.opacity), this.isVisible;
    }, HBaseElement.prototype.destroy = function() {
      this.layerElement = null, this.parentContainer = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
    }, HBaseElement.prototype.getDomElement = function() {
      return this.layerElement;
    }, HBaseElement.prototype.addMasks = function(t) {
      this.maskManager = new MaskElement(t, this, this.globalData);
    }, HBaseElement.prototype.hide = function() {}, HBaseElement.prototype.setMatte = function() {}, createElement(HBaseElement, HSolidElement), HSolidElement.prototype.createElements = function() {
      var t = document.createElement("div");
      styleDiv(t);
      var e = document.createElementNS(svgNS, "svg");
      e.setAttribute("width", this.data.sw), e.setAttribute("height", this.data.sh), t.appendChild(e), this.layerElement = t, this.parentContainer.appendChild(t), this.innerElem = t, this.data.ln && this.innerElem.setAttribute("id", this.data.ln);
      var s = document.createElementNS(svgNS, "rect");
      s.setAttribute("width", this.data.sw), s.setAttribute("height", this.data.sh), s.setAttribute("fill", this.data.sc), e.appendChild(s), this.data.hasMask && (this.maskedElement = s);
    }, HSolidElement.prototype.hide = function() {
      this.hidden || (this.innerElem.style.display = "none", this.hidden = !0);
    }, HSolidElement.prototype.renderFrame = function(t) {
      var e = this.parent.renderFrame.call(this, t);
      return e === !1 ? void this.hide() : (this.hidden && (this.hidden = !1, this.innerElem.style.display = "block"), void(this.firstFrame && (this.firstFrame = !1)));
    }, HSolidElement.prototype.destroy = function() {
      this.parent.destroy.call(), this.innerElem = null;
    }, createElement(HBaseElement, HCompElement), extendPrototype(ExpressionComp, HCompElement), HCompElement.prototype.getDomElement = function() {
      return this.composingElement;
    }, HCompElement.prototype.getComposingElement = function() {
      return this.layerElement;
    }, HCompElement.prototype.createElements = function() {
      if (this.layerElement = document.createElement("div"), styleDiv(this.layerElement), this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.layerElement.style.clip = "rect(0px, " + this.data.w + "px, " + this.data.h + "px, 0px)", this.layerElement !== this.parentContainer && (this.placeholder = null), this.data.hasMask) {
        var t = document.createElementNS(svgNS, "svg");
        t.setAttribute("width", this.data.w), t.setAttribute("height", this.data.h);
        var e = document.createElementNS(svgNS, "g");
        t.appendChild(e), this.layerElement.appendChild(t), this.maskedElement = e, this.composingElement = e;
      } else
        this.composingElement = this.layerElement;
      this.appendNodeToParent(this.layerElement);
    }, HCompElement.prototype.hide = ICompElement.prototype.hide, HCompElement.prototype.prepareFrame = ICompElement.prototype.prepareFrame, HCompElement.prototype.setElements = ICompElement.prototype.setElements, HCompElement.prototype.getElements = ICompElement.prototype.getElements, HCompElement.prototype.destroy = ICompElement.prototype.destroy, HCompElement.prototype.renderFrame = function(t) {
      var e,
          s = this.parent.renderFrame.call(this, t),
          i = this.layers.length;
      if (s === !1)
        return void this.hide();
      for (this.hidden = !1, e = 0; i > e; e += 1)
        this.elements[e].renderFrame();
      this.firstFrame && (this.firstFrame = !1);
    }, createElement(HBaseElement, HShapeElement);
    var parent = HShapeElement.prototype.parent;
    extendPrototype(IShapeElement, HShapeElement), HShapeElement.prototype.parent = parent, HShapeElement.prototype.createElements = function() {
      var t = document.createElement("div");
      styleDiv(t);
      var e = document.createElementNS(svgNS, "svg");
      if (999999 === this.data.bounds.l, e.setAttribute("width", this.data.bounds.r - this.data.bounds.l), e.setAttribute("height", this.data.bounds.b - this.data.bounds.t), e.setAttribute("viewBox", this.data.bounds.l + " " + this.data.bounds.t + " " + (this.data.bounds.r - this.data.bounds.l) + " " + (this.data.bounds.b - this.data.bounds.t)), e.style.transform = e.style.webkitTransform = "translate(" + this.data.bounds.l + "px," + this.data.bounds.t + "px)", this.data.hasMask) {
        var s = document.createElementNS(svgNS, "g");
        t.appendChild(e), e.appendChild(s), this.maskedElement = s, this.layerElement = s, this.shapesContainer = s;
      } else
        t.appendChild(e), this.layerElement = e, this.shapesContainer = document.createElementNS(svgNS, "g"), this.layerElement.appendChild(this.shapesContainer);
      this.parentContainer.appendChild(t), this.innerElem = t, this.data.ln && this.innerElem.setAttribute("id", this.data.ln), this.searchShapes(this.shapesData, this.viewData, this.dynamicProperties, []), this.buildExpressionInterface(), this.layerElement = t;
    }, HShapeElement.prototype.renderFrame = function(t) {
      var e = this.parent.renderFrame.call(this, t);
      return e === !1 ? void this.hide() : (this.hidden = !1, this.transformHelper.opacity = this.finalTransform.opacity, this.transformHelper.matMdf = !1, this.transformHelper.opMdf = this.finalTransform.opMdf, void this.renderShape(this.transformHelper, null, null, !0));
    }, createElement(HBaseElement, HTextElement), HTextElement.prototype.init = ITextElement.prototype.init, HTextElement.prototype.getMeasures = ITextElement.prototype.getMeasures, HTextElement.prototype.createPathShape = ITextElement.prototype.createPathShape, HTextElement.prototype.createElements = function() {
      this.isMasked = this.checkMasks();
      var t = this.data.t.d,
          e = document.createElement("div");
      if (styleDiv(e), this.layerElement = e, this.isMasked) {
        this.renderType = "svg";
        var s = document.createElementNS(svgNS, "svg");
        this.cont = s, this.compW = this.comp.data ? this.comp.data.w : this.globalData.compSize.w, this.compH = this.comp.data ? this.comp.data.h : this.globalData.compSize.h, s.setAttribute("width", this.compW), s.setAttribute("height", this.compH);
        var i = document.createElementNS(svgNS, "g");
        s.appendChild(i), e.appendChild(s), this.maskedElement = i, this.innerElem = i;
      } else
        this.renderType = "html", this.innerElem = e;
      this.parentContainer.appendChild(e), this.innerElem.style.color = this.innerElem.style.fill = t.fc ? "rgb(" + t.fc[0] + "," + t.fc[1] + "," + t.fc[2] + ")" : "rgba(0,0,0,0)", t.sc && (this.innerElem.style.stroke = "rgb(" + t.sc[0] + "," + t.sc[1] + "," + t.sc[2] + ")", this.innerElem.style.strokeWidth = t.sw + "px");
      var a = this.globalData.fontManager.getFontByName(t.f);
      if (!this.globalData.fontManager.chars)
        if (this.innerElem.style.fontSize = t.s + "px", this.innerElem.style.lineHeight = t.s + "px", a.fClass)
          this.innerElem.className = a.fClass;
        else {
          this.innerElem.style.fontFamily = a.fFamily;
          var r = t.fWeight,
              n = t.fStyle;
          this.innerElem.style.fontStyle = n, this.innerElem.style.fontWeight = r;
        }
      var o,
          h,
          l = t.l;
      h = l.length;
      var p,
          m,
          f,
          d,
          c = this.mHelper,
          u = "";
      for (o = 0; h > o; o += 1) {
        if (this.globalData.fontManager.chars ? (p = document.createElementNS(svgNS, "path"), this.isMasked || (m = document.createElement("div"), f = document.createElementNS(svgNS, "svg"), m.appendChild(f), f.appendChild(p), styleDiv(m)), p.setAttribute("stroke-linecap", "butt"), p.setAttribute("stroke-linejoin", "round"), p.setAttribute("stroke-miterlimit", "4")) : this.isMasked ? p = document.createElementNS(svgNS, "text") : (m = document.createElement("span"), styleDiv(m), p = document.createElement("span"), styleDiv(p), m.appendChild(p)), this.globalData.fontManager.chars) {
          var y,
              v = this.globalData.fontManager.getCharData(t.t.charAt(o), a.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily);
          if (y = v ? v.data : null, c.reset(), y && y.shapes && (d = y.shapes[0].it, c.scale(t.s / 100, t.s / 100), u = this.createPathShape(c, d), p.setAttribute("d", u)), this.isMasked)
            this.innerElem.appendChild(p);
          else {
            this.innerElem.appendChild(m);
            var g = t.s / 100;
            if (y && y.shapes) {
              var b = Math.ceil(y.bounds.r * g),
                  E = Math.floor(y.bounds.t * g),
                  P = Math.floor(y.bounds.l * g),
                  k = Math.ceil(y.bounds.b * g);
              f.setAttribute("width", b - P), f.setAttribute("height", k - E), f.setAttribute("viewBox", P + " " + E + " " + (b - P) + " " + (k - E)), f.style.transform = f.style.webkitTransform = "translate(" + P + "px," + E + "px)", l[o].yOffset = E;
            } else
              f.setAttribute("width", 1), f.setAttribute("height", 1);
          }
        } else
          p.textContent = l[o].val, p.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked ? this.innerElem.appendChild(p) : (this.innerElem.appendChild(m), p.style.transform = p.style.webkitTransform = "translate3d(0," + -t.s / 1.2 + "px,0)");
        this.textSpans.push(this.isMasked ? p : m), this.textPaths.push(p);
      }
    }, HTextElement.prototype.hide = SVGTextElement.prototype.hide, HTextElement.prototype.renderFrame = function(t) {
      var e = this.parent.renderFrame.call(this, t);
      if (e === !1)
        return void this.hide();
      if (this.hidden && (this.hidden = !1, this.innerElem.style.display = "block"), this.data.singleShape) {
        if (!this.firstFrame)
          return;
        this.isMasked && this.finalTransform.matMdf && (this.cont.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), this.cont.style.transform = this.cont.style.webkitTransform = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)");
      }
      if (this.getMeasures(), this.lettersChangedFlag) {
        var s,
            i,
            a = this.renderedLetters,
            r = this.data.t.d.l;
        i = r.length;
        var n;
        for (s = 0; i > s; s += 1)
          r[s].n || (n = a[s], this.isMasked ? this.textSpans[s].setAttribute("transform", n.m) : this.textSpans[s].style.transform = this.textSpans[s].style.webkitTransform = n.m, this.textSpans[s].style.opacity = n.o, n.sw && this.textPaths[s].setAttribute("stroke-width", n.sw), n.sc && this.textPaths[s].setAttribute("stroke", n.sc), n.fc && (this.textPaths[s].setAttribute("fill", n.fc), this.textPaths[s].style.color = n.fc));
        if (this.isMasked) {
          var o = this.innerElem.getBBox();
          this.currentBBox.w !== o.width && (this.currentBBox.w = o.width, this.cont.setAttribute("width", o.width)), this.currentBBox.h !== o.height && (this.currentBBox.h = o.height, this.cont.setAttribute("height", o.height)), (this.currentBBox.w !== o.width || this.currentBBox.h !== o.height || this.currentBBox.x !== o.x || this.currentBBox.y !== o.y) && (this.currentBBox.w = o.width, this.currentBBox.h = o.height, this.currentBBox.x = o.x, this.currentBBox.y = o.y, this.cont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), this.cont.style.transform = this.cont.style.webkitTransform = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)");
        }
        this.firstFrame && (this.firstFrame = !1);
      }
    }, HTextElement.prototype.destroy = SVGTextElement.prototype.destroy, createElement(HBaseElement, HImageElement), HImageElement.prototype.createElements = function() {
      var t,
          e = function() {
            this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", this.path + this.assetData.p);
          },
          s = new Image;
      if (this.data.hasMask) {
        var t = document.createElement("div");
        styleDiv(t);
        var i = document.createElementNS(svgNS, "svg");
        i.setAttribute("width", this.assetData.w), i.setAttribute("height", this.assetData.h), t.appendChild(i), this.imageElem = document.createElementNS(svgNS, "image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), i.appendChild(this.imageElem), this.layerElement = t, this.parentContainer.appendChild(t), this.innerElem = t, this.maskedElement = this.imageElem, s.addEventListener("load", e.bind(this), !1), s.addEventListener("error", e.bind(this), !1);
      } else
        styleDiv(s), this.layerElement = s, this.parentContainer.appendChild(s), this.innerElem = s;
      s.src = this.path + this.assetData.p, this.data.ln && this.innerElem.setAttribute("id", this.data.ln);
    }, HImageElement.prototype.hide = HSolidElement.prototype.hide, HImageElement.prototype.renderFrame = HSolidElement.prototype.renderFrame, HImageElement.prototype.destroy = HSolidElement.prototype.destroy, createElement(HBaseElement, HCameraElement), HCameraElement.prototype.setup = function() {
      var t,
          e,
          s = this.comp.threeDElements.length;
      for (t = 0; s > t; t += 1)
        e = this.comp.threeDElements[t], e[0].style.perspective = e[0].style.webkitPerspective = this.pe.v + "px", e[1].style.transformOrigin = e[1].style.mozTransformOrigin = e[1].style.webkitTransformOrigin = "0px 0px 0px", e[0].style.transform = e[0].style.webkitTransform = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
    }, HCameraElement.prototype.createElements = function() {}, HCameraElement.prototype.hide = function() {}, HCameraElement.prototype.renderFrame = function() {
      var t,
          e,
          s = this.firstFrame;
      if (this.hierarchy)
        for (e = this.hierarchy.length, t = 0; e > t; t += 1)
          s = this.hierarchy[t].finalTransform.mProp.mdf ? !0 : s;
      if (s || this.p && this.p.mdf || this.px && (this.px.mdf || this.py.mdf || this.pz.mdf) || this.rx.mdf || this.ry.mdf || this.rz.mdf || this.or.mdf || this.a && this.a.mdf) {
        if (this.mat.reset(), this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
          var i = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]],
              a = Math.sqrt(Math.pow(i[0], 2) + Math.pow(i[1], 2) + Math.pow(i[2], 2)),
              r = [i[0] / a, i[1] / a, i[2] / a],
              n = Math.sqrt(r[2] * r[2] + r[0] * r[0]),
              o = Math.atan2(r[1], n),
              h = Math.atan2(r[0], -r[2]);
          this.mat.rotateY(h).rotateX(-o);
        }
        if (this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v), this.hierarchy) {
          var l;
          for (e = this.hierarchy.length, t = 0; e > t; t += 1)
            l = this.hierarchy[t].finalTransform.mProp.iv.props, this.mat.transform(l[0], l[1], l[2], l[3], l[4], l[5], l[6], l[7], l[8], l[9], l[10], l[11], -l[12], -l[13], l[14], l[15]);
        }
        e = this.comp.threeDElements.length;
        var p;
        for (t = 0; e > t; t += 1)
          p = this.comp.threeDElements[t], p[1].style.transform = p[1].style.webkitTransform = this.mat.toCSS();
      }
      this.firstFrame = !1;
    }, HCameraElement.prototype.destroy = function() {};
    var animationManager = function() {
      function t(e) {
        var s = 0,
            i = e.target;
        for (i.removeEventListener("destroy", t); P > s; )
          g[s].animation === i && (g.splice(s, 1), s -= 1, P -= 1), s += 1;
      }
      function e(e, s) {
        if (!e)
          return null;
        for (var i = 0; P > i; ) {
          if (g[i].elem == e && null !== g[i].elem)
            return g[i].animation;
          i += 1;
        }
        var a = new AnimationItem;
        return a.setData(e, s), a.addEventListener("destroy", t), g.push({
          elem: e,
          animation: a
        }), P += 1, a;
      }
      function s(e) {
        var s = new AnimationItem;
        return s.setParams(e), s.addEventListener("destroy", t), g.push({
          elem: null,
          animation: s
        }), P += 1, s;
      }
      function i(t, e) {
        var s;
        for (s = 0; P > s; s += 1)
          g[s].animation.setSpeed(t, e);
      }
      function a(t, e) {
        var s;
        for (s = 0; P > s; s += 1)
          g[s].animation.setDirection(t, e);
      }
      function r(t) {
        var e;
        for (e = 0; P > e; e += 1)
          g[e].animation.play(t);
      }
      function n(t, e) {
        E = !1, b = Date.now();
        var s;
        for (s = 0; P > s; s += 1)
          g[s].animation.moveFrame(t, e);
      }
      function o(t) {
        var e,
            s = t - b;
        for (e = 0; P > e; e += 1)
          g[e].animation.advanceTime(s);
        b = t, requestAnimationFrame(o);
      }
      function h(t) {
        b = t, requestAnimationFrame(o);
      }
      function l(t) {
        var e;
        for (e = 0; P > e; e += 1)
          g[e].animation.pause(t);
      }
      function p(t, e, s) {
        var i;
        for (i = 0; P > i; i += 1)
          g[i].animation.goToAndStop(t, e, s);
      }
      function m(t) {
        var e;
        for (e = 0; P > e; e += 1)
          g[e].animation.stop(t);
      }
      function f(t) {
        var e;
        for (e = 0; P > e; e += 1)
          g[e].animation.togglePause(t);
      }
      function d(t) {
        var e;
        for (e = 0; P > e; e += 1)
          g[e].animation.destroy(t);
      }
      function c(t, s, i) {
        var a,
            r = document.getElementsByClassName("bodymovin"),
            n = r.length;
        for (a = 0; n > a; a += 1)
          i && r[a].setAttribute("data-bm-type", i), e(r[a], t);
        if (s && 0 === n) {
          i || (i = "svg");
          var o = document.getElementsByTagName("body")[0];
          o.innerHTML = "";
          var h = document.createElement("div");
          h.style.width = "100%", h.style.height = "100%", h.setAttribute("data-bm-type", i), o.appendChild(h), e(h, t);
        }
      }
      function u() {
        var t;
        for (t = 0; P > t; t += 1)
          g[t].animation.resize();
      }
      function y() {
        requestAnimationFrame(h);
      }
      var v = {},
          g = [],
          b = 0,
          E = !0,
          P = 0;
      return setTimeout(y, 0), v.registerAnimation = e, v.loadAnimation = s, v.setSpeed = i, v.setDirection = a, v.play = r, v.moveFrame = n, v.pause = l, v.stop = m, v.togglePause = f, v.searchAnimations = c, v.resize = u, v.start = y, v.goToAndStop = p, v.destroy = d, v;
    }(),
        AnimationItem = function() {
          this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.pendingElements = 0, this.playCount = 0, this.prerenderFramesFlag = !0, this.repeat = "indefinite", this.animationData = {}, this.layers = [], this.assets = [], this.isPaused = !0, this.isScrolling = !1, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = randomString(10), this.renderedFrameCount = 0, this.scaleMode = "fit", this.math = Math, this.removed = !1, this.timeCompleted = 0, this.segmentPos = 0, this.segments = [];
        };
    AnimationItem.prototype.setParams = function(t) {
      var e = this;
      t.context && (this.context = t.context), (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
      var s = t.animType ? t.animType : t.renderer ? t.renderer : "canvas";
      switch (s) {
        case "canvas":
          this.renderer = new CanvasRenderer(this, t.rendererSettings);
          break;
        case "svg":
          this.renderer = new SVGRenderer(this, t.rendererSettings);
          break;
        case "hybrid":
        case "html":
        default:
          this.renderer = new HybridRenderer(this, t.rendererSettings);
      }
      if (this.animType = s, "" === t.loop || null === t.loop || (this.loop = t.loop === !1 ? !1 : t.loop === !0 ? !0 : parseInt(t.loop)), this.autoplay = "autoplay" in t ? t.autoplay : !0, this.name = t.name ? t.name : "", this.prerenderFramesFlag = "prerender" in t ? t.prerender : !0, this.autoloadSegments = t.hasOwnProperty("autoloadSegments") ? t.autoloadSegments : !0, t.animationData)
        e.configAnimation(t.animationData);
      else if (t.path) {
        "json" != t.path.substr(-4) && ("/" != t.path.substr(-1, 1) && (t.path += "/"), t.path += "data.json");
        var i = new XMLHttpRequest;
        this.path = -1 != t.path.lastIndexOf("\\") ? t.path.substr(0, t.path.lastIndexOf("\\") + 1) : t.path.substr(0, t.path.lastIndexOf("/") + 1), this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), i.open("GET", t.path, !0), i.send(), i.onreadystatechange = function() {
          if (4 == i.readyState)
            if (200 == i.status)
              e.configAnimation(JSON.parse(i.responseText));
            else
              try {
                var t = JSON.parse(i.responseText);
                e.configAnimation(t);
              } catch (s) {}
        };
      }
    }, AnimationItem.prototype.setData = function(t, e) {
      var s = {
        wrapper: t,
        animationData: e ? "object" == typeof e ? e : JSON.parse(e) : null
      },
          i = t.attributes;
      s.path = i.getNamedItem("data-animation-path") ? i.getNamedItem("data-animation-path").value : i.getNamedItem("data-bm-path") ? i.getNamedItem("data-bm-path").value : i.getNamedItem("bm-path") ? i.getNamedItem("bm-path").value : "", s.animType = i.getNamedItem("data-anim-type") ? i.getNamedItem("data-anim-type").value : i.getNamedItem("data-bm-type") ? i.getNamedItem("data-bm-type").value : i.getNamedItem("bm-type") ? i.getNamedItem("bm-type").value : i.getNamedItem("data-bm-renderer") ? i.getNamedItem("data-bm-renderer").value : i.getNamedItem("bm-renderer") ? i.getNamedItem("bm-renderer").value : "canvas";
      var a = i.getNamedItem("data-anim-loop") ? i.getNamedItem("data-anim-loop").value : i.getNamedItem("data-bm-loop") ? i.getNamedItem("data-bm-loop").value : i.getNamedItem("bm-loop") ? i.getNamedItem("bm-loop").value : "";
      "" === a || (s.loop = "false" === a ? !1 : "true" === a ? !0 : parseInt(a)), s.name = i.getNamedItem("data-name") ? i.getNamedItem("data-name").value : i.getNamedItem("data-bm-name") ? i.getNamedItem("data-bm-name").value : i.getNamedItem("bm-name") ? i.getNamedItem("bm-name").value : "";
      var r = i.getNamedItem("data-anim-prerender") ? i.getNamedItem("data-anim-prerender").value : i.getNamedItem("data-bm-prerender") ? i.getNamedItem("data-bm-prerender").value : i.getNamedItem("bm-prerender") ? i.getNamedItem("bm-prerender").value : "";
      "false" === r && (s.prerender = !1), this.setParams(s);
    }, AnimationItem.prototype.includeLayers = function(t) {
      t.op > this.animationData.op && (this.animationData.op = t.op, this.totalFrames = Math.floor(t.op - this.animationData.ip), this.animationData.tf = this.totalFrames);
      var e,
          s,
          i = this.animationData.layers,
          a = i.length,
          r = t.layers,
          n = r.length;
      for (s = 0; n > s; s += 1)
        for (e = 0; a > e; ) {
          if (i[e].id == r[s].id) {
            i[e] = r[s];
            break;
          }
          e += 1;
        }
      if ((t.chars || t.fonts) && (this.renderer.globalData.fontManager.addChars(t.chars), this.renderer.globalData.fontManager.addFonts(t.fonts, this.renderer.globalData.defs)), t.assets)
        for (a = t.assets.length, e = 0; a > e; e += 1)
          this.animationData.assets.push(t.assets[e]);
      dataManager.completeData(this.animationData, this.renderer.globalData.fontManager), this.renderer.includeLayers(t.layers), this.renderer.buildStage(this.container, this.layers), this.renderer.renderFrame(null), this.loadNextSegment();
    }, AnimationItem.prototype.loadNextSegment = function() {
      var t = this.animationData.segments;
      if (!t || 0 === t.length || !this.autoloadSegments)
        return this.trigger("data_ready"), void(this.timeCompleted = this.animationData.tf);
      var e = t.shift();
      this.timeCompleted = e.time * this.frameRate;
      var s = new XMLHttpRequest,
          i = this,
          a = this.path + this.fileName + "_" + this.segmentPos + ".json";
      this.segmentPos += 1, s.open("GET", a, !0), s.send(), s.onreadystatechange = function() {
        if (4 == s.readyState)
          if (200 == s.status)
            i.includeLayers(JSON.parse(s.responseText));
          else
            try {
              var t = JSON.parse(s.responseText);
              i.includeLayers(t);
            } catch (e) {}
      };
    }, AnimationItem.prototype.loadSegments = function() {
      var t = this.animationData.segments;
      t || (this.timeCompleted = this.animationData.tf), this.loadNextSegment();
    }, AnimationItem.prototype.configAnimation = function(t) {
      this.animationData = t, this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.animationData.tf = this.totalFrames, this.renderer.configAnimation(t), t.assets || (t.assets = []), t.comps && (t.assets = t.assets.concat(t.comps), t.comps = null), this.animationData._id = this.animationID, this.animationData._animType = this.animType, this.layers = this.animationData.layers, this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.firstFrame = Math.round(this.animationData.ip), this.frameMult = this.animationData.fr / 1e3, this.trigger("config_ready"), this.loadSegments(), this.updaFrameModifier(), this.renderer.globalData.fontManager ? this.waitForFontsLoaded() : (dataManager.completeData(this.animationData, this.renderer.globalData.fontManager), this.checkLoaded());
    }, AnimationItem.prototype.waitForFontsLoaded = function() {
      function t() {
        this.renderer.globalData.fontManager.loaded ? (dataManager.completeData(this.animationData, this.renderer.globalData.fontManager), this.renderer.buildItems(this.animationData.layers), this.checkLoaded()) : setTimeout(t.bind(this), 20);
      }
      return function() {
        t.bind(this)();
      };
    }(), AnimationItem.prototype.elementLoaded = function() {
      this.pendingElements--, this.checkLoaded();
    }, AnimationItem.prototype.checkLoaded = function() {
      0 === this.pendingElements && (this.renderer.buildStage(this.container, this.layers), this.trigger("DOMLoaded"), this.isLoaded = !0, this.gotoFrame(), this.autoplay && this.play());
    }, AnimationItem.prototype.resize = function() {
      this.renderer.updateContainerSize();
    }, AnimationItem.prototype.gotoFrame = function() {
      this.currentFrame = subframeEnabled ? this.currentRawFrame : this.math.floor(this.currentRawFrame), this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame();
    }, AnimationItem.prototype.renderFrame = function() {
      this.isLoaded !== !1 && this.renderer.renderFrame(this.currentFrame + this.firstFrame);
    }, AnimationItem.prototype.play = function(t) {
      t && this.name != t || this.isPaused === !0 && (this.isPaused = !1);
    }, AnimationItem.prototype.pause = function(t) {
      t && this.name != t || this.isPaused === !1 && (this.isPaused = !0);
    }, AnimationItem.prototype.togglePause = function(t) {
      t && this.name != t || (this.isPaused === !0 ? (this.isPaused = !1, this.play()) : (this.isPaused = !0, this.pause()));
    }, AnimationItem.prototype.stop = function(t) {
      t && this.name != t || (this.isPaused = !0, this.currentFrame = this.currentRawFrame = 0, this.playCount = 0, this.gotoFrame());
    }, AnimationItem.prototype.goToAndStop = function(t, e, s) {
      s && this.name != s || (this.setCurrentRawFrameValue(e ? t : t * this.frameModifier), this.isPaused = !0);
    }, AnimationItem.prototype.advanceTime = function(t) {
      this.isPaused !== !0 && this.isScrolling !== !0 && this.isLoaded !== !1 && this.setCurrentRawFrameValue(this.currentRawFrame + t * this.frameModifier);
    }, AnimationItem.prototype.updateAnimation = function(t) {
      this.setCurrentRawFrameValue(this.totalFrames * t);
    }, AnimationItem.prototype.moveFrame = function(t, e) {
      e && this.name != e || this.setCurrentRawFrameValue(this.currentRawFrame + t);
    }, AnimationItem.prototype.adjustSegment = function(t) {
      this.totalFrames = t[1] - t[0], this.firstFrame = t[0], this.trigger("segmentStart");
    }, AnimationItem.prototype.playSegments = function(t, e) {
      if ("object" == typeof t[0]) {
        var s,
            i = t.length;
        for (s = 0; i > s; s += 1)
          this.segments.push(t[s]);
      } else
        this.segments.push(t);
      e && (this.adjustSegment(this.segments.shift()), this.setCurrentRawFrameValue(0)), this.isPaused && this.play();
    }, AnimationItem.prototype.resetSegments = function(t) {
      this.segments.length = 0, this.segments.push([this.animationData.ip * this.frameRate, Math.floor(this.animationData.op - this.animationData.ip + this.animationData.ip * this.frameRate)]), t && this.adjustSegment(this.segments.shift());
    }, AnimationItem.prototype.remove = function(t) {
      t && this.name != t || this.renderer.destroy();
    }, AnimationItem.prototype.destroy = function(t) {
      t && this.name != t || this.renderer && this.renderer.destroyed || (this.renderer.destroy(), this.trigger("destroy"), this._cbs = null);
    }, AnimationItem.prototype.setCurrentRawFrameValue = function(t) {
      this.currentRawFrame = t;
      var e = !1;
      if (this.currentRawFrame >= this.totalFrames) {
        if (this.segments.length && (e = !0), this.loop === !1)
          return this.currentRawFrame = this.totalFrames - .01, this.gotoFrame(), this.pause(), void this.trigger("complete");
        if (this.trigger("loopComplete"), this.playCount += 1, this.loop !== !0 && this.playCount == this.loop)
          return this.currentRawFrame = this.totalFrames - .01, this.gotoFrame(), this.pause(), void this.trigger("complete");
      } else if (this.currentRawFrame < 0)
        return this.playCount -= 1, this.playCount < 0 && (this.playCount = 0), this.loop === !1 ? (this.currentRawFrame = 0, this.gotoFrame(), this.pause(), void this.trigger("complete")) : (this.trigger("loopComplete"), this.currentRawFrame = this.totalFrames + this.currentRawFrame, void this.gotoFrame());
      if (e) {
        var s = this.currentRawFrame % this.totalFrames;
        this.adjustSegment(this.segments.shift()), this.currentRawFrame = s;
      } else
        this.currentRawFrame = this.currentRawFrame % this.totalFrames;
      this.gotoFrame();
    }, AnimationItem.prototype.setSpeed = function(t) {
      this.playSpeed = t, this.updaFrameModifier();
    }, AnimationItem.prototype.setDirection = function(t) {
      this.playDirection = 0 > t ? -1 : 1, this.updaFrameModifier();
    }, AnimationItem.prototype.updaFrameModifier = function() {
      this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
    }, AnimationItem.prototype.getPath = function() {
      return this.path;
    }, AnimationItem.prototype.getAssetData = function(t) {
      for (var e = 0,
          s = this.assets.length; s > e; ) {
        if (t == this.assets[e].id)
          return this.assets[e];
        e += 1;
      }
    }, AnimationItem.prototype.hide = function() {
      this.renderer.hide();
    }, AnimationItem.prototype.show = function() {
      this.renderer.show();
    }, AnimationItem.prototype.getAssets = function() {
      return this.assets;
    }, AnimationItem.prototype.trigger = function(t) {
      if (this._cbs[t])
        switch (t) {
          case "enterFrame":
            this.triggerEvent(t, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameMult));
            break;
          case "loopComplete":
            this.triggerEvent(t, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult));
            break;
          case "complete":
            this.triggerEvent(t, new BMCompleteEvent(t, this.frameMult));
            break;
          case "segmentStart":
            this.triggerEvent(t, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames));
            break;
          case "destroy":
            this.triggerEvent(t, new BMDestroyEvent(t, this));
            break;
          default:
            this.triggerEvent(t);
        }
      "enterFrame" === t && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameMult)), "loopComplete" === t && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult)), "complete" === t && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(t, this.frameMult)), "segmentStart" === t && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames)), "destroy" === t && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(t, this));
    }, AnimationItem.prototype.addEventListener = _addEventListener, AnimationItem.prototype.removeEventListener = _removeEventListener, AnimationItem.prototype.triggerEvent = _triggerEvent;
    var bodymovinjs = {};
    function play(animation) {
      animationManager.play(animation);
    }
    function pause(animation) {
      animationManager.pause(animation);
    }
    function togglePause(animation) {
      animationManager.togglePause(animation);
    }
    function setSpeed(value, animation) {
      animationManager.setSpeed(value, animation);
    }
    function setDirection(value, animation) {
      animationManager.setDirection(value, animation);
    }
    function stop(animation) {
      animationManager.stop(animation);
    }
    function moveFrame(value) {
      animationManager.moveFrame(value);
    }
    function searchAnimations() {
      if (standalone === true) {
        animationManager.searchAnimations(animationData, standalone, renderer);
      } else {
        animationManager.searchAnimations();
      }
    }
    function registerAnimation(elem) {
      return animationManager.registerAnimation(elem);
    }
    function resize() {
      animationManager.resize();
    }
    function start() {
      animationManager.start();
    }
    function goToAndStop(val, isFrame, animation) {
      animationManager.goToAndStop(val, isFrame, animation);
    }
    function setSubframeRendering(flag) {
      subframeEnabled = flag;
    }
    function loadAnimation(params) {
      if (standalone === true) {
        params.animationData = JSON.parse(animationData);
      }
      return animationManager.loadAnimation(params);
    }
    function destroy(animation) {
      return animationManager.destroy(animation);
    }
    function setQuality(value) {
      if (typeof value === 'string') {
        switch (value) {
          case 'high':
            defaultCurveSegments = 200;
            break;
          case 'medium':
            defaultCurveSegments = 50;
            break;
          case 'low':
            defaultCurveSegments = 10;
            break;
        }
      } else if (!isNaN(value) && value > 1) {
        defaultCurveSegments = value;
      }
      if (defaultCurveSegments >= 50) {
        roundValues(false);
      } else {
        roundValues(true);
      }
    }
    bodymovinjs.play = play;
    bodymovinjs.pause = pause;
    bodymovinjs.togglePause = togglePause;
    bodymovinjs.setSpeed = setSpeed;
    bodymovinjs.setDirection = setDirection;
    bodymovinjs.stop = stop;
    bodymovinjs.moveFrame = moveFrame;
    bodymovinjs.searchAnimations = searchAnimations;
    bodymovinjs.registerAnimation = registerAnimation;
    bodymovinjs.loadAnimation = loadAnimation;
    bodymovinjs.setSubframeRendering = setSubframeRendering;
    bodymovinjs.resize = resize;
    bodymovinjs.start = start;
    bodymovinjs.goToAndStop = goToAndStop;
    bodymovinjs.destroy = destroy;
    bodymovinjs.setQuality = setQuality;
    bodymovinjs.version = '4.1.8';
    function checkReady() {
      if (document.readyState === "complete") {
        clearInterval(readyStateCheckInterval);
        searchAnimations();
      }
    }
    function getQueryVariable(variable) {
      var vars = queryString.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
          return decodeURIComponent(pair[1]);
        }
      }
    }
    var standalone = '__[STANDALONE]__';
    var animationData = '__[ANIMATIONDATA]__';
    var renderer = '';
    if (standalone) {
      var scripts = document.getElementsByTagName('script');
      var index = scripts.length - 1;
      var myScript = scripts[index];
      var queryString = myScript.src.replace(/^[^\?]+\??/, '');
      renderer = getQueryVariable('renderer');
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    return bodymovinjs;
  }));
  return module.exports;
});

$__System.registerDynamic("39", ["38"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = $__require('38');
  return module.exports;
});

$__System.register('5', ['3b', '1f', '1d', '1e', '3a'], function (_export) {
  var _createClass, _classCallCheck, _get, _inherits, symbol, GlyphChart, ClassedGlyphChart, MeanderingGlyphChart, AttributionTargetChart, MultiFociGlyphChart, FootTrafficChart;

  return {
    setters: [function (_b) {
      _createClass = _b['default'];
    }, function (_f) {
      _classCallCheck = _f['default'];
    }, function (_d) {
      _get = _d['default'];
    }, function (_e) {
      _inherits = _e['default'];
    }, function (_a) {
      symbol = _a.symbol;
    }],
    execute: function () {
      'use strict';

      GlyphChart = (function () {
        function GlyphChart(d3, container, Glyph, glyphSize, nodeLimit) {
          var charge = arguments.length <= 5 || arguments[5] === undefined ? -30 : arguments[5];
          var spawnInterval = arguments.length <= 6 || arguments[6] === undefined ? 2000 : arguments[6];
          var friction = arguments.length <= 7 || arguments[7] === undefined ? 0.8 : arguments[7];

          _classCallCheck(this, GlyphChart);

          this._d3 = d3;
          this.container = container;
          this.Glyph = Glyph;
          this.glyphSize = glyphSize;
          this.nodeLimit = nodeLimit;
          this.charge = charge;
          this.chargeDistance = 50;
          this.spawnInterval = spawnInterval;
          this.friction = friction;

          this.nodes = [];
          this.gravity = 0.1;

          this.setWidthHeight(container);
          this.createChart();
          this.force = this.initializeForce();
          this.tick();
        }

        _createClass(GlyphChart, [{
          key: 'setWidthHeight',
          value: function setWidthHeight(container) {
            this.width = 100;
            this.height = 100 * this.getConatinerAspectRatio(container);
          }
        }, {
          key: 'getConatinerAspectRatio',
          value: function getConatinerAspectRatio(container) {
            var height = container.getBoundingClientRect().height;
            var width = container.getBoundingClientRect().width;
            return height / width;
          }
        }, {
          key: 'removalDelay',
          value: function removalDelay(d, i) {
            var delay = 2000 * (i + 1);
            return delay;
          }
        }, {
          key: 'tick',
          value: function tick() {
            setTimeout(this.addNode.bind(this), this.tickInterval());
          }
        }, {
          key: 'tickInterval',
          value: function tickInterval() {
            return Math.floor(Math.random() * this.spawnInterval);
          }
        }, {
          key: 'moveNodes',
          value: function moveNodes() {
            this.vis.selectAll('.glyph').attr('transform', function (glyph) {
              return 'translate(' + glyph.x + ', ' + glyph.y + ') rotate(' + glyph.rotate() + ')';
            });
          }
        }, {
          key: 'setViewBox',
          value: function setViewBox() {
            this.vis.attr('viewBox', '0  0 ' + this.width + ' ' + this.height);
          }
        }, {
          key: 'setPreserveAspectRatio',
          value: function setPreserveAspectRatio() {
            this.vis.attr('preserveAspectRatio', 'xMinYMin');
          }
        }, {
          key: 'createChart',
          value: function createChart() {
            this.vis = this._d3.select(this.container).insert('svg', ':first-child');
            this.setViewBox();
            this.setPreserveAspectRatio();
          }
        }, {
          key: 'initializeForce',
          value: function initializeForce() {
            return this._d3.layout.force().nodes(this.nodes).links([]).charge(this.charge).chargeDistance(this.chargeDistance).friction(this.friction).gravity(this.gravity).size([this.width, this.height]).on('tick', this.moveNodes.bind(this)).on('end', this.addNode.bind(this));
          }
        }, {
          key: 'setGlyphStartPosition',
          value: function setGlyphStartPosition(glyph) {
            return glyph;
          }
        }, {
          key: 'constructGlyphs',
          value: function constructGlyphs(glyphs) {
            return glyphs.attr('class', function (glyph) {
              return glyph['class'];
            }).append('path').attr('d', function (glyph) {
              return symbol(1e-6, glyph.type);
            }).each(this.setGlyphStartPosition.bind(this)).transition().attr('d', function (glyph) {
              return symbol(glyph.size, glyph.type);
            });
          }
        }, {
          key: 'expireGlyphs',
          value: function expireGlyphs(glyphs) {
            var _this = this;

            var removedGlyphs = glyphs.transition().delay(this.removalDelay.bind(this)).duration(300);

            removedGlyphs.selectAll('path').attr('d', function (glyph) {
              return symbol(1e-6, glyph.type);
            }).each('end', function () {
              _this.force.nodes().shift();
              _this.force.start();
            });

            removedGlyphs.remove();
            return removedGlyphs;
          }
        }, {
          key: 'makeGlyphsDraggable',
          value: function makeGlyphsDraggable(glyphs) {
            glyphs.call(this.force.drag);
          }
        }, {
          key: 'createNode',
          value: function createNode() {
            return new this.Glyph(this.glyphSize);
          }
        }, {
          key: 'addNode',
          value: function addNode() {
            this.tick();
            if (this.nodes.length > this.nodeLimit) {
              return;
            }

            this.nodes.push(this.createNode());
            this.force.start();

            var glyphs = this.vis.selectAll('.glyph').data(this.nodes).enter().append('g');

            this.constructGlyphs(glyphs);
            this.expireGlyphs(glyphs);
            this.makeGlyphsDraggable(glyphs);
          }
        }]);

        return GlyphChart;
      })();

      _export('GlyphChart', GlyphChart);

      ClassedGlyphChart = (function (_GlyphChart) {
        _inherits(ClassedGlyphChart, _GlyphChart);

        function ClassedGlyphChart(d3, container, Glyph, classWeights, glyphSize, nodeLimit) {
          var charge = arguments.length <= 6 || arguments[6] === undefined ? -30 : arguments[6];
          var spawnInterval = arguments.length <= 7 || arguments[7] === undefined ? 2000 : arguments[7];
          var friction = arguments.length <= 8 || arguments[8] === undefined ? 0.8 : arguments[8];

          _classCallCheck(this, ClassedGlyphChart);

          _get(Object.getPrototypeOf(ClassedGlyphChart.prototype), 'constructor', this).call(this, d3, container, Glyph, glyphSize, nodeLimit, charge, spawnInterval, friction);
          this.classWeights = classWeights;
        }

        _createClass(ClassedGlyphChart, [{
          key: 'createNode',
          value: function createNode() {
            return new this.Glyph(this.glyphSize, this.classWeights);
          }
        }]);

        return ClassedGlyphChart;
      })(GlyphChart);

      _export('ClassedGlyphChart', ClassedGlyphChart);

      MeanderingGlyphChart = (function (_ClassedGlyphChart) {
        _inherits(MeanderingGlyphChart, _ClassedGlyphChart);

        function MeanderingGlyphChart(d3, container, Glyph, classWeights, glyphSize, nodeLimit) {
          var charge = arguments.length <= 6 || arguments[6] === undefined ? -30 : arguments[6];
          var spawnInterval = arguments.length <= 7 || arguments[7] === undefined ? 2000 : arguments[7];

          _classCallCheck(this, MeanderingGlyphChart);

          _get(Object.getPrototypeOf(MeanderingGlyphChart.prototype), 'constructor', this).call(this, d3, container, Glyph, classWeights, glyphSize, nodeLimit, charge, spawnInterval);
          this.gravity = 0;
          this.friction = 0.9;
          this.chargeDistance = 7;
          this.force = _get(Object.getPrototypeOf(MeanderingGlyphChart.prototype), 'initializeForce', this).call(this);
        }

        _createClass(MeanderingGlyphChart, [{
          key: 'setPreserveAspectRatio',
          value: function setPreserveAspectRatio() {
            this.vis.attr('preserveAspectRatio', 'xMinYMin slice');
          }
        }, {
          key: 'removalDelay',
          value: function removalDelay() {
            return 3000;
          }
        }]);

        return MeanderingGlyphChart;
      })(ClassedGlyphChart);

      _export('MeanderingGlyphChart', MeanderingGlyphChart);

      AttributionTargetChart = (function (_ClassedGlyphChart2) {
        _inherits(AttributionTargetChart, _ClassedGlyphChart2);

        function AttributionTargetChart(d3, container, Glyph, classWeights, glyphSize, nodeLimit) {
          var charge = arguments.length <= 6 || arguments[6] === undefined ? -30 : arguments[6];
          var spawnInterval = arguments.length <= 7 || arguments[7] === undefined ? 2000 : arguments[7];
          var friction = arguments.length <= 8 || arguments[8] === undefined ? 0.8 : arguments[8];

          _classCallCheck(this, AttributionTargetChart);

          _get(Object.getPrototypeOf(AttributionTargetChart.prototype), 'constructor', this).call(this, d3, container, Glyph, classWeights, glyphSize, nodeLimit, charge, spawnInterval, friction);
          this.notAnimating = true;
          this.minAnimationCount = this.nodeLimit * 0.3;
        }

        _createClass(AttributionTargetChart, [{
          key: 'removalDelay',
          value: function removalDelay() {
            return 0;
          }
        }, {
          key: 'expireGlyphs',
          value: function expireGlyphs() {
            var _this2 = this;

            var targetedGlyphs = this.vis.selectAll('.glyph--accent:not(.glyph--count)');

            if (targetedGlyphs.data().length > this.minAnimationCount && this.notAnimating) {
              (function () {
                var currentGlyphs = _this2.vis.selectAll('.glyph');
                _this2.notAnimating = false;
                targetedGlyphs.selectAll('path').classed('glyph--count', true);

                setTimeout(function () {
                  var removed = _get(Object.getPrototypeOf(AttributionTargetChart.prototype), 'expireGlyphs', _this2).call(_this2, currentGlyphs);
                  _this2.notAnimating = true;
                  return removed;
                }, 7000);
              })();
            }
          }
        }]);

        return AttributionTargetChart;
      })(ClassedGlyphChart);

      _export('AttributionTargetChart', AttributionTargetChart);

      MultiFociGlyphChart = (function (_ClassedGlyphChart3) {
        _inherits(MultiFociGlyphChart, _ClassedGlyphChart3);

        function MultiFociGlyphChart(d3, container, Glyph, classWeights, glyphSize, nodeLimit, charge, spawnInterval) {
          if (charge === undefined) charge = -30;
          var friction = arguments.length <= 8 || arguments[8] === undefined ? 0.8 : arguments[8];
          var foci = arguments.length <= 9 || arguments[9] === undefined ? [{ x: 50, y: 50 }] : arguments[9];

          _classCallCheck(this, MultiFociGlyphChart);

          _get(Object.getPrototypeOf(MultiFociGlyphChart.prototype), 'constructor', this).call(this, d3, container, Glyph, classWeights, glyphSize, nodeLimit, charge, spawnInterval, friction);
          this.foci = this.scaleToChartDemensions(foci);
          this.force = _get(Object.getPrototypeOf(MultiFociGlyphChart.prototype), 'initializeForce', this).call(this);
        }

        _createClass(MultiFociGlyphChart, [{
          key: 'scaleToChartDemensions',
          value: function scaleToChartDemensions(focusPoints) {
            var _this3 = this;

            return focusPoints.map(function (point) {
              var x = point.x / 100 * _this3.width;
              var y = point.y / 100 * _this3.height;
              return { x: x, y: y };
            });
          }
        }, {
          key: 'moveNodes',
          value: function moveNodes(e) {
            var smoothingFactor = 0.1 * e.alpha;
            var foci = this.foci;

            this.nodes.forEach(function (node) {
              node.y += (foci[node.focusId].y - node.y) * smoothingFactor;
              node.x += (foci[node.focusId].x - node.x) * smoothingFactor;
            });

            _get(Object.getPrototypeOf(MultiFociGlyphChart.prototype), 'moveNodes', this).call(this);
          }
        }]);

        return MultiFociGlyphChart;
      })(ClassedGlyphChart);

      _export('MultiFociGlyphChart', MultiFociGlyphChart);

      FootTrafficChart = (function (_MultiFociGlyphChart) {
        _inherits(FootTrafficChart, _MultiFociGlyphChart);

        function FootTrafficChart(d3, container, Glyph, classWeights, glyphSize, nodeLimit) {
          var charge = arguments.length <= 6 || arguments[6] === undefined ? -30 : arguments[6];
          var spawnInterval = arguments.length <= 7 || arguments[7] === undefined ? 2000 : arguments[7];

          var _this4 = this;

          var friction = arguments.length <= 8 || arguments[8] === undefined ? 0.8 : arguments[8];
          var foci = arguments.length <= 9 || arguments[9] === undefined ? [{ x: 50, y: 50 }] : arguments[9];

          _classCallCheck(this, FootTrafficChart);

          _get(Object.getPrototypeOf(FootTrafficChart.prototype), 'constructor', this).call(this, d3, container, Glyph, classWeights, glyphSize, nodeLimit, charge, spawnInterval, friction, foci);
          this.gravity = 0;
          this.force = _get(Object.getPrototypeOf(FootTrafficChart.prototype), 'initializeForce', this).call(this);

          window.addEventListener('resize', function () {
            _this4.setWidthHeight(container);
            _this4.setViewBox();
            _this4.foci = _this4.scaleToChartDemensions(foci);
          });
        }

        _createClass(FootTrafficChart, [{
          key: 'setGlyphStartPosition',
          value: function setGlyphStartPosition(glyph) {
            var x = this.foci[glyph.focusId].x;
            var y = this.height * 0.9 * -1;

            glyph.px = glyph.x = x;
            glyph.py = glyph.y = y;
            return glyph;
          }
        }, {
          key: 'removalDelay',
          value: function removalDelay() {
            return 4000;
          }
        }]);

        return FootTrafficChart;
      })(MultiFociGlyphChart);

      _export('FootTrafficChart', FootTrafficChart);
    }
  };
});
$__System.registerDynamic("3c", ["3d", "3e"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var toIObject = $__require('3d');
  $__require('3e')('getOwnPropertyDescriptor', function($getOwnPropertyDescriptor) {
    return function getOwnPropertyDescriptor(it, key) {
      return $getOwnPropertyDescriptor(toIObject(it), key);
    };
  });
  return module.exports;
});

$__System.registerDynamic("3f", ["11", "3c"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var $ = $__require('11');
  $__require('3c');
  module.exports = function getOwnPropertyDescriptor(it, key) {
    return $.getDesc(it, key);
  };
  return module.exports;
});

$__System.registerDynamic("40", ["3f"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = {
    "default": $__require('3f'),
    __esModule: true
  };
  return module.exports;
});

$__System.registerDynamic("1d", ["40"], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  var _Object$getOwnPropertyDescriptor = $__require('40')["default"];
  exports["default"] = function get(_x, _x2, _x3) {
    var _again = true;
    _function: while (_again) {
      var object = _x,
          property = _x2,
          receiver = _x3;
      _again = false;
      if (object === null)
        object = Function.prototype;
      var desc = _Object$getOwnPropertyDescriptor(object, property);
      if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);
        if (parent === null) {
          return undefined;
        } else {
          _x = parent;
          _x2 = property;
          _x3 = receiver;
          _again = true;
          desc = parent = undefined;
          continue _function;
        }
      } else if ("value" in desc) {
        return desc.value;
      } else {
        var getter = desc.get;
        if (getter === undefined) {
          return undefined;
        }
        return getter.call(receiver);
      }
    }
  };
  exports.__esModule = true;
  return module.exports;
});

$__System.registerDynamic("1e", ["41", "42"], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  var _Object$create = $__require('41')["default"];
  var _Object$setPrototypeOf = $__require('42')["default"];
  exports["default"] = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = _Object$create(superClass && superClass.prototype, {constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }});
    if (superClass)
      _Object$setPrototypeOf ? _Object$setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };
  exports.__esModule = true;
  return module.exports;
});

$__System.registerDynamic("3e", ["16", "18", "14"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var $export = $__require('16'),
      core = $__require('18'),
      fails = $__require('14');
  module.exports = function(KEY, exec) {
    var fn = (core.Object || {})[KEY] || Object[KEY],
        exp = {};
    exp[KEY] = exec(fn);
    $export($export.S + $export.F * fails(function() {
      fn(1);
    }), 'Object', exp);
  };
  return module.exports;
});

$__System.registerDynamic("43", ["12", "3e"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var toObject = $__require('12');
  $__require('3e')('keys', function($keys) {
    return function keys(it) {
      return $keys(toObject(it));
    };
  });
  return module.exports;
});

$__System.registerDynamic("44", ["43", "18"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  $__require('43');
  module.exports = $__require('18').Object.keys;
  return module.exports;
});

$__System.registerDynamic("45", ["44"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = {
    "default": $__require('44'),
    __esModule: true
  };
  return module.exports;
});

$__System.registerDynamic("46", [], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  var paramCounts = {
    a: 7,
    c: 6,
    h: 1,
    l: 2,
    m: 2,
    r: 4,
    q: 4,
    s: 4,
    t: 2,
    v: 1,
    z: 0
  };
  var SPECIAL_SPACES = [0x1680, 0x180E, 0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005, 0x2006, 0x2007, 0x2008, 0x2009, 0x200A, 0x202F, 0x205F, 0x3000, 0xFEFF];
  function isSpace(ch) {
    return (ch === 0x0A) || (ch === 0x0D) || (ch === 0x2028) || (ch === 0x2029) || (ch === 0x20) || (ch === 0x09) || (ch === 0x0B) || (ch === 0x0C) || (ch === 0xA0) || (ch >= 0x1680 && SPECIAL_SPACES.indexOf(ch) >= 0);
  }
  function isCommand(code) {
    switch (code | 0x20) {
      case 0x6D:
      case 0x7A:
      case 0x6C:
      case 0x68:
      case 0x76:
      case 0x63:
      case 0x73:
      case 0x71:
      case 0x74:
      case 0x61:
      case 0x72:
        return true;
    }
    return false;
  }
  function isDigit(code) {
    return (code >= 48 && code <= 57);
  }
  function isDigitStart(code) {
    return (code >= 48 && code <= 57) || code === 0x2B || code === 0x2D || code === 0x2E;
  }
  function State(path) {
    this.index = 0;
    this.path = path;
    this.max = path.length;
    this.result = [];
    this.param = 0.0;
    this.err = '';
    this.segmentStart = 0;
    this.data = [];
  }
  function skipSpaces(state) {
    while (state.index < state.max && isSpace(state.path.charCodeAt(state.index))) {
      state.index++;
    }
  }
  function scanParam(state) {
    var start = state.index,
        index = start,
        max = state.max,
        zeroFirst = false,
        hasCeiling = false,
        hasDecimal = false,
        hasDot = false,
        ch;
    if (index >= max) {
      state.err = 'SvgPath: missed param (at pos ' + index + ')';
      return;
    }
    ch = state.path.charCodeAt(index);
    if (ch === 0x2B || ch === 0x2D) {
      index++;
      ch = (index < max) ? state.path.charCodeAt(index) : 0;
    }
    if (!isDigit(ch) && ch !== 0x2E) {
      state.err = 'SvgPath: param should start with 0..9 or `.` (at pos ' + index + ')';
      return;
    }
    if (ch !== 0x2E) {
      zeroFirst = (ch === 0x30);
      index++;
      ch = (index < max) ? state.path.charCodeAt(index) : 0;
      if (zeroFirst && index < max) {
        if (ch && isDigit(ch)) {
          state.err = 'SvgPath: numbers started with `0` such as `09` are ilegal (at pos ' + start + ')';
          return;
        }
      }
      while (index < max && isDigit(state.path.charCodeAt(index))) {
        index++;
        hasCeiling = true;
      }
      ch = (index < max) ? state.path.charCodeAt(index) : 0;
    }
    if (ch === 0x2E) {
      hasDot = true;
      index++;
      while (isDigit(state.path.charCodeAt(index))) {
        index++;
        hasDecimal = true;
      }
      ch = (index < max) ? state.path.charCodeAt(index) : 0;
    }
    if (ch === 0x65 || ch === 0x45) {
      if (hasDot && !hasCeiling && !hasDecimal) {
        state.err = 'SvgPath: invalid float exponent (at pos ' + index + ')';
        return;
      }
      index++;
      ch = (index < max) ? state.path.charCodeAt(index) : 0;
      if (ch === 0x2B || ch === 0x2D) {
        index++;
      }
      if (index < max && isDigit(state.path.charCodeAt(index))) {
        while (index < max && isDigit(state.path.charCodeAt(index))) {
          index++;
        }
      } else {
        state.err = 'SvgPath: invalid float exponent (at pos ' + index + ')';
        return;
      }
    }
    state.index = index;
    state.param = parseFloat(state.path.slice(start, index)) + 0.0;
  }
  function finalizeSegment(state) {
    var cmd,
        cmdLC;
    cmd = state.path[state.segmentStart];
    cmdLC = cmd.toLowerCase();
    var params = state.data;
    if (cmdLC === 'm' && params.length > 2) {
      state.result.push([cmd, params[0], params[1]]);
      params = params.slice(2);
      cmdLC = 'l';
      cmd = (cmd === 'm') ? 'l' : 'L';
    }
    if (cmdLC === 'r') {
      state.result.push([cmd].concat(params));
    } else {
      while (params.length >= paramCounts[cmdLC]) {
        state.result.push([cmd].concat(params.splice(0, paramCounts[cmdLC])));
        if (!paramCounts[cmdLC]) {
          break;
        }
      }
    }
  }
  function scanSegment(state) {
    var max = state.max,
        cmdCode,
        comma_found,
        need_params,
        i;
    state.segmentStart = state.index;
    cmdCode = state.path.charCodeAt(state.index);
    if (!isCommand(cmdCode)) {
      state.err = 'SvgPath: bad command ' + state.path[state.index] + ' (at pos ' + state.index + ')';
      return;
    }
    need_params = paramCounts[state.path[state.index].toLowerCase()];
    state.index++;
    skipSpaces(state);
    state.data = [];
    if (!need_params) {
      finalizeSegment(state);
      return;
    }
    comma_found = false;
    for (; ; ) {
      for (i = need_params; i > 0; i--) {
        scanParam(state);
        if (state.err.length) {
          return;
        }
        state.data.push(state.param);
        skipSpaces(state);
        comma_found = false;
        if (state.index < max && state.path.charCodeAt(state.index) === 0x2C) {
          state.index++;
          skipSpaces(state);
          comma_found = true;
        }
      }
      if (comma_found) {
        continue;
      }
      if (state.index >= state.max) {
        break;
      }
      if (!isDigitStart(state.path.charCodeAt(state.index))) {
        break;
      }
    }
    finalizeSegment(state);
  }
  module.exports = function pathParse(svgPath) {
    var state = new State(svgPath);
    var max = state.max;
    skipSpaces(state);
    while (state.index < max && !state.err.length) {
      scanSegment(state);
    }
    if (state.err.length) {
      state.result = [];
    } else if (state.result.length) {
      if ('mM'.indexOf(state.result[0][0]) < 0) {
        state.err = 'SvgPath: string should start with `M` or `m`';
        state.result = [];
      } else {
        state.result[0][0] = 'M';
      }
    }
    return {
      err: state.err,
      segments: state.result
    };
  };
  return module.exports;
});

$__System.registerDynamic("47", ["48"], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  var Matrix = $__require('48');
  var operations = {
    matrix: true,
    scale: true,
    rotate: true,
    translate: true,
    skewX: true,
    skewY: true
  };
  var CMD_SPLIT_RE = /\s*(matrix|translate|scale|rotate|skewX|skewY)\s*\(\s*(.+?)\s*\)[\s,]*/;
  var PARAMS_SPLIT_RE = /[\s,]+/;
  module.exports = function transformParse(transformString) {
    var matrix = new Matrix();
    var cmd,
        params;
    transformString.split(CMD_SPLIT_RE).forEach(function(item) {
      if (!item.length) {
        return;
      }
      if (typeof operations[item] !== 'undefined') {
        cmd = item;
        return;
      }
      params = item.split(PARAMS_SPLIT_RE).map(function(i) {
        return +i || 0;
      });
      switch (cmd) {
        case 'matrix':
          if (params.length === 6) {
            matrix.matrix(params);
          }
          return;
        case 'scale':
          if (params.length === 1) {
            matrix.scale(params[0], params[0]);
          } else if (params.length === 2) {
            matrix.scale(params[0], params[1]);
          }
          return;
        case 'rotate':
          if (params.length === 1) {
            matrix.rotate(params[0], 0, 0);
          } else if (params.length === 3) {
            matrix.rotate(params[0], params[1], params[2]);
          }
          return;
        case 'translate':
          if (params.length === 1) {
            matrix.translate(params[0], 0);
          } else if (params.length === 2) {
            matrix.translate(params[0], params[1]);
          }
          return;
        case 'skewX':
          if (params.length === 1) {
            matrix.skewX(params[0]);
          }
          return;
        case 'skewY':
          if (params.length === 1) {
            matrix.skewY(params[0]);
          }
          return;
      }
    });
    return matrix;
  };
  return module.exports;
});

$__System.registerDynamic("48", [], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  function combine(m1, m2) {
    return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
  }
  function Matrix() {
    if (!(this instanceof Matrix)) {
      return new Matrix();
    }
    this.queue = [];
    this.cache = null;
  }
  Matrix.prototype.matrix = function(m) {
    if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1 && m[4] === 0 && m[5] === 0) {
      return this;
    }
    this.cache = null;
    this.queue.push(m);
    return this;
  };
  Matrix.prototype.translate = function(tx, ty) {
    if (tx !== 0 || ty !== 0) {
      this.cache = null;
      this.queue.push([1, 0, 0, 1, tx, ty]);
    }
    return this;
  };
  Matrix.prototype.scale = function(sx, sy) {
    if (sx !== 1 || sy !== 1) {
      this.cache = null;
      this.queue.push([sx, 0, 0, sy, 0, 0]);
    }
    return this;
  };
  Matrix.prototype.rotate = function(angle, rx, ry) {
    var rad,
        cos,
        sin;
    if (angle !== 0) {
      this.translate(rx, ry);
      rad = angle * Math.PI / 180;
      cos = Math.cos(rad);
      sin = Math.sin(rad);
      this.queue.push([cos, sin, -sin, cos, 0, 0]);
      this.cache = null;
      this.translate(-rx, -ry);
    }
    return this;
  };
  Matrix.prototype.skewX = function(angle) {
    if (angle !== 0) {
      this.cache = null;
      this.queue.push([1, 0, Math.tan(angle * Math.PI / 180), 1, 0, 0]);
    }
    return this;
  };
  Matrix.prototype.skewY = function(angle) {
    if (angle !== 0) {
      this.cache = null;
      this.queue.push([1, Math.tan(angle * Math.PI / 180), 0, 1, 0, 0]);
    }
    return this;
  };
  Matrix.prototype.toArray = function() {
    if (this.cache) {
      return this.cache;
    }
    if (!this.queue.length) {
      this.cache = [1, 0, 0, 1, 0, 0];
      return this.cache;
    }
    this.cache = this.queue[0];
    if (this.queue.length === 1) {
      return this.cache;
    }
    for (var i = 1; i < this.queue.length; i++) {
      this.cache = combine(this.cache, this.queue[i]);
    }
    return this.cache;
  };
  Matrix.prototype.calc = function(x, y, isRelative) {
    var m,
        i,
        len;
    if (!this.queue.length) {
      return [x, y];
    }
    if (!this.cache) {
      this.cache = this.toArray();
    }
    m = this.cache;
    return [x * m[0] + y * m[2] + (isRelative ? 0 : m[4]), x * m[1] + y * m[3] + (isRelative ? 0 : m[5])];
  };
  module.exports = Matrix;
  return module.exports;
});

$__System.registerDynamic("49", [], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  var TAU = Math.PI * 2;
  function vector_angle(ux, uy, vx, vy) {
    var sign = (ux * vy - uy * vx < 0) ? -1 : 1;
    var umag = Math.sqrt(ux * ux + uy * uy);
    var vmag = Math.sqrt(ux * ux + uy * uy);
    var dot = ux * vx + uy * vy;
    var div = dot / (umag * vmag);
    if (div > 1.0) {
      div = 1.0;
    }
    if (div < -1.0) {
      div = -1.0;
    }
    return sign * Math.acos(div);
  }
  function get_arc_center(x1, y1, x2, y2, fa, fs, rx, ry, sin_φ, cos_φ) {
    var x1p = cos_φ * (x1 - x2) / 2 + sin_φ * (y1 - y2) / 2;
    var y1p = -sin_φ * (x1 - x2) / 2 + cos_φ * (y1 - y2) / 2;
    var rx_sq = rx * rx;
    var ry_sq = ry * ry;
    var x1p_sq = x1p * x1p;
    var y1p_sq = y1p * y1p;
    var radicant = (rx_sq * ry_sq) - (rx_sq * y1p_sq) - (ry_sq * x1p_sq);
    if (radicant < 0) {
      radicant = 0;
    }
    radicant /= (rx_sq * y1p_sq) + (ry_sq * x1p_sq);
    radicant = Math.sqrt(radicant) * (fa === fs ? -1 : 1);
    var cxp = radicant * rx / ry * y1p;
    var cyp = radicant * -ry / rx * x1p;
    var cx = cos_φ * cxp - sin_φ * cyp + (x1 + x2) / 2;
    var cy = sin_φ * cxp + cos_φ * cyp + (y1 + y2) / 2;
    var v1x = (x1p - cxp) / rx;
    var v1y = (y1p - cyp) / ry;
    var v2x = (-x1p - cxp) / rx;
    var v2y = (-y1p - cyp) / ry;
    var θ1 = vector_angle(1, 0, v1x, v1y);
    var Δθ = vector_angle(v1x, v1y, v2x, v2y);
    if (fs === 0 && Δθ > 0) {
      Δθ -= TAU;
    }
    if (fs === 1 && Δθ < 0) {
      Δθ += TAU;
    }
    return [cx, cy, θ1, Δθ];
  }
  function approximate_unit_arc(θ1, Δθ) {
    var α = 4 / 3 * Math.tan(Δθ / 4);
    var x1 = Math.cos(θ1);
    var y1 = Math.sin(θ1);
    var x2 = Math.cos(θ1 + Δθ);
    var y2 = Math.sin(θ1 + Δθ);
    return [x1, y1, x1 - y1 * α, y1 + x1 * α, x2 + y2 * α, y2 - x2 * α, x2, y2];
  }
  module.exports = function a2c(x1, y1, x2, y2, fa, fs, rx, ry, φ) {
    var sin_φ = Math.sin(φ * TAU / 360);
    var cos_φ = Math.cos(φ * TAU / 360);
    var x1p = cos_φ * (x1 - x2) / 2 + sin_φ * (y1 - y2) / 2;
    var y1p = -sin_φ * (x1 - x2) / 2 + cos_φ * (y1 - y2) / 2;
    if (x1p === 0 && y1p === 0) {
      return [];
    }
    if (rx === 0 || ry === 0) {
      return [];
    }
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    var Λ = (x1p * x1p) / (rx * rx) + (y1p * y1p) / (ry * ry);
    if (Λ > 1) {
      rx *= Math.sqrt(Λ);
      ry *= Math.sqrt(Λ);
    }
    var cc = get_arc_center(x1, y1, x2, y2, fa, fs, rx, ry, sin_φ, cos_φ);
    var result = [];
    var θ1 = cc[2];
    var Δθ = cc[3];
    var segments = Math.max(Math.ceil(Math.abs(Δθ) / (TAU / 4)), 1);
    Δθ /= segments;
    for (var i = 0; i < segments; i++) {
      result.push(approximate_unit_arc(θ1, Δθ));
      θ1 += Δθ;
    }
    return result.map(function(curve) {
      for (var i = 0; i < curve.length; i += 2) {
        var x = curve[i + 0];
        var y = curve[i + 1];
        x *= rx;
        y *= ry;
        var xp = cos_φ * x - sin_φ * y;
        var yp = sin_φ * x + cos_φ * y;
        curve[i + 0] = xp + cc[0];
        curve[i + 1] = yp + cc[1];
      }
      return curve;
    });
  };
  return module.exports;
});

$__System.registerDynamic("4a", [], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  var epsilon = 0.0000000001;
  var torad = Math.PI / 180;
  function Ellipse(rx, ry, ax) {
    if (!(this instanceof Ellipse)) {
      return new Ellipse(rx, ry, ax);
    }
    this.rx = rx;
    this.ry = ry;
    this.ax = ax;
  }
  Ellipse.prototype.transform = function(m) {
    var c = Math.cos(this.ax * torad),
        s = Math.sin(this.ax * torad);
    var ma = [this.rx * (m[0] * c + m[2] * s), this.rx * (m[1] * c + m[3] * s), this.ry * (-m[0] * s + m[2] * c), this.ry * (-m[1] * s + m[3] * c)];
    var J = ma[0] * ma[0] + ma[2] * ma[2],
        K = ma[1] * ma[1] + ma[3] * ma[3];
    var D = ((ma[0] - ma[3]) * (ma[0] - ma[3]) + (ma[2] + ma[1]) * (ma[2] + ma[1])) * ((ma[0] + ma[3]) * (ma[0] + ma[3]) + (ma[2] - ma[1]) * (ma[2] - ma[1]));
    var JK = (J + K) / 2;
    if (D < epsilon * JK) {
      this.rx = this.ry = Math.sqrt(JK);
      this.ax = 0;
      return this;
    }
    var L = ma[0] * ma[1] + ma[2] * ma[3];
    D = Math.sqrt(D);
    var l1 = JK + D / 2,
        l2 = JK - D / 2;
    this.ax = (Math.abs(L) < epsilon && Math.abs(l1 - K) < epsilon) ? 90 : Math.atan(Math.abs(L) > Math.abs(l1 - K) ? (l1 - J) / L : L / (l1 - K)) * 180 / Math.PI;
    if (this.ax >= 0) {
      this.rx = Math.sqrt(l1);
      this.ry = Math.sqrt(l2);
    } else {
      this.ax += 90;
      this.rx = Math.sqrt(l2);
      this.ry = Math.sqrt(l1);
    }
    return this;
  };
  Ellipse.prototype.isDegenerate = function() {
    return (this.rx < epsilon * this.ry || this.ry < epsilon * this.rx);
  };
  module.exports = Ellipse;
  return module.exports;
});

$__System.registerDynamic("4b", ["46", "47", "48", "49", "4a", "4c"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  (function(process) {
    'use strict';
    var pathParse = $__require('46');
    var transformParse = $__require('47');
    var matrix = $__require('48');
    var a2c = $__require('49');
    var ellipse = $__require('4a');
    function SvgPath(path) {
      if (!(this instanceof SvgPath)) {
        return new SvgPath(path);
      }
      var pstate = pathParse(path);
      this.segments = pstate.segments;
      this.err = pstate.err;
      this.__stack = [];
    }
    SvgPath.prototype.__matrix = function(m) {
      var self = this,
          ma,
          sx,
          sy,
          angle,
          arc2line,
          i;
      if (!m.queue.length) {
        return;
      }
      this.iterate(function(s, index, x, y) {
        var p,
            result,
            name,
            isRelative;
        switch (s[0]) {
          case 'v':
            p = m.calc(0, s[1], true);
            result = (p[0] === 0) ? ['v', p[1]] : ['l', p[0], p[1]];
            break;
          case 'V':
            p = m.calc(x, s[1], false);
            result = (p[0] === m.calc(x, y, false)[0]) ? ['V', p[1]] : ['L', p[0], p[1]];
            break;
          case 'h':
            p = m.calc(s[1], 0, true);
            result = (p[1] === 0) ? ['h', p[0]] : ['l', p[0], p[1]];
            break;
          case 'H':
            p = m.calc(s[1], y, false);
            result = (p[1] === m.calc(x, y, false)[1]) ? ['H', p[0]] : ['L', p[0], p[1]];
            break;
          case 'a':
          case 'A':
            var ma = m.toArray();
            var e = ellipse(s[1], s[2], s[3]).transform(ma);
            if (ma[0] * ma[3] - ma[1] * ma[2] < 0) {
              s[5] = s[5] ? '0' : '1';
            }
            p = m.calc(s[6], s[7], s[0] === 'a');
            if ((s[0] === 'A' && s[6] === x && s[7] === y) || (s[0] === 'a' && s[6] === 0 && s[7] === 0)) {
              result = [s[0] === 'a' ? 'l' : 'L', p[0], p[1]];
              break;
            }
            if (e.isDegenerate()) {
              result = [s[0] === 'a' ? 'l' : 'L', p[0], p[1]];
            } else {
              result = [s[0], e.rx, e.ry, e.ax, s[4], s[5], p[0], p[1]];
            }
            break;
          case 'm':
            isRelative = index > 0;
            p = m.calc(s[1], s[2], isRelative);
            result = ['m', p[0], p[1]];
            break;
          default:
            name = s[0];
            result = [name];
            isRelative = (name.toLowerCase() === name);
            for (i = 1; i < s.length; i += 2) {
              p = m.calc(s[i], s[i + 1], isRelative);
              result.push(p[0], p[1]);
            }
        }
        self.segments[index] = result;
      }, true);
    };
    SvgPath.prototype.__evaluateStack = function() {
      var m,
          i;
      if (!this.__stack.length) {
        return;
      }
      if (this.__stack.length === 1) {
        this.__matrix(this.__stack[0]);
        this.__stack = [];
        return;
      }
      m = matrix();
      i = this.__stack.length;
      while (--i >= 0) {
        m.matrix(this.__stack[i].toArray());
      }
      this.__matrix(m);
      this.__stack = [];
    };
    SvgPath.prototype.toString = function() {
      var elements = [],
          skipCmd,
          cmd;
      this.__evaluateStack();
      for (var i = 0; i < this.segments.length; i++) {
        cmd = this.segments[i][0];
        skipCmd = i > 0 && cmd !== 'm' && cmd !== 'M' && cmd === this.segments[i - 1][0];
        elements = elements.concat(skipCmd ? this.segments[i].slice(1) : this.segments[i]);
      }
      return elements.join(' ').replace(/ ?([achlmqrstvz]) ?/gi, '$1').replace(/ \-/g, '-').replace(/zm/g, 'z m');
    };
    SvgPath.prototype.translate = function(x, y) {
      this.__stack.push(matrix().translate(x, y || 0));
      return this;
    };
    SvgPath.prototype.scale = function(sx, sy) {
      this.__stack.push(matrix().scale(sx, (!sy && (sy !== 0)) ? sx : sy));
      return this;
    };
    SvgPath.prototype.rotate = function(angle, rx, ry) {
      this.__stack.push(matrix().rotate(angle, rx || 0, ry || 0));
      return this;
    };
    SvgPath.prototype.matrix = function(m) {
      this.__stack.push(matrix().matrix(m));
      return this;
    };
    SvgPath.prototype.transform = function(transformString) {
      if (!transformString.trim()) {
        return this;
      }
      this.__stack.push(transformParse(transformString));
      return this;
    };
    SvgPath.prototype.round = function(d) {
      var contourStartDeltaX = 0,
          contourStartDeltaY = 0,
          deltaX = 0,
          deltaY = 0,
          l;
      d = d || 0;
      this.__evaluateStack();
      this.segments.forEach(function(s) {
        var isRelative = (s[0].toLowerCase() === s[0]),
            t;
        switch (s[0]) {
          case 'H':
          case 'h':
            if (isRelative) {
              s[1] += deltaX;
            }
            deltaX = s[1] - s[1].toFixed(d);
            s[1] = +s[1].toFixed(d);
            return;
          case 'V':
          case 'v':
            if (isRelative) {
              s[1] += deltaY;
            }
            deltaY = s[1] - s[1].toFixed(d);
            s[1] = +s[1].toFixed(d);
            return;
          case 'Z':
          case 'z':
            deltaX = contourStartDeltaX;
            deltaY = contourStartDeltaY;
            return;
          case 'M':
          case 'm':
            if (isRelative) {
              s[1] += deltaX;
              s[2] += deltaY;
            }
            deltaX = s[1] - s[1].toFixed(d);
            deltaY = s[2] - s[2].toFixed(d);
            contourStartDeltaX = deltaX;
            contourStartDeltaY = deltaY;
            s[1] = +s[1].toFixed(d);
            s[2] = +s[2].toFixed(d);
            return;
          case 'A':
          case 'a':
            if (isRelative) {
              s[6] += deltaX;
              s[7] += deltaY;
            }
            deltaX = s[6] - s[6].toFixed(d);
            deltaY = s[7] - s[7].toFixed(d);
            s[1] = +s[1].toFixed(d);
            s[2] = +s[2].toFixed(d);
            s[3] = +s[3].toFixed(d + 2);
            s[6] = +s[6].toFixed(d);
            s[7] = +s[7].toFixed(d);
            return;
          default:
            l = s.length;
            if (isRelative) {
              s[l - 2] += deltaX;
              s[l - 1] += deltaY;
            }
            deltaX = s[l - 2] - s[l - 2].toFixed(d);
            deltaY = s[l - 1] - s[l - 1].toFixed(d);
            s.forEach(function(val, i) {
              if (!i) {
                return;
              }
              s[i] = +s[i].toFixed(d);
            });
            return;
        }
      });
      return this;
    };
    SvgPath.prototype.iterate = function(iterator, keepLazyStack) {
      var segments = this.segments,
          replacements = {},
          needReplace = false,
          lastX = 0,
          lastY = 0,
          countourStartX = 0,
          countourStartY = 0;
      var i,
          j,
          isRelative,
          newSegments;
      if (!keepLazyStack) {
        this.__evaluateStack();
      }
      segments.forEach(function(s, index) {
        var res = iterator(s, index, lastX, lastY);
        if (Array.isArray(res)) {
          replacements[index] = res;
          needReplace = true;
        }
        var isRelative = (s[0] === s[0].toLowerCase());
        switch (s[0]) {
          case 'm':
          case 'M':
            lastX = s[1] + (isRelative ? lastX : 0);
            lastY = s[2] + (isRelative ? lastY : 0);
            countourStartX = lastX;
            countourStartY = lastY;
            return;
          case 'h':
          case 'H':
            lastX = s[1] + (isRelative ? lastX : 0);
            return;
          case 'v':
          case 'V':
            lastY = s[1] + (isRelative ? lastY : 0);
            return;
          case 'z':
          case 'Z':
            lastX = countourStartX;
            lastY = countourStartY;
            return;
          default:
            lastX = s[s.length - 2] + (isRelative ? lastX : 0);
            lastY = s[s.length - 1] + (isRelative ? lastY : 0);
        }
      });
      if (!needReplace) {
        return this;
      }
      newSegments = [];
      for (i = 0; i < segments.length; i++) {
        if (typeof replacements[i] !== 'undefined') {
          for (j = 0; j < replacements[i].length; j++) {
            newSegments.push(replacements[i][j]);
          }
        } else {
          newSegments.push(segments[i]);
        }
      }
      this.segments = newSegments;
      return this;
    };
    SvgPath.prototype.abs = function() {
      this.iterate(function(s, index, x, y) {
        var name = s[0],
            nameUC = name.toUpperCase(),
            i;
        if (name === nameUC) {
          return;
        }
        s[0] = nameUC;
        switch (name) {
          case 'v':
            s[1] += y;
            return;
          case 'a':
            s[6] += x;
            s[7] += y;
            return;
          default:
            for (i = 1; i < s.length; i++) {
              s[i] += i % 2 ? x : y;
            }
        }
      }, true);
      return this;
    };
    SvgPath.prototype.rel = function() {
      this.iterate(function(s, index, x, y) {
        var name = s[0],
            nameLC = name.toLowerCase(),
            i;
        if (name === nameLC) {
          return;
        }
        if (index === 0 && name === 'M') {
          return;
        }
        s[0] = nameLC;
        switch (name) {
          case 'V':
            s[1] -= y;
            return;
          case 'A':
            s[6] -= x;
            s[7] -= y;
            return;
          default:
            for (i = 1; i < s.length; i++) {
              s[i] -= i % 2 ? x : y;
            }
        }
      }, true);
      return this;
    };
    SvgPath.prototype.unarc = function() {
      this.iterate(function(s, index, x, y) {
        var i,
            new_segments,
            nextX,
            nextY,
            result = [],
            name = s[0];
        if (name !== 'A' && name !== 'a') {
          return null;
        }
        if (name === 'a') {
          nextX = x + s[6];
          nextY = y + s[7];
        } else {
          nextX = s[6];
          nextY = s[7];
        }
        new_segments = a2c(x, y, nextX, nextY, s[4], s[5], s[1], s[2], s[3]);
        if (new_segments.length === 0) {
          return [[s[0] === 'a' ? 'l' : 'L', s[6], s[7]]];
        }
        new_segments.forEach(function(s) {
          result.push(['C', s[2], s[3], s[4], s[5], s[6], s[7]]);
        });
        return result;
      });
      return this;
    };
    SvgPath.prototype.unshort = function() {
      var segments = this.segments;
      var prevControlX,
          prevControlY,
          prevSegment;
      var curControlX,
          curControlY;
      this.iterate(function(s, idx, x, y) {
        var name = s[0],
            nameUC = name.toUpperCase(),
            isRelative;
        if (!idx) {
          return;
        }
        if (nameUC === 'T') {
          isRelative = (name === 't');
          prevSegment = segments[idx - 1];
          if (prevSegment[0] === 'Q') {
            prevControlX = prevSegment[1] - x;
            prevControlY = prevSegment[2] - y;
          } else if (prevSegment[0] === 'q') {
            prevControlX = prevSegment[1] - prevSegment[3];
            prevControlY = prevSegment[2] - prevSegment[4];
          } else {
            prevControlX = 0;
            prevControlY = 0;
          }
          curControlX = -prevControlX;
          curControlY = -prevControlY;
          if (!isRelative) {
            curControlX += x;
            curControlY += y;
          }
          segments[idx] = [isRelative ? 'q' : 'Q', curControlX, curControlY, s[1], s[2]];
        } else if (nameUC === 'S') {
          isRelative = (name === 's');
          prevSegment = segments[idx - 1];
          if (prevSegment[0] === 'C') {
            prevControlX = prevSegment[3] - x;
            prevControlY = prevSegment[4] - y;
          } else if (prevSegment[0] === 'c') {
            prevControlX = prevSegment[3] - prevSegment[5];
            prevControlY = prevSegment[4] - prevSegment[6];
          } else {
            prevControlX = 0;
            prevControlY = 0;
          }
          curControlX = -prevControlX;
          curControlY = -prevControlY;
          if (!isRelative) {
            curControlX += x;
            curControlY += y;
          }
          segments[idx] = [isRelative ? 'c' : 'C', curControlX, curControlY, s[1], s[2], s[3], s[4]];
        }
      });
      return this;
    };
    module.exports = SvgPath;
  })($__require('4c'));
  return module.exports;
});

$__System.registerDynamic("4d", ["4b"], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = $__require('4b');
  return module.exports;
});

$__System.registerDynamic("4e", ["4d"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = $__require('4d');
  return module.exports;
});

$__System.register('3a', ['45', '4e'], function (_export) {
  var _Object$keys, svgpath, symbols, symbolTypes;

  function symbol() {
    var size = arguments.length <= 0 || arguments[0] === undefined ? 1 : arguments[0];
    var type = arguments.length <= 1 || arguments[1] === undefined ? 'square' : arguments[1];

    return svgpath(symbols[type]).scale(size).toString();
  }

  return {
    setters: [function (_) {
      _Object$keys = _['default'];
    }, function (_e) {
      svgpath = _e['default'];
    }],
    execute: function () {
      'use strict';

      _export('symbol', symbol);

      symbols = {
        square: 'M1.414-9.9a2,2,0,0,0-2.828,0L-9.9-1.414a2,2,0,0,0,0,2.828L-1.414,9.9a2,2,0,0,0,2.828,0L9.9,1.414a2,2,0,0,0,0-2.828ZM0,2A2,2,0,0,1-2,0,2,2,0,0,1,0-2,2,2,0,0,1,2,0,2,2,0,0,1,0,2Z',
        pentagon: 'M8.79-4.085L1.134-9.648a1.874,1.874,0,0,0-2.2,0L-8.727-4.085a1.874,1.874,0,0,0-.681,2.1l2.925,8.848A1.746,1.746,0,0,0-4.7,8H4.764A1.746,1.746,0,0,0,6.547,6.858L9.471-2.066A1.764,1.764,0,0,0,8.79-4.085ZM0.032,1.969a2,2,0,0,1-2-2,2,2,0,0,1,2-2,2,2,0,0,1,2,2A2,2,0,0,1,.032,1.969Z',
        hexagon: 'M8.532-6.639L1.548-10.681a2.985,2.985,0,0,0-2.992,0L-8.472-6.639A3.026,3.026,0,0,0-10-4.041V4.041a3.03,3.03,0,0,0,1.532,2.6l7.016,4.042a3.015,3.015,0,0,0,3.008,0L8.528,6.639A2.974,2.974,0,0,0,10,4.041V-4.041A2.97,2.97,0,0,0,8.532-6.639ZM0.064,2a2,2,0,0,1-2-2,2,2,0,0,1,4,0A2,2,0,0,1,.064,2Z',
        octagon: 'M6.388-7.388L0.848-9.683a2,2,0,0,0-1.531,0l-5.54,2.295A2,2,0,0,0-7.306-6.306L-9.6-.765A2,2,0,0,0-9.6.765l2.295,5.54A2,2,0,0,0-6.223,7.388l5.54,2.295a2,2,0,0,0,1.531,0l5.54-2.295A2,2,0,0,0,7.47,6.306l2.295-5.54a2,2,0,0,0,0-1.531L7.47-6.306A2,2,0,0,0,6.388-7.388ZM0.082,2a2,2,0,0,1-2-2,2,2,0,1,1,4,0A2,2,0,0,1,.082,2Z',
        triangle: 'M8.467,2.888L1.732-8.832A2,2,0,0,0-1.732-8.86L-8.467,2.9A2.075,2.075,0,0,0-6.735,6H6.735A2.086,2.086,0,0,0,8.467,2.888ZM0,2.011a2,2,0,0,1-2-2,2,2,0,0,1,2-2,2,2,0,0,1,2,2A2,2,0,0,1,0,2.011Z'
      };

      _export('symbols', symbols);

      symbolTypes = _Object$keys(symbols);

      _export('symbolTypes', symbolTypes);
    }
  };
});
$__System.register('6', ['3b', '1f', '1d', '1e', '3a'], function (_export) {
  var _createClass, _classCallCheck, _get, _inherits, symbolTypes, Glyph, FocusedGlyph, ClassedGlyph, ClassedFocusedGlyph, HexagonGlyph, YellowHexagonGlyph;

  return {
    setters: [function (_b) {
      _createClass = _b['default'];
    }, function (_f) {
      _classCallCheck = _f['default'];
    }, function (_d) {
      _get = _d['default'];
    }, function (_e) {
      _inherits = _e['default'];
    }, function (_a) {
      symbolTypes = _a.symbolTypes;
    }],
    execute: function () {
      'use strict';

      Glyph = (function () {
        function Glyph(sizeModifier) {
          var glyphClass = arguments.length <= 1 || arguments[1] === undefined ? 'glyph' : arguments[1];

          _classCallCheck(this, Glyph);

          this.sizeChoices = [1, 1.25, 1.5];
          this.rotation = 0;
          this.rotationSpeed = Math.random() * 3;
          this.size = this.getSize(sizeModifier);
          this.type = this.getType();
          this['class'] = this.getClass(glyphClass);
        }

        _createClass(Glyph, [{
          key: 'getClass',
          value: function getClass(glyphClass) {
            this.styleClass = glyphClass;
            return glyphClass + ' ' + this.type;
          }
        }, {
          key: 'getSize',
          value: function getSize(sizeModifier) {
            var sizeChoice = this.chooseRandomItem(this.sizeChoices);
            return sizeChoice * sizeModifier;
          }
        }, {
          key: 'getType',
          value: function getType() {
            return this.chooseRandomItem(symbolTypes);
          }
        }, {
          key: 'rotate',
          value: function rotate() {
            this.rotation += this.rotationSpeed;
            return this.rotation;
          }
        }, {
          key: 'chooseRandomItem',
          value: function chooseRandomItem(array) {
            return array[Math.floor(Math.random() * array.length)];
          }
        }]);

        return Glyph;
      })();

      _export('Glyph', Glyph);

      FocusedGlyph = (function (_Glyph) {
        _inherits(FocusedGlyph, _Glyph);

        function FocusedGlyph(sizeModifier, glyphClass, focusId) {
          _classCallCheck(this, FocusedGlyph);

          _get(Object.getPrototypeOf(FocusedGlyph.prototype), 'constructor', this).call(this, sizeModifier, glyphClass);
          this.focusId = focusId;
        }

        return FocusedGlyph;
      })(Glyph);

      _export('FocusedGlyph', FocusedGlyph);

      ClassedGlyph = (function (_Glyph2) {
        _inherits(ClassedGlyph, _Glyph2);

        function ClassedGlyph(sizeModifier, classPopulationWieghts) {
          _classCallCheck(this, ClassedGlyph);

          _get(Object.getPrototypeOf(ClassedGlyph.prototype), 'constructor', this).call(this, sizeModifier);
          var populationConfig = classPopulationWieghts.slice(0);
          populationConfig.sort(function (a, b) {
            return a.weight - b.weight;
          });
          this['class'] = this.getClass(this.chooseClass(populationConfig));
        }

        _createClass(ClassedGlyph, [{
          key: 'chooseClass',
          value: function chooseClass(populationConfig) {
            var chance = Math.random();
            var weightLength = populationConfig.length - 1;
            var index = 0;

            for (; index < weightLength; index++) {
              if (chance <= populationConfig[index].weight) {
                return populationConfig[index]['class'];
              }
            }

            return populationConfig[weightLength]['class'];
          }
        }]);

        return ClassedGlyph;
      })(Glyph);

      _export('ClassedGlyph', ClassedGlyph);

      ClassedFocusedGlyph = (function (_ClassedGlyph) {
        _inherits(ClassedFocusedGlyph, _ClassedGlyph);

        function ClassedFocusedGlyph(sizeModifier, classPopulationWieghts) {
          _classCallCheck(this, ClassedFocusedGlyph);

          _get(Object.getPrototypeOf(ClassedFocusedGlyph.prototype), 'constructor', this).call(this, sizeModifier, classPopulationWieghts);
          this.focusId = this.getFocusId(classPopulationWieghts);
        }

        _createClass(ClassedFocusedGlyph, [{
          key: 'getFocusId',
          value: function getFocusId(classPopulationWieghts) {
            var classCategories = classPopulationWieghts.map(function (item) {
              return item['class'];
            });
            return classCategories.indexOf(this.styleClass);
          }
        }]);

        return ClassedFocusedGlyph;
      })(ClassedGlyph);

      _export('ClassedFocusedGlyph', ClassedFocusedGlyph);

      HexagonGlyph = (function (_Glyph3) {
        _inherits(HexagonGlyph, _Glyph3);

        function HexagonGlyph() {
          _classCallCheck(this, HexagonGlyph);

          _get(Object.getPrototypeOf(HexagonGlyph.prototype), 'constructor', this).apply(this, arguments);
        }

        _createClass(HexagonGlyph, [{
          key: 'getType',
          value: function getType() {
            return symbolTypes[symbolTypes.indexOf('hexagon')];
          }
        }]);

        return HexagonGlyph;
      })(Glyph);

      _export('HexagonGlyph', HexagonGlyph);

      YellowHexagonGlyph = (function (_HexagonGlyph) {
        _inherits(YellowHexagonGlyph, _HexagonGlyph);

        function YellowHexagonGlyph(sizeModifier) {
          _classCallCheck(this, YellowHexagonGlyph);

          _get(Object.getPrototypeOf(YellowHexagonGlyph.prototype), 'constructor', this).call(this, sizeModifier, 'glyph glyph--yellow');
        }

        return YellowHexagonGlyph;
      })(HexagonGlyph);

      _export('YellowHexagonGlyph', YellowHexagonGlyph);
    }
  };
});
$__System.register('4f', ['4', '3b', '1f'], function (_export) {
  var bootstrap, _createClass, _classCallCheck, ComponentLoader;

  return {
    setters: [function (_) {
      bootstrap = _.bootstrap;
    }, function (_b) {
      _createClass = _b['default'];
    }, function (_f) {
      _classCallCheck = _f['default'];
    }],
    execute: function () {
      'use strict';

      ComponentLoader = (function () {
        function ComponentLoader() {
          _classCallCheck(this, ComponentLoader);

          this.loaderElement = undefined;
          this.fadeOutSpeed = 600;
        }

        _createClass(ComponentLoader, [{
          key: 'hideLoader',
          value: function hideLoader(cb) {
            var _this = this;

            this.loaderElement.classList.add('component-loader--hide');
            window.setTimeout(function () {
              _this.loaderElement.style.display = 'none';
              cb();
            }, this.fadeOutSpeed);
          }
        }, {
          key: 'selectLoader',
          value: function selectLoader(el) {
            var _this2 = this;

            bootstrap(el, function (el) {
              _this2.loaderElement = el;
            });
          }
        }]);

        return ComponentLoader;
      })();

      _export('default', ComponentLoader);
    }
  };
});
$__System.register('50', ['8'], function (_export) {
  var _Array$from;

  function removeCurrent(nav) {
    var accurateNavDots = nav.querySelectorAll('a.dot');
    Array.prototype.forEach.call(accurateNavDots, function (dot) {
      if (dot.classList.contains('dot--current')) {
        dot.classList.remove('dot--current');
      }
    });
  }

  function updateCopySlider(copyWrapper, step) {
    if (copyWrapper.querySelector('.data-slide--current') !== null) {
      copyWrapper.querySelector('.data-slide--current').classList.remove('data-slide--current');
    }
    window.setTimeout(function () {
      Array.prototype.forEach.call(copyWrapper.querySelectorAll('.data-slide'), function (copySlide) {
        copySlide.classList.add('data-slide--hide');
      });
      copyWrapper.querySelector('.data-slide[data-slide="' + step + '"]').classList.remove('data-slide--hide');
      window.setTimeout(function () {
        copyWrapper.querySelector('.data-slide[data-slide="' + step + '"]').classList.add('data-slide--current');
      }, 10);
    }, 500);
  }

  function attachEvents(slider, animation) {
    for (var _len = arguments.length, animationParams = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      animationParams[_key - 2] = arguments[_key];
    }

    var _this = this;

    var nav = slider.querySelector('nav');
    var navDots = _Array$from(nav.querySelectorAll('a.dot'));

    navDots.forEach(function (dot) {
      dot.addEventListener('click', changeSlide.bind.apply(changeSlide, [_this, dot, slider, nav, animation].concat(animationParams)), false);
      dot.setAttribute('data-handler', 'true');
    });
  }

  function changeSlide(dot, slider, nav, playAnimation) {
    for (var _len2 = arguments.length, animationParams = Array(_len2 > 4 ? _len2 - 4 : 0), _key2 = 4; _key2 < _len2; _key2++) {
      animationParams[_key2 - 4] = arguments[_key2];
    }

    var e = animationParams.pop(1);
    e.preventDefault();

    if (dot.getAttribute('data-handler') === 'true') {
      var step = parseInt(dot.getAttribute('data-slide'), 10);
      updateCopySlider(slider.querySelector('.wrapper'), step);
      removeCurrent(nav);
      dot.classList.add('dot--current');

      animationParams.push(step);
      playAnimation.apply(slider, animationParams);
    }
  }

  return {
    setters: [function (_) {
      _Array$from = _['default'];
    }],
    execute: function () {
      'use strict';

      _export('removeCurrent', removeCurrent);

      _export('updateCopySlider', updateCopySlider);

      _export('attachEvents', attachEvents);

      _export('changeSlide', changeSlide);
    }
  };
});
$__System.register('51', [], function (_export) {
  'use strict';

  _export('getAnimationEndpoint', getAnimationEndpoint);

  function getAnimationEndpoint(endpoint, cb) {
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        cb(JSON.parse(xhr.response));
      }
    };
    xhr.addEventListener('error', function (err) {
      return console.error(err);
    });
    xhr.open('GET', endpoint, true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send();
  }

  return {
    setters: [],
    execute: function () {}
  };
});
$__System.registerDynamic("52", ["8"], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  var _Array$from = $__require('8')["default"];
  exports["default"] = function(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0,
          arr2 = Array(arr.length); i < arr.length; i++)
        arr2[i] = arr[i];
      return arr2;
    } else {
      return _Array$from(arr);
    }
  };
  exports.__esModule = true;
  return module.exports;
});

$__System.registerDynamic("53", [], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  exports["default"] = Function.prototype.bind;
  exports.__esModule = true;
  return module.exports;
});

$__System.register('7', ['52', '53'], function (_export) {
  var _toConsumableArray, _bind;

  function initializeChart() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var element = args[0];
    var Chart = args[1];
    var params = args.slice(2);
    params.splice(1, 0, element);

    return new (_bind.apply(Chart, [null].concat(_toConsumableArray(params))))();
  }

  return {
    setters: [function (_) {
      _toConsumableArray = _['default'];
    }, function (_2) {
      _bind = _2['default'];
    }],
    execute: function () {
      'use strict';

      _export('initializeChart', initializeChart);
    }
  };
});
$__System.register('54', ['4', '7', '8', '52'], function (_export) {
  var bootstrap, initializeChart, _Array$from, _toConsumableArray;

  function stepBodyMovinAnimations(animationName, bmAnimation, animationSegments, step) {
    if (bmAnimation !== null && animationName !== '') {
      bmAnimation.playSegments(animationSegments[animationName][step - 1], true);
    }
  }

  function stepGylphAnimationCharts(glyphAnimationSegments, step) {
    var glyphChart = glyphAnimationSegments[step - 1];
    var newClassList = 'half half--visualization glyph-chart ' + glyphChart['class'];
    var visualizationContainer = this.querySelector('.half--visualization');
    var charts = _Array$from(visualizationContainer.getElementsByTagName('svg'));

    charts.forEach(function (chart) {
      return chart.remove();
    });
    visualizationContainer.classList = newClassList;
    bootstrap.apply(undefined, [visualizationContainer, initializeChart].concat(_toConsumableArray(glyphChart.configuration)));
  }

  return {
    setters: [function (_3) {
      bootstrap = _3.bootstrap;
    }, function (_4) {
      initializeChart = _4.initializeChart;
    }, function (_2) {
      _Array$from = _2['default'];
    }, function (_) {
      _toConsumableArray = _['default'];
    }],
    execute: function () {
      'use strict';

      _export('stepBodyMovinAnimations', stepBodyMovinAnimations);

      _export('stepGylphAnimationCharts', stepGylphAnimationCharts);
    }
  };
});
$__System.register('55', ['3', '4', '5', '6', '39', '50', '51', '54', '4f'], function (_export) {
  'use strict';

  var d3, bootstrap, GlyphChart, ClassedGlyphChart, Glyph, YellowHexagonGlyph, ClassedGlyph, bodymovin, attachEvents, getAnimationEndpoint, stepBodyMovinAnimations, stepGylphAnimationCharts, ComponentLoader, animationsEndpoint, loaderAccurate, loaderContext, loaderAccurateContainer, loaderContextContainer, sliderAccurate, sliderContext, sliderGathering, svgContextContainer, svgAccurateDataContainer, classWeights, animationSegments, glyphAnimationSegments;
  return {
    setters: [function (_) {
      d3 = _['default'];
    }, function (_3) {
      bootstrap = _3.bootstrap;
    }, function (_4) {
      GlyphChart = _4.GlyphChart;
      ClassedGlyphChart = _4.ClassedGlyphChart;
    }, function (_5) {
      Glyph = _5.Glyph;
      YellowHexagonGlyph = _5.YellowHexagonGlyph;
      ClassedGlyph = _5.ClassedGlyph;
    }, function (_2) {
      bodymovin = _2['default'];
    }, function (_6) {
      attachEvents = _6.attachEvents;
    }, function (_7) {
      getAnimationEndpoint = _7.getAnimationEndpoint;
    }, function (_8) {
      stepBodyMovinAnimations = _8.stepBodyMovinAnimations;
      stepGylphAnimationCharts = _8.stepGylphAnimationCharts;
    }, function (_f) {
      ComponentLoader = _f['default'];
    }],
    execute: function () {
      animationsEndpoint = '/cmsapi/v1/animations/';
      loaderAccurate = new ComponentLoader();
      loaderContext = new ComponentLoader();
      loaderAccurateContainer = document.querySelector('.slider-content-animation[data-name="accurate"] .component-loader');
      loaderContextContainer = document.querySelector('.slider-content-animation[data-name="context"] .component-loader');
      sliderAccurate = document.querySelector('.slider-content-animation[data-name="accurate"]');
      sliderContext = document.querySelector('.slider-content-animation[data-name="context"]');
      sliderGathering = document.querySelector('.slider-content-animation[data-name="gathering"]');
      svgContextContainer = document.querySelector('.svg--context');
      svgAccurateDataContainer = document.querySelector('.svg--accurate-data');
      classWeights = [{ 'class': 'glyph', weight: 0.2 }, { 'class': 'glyph glyph--accent', weight: 0.4 }, { 'class': 'glyph glyph--red', weight: 0.6 }, { 'class': 'glyph glyph--blue', weight: 0.8 }, { 'class': 'glyph glyph--yellow', weight: 0.9 }];
      animationSegments = {
        accurate: [[0, 240], [270, 660]],
        context: [[840, 1060], [1060, 1261]]
      };
      glyphAnimationSegments = [{
        'class': 'glyph-chart--customers',
        configuration: [GlyphChart, d3, YellowHexagonGlyph, 0.21, 4, -10]
      }, {
        'class': 'glyph-chart--scale',
        configuration: [GlyphChart, d3, Glyph, 0.21, 30, -4, 750]
      }, {
        'class': 'glyph-chart--target',
        configuration: [ClassedGlyphChart, d3, ClassedGlyph, classWeights, 0.21, 30, -4, 300]
      }];

      loaderAccurate.selectLoader(loaderAccurateContainer);
      loaderContext.selectLoader(loaderContextContainer);
      bootstrap(sliderGathering, attachEvents, stepGylphAnimationCharts, glyphAnimationSegments);
      bootstrap(svgAccurateDataContainer, function (svgAccurateDataWrapper) {
        getAnimationEndpoint(animationsEndpoint + 'hiw-accurate/', function (animationEndpoint) {
          loaderAccurate.hideLoader(function () {
            var bmAccurateAnimation = bodymovin.loadAnimation({
              container: svgAccurateDataWrapper,
              renderer: 'svg',
              loop: false,
              autoplay: false,
              path: animationEndpoint.instructions
            });
            bootstrap(sliderAccurate, attachEvents, stepBodyMovinAnimations, 'accurate', bmAccurateAnimation, animationSegments);
          });
        });
      });

      bootstrap(svgContextContainer, function (svgContextContainer) {
        getAnimationEndpoint(animationsEndpoint + 'hiw-context/', function (animationEndpoint) {
          loaderContext.hideLoader(function () {
            var bmContextAnimation = bodymovin.loadAnimation({
              container: svgContextContainer,
              renderer: 'svg',
              loop: false,
              autoplay: false,
              path: animationEndpoint.instructions
            });
            bootstrap(sliderContext, attachEvents, stepBodyMovinAnimations, 'context', bmContextAnimation, animationSegments);
          });
        });
      });
    }
  };
});
$__System.registerDynamic("56", [], false, function($__require, $__exports, $__module) {
  var _retrieveGlobal = $__System.get("@@global-helpers").prepareGlobal($__module.id, "d3", null);
  (function() {
    "format global";
    "exports d3";
    !function() {
      var d3 = {version: "3.5.16"};
      var d3_arraySlice = [].slice,
          d3_array = function(list) {
            return d3_arraySlice.call(list);
          };
      var d3_document = this.document;
      function d3_documentElement(node) {
        return node && (node.ownerDocument || node.document || node).documentElement;
      }
      function d3_window(node) {
        return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
      }
      if (d3_document) {
        try {
          d3_array(d3_document.documentElement.childNodes)[0].nodeType;
        } catch (e) {
          d3_array = function(list) {
            var i = list.length,
                array = new Array(i);
            while (i--)
              array[i] = list[i];
            return array;
          };
        }
      }
      if (!Date.now)
        Date.now = function() {
          return +new Date();
        };
      if (d3_document) {
        try {
          d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
        } catch (error) {
          var d3_element_prototype = this.Element.prototype,
              d3_element_setAttribute = d3_element_prototype.setAttribute,
              d3_element_setAttributeNS = d3_element_prototype.setAttributeNS,
              d3_style_prototype = this.CSSStyleDeclaration.prototype,
              d3_style_setProperty = d3_style_prototype.setProperty;
          d3_element_prototype.setAttribute = function(name, value) {
            d3_element_setAttribute.call(this, name, value + "");
          };
          d3_element_prototype.setAttributeNS = function(space, local, value) {
            d3_element_setAttributeNS.call(this, space, local, value + "");
          };
          d3_style_prototype.setProperty = function(name, value, priority) {
            d3_style_setProperty.call(this, name, value + "", priority);
          };
        }
      }
      d3.ascending = d3_ascending;
      function d3_ascending(a, b) {
        return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
      }
      d3.descending = function(a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
      };
      d3.min = function(array, f) {
        var i = -1,
            n = array.length,
            a,
            b;
        if (arguments.length === 1) {
          while (++i < n)
            if ((b = array[i]) != null && b >= b) {
              a = b;
              break;
            }
          while (++i < n)
            if ((b = array[i]) != null && a > b)
              a = b;
        } else {
          while (++i < n)
            if ((b = f.call(array, array[i], i)) != null && b >= b) {
              a = b;
              break;
            }
          while (++i < n)
            if ((b = f.call(array, array[i], i)) != null && a > b)
              a = b;
        }
        return a;
      };
      d3.max = function(array, f) {
        var i = -1,
            n = array.length,
            a,
            b;
        if (arguments.length === 1) {
          while (++i < n)
            if ((b = array[i]) != null && b >= b) {
              a = b;
              break;
            }
          while (++i < n)
            if ((b = array[i]) != null && b > a)
              a = b;
        } else {
          while (++i < n)
            if ((b = f.call(array, array[i], i)) != null && b >= b) {
              a = b;
              break;
            }
          while (++i < n)
            if ((b = f.call(array, array[i], i)) != null && b > a)
              a = b;
        }
        return a;
      };
      d3.extent = function(array, f) {
        var i = -1,
            n = array.length,
            a,
            b,
            c;
        if (arguments.length === 1) {
          while (++i < n)
            if ((b = array[i]) != null && b >= b) {
              a = c = b;
              break;
            }
          while (++i < n)
            if ((b = array[i]) != null) {
              if (a > b)
                a = b;
              if (c < b)
                c = b;
            }
        } else {
          while (++i < n)
            if ((b = f.call(array, array[i], i)) != null && b >= b) {
              a = c = b;
              break;
            }
          while (++i < n)
            if ((b = f.call(array, array[i], i)) != null) {
              if (a > b)
                a = b;
              if (c < b)
                c = b;
            }
        }
        return [a, c];
      };
      function d3_number(x) {
        return x === null ? NaN : +x;
      }
      function d3_numeric(x) {
        return !isNaN(x);
      }
      d3.sum = function(array, f) {
        var s = 0,
            n = array.length,
            a,
            i = -1;
        if (arguments.length === 1) {
          while (++i < n)
            if (d3_numeric(a = +array[i]))
              s += a;
        } else {
          while (++i < n)
            if (d3_numeric(a = +f.call(array, array[i], i)))
              s += a;
        }
        return s;
      };
      d3.mean = function(array, f) {
        var s = 0,
            n = array.length,
            a,
            i = -1,
            j = n;
        if (arguments.length === 1) {
          while (++i < n)
            if (d3_numeric(a = d3_number(array[i])))
              s += a;
            else
              --j;
        } else {
          while (++i < n)
            if (d3_numeric(a = d3_number(f.call(array, array[i], i))))
              s += a;
            else
              --j;
        }
        if (j)
          return s / j;
      };
      d3.quantile = function(values, p) {
        var H = (values.length - 1) * p + 1,
            h = Math.floor(H),
            v = +values[h - 1],
            e = H - h;
        return e ? v + e * (values[h] - v) : v;
      };
      d3.median = function(array, f) {
        var numbers = [],
            n = array.length,
            a,
            i = -1;
        if (arguments.length === 1) {
          while (++i < n)
            if (d3_numeric(a = d3_number(array[i])))
              numbers.push(a);
        } else {
          while (++i < n)
            if (d3_numeric(a = d3_number(f.call(array, array[i], i))))
              numbers.push(a);
        }
        if (numbers.length)
          return d3.quantile(numbers.sort(d3_ascending), .5);
      };
      d3.variance = function(array, f) {
        var n = array.length,
            m = 0,
            a,
            d,
            s = 0,
            i = -1,
            j = 0;
        if (arguments.length === 1) {
          while (++i < n) {
            if (d3_numeric(a = d3_number(array[i]))) {
              d = a - m;
              m += d / ++j;
              s += d * (a - m);
            }
          }
        } else {
          while (++i < n) {
            if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
              d = a - m;
              m += d / ++j;
              s += d * (a - m);
            }
          }
        }
        if (j > 1)
          return s / (j - 1);
      };
      d3.deviation = function() {
        var v = d3.variance.apply(this, arguments);
        return v ? Math.sqrt(v) : v;
      };
      function d3_bisector(compare) {
        return {
          left: function(a, x, lo, hi) {
            if (arguments.length < 3)
              lo = 0;
            if (arguments.length < 4)
              hi = a.length;
            while (lo < hi) {
              var mid = lo + hi >>> 1;
              if (compare(a[mid], x) < 0)
                lo = mid + 1;
              else
                hi = mid;
            }
            return lo;
          },
          right: function(a, x, lo, hi) {
            if (arguments.length < 3)
              lo = 0;
            if (arguments.length < 4)
              hi = a.length;
            while (lo < hi) {
              var mid = lo + hi >>> 1;
              if (compare(a[mid], x) > 0)
                hi = mid;
              else
                lo = mid + 1;
            }
            return lo;
          }
        };
      }
      var d3_bisect = d3_bisector(d3_ascending);
      d3.bisectLeft = d3_bisect.left;
      d3.bisect = d3.bisectRight = d3_bisect.right;
      d3.bisector = function(f) {
        return d3_bisector(f.length === 1 ? function(d, x) {
          return d3_ascending(f(d), x);
        } : f);
      };
      d3.shuffle = function(array, i0, i1) {
        if ((m = arguments.length) < 3) {
          i1 = array.length;
          if (m < 2)
            i0 = 0;
        }
        var m = i1 - i0,
            t,
            i;
        while (m) {
          i = Math.random() * m-- | 0;
          t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
        }
        return array;
      };
      d3.permute = function(array, indexes) {
        var i = indexes.length,
            permutes = new Array(i);
        while (i--)
          permutes[i] = array[indexes[i]];
        return permutes;
      };
      d3.pairs = function(array) {
        var i = 0,
            n = array.length - 1,
            p0,
            p1 = array[0],
            pairs = new Array(n < 0 ? 0 : n);
        while (i < n)
          pairs[i] = [p0 = p1, p1 = array[++i]];
        return pairs;
      };
      d3.transpose = function(matrix) {
        if (!(n = matrix.length))
          return [];
        for (var i = -1,
            m = d3.min(matrix, d3_transposeLength),
            transpose = new Array(m); ++i < m; ) {
          for (var j = -1,
              n,
              row = transpose[i] = new Array(n); ++j < n; ) {
            row[j] = matrix[j][i];
          }
        }
        return transpose;
      };
      function d3_transposeLength(d) {
        return d.length;
      }
      d3.zip = function() {
        return d3.transpose(arguments);
      };
      d3.keys = function(map) {
        var keys = [];
        for (var key in map)
          keys.push(key);
        return keys;
      };
      d3.values = function(map) {
        var values = [];
        for (var key in map)
          values.push(map[key]);
        return values;
      };
      d3.entries = function(map) {
        var entries = [];
        for (var key in map)
          entries.push({
            key: key,
            value: map[key]
          });
        return entries;
      };
      d3.merge = function(arrays) {
        var n = arrays.length,
            m,
            i = -1,
            j = 0,
            merged,
            array;
        while (++i < n)
          j += arrays[i].length;
        merged = new Array(j);
        while (--n >= 0) {
          array = arrays[n];
          m = array.length;
          while (--m >= 0) {
            merged[--j] = array[m];
          }
        }
        return merged;
      };
      var abs = Math.abs;
      d3.range = function(start, stop, step) {
        if (arguments.length < 3) {
          step = 1;
          if (arguments.length < 2) {
            stop = start;
            start = 0;
          }
        }
        if ((stop - start) / step === Infinity)
          throw new Error("infinite range");
        var range = [],
            k = d3_range_integerScale(abs(step)),
            i = -1,
            j;
        start *= k, stop *= k, step *= k;
        if (step < 0)
          while ((j = start + step * ++i) > stop)
            range.push(j / k);
        else
          while ((j = start + step * ++i) < stop)
            range.push(j / k);
        return range;
      };
      function d3_range_integerScale(x) {
        var k = 1;
        while (x * k % 1)
          k *= 10;
        return k;
      }
      function d3_class(ctor, properties) {
        for (var key in properties) {
          Object.defineProperty(ctor.prototype, key, {
            value: properties[key],
            enumerable: false
          });
        }
      }
      d3.map = function(object, f) {
        var map = new d3_Map();
        if (object instanceof d3_Map) {
          object.forEach(function(key, value) {
            map.set(key, value);
          });
        } else if (Array.isArray(object)) {
          var i = -1,
              n = object.length,
              o;
          if (arguments.length === 1)
            while (++i < n)
              map.set(i, object[i]);
          else
            while (++i < n)
              map.set(f.call(object, o = object[i], i), o);
        } else {
          for (var key in object)
            map.set(key, object[key]);
        }
        return map;
      };
      function d3_Map() {
        this._ = Object.create(null);
      }
      var d3_map_proto = "__proto__",
          d3_map_zero = "\x00";
      d3_class(d3_Map, {
        has: d3_map_has,
        get: function(key) {
          return this._[d3_map_escape(key)];
        },
        set: function(key, value) {
          return this._[d3_map_escape(key)] = value;
        },
        remove: d3_map_remove,
        keys: d3_map_keys,
        values: function() {
          var values = [];
          for (var key in this._)
            values.push(this._[key]);
          return values;
        },
        entries: function() {
          var entries = [];
          for (var key in this._)
            entries.push({
              key: d3_map_unescape(key),
              value: this._[key]
            });
          return entries;
        },
        size: d3_map_size,
        empty: d3_map_empty,
        forEach: function(f) {
          for (var key in this._)
            f.call(this, d3_map_unescape(key), this._[key]);
        }
      });
      function d3_map_escape(key) {
        return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
      }
      function d3_map_unescape(key) {
        return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
      }
      function d3_map_has(key) {
        return d3_map_escape(key) in this._;
      }
      function d3_map_remove(key) {
        return (key = d3_map_escape(key)) in this._ && delete this._[key];
      }
      function d3_map_keys() {
        var keys = [];
        for (var key in this._)
          keys.push(d3_map_unescape(key));
        return keys;
      }
      function d3_map_size() {
        var size = 0;
        for (var key in this._)
          ++size;
        return size;
      }
      function d3_map_empty() {
        for (var key in this._)
          return false;
        return true;
      }
      d3.nest = function() {
        var nest = {},
            keys = [],
            sortKeys = [],
            sortValues,
            rollup;
        function map(mapType, array, depth) {
          if (depth >= keys.length)
            return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
          var i = -1,
              n = array.length,
              key = keys[depth++],
              keyValue,
              object,
              setter,
              valuesByKey = new d3_Map(),
              values;
          while (++i < n) {
            if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
              values.push(object);
            } else {
              valuesByKey.set(keyValue, [object]);
            }
          }
          if (mapType) {
            object = mapType();
            setter = function(keyValue, values) {
              object.set(keyValue, map(mapType, values, depth));
            };
          } else {
            object = {};
            setter = function(keyValue, values) {
              object[keyValue] = map(mapType, values, depth);
            };
          }
          valuesByKey.forEach(setter);
          return object;
        }
        function entries(map, depth) {
          if (depth >= keys.length)
            return map;
          var array = [],
              sortKey = sortKeys[depth++];
          map.forEach(function(key, keyMap) {
            array.push({
              key: key,
              values: entries(keyMap, depth)
            });
          });
          return sortKey ? array.sort(function(a, b) {
            return sortKey(a.key, b.key);
          }) : array;
        }
        nest.map = function(array, mapType) {
          return map(mapType, array, 0);
        };
        nest.entries = function(array) {
          return entries(map(d3.map, array, 0), 0);
        };
        nest.key = function(d) {
          keys.push(d);
          return nest;
        };
        nest.sortKeys = function(order) {
          sortKeys[keys.length - 1] = order;
          return nest;
        };
        nest.sortValues = function(order) {
          sortValues = order;
          return nest;
        };
        nest.rollup = function(f) {
          rollup = f;
          return nest;
        };
        return nest;
      };
      d3.set = function(array) {
        var set = new d3_Set();
        if (array)
          for (var i = 0,
              n = array.length; i < n; ++i)
            set.add(array[i]);
        return set;
      };
      function d3_Set() {
        this._ = Object.create(null);
      }
      d3_class(d3_Set, {
        has: d3_map_has,
        add: function(key) {
          this._[d3_map_escape(key += "")] = true;
          return key;
        },
        remove: d3_map_remove,
        values: d3_map_keys,
        size: d3_map_size,
        empty: d3_map_empty,
        forEach: function(f) {
          for (var key in this._)
            f.call(this, d3_map_unescape(key));
        }
      });
      d3.behavior = {};
      function d3_identity(d) {
        return d;
      }
      d3.rebind = function(target, source) {
        var i = 1,
            n = arguments.length,
            method;
        while (++i < n)
          target[method = arguments[i]] = d3_rebind(target, source, source[method]);
        return target;
      };
      function d3_rebind(target, source, method) {
        return function() {
          var value = method.apply(source, arguments);
          return value === source ? target : value;
        };
      }
      function d3_vendorSymbol(object, name) {
        if (name in object)
          return name;
        name = name.charAt(0).toUpperCase() + name.slice(1);
        for (var i = 0,
            n = d3_vendorPrefixes.length; i < n; ++i) {
          var prefixName = d3_vendorPrefixes[i] + name;
          if (prefixName in object)
            return prefixName;
        }
      }
      var d3_vendorPrefixes = ["webkit", "ms", "moz", "Moz", "o", "O"];
      function d3_noop() {}
      d3.dispatch = function() {
        var dispatch = new d3_dispatch(),
            i = -1,
            n = arguments.length;
        while (++i < n)
          dispatch[arguments[i]] = d3_dispatch_event(dispatch);
        return dispatch;
      };
      function d3_dispatch() {}
      d3_dispatch.prototype.on = function(type, listener) {
        var i = type.indexOf("."),
            name = "";
        if (i >= 0) {
          name = type.slice(i + 1);
          type = type.slice(0, i);
        }
        if (type)
          return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
        if (arguments.length === 2) {
          if (listener == null)
            for (type in this) {
              if (this.hasOwnProperty(type))
                this[type].on(name, null);
            }
          return this;
        }
      };
      function d3_dispatch_event(dispatch) {
        var listeners = [],
            listenerByName = new d3_Map();
        function event() {
          var z = listeners,
              i = -1,
              n = z.length,
              l;
          while (++i < n)
            if (l = z[i].on)
              l.apply(this, arguments);
          return dispatch;
        }
        event.on = function(name, listener) {
          var l = listenerByName.get(name),
              i;
          if (arguments.length < 2)
            return l && l.on;
          if (l) {
            l.on = null;
            listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
            listenerByName.remove(name);
          }
          if (listener)
            listeners.push(listenerByName.set(name, {on: listener}));
          return dispatch;
        };
        return event;
      }
      d3.event = null;
      function d3_eventPreventDefault() {
        d3.event.preventDefault();
      }
      function d3_eventSource() {
        var e = d3.event,
            s;
        while (s = e.sourceEvent)
          e = s;
        return e;
      }
      function d3_eventDispatch(target) {
        var dispatch = new d3_dispatch(),
            i = 0,
            n = arguments.length;
        while (++i < n)
          dispatch[arguments[i]] = d3_dispatch_event(dispatch);
        dispatch.of = function(thiz, argumentz) {
          return function(e1) {
            try {
              var e0 = e1.sourceEvent = d3.event;
              e1.target = target;
              d3.event = e1;
              dispatch[e1.type].apply(thiz, argumentz);
            } finally {
              d3.event = e0;
            }
          };
        };
        return dispatch;
      }
      d3.requote = function(s) {
        return s.replace(d3_requote_re, "\\$&");
      };
      var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
      var d3_subclass = {}.__proto__ ? function(object, prototype) {
        object.__proto__ = prototype;
      } : function(object, prototype) {
        for (var property in prototype)
          object[property] = prototype[property];
      };
      function d3_selection(groups) {
        d3_subclass(groups, d3_selectionPrototype);
        return groups;
      }
      var d3_select = function(s, n) {
        return n.querySelector(s);
      },
          d3_selectAll = function(s, n) {
            return n.querySelectorAll(s);
          },
          d3_selectMatches = function(n, s) {
            var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
            d3_selectMatches = function(n, s) {
              return d3_selectMatcher.call(n, s);
            };
            return d3_selectMatches(n, s);
          };
      if (typeof Sizzle === "function") {
        d3_select = function(s, n) {
          return Sizzle(s, n)[0] || null;
        };
        d3_selectAll = Sizzle;
        d3_selectMatches = Sizzle.matchesSelector;
      }
      d3.selection = function() {
        return d3.select(d3_document.documentElement);
      };
      var d3_selectionPrototype = d3.selection.prototype = [];
      d3_selectionPrototype.select = function(selector) {
        var subgroups = [],
            subgroup,
            subnode,
            group,
            node;
        selector = d3_selection_selector(selector);
        for (var j = -1,
            m = this.length; ++j < m; ) {
          subgroups.push(subgroup = []);
          subgroup.parentNode = (group = this[j]).parentNode;
          for (var i = -1,
              n = group.length; ++i < n; ) {
            if (node = group[i]) {
              subgroup.push(subnode = selector.call(node, node.__data__, i, j));
              if (subnode && "__data__" in node)
                subnode.__data__ = node.__data__;
            } else {
              subgroup.push(null);
            }
          }
        }
        return d3_selection(subgroups);
      };
      function d3_selection_selector(selector) {
        return typeof selector === "function" ? selector : function() {
          return d3_select(selector, this);
        };
      }
      d3_selectionPrototype.selectAll = function(selector) {
        var subgroups = [],
            subgroup,
            node;
        selector = d3_selection_selectorAll(selector);
        for (var j = -1,
            m = this.length; ++j < m; ) {
          for (var group = this[j],
              i = -1,
              n = group.length; ++i < n; ) {
            if (node = group[i]) {
              subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
              subgroup.parentNode = node;
            }
          }
        }
        return d3_selection(subgroups);
      };
      function d3_selection_selectorAll(selector) {
        return typeof selector === "function" ? selector : function() {
          return d3_selectAll(selector, this);
        };
      }
      var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
      var d3_nsPrefix = {
        svg: "http://www.w3.org/2000/svg",
        xhtml: d3_nsXhtml,
        xlink: "http://www.w3.org/1999/xlink",
        xml: "http://www.w3.org/XML/1998/namespace",
        xmlns: "http://www.w3.org/2000/xmlns/"
      };
      d3.ns = {
        prefix: d3_nsPrefix,
        qualify: function(name) {
          var i = name.indexOf(":"),
              prefix = name;
          if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns")
            name = name.slice(i + 1);
          return d3_nsPrefix.hasOwnProperty(prefix) ? {
            space: d3_nsPrefix[prefix],
            local: name
          } : name;
        }
      };
      d3_selectionPrototype.attr = function(name, value) {
        if (arguments.length < 2) {
          if (typeof name === "string") {
            var node = this.node();
            name = d3.ns.qualify(name);
            return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
          }
          for (value in name)
            this.each(d3_selection_attr(value, name[value]));
          return this;
        }
        return this.each(d3_selection_attr(name, value));
      };
      function d3_selection_attr(name, value) {
        name = d3.ns.qualify(name);
        function attrNull() {
          this.removeAttribute(name);
        }
        function attrNullNS() {
          this.removeAttributeNS(name.space, name.local);
        }
        function attrConstant() {
          this.setAttribute(name, value);
        }
        function attrConstantNS() {
          this.setAttributeNS(name.space, name.local, value);
        }
        function attrFunction() {
          var x = value.apply(this, arguments);
          if (x == null)
            this.removeAttribute(name);
          else
            this.setAttribute(name, x);
        }
        function attrFunctionNS() {
          var x = value.apply(this, arguments);
          if (x == null)
            this.removeAttributeNS(name.space, name.local);
          else
            this.setAttributeNS(name.space, name.local, x);
        }
        return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
      }
      function d3_collapse(s) {
        return s.trim().replace(/\s+/g, " ");
      }
      d3_selectionPrototype.classed = function(name, value) {
        if (arguments.length < 2) {
          if (typeof name === "string") {
            var node = this.node(),
                n = (name = d3_selection_classes(name)).length,
                i = -1;
            if (value = node.classList) {
              while (++i < n)
                if (!value.contains(name[i]))
                  return false;
            } else {
              value = node.getAttribute("class");
              while (++i < n)
                if (!d3_selection_classedRe(name[i]).test(value))
                  return false;
            }
            return true;
          }
          for (value in name)
            this.each(d3_selection_classed(value, name[value]));
          return this;
        }
        return this.each(d3_selection_classed(name, value));
      };
      function d3_selection_classedRe(name) {
        return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
      }
      function d3_selection_classes(name) {
        return (name + "").trim().split(/^|\s+/);
      }
      function d3_selection_classed(name, value) {
        name = d3_selection_classes(name).map(d3_selection_classedName);
        var n = name.length;
        function classedConstant() {
          var i = -1;
          while (++i < n)
            name[i](this, value);
        }
        function classedFunction() {
          var i = -1,
              x = value.apply(this, arguments);
          while (++i < n)
            name[i](this, x);
        }
        return typeof value === "function" ? classedFunction : classedConstant;
      }
      function d3_selection_classedName(name) {
        var re = d3_selection_classedRe(name);
        return function(node, value) {
          if (c = node.classList)
            return value ? c.add(name) : c.remove(name);
          var c = node.getAttribute("class") || "";
          if (value) {
            re.lastIndex = 0;
            if (!re.test(c))
              node.setAttribute("class", d3_collapse(c + " " + name));
          } else {
            node.setAttribute("class", d3_collapse(c.replace(re, " ")));
          }
        };
      }
      d3_selectionPrototype.style = function(name, value, priority) {
        var n = arguments.length;
        if (n < 3) {
          if (typeof name !== "string") {
            if (n < 2)
              value = "";
            for (priority in name)
              this.each(d3_selection_style(priority, name[priority], value));
            return this;
          }
          if (n < 2) {
            var node = this.node();
            return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
          }
          priority = "";
        }
        return this.each(d3_selection_style(name, value, priority));
      };
      function d3_selection_style(name, value, priority) {
        function styleNull() {
          this.style.removeProperty(name);
        }
        function styleConstant() {
          this.style.setProperty(name, value, priority);
        }
        function styleFunction() {
          var x = value.apply(this, arguments);
          if (x == null)
            this.style.removeProperty(name);
          else
            this.style.setProperty(name, x, priority);
        }
        return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
      }
      d3_selectionPrototype.property = function(name, value) {
        if (arguments.length < 2) {
          if (typeof name === "string")
            return this.node()[name];
          for (value in name)
            this.each(d3_selection_property(value, name[value]));
          return this;
        }
        return this.each(d3_selection_property(name, value));
      };
      function d3_selection_property(name, value) {
        function propertyNull() {
          delete this[name];
        }
        function propertyConstant() {
          this[name] = value;
        }
        function propertyFunction() {
          var x = value.apply(this, arguments);
          if (x == null)
            delete this[name];
          else
            this[name] = x;
        }
        return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
      }
      d3_selectionPrototype.text = function(value) {
        return arguments.length ? this.each(typeof value === "function" ? function() {
          var v = value.apply(this, arguments);
          this.textContent = v == null ? "" : v;
        } : value == null ? function() {
          this.textContent = "";
        } : function() {
          this.textContent = value;
        }) : this.node().textContent;
      };
      d3_selectionPrototype.html = function(value) {
        return arguments.length ? this.each(typeof value === "function" ? function() {
          var v = value.apply(this, arguments);
          this.innerHTML = v == null ? "" : v;
        } : value == null ? function() {
          this.innerHTML = "";
        } : function() {
          this.innerHTML = value;
        }) : this.node().innerHTML;
      };
      d3_selectionPrototype.append = function(name) {
        name = d3_selection_creator(name);
        return this.select(function() {
          return this.appendChild(name.apply(this, arguments));
        });
      };
      function d3_selection_creator(name) {
        function create() {
          var document = this.ownerDocument,
              namespace = this.namespaceURI;
          return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
        }
        function createNS() {
          return this.ownerDocument.createElementNS(name.space, name.local);
        }
        return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
      }
      d3_selectionPrototype.insert = function(name, before) {
        name = d3_selection_creator(name);
        before = d3_selection_selector(before);
        return this.select(function() {
          return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
        });
      };
      d3_selectionPrototype.remove = function() {
        return this.each(d3_selectionRemove);
      };
      function d3_selectionRemove() {
        var parent = this.parentNode;
        if (parent)
          parent.removeChild(this);
      }
      d3_selectionPrototype.data = function(value, key) {
        var i = -1,
            n = this.length,
            group,
            node;
        if (!arguments.length) {
          value = new Array(n = (group = this[0]).length);
          while (++i < n) {
            if (node = group[i]) {
              value[i] = node.__data__;
            }
          }
          return value;
        }
        function bind(group, groupData) {
          var i,
              n = group.length,
              m = groupData.length,
              n0 = Math.min(n, m),
              updateNodes = new Array(m),
              enterNodes = new Array(m),
              exitNodes = new Array(n),
              node,
              nodeData;
          if (key) {
            var nodeByKeyValue = new d3_Map(),
                keyValues = new Array(n),
                keyValue;
            for (i = -1; ++i < n; ) {
              if (node = group[i]) {
                if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
                  exitNodes[i] = node;
                } else {
                  nodeByKeyValue.set(keyValue, node);
                }
                keyValues[i] = keyValue;
              }
            }
            for (i = -1; ++i < m; ) {
              if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
                enterNodes[i] = d3_selection_dataNode(nodeData);
              } else if (node !== true) {
                updateNodes[i] = node;
                node.__data__ = nodeData;
              }
              nodeByKeyValue.set(keyValue, true);
            }
            for (i = -1; ++i < n; ) {
              if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
                exitNodes[i] = group[i];
              }
            }
          } else {
            for (i = -1; ++i < n0; ) {
              node = group[i];
              nodeData = groupData[i];
              if (node) {
                node.__data__ = nodeData;
                updateNodes[i] = node;
              } else {
                enterNodes[i] = d3_selection_dataNode(nodeData);
              }
            }
            for (; i < m; ++i) {
              enterNodes[i] = d3_selection_dataNode(groupData[i]);
            }
            for (; i < n; ++i) {
              exitNodes[i] = group[i];
            }
          }
          enterNodes.update = updateNodes;
          enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
          enter.push(enterNodes);
          update.push(updateNodes);
          exit.push(exitNodes);
        }
        var enter = d3_selection_enter([]),
            update = d3_selection([]),
            exit = d3_selection([]);
        if (typeof value === "function") {
          while (++i < n) {
            bind(group = this[i], value.call(group, group.parentNode.__data__, i));
          }
        } else {
          while (++i < n) {
            bind(group = this[i], value);
          }
        }
        update.enter = function() {
          return enter;
        };
        update.exit = function() {
          return exit;
        };
        return update;
      };
      function d3_selection_dataNode(data) {
        return {__data__: data};
      }
      d3_selectionPrototype.datum = function(value) {
        return arguments.length ? this.property("__data__", value) : this.property("__data__");
      };
      d3_selectionPrototype.filter = function(filter) {
        var subgroups = [],
            subgroup,
            group,
            node;
        if (typeof filter !== "function")
          filter = d3_selection_filter(filter);
        for (var j = 0,
            m = this.length; j < m; j++) {
          subgroups.push(subgroup = []);
          subgroup.parentNode = (group = this[j]).parentNode;
          for (var i = 0,
              n = group.length; i < n; i++) {
            if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
              subgroup.push(node);
            }
          }
        }
        return d3_selection(subgroups);
      };
      function d3_selection_filter(selector) {
        return function() {
          return d3_selectMatches(this, selector);
        };
      }
      d3_selectionPrototype.order = function() {
        for (var j = -1,
            m = this.length; ++j < m; ) {
          for (var group = this[j],
              i = group.length - 1,
              next = group[i],
              node; --i >= 0; ) {
            if (node = group[i]) {
              if (next && next !== node.nextSibling)
                next.parentNode.insertBefore(node, next);
              next = node;
            }
          }
        }
        return this;
      };
      d3_selectionPrototype.sort = function(comparator) {
        comparator = d3_selection_sortComparator.apply(this, arguments);
        for (var j = -1,
            m = this.length; ++j < m; )
          this[j].sort(comparator);
        return this.order();
      };
      function d3_selection_sortComparator(comparator) {
        if (!arguments.length)
          comparator = d3_ascending;
        return function(a, b) {
          return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
        };
      }
      d3_selectionPrototype.each = function(callback) {
        return d3_selection_each(this, function(node, i, j) {
          callback.call(node, node.__data__, i, j);
        });
      };
      function d3_selection_each(groups, callback) {
        for (var j = 0,
            m = groups.length; j < m; j++) {
          for (var group = groups[j],
              i = 0,
              n = group.length,
              node; i < n; i++) {
            if (node = group[i])
              callback(node, i, j);
          }
        }
        return groups;
      }
      d3_selectionPrototype.call = function(callback) {
        var args = d3_array(arguments);
        callback.apply(args[0] = this, args);
        return this;
      };
      d3_selectionPrototype.empty = function() {
        return !this.node();
      };
      d3_selectionPrototype.node = function() {
        for (var j = 0,
            m = this.length; j < m; j++) {
          for (var group = this[j],
              i = 0,
              n = group.length; i < n; i++) {
            var node = group[i];
            if (node)
              return node;
          }
        }
        return null;
      };
      d3_selectionPrototype.size = function() {
        var n = 0;
        d3_selection_each(this, function() {
          ++n;
        });
        return n;
      };
      function d3_selection_enter(selection) {
        d3_subclass(selection, d3_selection_enterPrototype);
        return selection;
      }
      var d3_selection_enterPrototype = [];
      d3.selection.enter = d3_selection_enter;
      d3.selection.enter.prototype = d3_selection_enterPrototype;
      d3_selection_enterPrototype.append = d3_selectionPrototype.append;
      d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
      d3_selection_enterPrototype.node = d3_selectionPrototype.node;
      d3_selection_enterPrototype.call = d3_selectionPrototype.call;
      d3_selection_enterPrototype.size = d3_selectionPrototype.size;
      d3_selection_enterPrototype.select = function(selector) {
        var subgroups = [],
            subgroup,
            subnode,
            upgroup,
            group,
            node;
        for (var j = -1,
            m = this.length; ++j < m; ) {
          upgroup = (group = this[j]).update;
          subgroups.push(subgroup = []);
          subgroup.parentNode = group.parentNode;
          for (var i = -1,
              n = group.length; ++i < n; ) {
            if (node = group[i]) {
              subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
              subnode.__data__ = node.__data__;
            } else {
              subgroup.push(null);
            }
          }
        }
        return d3_selection(subgroups);
      };
      d3_selection_enterPrototype.insert = function(name, before) {
        if (arguments.length < 2)
          before = d3_selection_enterInsertBefore(this);
        return d3_selectionPrototype.insert.call(this, name, before);
      };
      function d3_selection_enterInsertBefore(enter) {
        var i0,
            j0;
        return function(d, i, j) {
          var group = enter[j].update,
              n = group.length,
              node;
          if (j != j0)
            j0 = j, i0 = 0;
          if (i >= i0)
            i0 = i + 1;
          while (!(node = group[i0]) && ++i0 < n)
            ;
          return node;
        };
      }
      d3.select = function(node) {
        var group;
        if (typeof node === "string") {
          group = [d3_select(node, d3_document)];
          group.parentNode = d3_document.documentElement;
        } else {
          group = [node];
          group.parentNode = d3_documentElement(node);
        }
        return d3_selection([group]);
      };
      d3.selectAll = function(nodes) {
        var group;
        if (typeof nodes === "string") {
          group = d3_array(d3_selectAll(nodes, d3_document));
          group.parentNode = d3_document.documentElement;
        } else {
          group = d3_array(nodes);
          group.parentNode = null;
        }
        return d3_selection([group]);
      };
      d3_selectionPrototype.on = function(type, listener, capture) {
        var n = arguments.length;
        if (n < 3) {
          if (typeof type !== "string") {
            if (n < 2)
              listener = false;
            for (capture in type)
              this.each(d3_selection_on(capture, type[capture], listener));
            return this;
          }
          if (n < 2)
            return (n = this.node()["__on" + type]) && n._;
          capture = false;
        }
        return this.each(d3_selection_on(type, listener, capture));
      };
      function d3_selection_on(type, listener, capture) {
        var name = "__on" + type,
            i = type.indexOf("."),
            wrap = d3_selection_onListener;
        if (i > 0)
          type = type.slice(0, i);
        var filter = d3_selection_onFilters.get(type);
        if (filter)
          type = filter, wrap = d3_selection_onFilter;
        function onRemove() {
          var l = this[name];
          if (l) {
            this.removeEventListener(type, l, l.$);
            delete this[name];
          }
        }
        function onAdd() {
          var l = wrap(listener, d3_array(arguments));
          onRemove.call(this);
          this.addEventListener(type, this[name] = l, l.$ = capture);
          l._ = listener;
        }
        function removeAll() {
          var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"),
              match;
          for (var name in this) {
            if (match = name.match(re)) {
              var l = this[name];
              this.removeEventListener(match[1], l, l.$);
              delete this[name];
            }
          }
        }
        return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
      }
      var d3_selection_onFilters = d3.map({
        mouseenter: "mouseover",
        mouseleave: "mouseout"
      });
      if (d3_document) {
        d3_selection_onFilters.forEach(function(k) {
          if ("on" + k in d3_document)
            d3_selection_onFilters.remove(k);
        });
      }
      function d3_selection_onListener(listener, argumentz) {
        return function(e) {
          var o = d3.event;
          d3.event = e;
          argumentz[0] = this.__data__;
          try {
            listener.apply(this, argumentz);
          } finally {
            d3.event = o;
          }
        };
      }
      function d3_selection_onFilter(listener, argumentz) {
        var l = d3_selection_onListener(listener, argumentz);
        return function(e) {
          var target = this,
              related = e.relatedTarget;
          if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
            l.call(target, e);
          }
        };
      }
      var d3_event_dragSelect,
          d3_event_dragId = 0;
      function d3_event_dragSuppress(node) {
        var name = ".dragsuppress-" + ++d3_event_dragId,
            click = "click" + name,
            w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
        if (d3_event_dragSelect == null) {
          d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
        }
        if (d3_event_dragSelect) {
          var style = d3_documentElement(node).style,
              select = style[d3_event_dragSelect];
          style[d3_event_dragSelect] = "none";
        }
        return function(suppressClick) {
          w.on(name, null);
          if (d3_event_dragSelect)
            style[d3_event_dragSelect] = select;
          if (suppressClick) {
            var off = function() {
              w.on(click, null);
            };
            w.on(click, function() {
              d3_eventPreventDefault();
              off();
            }, true);
            setTimeout(off, 0);
          }
        };
      }
      d3.mouse = function(container) {
        return d3_mousePoint(container, d3_eventSource());
      };
      var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
      function d3_mousePoint(container, e) {
        if (e.changedTouches)
          e = e.changedTouches[0];
        var svg = container.ownerSVGElement || container;
        if (svg.createSVGPoint) {
          var point = svg.createSVGPoint();
          if (d3_mouse_bug44083 < 0) {
            var window = d3_window(container);
            if (window.scrollX || window.scrollY) {
              svg = d3.select("body").append("svg").style({
                position: "absolute",
                top: 0,
                left: 0,
                margin: 0,
                padding: 0,
                border: "none"
              }, "important");
              var ctm = svg[0][0].getScreenCTM();
              d3_mouse_bug44083 = !(ctm.f || ctm.e);
              svg.remove();
            }
          }
          if (d3_mouse_bug44083)
            point.x = e.pageX, point.y = e.pageY;
          else
            point.x = e.clientX, point.y = e.clientY;
          point = point.matrixTransform(container.getScreenCTM().inverse());
          return [point.x, point.y];
        }
        var rect = container.getBoundingClientRect();
        return [e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop];
      }
      d3.touch = function(container, touches, identifier) {
        if (arguments.length < 3)
          identifier = touches, touches = d3_eventSource().changedTouches;
        if (touches)
          for (var i = 0,
              n = touches.length,
              touch; i < n; ++i) {
            if ((touch = touches[i]).identifier === identifier) {
              return d3_mousePoint(container, touch);
            }
          }
      };
      d3.behavior.drag = function() {
        var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"),
            origin = null,
            mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"),
            touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
        function drag() {
          this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
        }
        function dragstart(id, position, subject, move, end) {
          return function() {
            var that = this,
                target = d3.event.target.correspondingElement || d3.event.target,
                parent = that.parentNode,
                dispatch = event.of(that, arguments),
                dragged = 0,
                dragId = id(),
                dragName = ".drag" + (dragId == null ? "" : "-" + dragId),
                dragOffset,
                dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended),
                dragRestore = d3_event_dragSuppress(target),
                position0 = position(parent, dragId);
            if (origin) {
              dragOffset = origin.apply(that, arguments);
              dragOffset = [dragOffset.x - position0[0], dragOffset.y - position0[1]];
            } else {
              dragOffset = [0, 0];
            }
            dispatch({type: "dragstart"});
            function moved() {
              var position1 = position(parent, dragId),
                  dx,
                  dy;
              if (!position1)
                return;
              dx = position1[0] - position0[0];
              dy = position1[1] - position0[1];
              dragged |= dx | dy;
              position0 = position1;
              dispatch({
                type: "drag",
                x: position1[0] + dragOffset[0],
                y: position1[1] + dragOffset[1],
                dx: dx,
                dy: dy
              });
            }
            function ended() {
              if (!position(parent, dragId))
                return;
              dragSubject.on(move + dragName, null).on(end + dragName, null);
              dragRestore(dragged);
              dispatch({type: "dragend"});
            }
          };
        }
        drag.origin = function(x) {
          if (!arguments.length)
            return origin;
          origin = x;
          return drag;
        };
        return d3.rebind(drag, event, "on");
      };
      function d3_behavior_dragTouchId() {
        return d3.event.changedTouches[0].identifier;
      }
      d3.touches = function(container, touches) {
        if (arguments.length < 2)
          touches = d3_eventSource().touches;
        return touches ? d3_array(touches).map(function(touch) {
          var point = d3_mousePoint(container, touch);
          point.identifier = touch.identifier;
          return point;
        }) : [];
      };
      var ε = 1e-6,
          ε2 = ε * ε,
          π = Math.PI,
          τ = 2 * π,
          τε = τ - ε,
          halfπ = π / 2,
          d3_radians = π / 180,
          d3_degrees = 180 / π;
      function d3_sgn(x) {
        return x > 0 ? 1 : x < 0 ? -1 : 0;
      }
      function d3_cross2d(a, b, c) {
        return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
      }
      function d3_acos(x) {
        return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
      }
      function d3_asin(x) {
        return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
      }
      function d3_sinh(x) {
        return ((x = Math.exp(x)) - 1 / x) / 2;
      }
      function d3_cosh(x) {
        return ((x = Math.exp(x)) + 1 / x) / 2;
      }
      function d3_tanh(x) {
        return ((x = Math.exp(2 * x)) - 1) / (x + 1);
      }
      function d3_haversin(x) {
        return (x = Math.sin(x / 2)) * x;
      }
      var ρ = Math.SQRT2,
          ρ2 = 2,
          ρ4 = 4;
      d3.interpolateZoom = function(p0, p1) {
        var ux0 = p0[0],
            uy0 = p0[1],
            w0 = p0[2],
            ux1 = p1[0],
            uy1 = p1[1],
            w1 = p1[2],
            dx = ux1 - ux0,
            dy = uy1 - uy0,
            d2 = dx * dx + dy * dy,
            i,
            S;
        if (d2 < ε2) {
          S = Math.log(w1 / w0) / ρ;
          i = function(t) {
            return [ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S)];
          };
        } else {
          var d1 = Math.sqrt(d2),
              b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1),
              b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1),
              r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
              r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
          S = (r1 - r0) / ρ;
          i = function(t) {
            var s = t * S,
                coshr0 = d3_cosh(r0),
                u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
            return [ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0)];
          };
        }
        i.duration = S * 1e3;
        return i;
      };
      d3.behavior.zoom = function() {
        var view = {
          x: 0,
          y: 0,
          k: 1
        },
            translate0,
            center0,
            center,
            size = [960, 500],
            scaleExtent = d3_behavior_zoomInfinity,
            duration = 250,
            zooming = 0,
            mousedown = "mousedown.zoom",
            mousemove = "mousemove.zoom",
            mouseup = "mouseup.zoom",
            mousewheelTimer,
            touchstart = "touchstart.zoom",
            touchtime,
            event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"),
            x0,
            x1,
            y0,
            y1;
        if (!d3_behavior_zoomWheel) {
          d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
            return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
          }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
            return d3.event.wheelDelta;
          }, "mousewheel") : (d3_behavior_zoomDelta = function() {
            return -d3.event.detail;
          }, "MozMousePixelScroll");
        }
        function zoom(g) {
          g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
        }
        zoom.event = function(g) {
          g.each(function() {
            var dispatch = event.of(this, arguments),
                view1 = view;
            if (d3_transitionInheritId) {
              d3.select(this).transition().each("start.zoom", function() {
                view = this.__chart__ || {
                  x: 0,
                  y: 0,
                  k: 1
                };
                zoomstarted(dispatch);
              }).tween("zoom:zoom", function() {
                var dx = size[0],
                    dy = size[1],
                    cx = center0 ? center0[0] : dx / 2,
                    cy = center0 ? center0[1] : dy / 2,
                    i = d3.interpolateZoom([(cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k], [(cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k]);
                return function(t) {
                  var l = i(t),
                      k = dx / l[2];
                  this.__chart__ = view = {
                    x: cx - l[0] * k,
                    y: cy - l[1] * k,
                    k: k
                  };
                  zoomed(dispatch);
                };
              }).each("interrupt.zoom", function() {
                zoomended(dispatch);
              }).each("end.zoom", function() {
                zoomended(dispatch);
              });
            } else {
              this.__chart__ = view;
              zoomstarted(dispatch);
              zoomed(dispatch);
              zoomended(dispatch);
            }
          });
        };
        zoom.translate = function(_) {
          if (!arguments.length)
            return [view.x, view.y];
          view = {
            x: +_[0],
            y: +_[1],
            k: view.k
          };
          rescale();
          return zoom;
        };
        zoom.scale = function(_) {
          if (!arguments.length)
            return view.k;
          view = {
            x: view.x,
            y: view.y,
            k: null
          };
          scaleTo(+_);
          rescale();
          return zoom;
        };
        zoom.scaleExtent = function(_) {
          if (!arguments.length)
            return scaleExtent;
          scaleExtent = _ == null ? d3_behavior_zoomInfinity : [+_[0], +_[1]];
          return zoom;
        };
        zoom.center = function(_) {
          if (!arguments.length)
            return center;
          center = _ && [+_[0], +_[1]];
          return zoom;
        };
        zoom.size = function(_) {
          if (!arguments.length)
            return size;
          size = _ && [+_[0], +_[1]];
          return zoom;
        };
        zoom.duration = function(_) {
          if (!arguments.length)
            return duration;
          duration = +_;
          return zoom;
        };
        zoom.x = function(z) {
          if (!arguments.length)
            return x1;
          x1 = z;
          x0 = z.copy();
          view = {
            x: 0,
            y: 0,
            k: 1
          };
          return zoom;
        };
        zoom.y = function(z) {
          if (!arguments.length)
            return y1;
          y1 = z;
          y0 = z.copy();
          view = {
            x: 0,
            y: 0,
            k: 1
          };
          return zoom;
        };
        function location(p) {
          return [(p[0] - view.x) / view.k, (p[1] - view.y) / view.k];
        }
        function point(l) {
          return [l[0] * view.k + view.x, l[1] * view.k + view.y];
        }
        function scaleTo(s) {
          view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
        }
        function translateTo(p, l) {
          l = point(l);
          view.x += p[0] - l[0];
          view.y += p[1] - l[1];
        }
        function zoomTo(that, p, l, k) {
          that.__chart__ = {
            x: view.x,
            y: view.y,
            k: view.k
          };
          scaleTo(Math.pow(2, k));
          translateTo(center0 = p, l);
          that = d3.select(that);
          if (duration > 0)
            that = that.transition().duration(duration);
          that.call(zoom.event);
        }
        function rescale() {
          if (x1)
            x1.domain(x0.range().map(function(x) {
              return (x - view.x) / view.k;
            }).map(x0.invert));
          if (y1)
            y1.domain(y0.range().map(function(y) {
              return (y - view.y) / view.k;
            }).map(y0.invert));
        }
        function zoomstarted(dispatch) {
          if (!zooming++)
            dispatch({type: "zoomstart"});
        }
        function zoomed(dispatch) {
          rescale();
          dispatch({
            type: "zoom",
            scale: view.k,
            translate: [view.x, view.y]
          });
        }
        function zoomended(dispatch) {
          if (!--zooming)
            dispatch({type: "zoomend"}), center0 = null;
        }
        function mousedowned() {
          var that = this,
              dispatch = event.of(that, arguments),
              dragged = 0,
              subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended),
              location0 = location(d3.mouse(that)),
              dragRestore = d3_event_dragSuppress(that);
          d3_selection_interrupt.call(that);
          zoomstarted(dispatch);
          function moved() {
            dragged = 1;
            translateTo(d3.mouse(that), location0);
            zoomed(dispatch);
          }
          function ended() {
            subject.on(mousemove, null).on(mouseup, null);
            dragRestore(dragged);
            zoomended(dispatch);
          }
        }
        function touchstarted() {
          var that = this,
              dispatch = event.of(that, arguments),
              locations0 = {},
              distance0 = 0,
              scale0,
              zoomName = ".zoom-" + d3.event.changedTouches[0].identifier,
              touchmove = "touchmove" + zoomName,
              touchend = "touchend" + zoomName,
              targets = [],
              subject = d3.select(that),
              dragRestore = d3_event_dragSuppress(that);
          started();
          zoomstarted(dispatch);
          subject.on(mousedown, null).on(touchstart, started);
          function relocate() {
            var touches = d3.touches(that);
            scale0 = view.k;
            touches.forEach(function(t) {
              if (t.identifier in locations0)
                locations0[t.identifier] = location(t);
            });
            return touches;
          }
          function started() {
            var target = d3.event.target;
            d3.select(target).on(touchmove, moved).on(touchend, ended);
            targets.push(target);
            var changed = d3.event.changedTouches;
            for (var i = 0,
                n = changed.length; i < n; ++i) {
              locations0[changed[i].identifier] = null;
            }
            var touches = relocate(),
                now = Date.now();
            if (touches.length === 1) {
              if (now - touchtime < 500) {
                var p = touches[0];
                zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
                d3_eventPreventDefault();
              }
              touchtime = now;
            } else if (touches.length > 1) {
              var p = touches[0],
                  q = touches[1],
                  dx = p[0] - q[0],
                  dy = p[1] - q[1];
              distance0 = dx * dx + dy * dy;
            }
          }
          function moved() {
            var touches = d3.touches(that),
                p0,
                l0,
                p1,
                l1;
            d3_selection_interrupt.call(that);
            for (var i = 0,
                n = touches.length; i < n; ++i, l1 = null) {
              p1 = touches[i];
              if (l1 = locations0[p1.identifier]) {
                if (l0)
                  break;
                p0 = p1, l0 = l1;
              }
            }
            if (l1) {
              var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1,
                  scale1 = distance0 && Math.sqrt(distance1 / distance0);
              p0 = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
              l0 = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
              scaleTo(scale1 * scale0);
            }
            touchtime = null;
            translateTo(p0, l0);
            zoomed(dispatch);
          }
          function ended() {
            if (d3.event.touches.length) {
              var changed = d3.event.changedTouches;
              for (var i = 0,
                  n = changed.length; i < n; ++i) {
                delete locations0[changed[i].identifier];
              }
              for (var identifier in locations0) {
                return void relocate();
              }
            }
            d3.selectAll(targets).on(zoomName, null);
            subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
            dragRestore();
            zoomended(dispatch);
          }
        }
        function mousewheeled() {
          var dispatch = event.of(this, arguments);
          if (mousewheelTimer)
            clearTimeout(mousewheelTimer);
          else
            d3_selection_interrupt.call(this), translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
          mousewheelTimer = setTimeout(function() {
            mousewheelTimer = null;
            zoomended(dispatch);
          }, 50);
          d3_eventPreventDefault();
          scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
          translateTo(center0, translate0);
          zoomed(dispatch);
        }
        function dblclicked() {
          var p = d3.mouse(this),
              k = Math.log(view.k) / Math.LN2;
          zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
        }
        return d3.rebind(zoom, event, "on");
      };
      var d3_behavior_zoomInfinity = [0, Infinity],
          d3_behavior_zoomDelta,
          d3_behavior_zoomWheel;
      d3.color = d3_color;
      function d3_color() {}
      d3_color.prototype.toString = function() {
        return this.rgb() + "";
      };
      d3.hsl = d3_hsl;
      function d3_hsl(h, s, l) {
        return this instanceof d3_hsl ? void(this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
      }
      var d3_hslPrototype = d3_hsl.prototype = new d3_color();
      d3_hslPrototype.brighter = function(k) {
        k = Math.pow(.7, arguments.length ? k : 1);
        return new d3_hsl(this.h, this.s, this.l / k);
      };
      d3_hslPrototype.darker = function(k) {
        k = Math.pow(.7, arguments.length ? k : 1);
        return new d3_hsl(this.h, this.s, k * this.l);
      };
      d3_hslPrototype.rgb = function() {
        return d3_hsl_rgb(this.h, this.s, this.l);
      };
      function d3_hsl_rgb(h, s, l) {
        var m1,
            m2;
        h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
        s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
        l = l < 0 ? 0 : l > 1 ? 1 : l;
        m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
        m1 = 2 * l - m2;
        function v(h) {
          if (h > 360)
            h -= 360;
          else if (h < 0)
            h += 360;
          if (h < 60)
            return m1 + (m2 - m1) * h / 60;
          if (h < 180)
            return m2;
          if (h < 240)
            return m1 + (m2 - m1) * (240 - h) / 60;
          return m1;
        }
        function vv(h) {
          return Math.round(v(h) * 255);
        }
        return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
      }
      d3.hcl = d3_hcl;
      function d3_hcl(h, c, l) {
        return this instanceof d3_hcl ? void(this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
      }
      var d3_hclPrototype = d3_hcl.prototype = new d3_color();
      d3_hclPrototype.brighter = function(k) {
        return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
      };
      d3_hclPrototype.darker = function(k) {
        return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
      };
      d3_hclPrototype.rgb = function() {
        return d3_hcl_lab(this.h, this.c, this.l).rgb();
      };
      function d3_hcl_lab(h, c, l) {
        if (isNaN(h))
          h = 0;
        if (isNaN(c))
          c = 0;
        return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
      }
      d3.lab = d3_lab;
      function d3_lab(l, a, b) {
        return this instanceof d3_lab ? void(this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
      }
      var d3_lab_K = 18;
      var d3_lab_X = .95047,
          d3_lab_Y = 1,
          d3_lab_Z = 1.08883;
      var d3_labPrototype = d3_lab.prototype = new d3_color();
      d3_labPrototype.brighter = function(k) {
        return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
      };
      d3_labPrototype.darker = function(k) {
        return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
      };
      d3_labPrototype.rgb = function() {
        return d3_lab_rgb(this.l, this.a, this.b);
      };
      function d3_lab_rgb(l, a, b) {
        var y = (l + 16) / 116,
            x = y + a / 500,
            z = y - b / 200;
        x = d3_lab_xyz(x) * d3_lab_X;
        y = d3_lab_xyz(y) * d3_lab_Y;
        z = d3_lab_xyz(z) * d3_lab_Z;
        return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
      }
      function d3_lab_hcl(l, a, b) {
        return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
      }
      function d3_lab_xyz(x) {
        return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
      }
      function d3_xyz_lab(x) {
        return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
      }
      function d3_xyz_rgb(r) {
        return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
      }
      d3.rgb = d3_rgb;
      function d3_rgb(r, g, b) {
        return this instanceof d3_rgb ? void(this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
      }
      function d3_rgbNumber(value) {
        return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
      }
      function d3_rgbString(value) {
        return d3_rgbNumber(value) + "";
      }
      var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
      d3_rgbPrototype.brighter = function(k) {
        k = Math.pow(.7, arguments.length ? k : 1);
        var r = this.r,
            g = this.g,
            b = this.b,
            i = 30;
        if (!r && !g && !b)
          return new d3_rgb(i, i, i);
        if (r && r < i)
          r = i;
        if (g && g < i)
          g = i;
        if (b && b < i)
          b = i;
        return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
      };
      d3_rgbPrototype.darker = function(k) {
        k = Math.pow(.7, arguments.length ? k : 1);
        return new d3_rgb(k * this.r, k * this.g, k * this.b);
      };
      d3_rgbPrototype.hsl = function() {
        return d3_rgb_hsl(this.r, this.g, this.b);
      };
      d3_rgbPrototype.toString = function() {
        return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
      };
      function d3_rgb_hex(v) {
        return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
      }
      function d3_rgb_parse(format, rgb, hsl) {
        var r = 0,
            g = 0,
            b = 0,
            m1,
            m2,
            color;
        m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
        if (m1) {
          m2 = m1[2].split(",");
          switch (m1[1]) {
            case "hsl":
              {
                return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
              }
            case "rgb":
              {
                return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
              }
          }
        }
        if (color = d3_rgb_names.get(format)) {
          return rgb(color.r, color.g, color.b);
        }
        if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
          if (format.length === 4) {
            r = (color & 3840) >> 4;
            r = r >> 4 | r;
            g = color & 240;
            g = g >> 4 | g;
            b = color & 15;
            b = b << 4 | b;
          } else if (format.length === 7) {
            r = (color & 16711680) >> 16;
            g = (color & 65280) >> 8;
            b = color & 255;
          }
        }
        return rgb(r, g, b);
      }
      function d3_rgb_hsl(r, g, b) {
        var min = Math.min(r /= 255, g /= 255, b /= 255),
            max = Math.max(r, g, b),
            d = max - min,
            h,
            s,
            l = (max + min) / 2;
        if (d) {
          s = l < .5 ? d / (max + min) : d / (2 - max - min);
          if (r == max)
            h = (g - b) / d + (g < b ? 6 : 0);
          else if (g == max)
            h = (b - r) / d + 2;
          else
            h = (r - g) / d + 4;
          h *= 60;
        } else {
          h = NaN;
          s = l > 0 && l < 1 ? 0 : h;
        }
        return new d3_hsl(h, s, l);
      }
      function d3_rgb_lab(r, g, b) {
        r = d3_rgb_xyz(r);
        g = d3_rgb_xyz(g);
        b = d3_rgb_xyz(b);
        var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X),
            y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y),
            z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
        return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
      }
      function d3_rgb_xyz(r) {
        return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
      }
      function d3_rgb_parseNumber(c) {
        var f = parseFloat(c);
        return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
      }
      var d3_rgb_names = d3.map({
        aliceblue: 15792383,
        antiquewhite: 16444375,
        aqua: 65535,
        aquamarine: 8388564,
        azure: 15794175,
        beige: 16119260,
        bisque: 16770244,
        black: 0,
        blanchedalmond: 16772045,
        blue: 255,
        blueviolet: 9055202,
        brown: 10824234,
        burlywood: 14596231,
        cadetblue: 6266528,
        chartreuse: 8388352,
        chocolate: 13789470,
        coral: 16744272,
        cornflowerblue: 6591981,
        cornsilk: 16775388,
        crimson: 14423100,
        cyan: 65535,
        darkblue: 139,
        darkcyan: 35723,
        darkgoldenrod: 12092939,
        darkgray: 11119017,
        darkgreen: 25600,
        darkgrey: 11119017,
        darkkhaki: 12433259,
        darkmagenta: 9109643,
        darkolivegreen: 5597999,
        darkorange: 16747520,
        darkorchid: 10040012,
        darkred: 9109504,
        darksalmon: 15308410,
        darkseagreen: 9419919,
        darkslateblue: 4734347,
        darkslategray: 3100495,
        darkslategrey: 3100495,
        darkturquoise: 52945,
        darkviolet: 9699539,
        deeppink: 16716947,
        deepskyblue: 49151,
        dimgray: 6908265,
        dimgrey: 6908265,
        dodgerblue: 2003199,
        firebrick: 11674146,
        floralwhite: 16775920,
        forestgreen: 2263842,
        fuchsia: 16711935,
        gainsboro: 14474460,
        ghostwhite: 16316671,
        gold: 16766720,
        goldenrod: 14329120,
        gray: 8421504,
        green: 32768,
        greenyellow: 11403055,
        grey: 8421504,
        honeydew: 15794160,
        hotpink: 16738740,
        indianred: 13458524,
        indigo: 4915330,
        ivory: 16777200,
        khaki: 15787660,
        lavender: 15132410,
        lavenderblush: 16773365,
        lawngreen: 8190976,
        lemonchiffon: 16775885,
        lightblue: 11393254,
        lightcoral: 15761536,
        lightcyan: 14745599,
        lightgoldenrodyellow: 16448210,
        lightgray: 13882323,
        lightgreen: 9498256,
        lightgrey: 13882323,
        lightpink: 16758465,
        lightsalmon: 16752762,
        lightseagreen: 2142890,
        lightskyblue: 8900346,
        lightslategray: 7833753,
        lightslategrey: 7833753,
        lightsteelblue: 11584734,
        lightyellow: 16777184,
        lime: 65280,
        limegreen: 3329330,
        linen: 16445670,
        magenta: 16711935,
        maroon: 8388608,
        mediumaquamarine: 6737322,
        mediumblue: 205,
        mediumorchid: 12211667,
        mediumpurple: 9662683,
        mediumseagreen: 3978097,
        mediumslateblue: 8087790,
        mediumspringgreen: 64154,
        mediumturquoise: 4772300,
        mediumvioletred: 13047173,
        midnightblue: 1644912,
        mintcream: 16121850,
        mistyrose: 16770273,
        moccasin: 16770229,
        navajowhite: 16768685,
        navy: 128,
        oldlace: 16643558,
        olive: 8421376,
        olivedrab: 7048739,
        orange: 16753920,
        orangered: 16729344,
        orchid: 14315734,
        palegoldenrod: 15657130,
        palegreen: 10025880,
        paleturquoise: 11529966,
        palevioletred: 14381203,
        papayawhip: 16773077,
        peachpuff: 16767673,
        peru: 13468991,
        pink: 16761035,
        plum: 14524637,
        powderblue: 11591910,
        purple: 8388736,
        rebeccapurple: 6697881,
        red: 16711680,
        rosybrown: 12357519,
        royalblue: 4286945,
        saddlebrown: 9127187,
        salmon: 16416882,
        sandybrown: 16032864,
        seagreen: 3050327,
        seashell: 16774638,
        sienna: 10506797,
        silver: 12632256,
        skyblue: 8900331,
        slateblue: 6970061,
        slategray: 7372944,
        slategrey: 7372944,
        snow: 16775930,
        springgreen: 65407,
        steelblue: 4620980,
        tan: 13808780,
        teal: 32896,
        thistle: 14204888,
        tomato: 16737095,
        turquoise: 4251856,
        violet: 15631086,
        wheat: 16113331,
        white: 16777215,
        whitesmoke: 16119285,
        yellow: 16776960,
        yellowgreen: 10145074
      });
      d3_rgb_names.forEach(function(key, value) {
        d3_rgb_names.set(key, d3_rgbNumber(value));
      });
      function d3_functor(v) {
        return typeof v === "function" ? v : function() {
          return v;
        };
      }
      d3.functor = d3_functor;
      d3.xhr = d3_xhrType(d3_identity);
      function d3_xhrType(response) {
        return function(url, mimeType, callback) {
          if (arguments.length === 2 && typeof mimeType === "function")
            callback = mimeType, mimeType = null;
          return d3_xhr(url, mimeType, response, callback);
        };
      }
      function d3_xhr(url, mimeType, response, callback) {
        var xhr = {},
            dispatch = d3.dispatch("beforesend", "progress", "load", "error"),
            headers = {},
            request = new XMLHttpRequest(),
            responseType = null;
        if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url))
          request = new XDomainRequest();
        "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
          request.readyState > 3 && respond();
        };
        function respond() {
          var status = request.status,
              result;
          if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
            try {
              result = response.call(xhr, request);
            } catch (e) {
              dispatch.error.call(xhr, e);
              return;
            }
            dispatch.load.call(xhr, result);
          } else {
            dispatch.error.call(xhr, request);
          }
        }
        request.onprogress = function(event) {
          var o = d3.event;
          d3.event = event;
          try {
            dispatch.progress.call(xhr, request);
          } finally {
            d3.event = o;
          }
        };
        xhr.header = function(name, value) {
          name = (name + "").toLowerCase();
          if (arguments.length < 2)
            return headers[name];
          if (value == null)
            delete headers[name];
          else
            headers[name] = value + "";
          return xhr;
        };
        xhr.mimeType = function(value) {
          if (!arguments.length)
            return mimeType;
          mimeType = value == null ? null : value + "";
          return xhr;
        };
        xhr.responseType = function(value) {
          if (!arguments.length)
            return responseType;
          responseType = value;
          return xhr;
        };
        xhr.response = function(value) {
          response = value;
          return xhr;
        };
        ["get", "post"].forEach(function(method) {
          xhr[method] = function() {
            return xhr.send.apply(xhr, [method].concat(d3_array(arguments)));
          };
        });
        xhr.send = function(method, data, callback) {
          if (arguments.length === 2 && typeof data === "function")
            callback = data, data = null;
          request.open(method, url, true);
          if (mimeType != null && !("accept" in headers))
            headers["accept"] = mimeType + ",*/*";
          if (request.setRequestHeader)
            for (var name in headers)
              request.setRequestHeader(name, headers[name]);
          if (mimeType != null && request.overrideMimeType)
            request.overrideMimeType(mimeType);
          if (responseType != null)
            request.responseType = responseType;
          if (callback != null)
            xhr.on("error", callback).on("load", function(request) {
              callback(null, request);
            });
          dispatch.beforesend.call(xhr, request);
          request.send(data == null ? null : data);
          return xhr;
        };
        xhr.abort = function() {
          request.abort();
          return xhr;
        };
        d3.rebind(xhr, dispatch, "on");
        return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
      }
      function d3_xhr_fixCallback(callback) {
        return callback.length === 1 ? function(error, request) {
          callback(error == null ? request : null);
        } : callback;
      }
      function d3_xhrHasResponse(request) {
        var type = request.responseType;
        return type && type !== "text" ? request.response : request.responseText;
      }
      d3.dsv = function(delimiter, mimeType) {
        var reFormat = new RegExp('["' + delimiter + "\n]"),
            delimiterCode = delimiter.charCodeAt(0);
        function dsv(url, row, callback) {
          if (arguments.length < 3)
            callback = row, row = null;
          var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
          xhr.row = function(_) {
            return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
          };
          return xhr;
        }
        function response(request) {
          return dsv.parse(request.responseText);
        }
        function typedResponse(f) {
          return function(request) {
            return dsv.parse(request.responseText, f);
          };
        }
        dsv.parse = function(text, f) {
          var o;
          return dsv.parseRows(text, function(row, i) {
            if (o)
              return o(row, i - 1);
            var a = new Function("d", "return {" + row.map(function(name, i) {
              return JSON.stringify(name) + ": d[" + i + "]";
            }).join(",") + "}");
            o = f ? function(row, i) {
              return f(a(row), i);
            } : a;
          });
        };
        dsv.parseRows = function(text, f) {
          var EOL = {},
              EOF = {},
              rows = [],
              N = text.length,
              I = 0,
              n = 0,
              t,
              eol;
          function token() {
            if (I >= N)
              return EOF;
            if (eol)
              return eol = false, EOL;
            var j = I;
            if (text.charCodeAt(j) === 34) {
              var i = j;
              while (i++ < N) {
                if (text.charCodeAt(i) === 34) {
                  if (text.charCodeAt(i + 1) !== 34)
                    break;
                  ++i;
                }
              }
              I = i + 2;
              var c = text.charCodeAt(i + 1);
              if (c === 13) {
                eol = true;
                if (text.charCodeAt(i + 2) === 10)
                  ++I;
              } else if (c === 10) {
                eol = true;
              }
              return text.slice(j + 1, i).replace(/""/g, '"');
            }
            while (I < N) {
              var c = text.charCodeAt(I++),
                  k = 1;
              if (c === 10)
                eol = true;
              else if (c === 13) {
                eol = true;
                if (text.charCodeAt(I) === 10)
                  ++I, ++k;
              } else if (c !== delimiterCode)
                continue;
              return text.slice(j, I - k);
            }
            return text.slice(j);
          }
          while ((t = token()) !== EOF) {
            var a = [];
            while (t !== EOL && t !== EOF) {
              a.push(t);
              t = token();
            }
            if (f && (a = f(a, n++)) == null)
              continue;
            rows.push(a);
          }
          return rows;
        };
        dsv.format = function(rows) {
          if (Array.isArray(rows[0]))
            return dsv.formatRows(rows);
          var fieldSet = new d3_Set(),
              fields = [];
          rows.forEach(function(row) {
            for (var field in row) {
              if (!fieldSet.has(field)) {
                fields.push(fieldSet.add(field));
              }
            }
          });
          return [fields.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
            return fields.map(function(field) {
              return formatValue(row[field]);
            }).join(delimiter);
          })).join("\n");
        };
        dsv.formatRows = function(rows) {
          return rows.map(formatRow).join("\n");
        };
        function formatRow(row) {
          return row.map(formatValue).join(delimiter);
        }
        function formatValue(text) {
          return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
        }
        return dsv;
      };
      d3.csv = d3.dsv(",", "text/csv");
      d3.tsv = d3.dsv("	", "text/tab-separated-values");
      var d3_timer_queueHead,
          d3_timer_queueTail,
          d3_timer_interval,
          d3_timer_timeout,
          d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
            setTimeout(callback, 17);
          };
      d3.timer = function() {
        d3_timer.apply(this, arguments);
      };
      function d3_timer(callback, delay, then) {
        var n = arguments.length;
        if (n < 2)
          delay = 0;
        if (n < 3)
          then = Date.now();
        var time = then + delay,
            timer = {
              c: callback,
              t: time,
              n: null
            };
        if (d3_timer_queueTail)
          d3_timer_queueTail.n = timer;
        else
          d3_timer_queueHead = timer;
        d3_timer_queueTail = timer;
        if (!d3_timer_interval) {
          d3_timer_timeout = clearTimeout(d3_timer_timeout);
          d3_timer_interval = 1;
          d3_timer_frame(d3_timer_step);
        }
        return timer;
      }
      function d3_timer_step() {
        var now = d3_timer_mark(),
            delay = d3_timer_sweep() - now;
        if (delay > 24) {
          if (isFinite(delay)) {
            clearTimeout(d3_timer_timeout);
            d3_timer_timeout = setTimeout(d3_timer_step, delay);
          }
          d3_timer_interval = 0;
        } else {
          d3_timer_interval = 1;
          d3_timer_frame(d3_timer_step);
        }
      }
      d3.timer.flush = function() {
        d3_timer_mark();
        d3_timer_sweep();
      };
      function d3_timer_mark() {
        var now = Date.now(),
            timer = d3_timer_queueHead;
        while (timer) {
          if (now >= timer.t && timer.c(now - timer.t))
            timer.c = null;
          timer = timer.n;
        }
        return now;
      }
      function d3_timer_sweep() {
        var t0,
            t1 = d3_timer_queueHead,
            time = Infinity;
        while (t1) {
          if (t1.c) {
            if (t1.t < time)
              time = t1.t;
            t1 = (t0 = t1).n;
          } else {
            t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
          }
        }
        d3_timer_queueTail = t0;
        return time;
      }
      function d3_format_precision(x, p) {
        return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
      }
      d3.round = function(x, n) {
        return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
      };
      var d3_formatPrefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"].map(d3_formatPrefix);
      d3.formatPrefix = function(value, precision) {
        var i = 0;
        if (value = +value) {
          if (value < 0)
            value *= -1;
          if (precision)
            value = d3.round(value, d3_format_precision(value, precision));
          i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
          i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
        }
        return d3_formatPrefixes[8 + i / 3];
      };
      function d3_formatPrefix(d, i) {
        var k = Math.pow(10, abs(8 - i) * 3);
        return {
          scale: i > 8 ? function(d) {
            return d / k;
          } : function(d) {
            return d * k;
          },
          symbol: d
        };
      }
      function d3_locale_numberFormat(locale) {
        var locale_decimal = locale.decimal,
            locale_thousands = locale.thousands,
            locale_grouping = locale.grouping,
            locale_currency = locale.currency,
            formatGroup = locale_grouping && locale_thousands ? function(value, width) {
              var i = value.length,
                  t = [],
                  j = 0,
                  g = locale_grouping[0],
                  length = 0;
              while (i > 0 && g > 0) {
                if (length + g + 1 > width)
                  g = Math.max(1, width - length);
                t.push(value.substring(i -= g, i + g));
                if ((length += g + 1) > width)
                  break;
                g = locale_grouping[j = (j + 1) % locale_grouping.length];
              }
              return t.reverse().join(locale_thousands);
            } : d3_identity;
        return function(specifier) {
          var match = d3_format_re.exec(specifier),
              fill = match[1] || " ",
              align = match[2] || ">",
              sign = match[3] || "-",
              symbol = match[4] || "",
              zfill = match[5],
              width = +match[6],
              comma = match[7],
              precision = match[8],
              type = match[9],
              scale = 1,
              prefix = "",
              suffix = "",
              integer = false,
              exponent = true;
          if (precision)
            precision = +precision.substring(1);
          if (zfill || fill === "0" && align === "=") {
            zfill = fill = "0";
            align = "=";
          }
          switch (type) {
            case "n":
              comma = true;
              type = "g";
              break;
            case "%":
              scale = 100;
              suffix = "%";
              type = "f";
              break;
            case "p":
              scale = 100;
              suffix = "%";
              type = "r";
              break;
            case "b":
            case "o":
            case "x":
            case "X":
              if (symbol === "#")
                prefix = "0" + type.toLowerCase();
            case "c":
              exponent = false;
            case "d":
              integer = true;
              precision = 0;
              break;
            case "s":
              scale = -1;
              type = "r";
              break;
          }
          if (symbol === "$")
            prefix = locale_currency[0], suffix = locale_currency[1];
          if (type == "r" && !precision)
            type = "g";
          if (precision != null) {
            if (type == "g")
              precision = Math.max(1, Math.min(21, precision));
            else if (type == "e" || type == "f")
              precision = Math.max(0, Math.min(20, precision));
          }
          type = d3_format_types.get(type) || d3_format_typeDefault;
          var zcomma = zfill && comma;
          return function(value) {
            var fullSuffix = suffix;
            if (integer && value % 1)
              return "";
            var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
            if (scale < 0) {
              var unit = d3.formatPrefix(value, precision);
              value = unit.scale(value);
              fullSuffix = unit.symbol + suffix;
            } else {
              value *= scale;
            }
            value = type(value, precision);
            var i = value.lastIndexOf("."),
                before,
                after;
            if (i < 0) {
              var j = exponent ? value.lastIndexOf("e") : -1;
              if (j < 0)
                before = value, after = "";
              else
                before = value.substring(0, j), after = value.substring(j);
            } else {
              before = value.substring(0, i);
              after = locale_decimal + value.substring(i + 1);
            }
            if (!zfill && comma)
              before = formatGroup(before, Infinity);
            var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length),
                padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
            if (zcomma)
              before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
            negative += prefix;
            value = before + after;
            return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
          };
        };
      }
      var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
      var d3_format_types = d3.map({
        b: function(x) {
          return x.toString(2);
        },
        c: function(x) {
          return String.fromCharCode(x);
        },
        o: function(x) {
          return x.toString(8);
        },
        x: function(x) {
          return x.toString(16);
        },
        X: function(x) {
          return x.toString(16).toUpperCase();
        },
        g: function(x, p) {
          return x.toPrecision(p);
        },
        e: function(x, p) {
          return x.toExponential(p);
        },
        f: function(x, p) {
          return x.toFixed(p);
        },
        r: function(x, p) {
          return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
        }
      });
      function d3_format_typeDefault(x) {
        return x + "";
      }
      var d3_time = d3.time = {},
          d3_date = Date;
      function d3_date_utc() {
        this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
      }
      d3_date_utc.prototype = {
        getDate: function() {
          return this._.getUTCDate();
        },
        getDay: function() {
          return this._.getUTCDay();
        },
        getFullYear: function() {
          return this._.getUTCFullYear();
        },
        getHours: function() {
          return this._.getUTCHours();
        },
        getMilliseconds: function() {
          return this._.getUTCMilliseconds();
        },
        getMinutes: function() {
          return this._.getUTCMinutes();
        },
        getMonth: function() {
          return this._.getUTCMonth();
        },
        getSeconds: function() {
          return this._.getUTCSeconds();
        },
        getTime: function() {
          return this._.getTime();
        },
        getTimezoneOffset: function() {
          return 0;
        },
        valueOf: function() {
          return this._.valueOf();
        },
        setDate: function() {
          d3_time_prototype.setUTCDate.apply(this._, arguments);
        },
        setDay: function() {
          d3_time_prototype.setUTCDay.apply(this._, arguments);
        },
        setFullYear: function() {
          d3_time_prototype.setUTCFullYear.apply(this._, arguments);
        },
        setHours: function() {
          d3_time_prototype.setUTCHours.apply(this._, arguments);
        },
        setMilliseconds: function() {
          d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
        },
        setMinutes: function() {
          d3_time_prototype.setUTCMinutes.apply(this._, arguments);
        },
        setMonth: function() {
          d3_time_prototype.setUTCMonth.apply(this._, arguments);
        },
        setSeconds: function() {
          d3_time_prototype.setUTCSeconds.apply(this._, arguments);
        },
        setTime: function() {
          d3_time_prototype.setTime.apply(this._, arguments);
        }
      };
      var d3_time_prototype = Date.prototype;
      function d3_time_interval(local, step, number) {
        function round(date) {
          var d0 = local(date),
              d1 = offset(d0, 1);
          return date - d0 < d1 - date ? d0 : d1;
        }
        function ceil(date) {
          step(date = local(new d3_date(date - 1)), 1);
          return date;
        }
        function offset(date, k) {
          step(date = new d3_date(+date), k);
          return date;
        }
        function range(t0, t1, dt) {
          var time = ceil(t0),
              times = [];
          if (dt > 1) {
            while (time < t1) {
              if (!(number(time) % dt))
                times.push(new Date(+time));
              step(time, 1);
            }
          } else {
            while (time < t1)
              times.push(new Date(+time)), step(time, 1);
          }
          return times;
        }
        function range_utc(t0, t1, dt) {
          try {
            d3_date = d3_date_utc;
            var utc = new d3_date_utc();
            utc._ = t0;
            return range(utc, t1, dt);
          } finally {
            d3_date = Date;
          }
        }
        local.floor = local;
        local.round = round;
        local.ceil = ceil;
        local.offset = offset;
        local.range = range;
        var utc = local.utc = d3_time_interval_utc(local);
        utc.floor = utc;
        utc.round = d3_time_interval_utc(round);
        utc.ceil = d3_time_interval_utc(ceil);
        utc.offset = d3_time_interval_utc(offset);
        utc.range = range_utc;
        return local;
      }
      function d3_time_interval_utc(method) {
        return function(date, k) {
          try {
            d3_date = d3_date_utc;
            var utc = new d3_date_utc();
            utc._ = date;
            return method(utc, k)._;
          } finally {
            d3_date = Date;
          }
        };
      }
      d3_time.year = d3_time_interval(function(date) {
        date = d3_time.day(date);
        date.setMonth(0, 1);
        return date;
      }, function(date, offset) {
        date.setFullYear(date.getFullYear() + offset);
      }, function(date) {
        return date.getFullYear();
      });
      d3_time.years = d3_time.year.range;
      d3_time.years.utc = d3_time.year.utc.range;
      d3_time.day = d3_time_interval(function(date) {
        var day = new d3_date(2e3, 0);
        day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
        return day;
      }, function(date, offset) {
        date.setDate(date.getDate() + offset);
      }, function(date) {
        return date.getDate() - 1;
      });
      d3_time.days = d3_time.day.range;
      d3_time.days.utc = d3_time.day.utc.range;
      d3_time.dayOfYear = function(date) {
        var year = d3_time.year(date);
        return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
      };
      ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"].forEach(function(day, i) {
        i = 7 - i;
        var interval = d3_time[day] = d3_time_interval(function(date) {
          (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
          return date;
        }, function(date, offset) {
          date.setDate(date.getDate() + Math.floor(offset) * 7);
        }, function(date) {
          var day = d3_time.year(date).getDay();
          return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
        });
        d3_time[day + "s"] = interval.range;
        d3_time[day + "s"].utc = interval.utc.range;
        d3_time[day + "OfYear"] = function(date) {
          var day = d3_time.year(date).getDay();
          return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
        };
      });
      d3_time.week = d3_time.sunday;
      d3_time.weeks = d3_time.sunday.range;
      d3_time.weeks.utc = d3_time.sunday.utc.range;
      d3_time.weekOfYear = d3_time.sundayOfYear;
      function d3_locale_timeFormat(locale) {
        var locale_dateTime = locale.dateTime,
            locale_date = locale.date,
            locale_time = locale.time,
            locale_periods = locale.periods,
            locale_days = locale.days,
            locale_shortDays = locale.shortDays,
            locale_months = locale.months,
            locale_shortMonths = locale.shortMonths;
        function d3_time_format(template) {
          var n = template.length;
          function format(date) {
            var string = [],
                i = -1,
                j = 0,
                c,
                p,
                f;
            while (++i < n) {
              if (template.charCodeAt(i) === 37) {
                string.push(template.slice(j, i));
                if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null)
                  c = template.charAt(++i);
                if (f = d3_time_formats[c])
                  c = f(date, p == null ? c === "e" ? " " : "0" : p);
                string.push(c);
                j = i + 1;
              }
            }
            string.push(template.slice(j, i));
            return string.join("");
          }
          format.parse = function(string) {
            var d = {
              y: 1900,
              m: 0,
              d: 1,
              H: 0,
              M: 0,
              S: 0,
              L: 0,
              Z: null
            },
                i = d3_time_parse(d, template, string, 0);
            if (i != string.length)
              return null;
            if ("p" in d)
              d.H = d.H % 12 + d.p * 12;
            var localZ = d.Z != null && d3_date !== d3_date_utc,
                date = new (localZ ? d3_date_utc : d3_date)();
            if ("j" in d)
              date.setFullYear(d.y, 0, d.j);
            else if ("W" in d || "U" in d) {
              if (!("w" in d))
                d.w = "W" in d ? 1 : 0;
              date.setFullYear(d.y, 0, 1);
              date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
            } else
              date.setFullYear(d.y, d.m, d.d);
            date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
            return localZ ? date._ : date;
          };
          format.toString = function() {
            return template;
          };
          return format;
        }
        function d3_time_parse(date, template, string, j) {
          var c,
              p,
              t,
              i = 0,
              n = template.length,
              m = string.length;
          while (i < n) {
            if (j >= m)
              return -1;
            c = template.charCodeAt(i++);
            if (c === 37) {
              t = template.charAt(i++);
              p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
              if (!p || (j = p(date, string, j)) < 0)
                return -1;
            } else if (c != string.charCodeAt(j++)) {
              return -1;
            }
          }
          return j;
        }
        d3_time_format.utc = function(template) {
          var local = d3_time_format(template);
          function format(date) {
            try {
              d3_date = d3_date_utc;
              var utc = new d3_date();
              utc._ = date;
              return local(utc);
            } finally {
              d3_date = Date;
            }
          }
          format.parse = function(string) {
            try {
              d3_date = d3_date_utc;
              var date = local.parse(string);
              return date && date._;
            } finally {
              d3_date = Date;
            }
          };
          format.toString = local.toString;
          return format;
        };
        d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
        var d3_time_periodLookup = d3.map(),
            d3_time_dayRe = d3_time_formatRe(locale_days),
            d3_time_dayLookup = d3_time_formatLookup(locale_days),
            d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays),
            d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays),
            d3_time_monthRe = d3_time_formatRe(locale_months),
            d3_time_monthLookup = d3_time_formatLookup(locale_months),
            d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths),
            d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
        locale_periods.forEach(function(p, i) {
          d3_time_periodLookup.set(p.toLowerCase(), i);
        });
        var d3_time_formats = {
          a: function(d) {
            return locale_shortDays[d.getDay()];
          },
          A: function(d) {
            return locale_days[d.getDay()];
          },
          b: function(d) {
            return locale_shortMonths[d.getMonth()];
          },
          B: function(d) {
            return locale_months[d.getMonth()];
          },
          c: d3_time_format(locale_dateTime),
          d: function(d, p) {
            return d3_time_formatPad(d.getDate(), p, 2);
          },
          e: function(d, p) {
            return d3_time_formatPad(d.getDate(), p, 2);
          },
          H: function(d, p) {
            return d3_time_formatPad(d.getHours(), p, 2);
          },
          I: function(d, p) {
            return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
          },
          j: function(d, p) {
            return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
          },
          L: function(d, p) {
            return d3_time_formatPad(d.getMilliseconds(), p, 3);
          },
          m: function(d, p) {
            return d3_time_formatPad(d.getMonth() + 1, p, 2);
          },
          M: function(d, p) {
            return d3_time_formatPad(d.getMinutes(), p, 2);
          },
          p: function(d) {
            return locale_periods[+(d.getHours() >= 12)];
          },
          S: function(d, p) {
            return d3_time_formatPad(d.getSeconds(), p, 2);
          },
          U: function(d, p) {
            return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
          },
          w: function(d) {
            return d.getDay();
          },
          W: function(d, p) {
            return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
          },
          x: d3_time_format(locale_date),
          X: d3_time_format(locale_time),
          y: function(d, p) {
            return d3_time_formatPad(d.getFullYear() % 100, p, 2);
          },
          Y: function(d, p) {
            return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
          },
          Z: d3_time_zone,
          "%": function() {
            return "%";
          }
        };
        var d3_time_parsers = {
          a: d3_time_parseWeekdayAbbrev,
          A: d3_time_parseWeekday,
          b: d3_time_parseMonthAbbrev,
          B: d3_time_parseMonth,
          c: d3_time_parseLocaleFull,
          d: d3_time_parseDay,
          e: d3_time_parseDay,
          H: d3_time_parseHour24,
          I: d3_time_parseHour24,
          j: d3_time_parseDayOfYear,
          L: d3_time_parseMilliseconds,
          m: d3_time_parseMonthNumber,
          M: d3_time_parseMinutes,
          p: d3_time_parseAmPm,
          S: d3_time_parseSeconds,
          U: d3_time_parseWeekNumberSunday,
          w: d3_time_parseWeekdayNumber,
          W: d3_time_parseWeekNumberMonday,
          x: d3_time_parseLocaleDate,
          X: d3_time_parseLocaleTime,
          y: d3_time_parseYear,
          Y: d3_time_parseFullYear,
          Z: d3_time_parseZone,
          "%": d3_time_parseLiteralPercent
        };
        function d3_time_parseWeekdayAbbrev(date, string, i) {
          d3_time_dayAbbrevRe.lastIndex = 0;
          var n = d3_time_dayAbbrevRe.exec(string.slice(i));
          return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function d3_time_parseWeekday(date, string, i) {
          d3_time_dayRe.lastIndex = 0;
          var n = d3_time_dayRe.exec(string.slice(i));
          return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function d3_time_parseMonthAbbrev(date, string, i) {
          d3_time_monthAbbrevRe.lastIndex = 0;
          var n = d3_time_monthAbbrevRe.exec(string.slice(i));
          return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function d3_time_parseMonth(date, string, i) {
          d3_time_monthRe.lastIndex = 0;
          var n = d3_time_monthRe.exec(string.slice(i));
          return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
        }
        function d3_time_parseLocaleFull(date, string, i) {
          return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
        }
        function d3_time_parseLocaleDate(date, string, i) {
          return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
        }
        function d3_time_parseLocaleTime(date, string, i) {
          return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
        }
        function d3_time_parseAmPm(date, string, i) {
          var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
          return n == null ? -1 : (date.p = n, i);
        }
        return d3_time_format;
      }
      var d3_time_formatPads = {
        "-": "",
        _: " ",
        "0": "0"
      },
          d3_time_numberRe = /^\s*\d+/,
          d3_time_percentRe = /^%/;
      function d3_time_formatPad(value, fill, width) {
        var sign = value < 0 ? "-" : "",
            string = (sign ? -value : value) + "",
            length = string.length;
        return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
      }
      function d3_time_formatRe(names) {
        return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
      }
      function d3_time_formatLookup(names) {
        var map = new d3_Map(),
            i = -1,
            n = names.length;
        while (++i < n)
          map.set(names[i].toLowerCase(), i);
        return map;
      }
      function d3_time_parseWeekdayNumber(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 1));
        return n ? (date.w = +n[0], i + n[0].length) : -1;
      }
      function d3_time_parseWeekNumberSunday(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i));
        return n ? (date.U = +n[0], i + n[0].length) : -1;
      }
      function d3_time_parseWeekNumberMonday(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i));
        return n ? (date.W = +n[0], i + n[0].length) : -1;
      }
      function d3_time_parseFullYear(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 4));
        return n ? (date.y = +n[0], i + n[0].length) : -1;
      }
      function d3_time_parseYear(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 2));
        return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
      }
      function d3_time_parseZone(date, string, i) {
        return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, i + 5) : -1;
      }
      function d3_time_expandYear(d) {
        return d + (d > 68 ? 1900 : 2e3);
      }
      function d3_time_parseMonthNumber(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 2));
        return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
      }
      function d3_time_parseDay(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 2));
        return n ? (date.d = +n[0], i + n[0].length) : -1;
      }
      function d3_time_parseDayOfYear(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 3));
        return n ? (date.j = +n[0], i + n[0].length) : -1;
      }
      function d3_time_parseHour24(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 2));
        return n ? (date.H = +n[0], i + n[0].length) : -1;
      }
      function d3_time_parseMinutes(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 2));
        return n ? (date.M = +n[0], i + n[0].length) : -1;
      }
      function d3_time_parseSeconds(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 2));
        return n ? (date.S = +n[0], i + n[0].length) : -1;
      }
      function d3_time_parseMilliseconds(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.slice(i, i + 3));
        return n ? (date.L = +n[0], i + n[0].length) : -1;
      }
      function d3_time_zone(d) {
        var z = d.getTimezoneOffset(),
            zs = z > 0 ? "-" : "+",
            zh = abs(z) / 60 | 0,
            zm = abs(z) % 60;
        return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
      }
      function d3_time_parseLiteralPercent(date, string, i) {
        d3_time_percentRe.lastIndex = 0;
        var n = d3_time_percentRe.exec(string.slice(i, i + 1));
        return n ? i + n[0].length : -1;
      }
      function d3_time_formatMulti(formats) {
        var n = formats.length,
            i = -1;
        while (++i < n)
          formats[i][0] = this(formats[i][0]);
        return function(date) {
          var i = 0,
              f = formats[i];
          while (!f[1](date))
            f = formats[++i];
          return f[0](date);
        };
      }
      d3.locale = function(locale) {
        return {
          numberFormat: d3_locale_numberFormat(locale),
          timeFormat: d3_locale_timeFormat(locale)
        };
      };
      var d3_locale_enUS = d3.locale({
        decimal: ".",
        thousands: ",",
        grouping: [3],
        currency: ["$", ""],
        dateTime: "%a %b %e %X %Y",
        date: "%m/%d/%Y",
        time: "%H:%M:%S",
        periods: ["AM", "PM"],
        days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      });
      d3.format = d3_locale_enUS.numberFormat;
      d3.geo = {};
      function d3_adder() {}
      d3_adder.prototype = {
        s: 0,
        t: 0,
        add: function(y) {
          d3_adderSum(y, this.t, d3_adderTemp);
          d3_adderSum(d3_adderTemp.s, this.s, this);
          if (this.s)
            this.t += d3_adderTemp.t;
          else
            this.s = d3_adderTemp.t;
        },
        reset: function() {
          this.s = this.t = 0;
        },
        valueOf: function() {
          return this.s;
        }
      };
      var d3_adderTemp = new d3_adder();
      function d3_adderSum(a, b, o) {
        var x = o.s = a + b,
            bv = x - a,
            av = x - bv;
        o.t = a - av + (b - bv);
      }
      d3.geo.stream = function(object, listener) {
        if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
          d3_geo_streamObjectType[object.type](object, listener);
        } else {
          d3_geo_streamGeometry(object, listener);
        }
      };
      function d3_geo_streamGeometry(geometry, listener) {
        if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
          d3_geo_streamGeometryType[geometry.type](geometry, listener);
        }
      }
      var d3_geo_streamObjectType = {
        Feature: function(feature, listener) {
          d3_geo_streamGeometry(feature.geometry, listener);
        },
        FeatureCollection: function(object, listener) {
          var features = object.features,
              i = -1,
              n = features.length;
          while (++i < n)
            d3_geo_streamGeometry(features[i].geometry, listener);
        }
      };
      var d3_geo_streamGeometryType = {
        Sphere: function(object, listener) {
          listener.sphere();
        },
        Point: function(object, listener) {
          object = object.coordinates;
          listener.point(object[0], object[1], object[2]);
        },
        MultiPoint: function(object, listener) {
          var coordinates = object.coordinates,
              i = -1,
              n = coordinates.length;
          while (++i < n)
            object = coordinates[i], listener.point(object[0], object[1], object[2]);
        },
        LineString: function(object, listener) {
          d3_geo_streamLine(object.coordinates, listener, 0);
        },
        MultiLineString: function(object, listener) {
          var coordinates = object.coordinates,
              i = -1,
              n = coordinates.length;
          while (++i < n)
            d3_geo_streamLine(coordinates[i], listener, 0);
        },
        Polygon: function(object, listener) {
          d3_geo_streamPolygon(object.coordinates, listener);
        },
        MultiPolygon: function(object, listener) {
          var coordinates = object.coordinates,
              i = -1,
              n = coordinates.length;
          while (++i < n)
            d3_geo_streamPolygon(coordinates[i], listener);
        },
        GeometryCollection: function(object, listener) {
          var geometries = object.geometries,
              i = -1,
              n = geometries.length;
          while (++i < n)
            d3_geo_streamGeometry(geometries[i], listener);
        }
      };
      function d3_geo_streamLine(coordinates, listener, closed) {
        var i = -1,
            n = coordinates.length - closed,
            coordinate;
        listener.lineStart();
        while (++i < n)
          coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
        listener.lineEnd();
      }
      function d3_geo_streamPolygon(coordinates, listener) {
        var i = -1,
            n = coordinates.length;
        listener.polygonStart();
        while (++i < n)
          d3_geo_streamLine(coordinates[i], listener, 1);
        listener.polygonEnd();
      }
      d3.geo.area = function(object) {
        d3_geo_areaSum = 0;
        d3.geo.stream(object, d3_geo_area);
        return d3_geo_areaSum;
      };
      var d3_geo_areaSum,
          d3_geo_areaRingSum = new d3_adder();
      var d3_geo_area = {
        sphere: function() {
          d3_geo_areaSum += 4 * π;
        },
        point: d3_noop,
        lineStart: d3_noop,
        lineEnd: d3_noop,
        polygonStart: function() {
          d3_geo_areaRingSum.reset();
          d3_geo_area.lineStart = d3_geo_areaRingStart;
        },
        polygonEnd: function() {
          var area = 2 * d3_geo_areaRingSum;
          d3_geo_areaSum += area < 0 ? 4 * π + area : area;
          d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
        }
      };
      function d3_geo_areaRingStart() {
        var λ00,
            φ00,
            λ0,
            cosφ0,
            sinφ0;
        d3_geo_area.point = function(λ, φ) {
          d3_geo_area.point = nextPoint;
          λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), sinφ0 = Math.sin(φ);
        };
        function nextPoint(λ, φ) {
          λ *= d3_radians;
          φ = φ * d3_radians / 2 + π / 4;
          var dλ = λ - λ0,
              sdλ = dλ >= 0 ? 1 : -1,
              adλ = sdλ * dλ,
              cosφ = Math.cos(φ),
              sinφ = Math.sin(φ),
              k = sinφ0 * sinφ,
              u = cosφ0 * cosφ + k * Math.cos(adλ),
              v = k * sdλ * Math.sin(adλ);
          d3_geo_areaRingSum.add(Math.atan2(v, u));
          λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
        }
        d3_geo_area.lineEnd = function() {
          nextPoint(λ00, φ00);
        };
      }
      function d3_geo_cartesian(spherical) {
        var λ = spherical[0],
            φ = spherical[1],
            cosφ = Math.cos(φ);
        return [cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ)];
      }
      function d3_geo_cartesianDot(a, b) {
        return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
      }
      function d3_geo_cartesianCross(a, b) {
        return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
      }
      function d3_geo_cartesianAdd(a, b) {
        a[0] += b[0];
        a[1] += b[1];
        a[2] += b[2];
      }
      function d3_geo_cartesianScale(vector, k) {
        return [vector[0] * k, vector[1] * k, vector[2] * k];
      }
      function d3_geo_cartesianNormalize(d) {
        var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
        d[0] /= l;
        d[1] /= l;
        d[2] /= l;
      }
      function d3_geo_spherical(cartesian) {
        return [Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2])];
      }
      function d3_geo_sphericalEqual(a, b) {
        return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
      }
      d3.geo.bounds = function() {
        var λ0,
            φ0,
            λ1,
            φ1,
            λ_,
            λ__,
            φ__,
            p0,
            dλSum,
            ranges,
            range;
        var bound = {
          point: point,
          lineStart: lineStart,
          lineEnd: lineEnd,
          polygonStart: function() {
            bound.point = ringPoint;
            bound.lineStart = ringStart;
            bound.lineEnd = ringEnd;
            dλSum = 0;
            d3_geo_area.polygonStart();
          },
          polygonEnd: function() {
            d3_geo_area.polygonEnd();
            bound.point = point;
            bound.lineStart = lineStart;
            bound.lineEnd = lineEnd;
            if (d3_geo_areaRingSum < 0)
              λ0 = -(λ1 = 180), φ0 = -(φ1 = 90);
            else if (dλSum > ε)
              φ1 = 90;
            else if (dλSum < -ε)
              φ0 = -90;
            range[0] = λ0, range[1] = λ1;
          }
        };
        function point(λ, φ) {
          ranges.push(range = [λ0 = λ, λ1 = λ]);
          if (φ < φ0)
            φ0 = φ;
          if (φ > φ1)
            φ1 = φ;
        }
        function linePoint(λ, φ) {
          var p = d3_geo_cartesian([λ * d3_radians, φ * d3_radians]);
          if (p0) {
            var normal = d3_geo_cartesianCross(p0, p),
                equatorial = [normal[1], -normal[0], 0],
                inflection = d3_geo_cartesianCross(equatorial, normal);
            d3_geo_cartesianNormalize(inflection);
            inflection = d3_geo_spherical(inflection);
            var dλ = λ - λ_,
                s = dλ > 0 ? 1 : -1,
                λi = inflection[0] * d3_degrees * s,
                antimeridian = abs(dλ) > 180;
            if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
              var φi = inflection[1] * d3_degrees;
              if (φi > φ1)
                φ1 = φi;
            } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
              var φi = -inflection[1] * d3_degrees;
              if (φi < φ0)
                φ0 = φi;
            } else {
              if (φ < φ0)
                φ0 = φ;
              if (φ > φ1)
                φ1 = φ;
            }
            if (antimeridian) {
              if (λ < λ_) {
                if (angle(λ0, λ) > angle(λ0, λ1))
                  λ1 = λ;
              } else {
                if (angle(λ, λ1) > angle(λ0, λ1))
                  λ0 = λ;
              }
            } else {
              if (λ1 >= λ0) {
                if (λ < λ0)
                  λ0 = λ;
                if (λ > λ1)
                  λ1 = λ;
              } else {
                if (λ > λ_) {
                  if (angle(λ0, λ) > angle(λ0, λ1))
                    λ1 = λ;
                } else {
                  if (angle(λ, λ1) > angle(λ0, λ1))
                    λ0 = λ;
                }
              }
            }
          } else {
            point(λ, φ);
          }
          p0 = p, λ_ = λ;
        }
        function lineStart() {
          bound.point = linePoint;
        }
        function lineEnd() {
          range[0] = λ0, range[1] = λ1;
          bound.point = point;
          p0 = null;
        }
        function ringPoint(λ, φ) {
          if (p0) {
            var dλ = λ - λ_;
            dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
          } else
            λ__ = λ, φ__ = φ;
          d3_geo_area.point(λ, φ);
          linePoint(λ, φ);
        }
        function ringStart() {
          d3_geo_area.lineStart();
        }
        function ringEnd() {
          ringPoint(λ__, φ__);
          d3_geo_area.lineEnd();
          if (abs(dλSum) > ε)
            λ0 = -(λ1 = 180);
          range[0] = λ0, range[1] = λ1;
          p0 = null;
        }
        function angle(λ0, λ1) {
          return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
        }
        function compareRanges(a, b) {
          return a[0] - b[0];
        }
        function withinRange(x, range) {
          return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
        }
        return function(feature) {
          φ1 = λ1 = -(λ0 = φ0 = Infinity);
          ranges = [];
          d3.geo.stream(feature, bound);
          var n = ranges.length;
          if (n) {
            ranges.sort(compareRanges);
            for (var i = 1,
                a = ranges[0],
                b,
                merged = [a]; i < n; ++i) {
              b = ranges[i];
              if (withinRange(b[0], a) || withinRange(b[1], a)) {
                if (angle(a[0], b[1]) > angle(a[0], a[1]))
                  a[1] = b[1];
                if (angle(b[0], a[1]) > angle(a[0], a[1]))
                  a[0] = b[0];
              } else {
                merged.push(a = b);
              }
            }
            var best = -Infinity,
                dλ;
            for (var n = merged.length - 1,
                i = 0,
                a = merged[n],
                b; i <= n; a = b, ++i) {
              b = merged[i];
              if ((dλ = angle(a[1], b[0])) > best)
                best = dλ, λ0 = b[0], λ1 = a[1];
            }
          }
          ranges = range = null;
          return λ0 === Infinity || φ0 === Infinity ? [[NaN, NaN], [NaN, NaN]] : [[λ0, φ0], [λ1, φ1]];
        };
      }();
      d3.geo.centroid = function(object) {
        d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
        d3.geo.stream(object, d3_geo_centroid);
        var x = d3_geo_centroidX2,
            y = d3_geo_centroidY2,
            z = d3_geo_centroidZ2,
            m = x * x + y * y + z * z;
        if (m < ε2) {
          x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
          if (d3_geo_centroidW1 < ε)
            x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
          m = x * x + y * y + z * z;
          if (m < ε2)
            return [NaN, NaN];
        }
        return [Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees];
      };
      var d3_geo_centroidW0,
          d3_geo_centroidW1,
          d3_geo_centroidX0,
          d3_geo_centroidY0,
          d3_geo_centroidZ0,
          d3_geo_centroidX1,
          d3_geo_centroidY1,
          d3_geo_centroidZ1,
          d3_geo_centroidX2,
          d3_geo_centroidY2,
          d3_geo_centroidZ2;
      var d3_geo_centroid = {
        sphere: d3_noop,
        point: d3_geo_centroidPoint,
        lineStart: d3_geo_centroidLineStart,
        lineEnd: d3_geo_centroidLineEnd,
        polygonStart: function() {
          d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
        },
        polygonEnd: function() {
          d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
        }
      };
      function d3_geo_centroidPoint(λ, φ) {
        λ *= d3_radians;
        var cosφ = Math.cos(φ *= d3_radians);
        d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
      }
      function d3_geo_centroidPointXYZ(x, y, z) {
        ++d3_geo_centroidW0;
        d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
        d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
        d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
      }
      function d3_geo_centroidLineStart() {
        var x0,
            y0,
            z0;
        d3_geo_centroid.point = function(λ, φ) {
          λ *= d3_radians;
          var cosφ = Math.cos(φ *= d3_radians);
          x0 = cosφ * Math.cos(λ);
          y0 = cosφ * Math.sin(λ);
          z0 = Math.sin(φ);
          d3_geo_centroid.point = nextPoint;
          d3_geo_centroidPointXYZ(x0, y0, z0);
        };
        function nextPoint(λ, φ) {
          λ *= d3_radians;
          var cosφ = Math.cos(φ *= d3_radians),
              x = cosφ * Math.cos(λ),
              y = cosφ * Math.sin(λ),
              z = Math.sin(φ),
              w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
          d3_geo_centroidW1 += w;
          d3_geo_centroidX1 += w * (x0 + (x0 = x));
          d3_geo_centroidY1 += w * (y0 + (y0 = y));
          d3_geo_centroidZ1 += w * (z0 + (z0 = z));
          d3_geo_centroidPointXYZ(x0, y0, z0);
        }
      }
      function d3_geo_centroidLineEnd() {
        d3_geo_centroid.point = d3_geo_centroidPoint;
      }
      function d3_geo_centroidRingStart() {
        var λ00,
            φ00,
            x0,
            y0,
            z0;
        d3_geo_centroid.point = function(λ, φ) {
          λ00 = λ, φ00 = φ;
          d3_geo_centroid.point = nextPoint;
          λ *= d3_radians;
          var cosφ = Math.cos(φ *= d3_radians);
          x0 = cosφ * Math.cos(λ);
          y0 = cosφ * Math.sin(λ);
          z0 = Math.sin(φ);
          d3_geo_centroidPointXYZ(x0, y0, z0);
        };
        d3_geo_centroid.lineEnd = function() {
          nextPoint(λ00, φ00);
          d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
          d3_geo_centroid.point = d3_geo_centroidPoint;
        };
        function nextPoint(λ, φ) {
          λ *= d3_radians;
          var cosφ = Math.cos(φ *= d3_radians),
              x = cosφ * Math.cos(λ),
              y = cosφ * Math.sin(λ),
              z = Math.sin(φ),
              cx = y0 * z - z0 * y,
              cy = z0 * x - x0 * z,
              cz = x0 * y - y0 * x,
              m = Math.sqrt(cx * cx + cy * cy + cz * cz),
              u = x0 * x + y0 * y + z0 * z,
              v = m && -d3_acos(u) / m,
              w = Math.atan2(m, u);
          d3_geo_centroidX2 += v * cx;
          d3_geo_centroidY2 += v * cy;
          d3_geo_centroidZ2 += v * cz;
          d3_geo_centroidW1 += w;
          d3_geo_centroidX1 += w * (x0 + (x0 = x));
          d3_geo_centroidY1 += w * (y0 + (y0 = y));
          d3_geo_centroidZ1 += w * (z0 + (z0 = z));
          d3_geo_centroidPointXYZ(x0, y0, z0);
        }
      }
      function d3_geo_compose(a, b) {
        function compose(x, y) {
          return x = a(x, y), b(x[0], x[1]);
        }
        if (a.invert && b.invert)
          compose.invert = function(x, y) {
            return x = b.invert(x, y), x && a.invert(x[0], x[1]);
          };
        return compose;
      }
      function d3_true() {
        return true;
      }
      function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
        var subject = [],
            clip = [];
        segments.forEach(function(segment) {
          if ((n = segment.length - 1) <= 0)
            return;
          var n,
              p0 = segment[0],
              p1 = segment[n];
          if (d3_geo_sphericalEqual(p0, p1)) {
            listener.lineStart();
            for (var i = 0; i < n; ++i)
              listener.point((p0 = segment[i])[0], p0[1]);
            listener.lineEnd();
            return;
          }
          var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true),
              b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
          a.o = b;
          subject.push(a);
          clip.push(b);
          a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
          b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
          a.o = b;
          subject.push(a);
          clip.push(b);
        });
        clip.sort(compare);
        d3_geo_clipPolygonLinkCircular(subject);
        d3_geo_clipPolygonLinkCircular(clip);
        if (!subject.length)
          return;
        for (var i = 0,
            entry = clipStartInside,
            n = clip.length; i < n; ++i) {
          clip[i].e = entry = !entry;
        }
        var start = subject[0],
            points,
            point;
        while (1) {
          var current = start,
              isSubject = true;
          while (current.v)
            if ((current = current.n) === start)
              return;
          points = current.z;
          listener.lineStart();
          do {
            current.v = current.o.v = true;
            if (current.e) {
              if (isSubject) {
                for (var i = 0,
                    n = points.length; i < n; ++i)
                  listener.point((point = points[i])[0], point[1]);
              } else {
                interpolate(current.x, current.n.x, 1, listener);
              }
              current = current.n;
            } else {
              if (isSubject) {
                points = current.p.z;
                for (var i = points.length - 1; i >= 0; --i)
                  listener.point((point = points[i])[0], point[1]);
              } else {
                interpolate(current.x, current.p.x, -1, listener);
              }
              current = current.p;
            }
            current = current.o;
            points = current.z;
            isSubject = !isSubject;
          } while (!current.v);
          listener.lineEnd();
        }
      }
      function d3_geo_clipPolygonLinkCircular(array) {
        if (!(n = array.length))
          return;
        var n,
            i = 0,
            a = array[0],
            b;
        while (++i < n) {
          a.n = b = array[i];
          b.p = a;
          a = b;
        }
        a.n = b = array[0];
        b.p = a;
      }
      function d3_geo_clipPolygonIntersection(point, points, other, entry) {
        this.x = point;
        this.z = points;
        this.o = other;
        this.e = entry;
        this.v = false;
        this.n = this.p = null;
      }
      function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
        return function(rotate, listener) {
          var line = clipLine(listener),
              rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
          var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
              clip.point = pointRing;
              clip.lineStart = ringStart;
              clip.lineEnd = ringEnd;
              segments = [];
              polygon = [];
            },
            polygonEnd: function() {
              clip.point = point;
              clip.lineStart = lineStart;
              clip.lineEnd = lineEnd;
              segments = d3.merge(segments);
              var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
              if (segments.length) {
                if (!polygonStarted)
                  listener.polygonStart(), polygonStarted = true;
                d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
              } else if (clipStartInside) {
                if (!polygonStarted)
                  listener.polygonStart(), polygonStarted = true;
                listener.lineStart();
                interpolate(null, null, 1, listener);
                listener.lineEnd();
              }
              if (polygonStarted)
                listener.polygonEnd(), polygonStarted = false;
              segments = polygon = null;
            },
            sphere: function() {
              listener.polygonStart();
              listener.lineStart();
              interpolate(null, null, 1, listener);
              listener.lineEnd();
              listener.polygonEnd();
            }
          };
          function point(λ, φ) {
            var point = rotate(λ, φ);
            if (pointVisible(λ = point[0], φ = point[1]))
              listener.point(λ, φ);
          }
          function pointLine(λ, φ) {
            var point = rotate(λ, φ);
            line.point(point[0], point[1]);
          }
          function lineStart() {
            clip.point = pointLine;
            line.lineStart();
          }
          function lineEnd() {
            clip.point = point;
            line.lineEnd();
          }
          var segments;
          var buffer = d3_geo_clipBufferListener(),
              ringListener = clipLine(buffer),
              polygonStarted = false,
              polygon,
              ring;
          function pointRing(λ, φ) {
            ring.push([λ, φ]);
            var point = rotate(λ, φ);
            ringListener.point(point[0], point[1]);
          }
          function ringStart() {
            ringListener.lineStart();
            ring = [];
          }
          function ringEnd() {
            pointRing(ring[0][0], ring[0][1]);
            ringListener.lineEnd();
            var clean = ringListener.clean(),
                ringSegments = buffer.buffer(),
                segment,
                n = ringSegments.length;
            ring.pop();
            polygon.push(ring);
            ring = null;
            if (!n)
              return;
            if (clean & 1) {
              segment = ringSegments[0];
              var n = segment.length - 1,
                  i = -1,
                  point;
              if (n > 0) {
                if (!polygonStarted)
                  listener.polygonStart(), polygonStarted = true;
                listener.lineStart();
                while (++i < n)
                  listener.point((point = segment[i])[0], point[1]);
                listener.lineEnd();
              }
              return;
            }
            if (n > 1 && clean & 2)
              ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
            segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
          }
          return clip;
        };
      }
      function d3_geo_clipSegmentLength1(segment) {
        return segment.length > 1;
      }
      function d3_geo_clipBufferListener() {
        var lines = [],
            line;
        return {
          lineStart: function() {
            lines.push(line = []);
          },
          point: function(λ, φ) {
            line.push([λ, φ]);
          },
          lineEnd: d3_noop,
          buffer: function() {
            var buffer = lines;
            lines = [];
            line = null;
            return buffer;
          },
          rejoin: function() {
            if (lines.length > 1)
              lines.push(lines.pop().concat(lines.shift()));
          }
        };
      }
      function d3_geo_clipSort(a, b) {
        return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
      }
      var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [-π, -π / 2]);
      function d3_geo_clipAntimeridianLine(listener) {
        var λ0 = NaN,
            φ0 = NaN,
            sλ0 = NaN,
            clean;
        return {
          lineStart: function() {
            listener.lineStart();
            clean = 1;
          },
          point: function(λ1, φ1) {
            var sλ1 = λ1 > 0 ? π : -π,
                dλ = abs(λ1 - λ0);
            if (abs(dλ - π) < ε) {
              listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
              listener.point(sλ0, φ0);
              listener.lineEnd();
              listener.lineStart();
              listener.point(sλ1, φ0);
              listener.point(λ1, φ0);
              clean = 0;
            } else if (sλ0 !== sλ1 && dλ >= π) {
              if (abs(λ0 - sλ0) < ε)
                λ0 -= sλ0 * ε;
              if (abs(λ1 - sλ1) < ε)
                λ1 -= sλ1 * ε;
              φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
              listener.point(sλ0, φ0);
              listener.lineEnd();
              listener.lineStart();
              listener.point(sλ1, φ0);
              clean = 0;
            }
            listener.point(λ0 = λ1, φ0 = φ1);
            sλ0 = sλ1;
          },
          lineEnd: function() {
            listener.lineEnd();
            λ0 = φ0 = NaN;
          },
          clean: function() {
            return 2 - clean;
          }
        };
      }
      function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
        var cosφ0,
            cosφ1,
            sinλ0_λ1 = Math.sin(λ0 - λ1);
        return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
      }
      function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
        var φ;
        if (from == null) {
          φ = direction * halfπ;
          listener.point(-π, φ);
          listener.point(0, φ);
          listener.point(π, φ);
          listener.point(π, 0);
          listener.point(π, -φ);
          listener.point(0, -φ);
          listener.point(-π, -φ);
          listener.point(-π, 0);
          listener.point(-π, φ);
        } else if (abs(from[0] - to[0]) > ε) {
          var s = from[0] < to[0] ? π : -π;
          φ = direction * s / 2;
          listener.point(-s, φ);
          listener.point(0, φ);
          listener.point(s, φ);
        } else {
          listener.point(to[0], to[1]);
        }
      }
      function d3_geo_pointInPolygon(point, polygon) {
        var meridian = point[0],
            parallel = point[1],
            meridianNormal = [Math.sin(meridian), -Math.cos(meridian), 0],
            polarAngle = 0,
            winding = 0;
        d3_geo_areaRingSum.reset();
        for (var i = 0,
            n = polygon.length; i < n; ++i) {
          var ring = polygon[i],
              m = ring.length;
          if (!m)
            continue;
          var point0 = ring[0],
              λ0 = point0[0],
              φ0 = point0[1] / 2 + π / 4,
              sinφ0 = Math.sin(φ0),
              cosφ0 = Math.cos(φ0),
              j = 1;
          while (true) {
            if (j === m)
              j = 0;
            point = ring[j];
            var λ = point[0],
                φ = point[1] / 2 + π / 4,
                sinφ = Math.sin(φ),
                cosφ = Math.cos(φ),
                dλ = λ - λ0,
                sdλ = dλ >= 0 ? 1 : -1,
                adλ = sdλ * dλ,
                antimeridian = adλ > π,
                k = sinφ0 * sinφ;
            d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
            polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
            if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
              var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
              d3_geo_cartesianNormalize(arc);
              var intersection = d3_geo_cartesianCross(meridianNormal, arc);
              d3_geo_cartesianNormalize(intersection);
              var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
              if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
                winding += antimeridian ^ dλ >= 0 ? 1 : -1;
              }
            }
            if (!j++)
              break;
            λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
          }
        }
        return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < 0) ^ winding & 1;
      }
      function d3_geo_clipCircle(radius) {
        var cr = Math.cos(radius),
            smallRadius = cr > 0,
            notHemisphere = abs(cr) > ε,
            interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
        return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-π, radius - π]);
        function visible(λ, φ) {
          return Math.cos(λ) * Math.cos(φ) > cr;
        }
        function clipLine(listener) {
          var point0,
              c0,
              v0,
              v00,
              clean;
          return {
            lineStart: function() {
              v00 = v0 = false;
              clean = 1;
            },
            point: function(λ, φ) {
              var point1 = [λ, φ],
                  point2,
                  v = visible(λ, φ),
                  c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
              if (!point0 && (v00 = v0 = v))
                listener.lineStart();
              if (v !== v0) {
                point2 = intersect(point0, point1);
                if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
                  point1[0] += ε;
                  point1[1] += ε;
                  v = visible(point1[0], point1[1]);
                }
              }
              if (v !== v0) {
                clean = 0;
                if (v) {
                  listener.lineStart();
                  point2 = intersect(point1, point0);
                  listener.point(point2[0], point2[1]);
                } else {
                  point2 = intersect(point0, point1);
                  listener.point(point2[0], point2[1]);
                  listener.lineEnd();
                }
                point0 = point2;
              } else if (notHemisphere && point0 && smallRadius ^ v) {
                var t;
                if (!(c & c0) && (t = intersect(point1, point0, true))) {
                  clean = 0;
                  if (smallRadius) {
                    listener.lineStart();
                    listener.point(t[0][0], t[0][1]);
                    listener.point(t[1][0], t[1][1]);
                    listener.lineEnd();
                  } else {
                    listener.point(t[1][0], t[1][1]);
                    listener.lineEnd();
                    listener.lineStart();
                    listener.point(t[0][0], t[0][1]);
                  }
                }
              }
              if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
                listener.point(point1[0], point1[1]);
              }
              point0 = point1, v0 = v, c0 = c;
            },
            lineEnd: function() {
              if (v0)
                listener.lineEnd();
              point0 = null;
            },
            clean: function() {
              return clean | (v00 && v0) << 1;
            }
          };
        }
        function intersect(a, b, two) {
          var pa = d3_geo_cartesian(a),
              pb = d3_geo_cartesian(b);
          var n1 = [1, 0, 0],
              n2 = d3_geo_cartesianCross(pa, pb),
              n2n2 = d3_geo_cartesianDot(n2, n2),
              n1n2 = n2[0],
              determinant = n2n2 - n1n2 * n1n2;
          if (!determinant)
            return !two && a;
          var c1 = cr * n2n2 / determinant,
              c2 = -cr * n1n2 / determinant,
              n1xn2 = d3_geo_cartesianCross(n1, n2),
              A = d3_geo_cartesianScale(n1, c1),
              B = d3_geo_cartesianScale(n2, c2);
          d3_geo_cartesianAdd(A, B);
          var u = n1xn2,
              w = d3_geo_cartesianDot(A, u),
              uu = d3_geo_cartesianDot(u, u),
              t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
          if (t2 < 0)
            return;
          var t = Math.sqrt(t2),
              q = d3_geo_cartesianScale(u, (-w - t) / uu);
          d3_geo_cartesianAdd(q, A);
          q = d3_geo_spherical(q);
          if (!two)
            return q;
          var λ0 = a[0],
              λ1 = b[0],
              φ0 = a[1],
              φ1 = b[1],
              z;
          if (λ1 < λ0)
            z = λ0, λ0 = λ1, λ1 = z;
          var δλ = λ1 - λ0,
              polar = abs(δλ - π) < ε,
              meridian = polar || δλ < ε;
          if (!polar && φ1 < φ0)
            z = φ0, φ0 = φ1, φ1 = z;
          if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
            var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
            d3_geo_cartesianAdd(q1, A);
            return [q, d3_geo_spherical(q1)];
          }
        }
        function code(λ, φ) {
          var r = smallRadius ? radius : π - radius,
              code = 0;
          if (λ < -r)
            code |= 1;
          else if (λ > r)
            code |= 2;
          if (φ < -r)
            code |= 4;
          else if (φ > r)
            code |= 8;
          return code;
        }
      }
      function d3_geom_clipLine(x0, y0, x1, y1) {
        return function(line) {
          var a = line.a,
              b = line.b,
              ax = a.x,
              ay = a.y,
              bx = b.x,
              by = b.y,
              t0 = 0,
              t1 = 1,
              dx = bx - ax,
              dy = by - ay,
              r;
          r = x0 - ax;
          if (!dx && r > 0)
            return;
          r /= dx;
          if (dx < 0) {
            if (r < t0)
              return;
            if (r < t1)
              t1 = r;
          } else if (dx > 0) {
            if (r > t1)
              return;
            if (r > t0)
              t0 = r;
          }
          r = x1 - ax;
          if (!dx && r < 0)
            return;
          r /= dx;
          if (dx < 0) {
            if (r > t1)
              return;
            if (r > t0)
              t0 = r;
          } else if (dx > 0) {
            if (r < t0)
              return;
            if (r < t1)
              t1 = r;
          }
          r = y0 - ay;
          if (!dy && r > 0)
            return;
          r /= dy;
          if (dy < 0) {
            if (r < t0)
              return;
            if (r < t1)
              t1 = r;
          } else if (dy > 0) {
            if (r > t1)
              return;
            if (r > t0)
              t0 = r;
          }
          r = y1 - ay;
          if (!dy && r < 0)
            return;
          r /= dy;
          if (dy < 0) {
            if (r > t1)
              return;
            if (r > t0)
              t0 = r;
          } else if (dy > 0) {
            if (r < t0)
              return;
            if (r < t1)
              t1 = r;
          }
          if (t0 > 0)
            line.a = {
              x: ax + t0 * dx,
              y: ay + t0 * dy
            };
          if (t1 < 1)
            line.b = {
              x: ax + t1 * dx,
              y: ay + t1 * dy
            };
          return line;
        };
      }
      var d3_geo_clipExtentMAX = 1e9;
      d3.geo.clipExtent = function() {
        var x0,
            y0,
            x1,
            y1,
            stream,
            clip,
            clipExtent = {
              stream: function(output) {
                if (stream)
                  stream.valid = false;
                stream = clip(output);
                stream.valid = true;
                return stream;
              },
              extent: function(_) {
                if (!arguments.length)
                  return [[x0, y0], [x1, y1]];
                clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
                if (stream)
                  stream.valid = false, stream = null;
                return clipExtent;
              }
            };
        return clipExtent.extent([[0, 0], [960, 500]]);
      };
      function d3_geo_clipExtent(x0, y0, x1, y1) {
        return function(listener) {
          var listener_ = listener,
              bufferListener = d3_geo_clipBufferListener(),
              clipLine = d3_geom_clipLine(x0, y0, x1, y1),
              segments,
              polygon,
              ring;
          var clip = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
              listener = bufferListener;
              segments = [];
              polygon = [];
              clean = true;
            },
            polygonEnd: function() {
              listener = listener_;
              segments = d3.merge(segments);
              var clipStartInside = insidePolygon([x0, y1]),
                  inside = clean && clipStartInside,
                  visible = segments.length;
              if (inside || visible) {
                listener.polygonStart();
                if (inside) {
                  listener.lineStart();
                  interpolate(null, null, 1, listener);
                  listener.lineEnd();
                }
                if (visible) {
                  d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
                }
                listener.polygonEnd();
              }
              segments = polygon = ring = null;
            }
          };
          function insidePolygon(p) {
            var wn = 0,
                n = polygon.length,
                y = p[1];
            for (var i = 0; i < n; ++i) {
              for (var j = 1,
                  v = polygon[i],
                  m = v.length,
                  a = v[0],
                  b; j < m; ++j) {
                b = v[j];
                if (a[1] <= y) {
                  if (b[1] > y && d3_cross2d(a, b, p) > 0)
                    ++wn;
                } else {
                  if (b[1] <= y && d3_cross2d(a, b, p) < 0)
                    --wn;
                }
                a = b;
              }
            }
            return wn !== 0;
          }
          function interpolate(from, to, direction, listener) {
            var a = 0,
                a1 = 0;
            if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
              do {
                listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
              } while ((a = (a + direction + 4) % 4) !== a1);
            } else {
              listener.point(to[0], to[1]);
            }
          }
          function pointVisible(x, y) {
            return x0 <= x && x <= x1 && y0 <= y && y <= y1;
          }
          function point(x, y) {
            if (pointVisible(x, y))
              listener.point(x, y);
          }
          var x__,
              y__,
              v__,
              x_,
              y_,
              v_,
              first,
              clean;
          function lineStart() {
            clip.point = linePoint;
            if (polygon)
              polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
          }
          function lineEnd() {
            if (segments) {
              linePoint(x__, y__);
              if (v__ && v_)
                bufferListener.rejoin();
              segments.push(bufferListener.buffer());
            }
            clip.point = point;
            if (v_)
              listener.lineEnd();
          }
          function linePoint(x, y) {
            x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
            y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
            var v = pointVisible(x, y);
            if (polygon)
              ring.push([x, y]);
            if (first) {
              x__ = x, y__ = y, v__ = v;
              first = false;
              if (v) {
                listener.lineStart();
                listener.point(x, y);
              }
            } else {
              if (v && v_)
                listener.point(x, y);
              else {
                var l = {
                  a: {
                    x: x_,
                    y: y_
                  },
                  b: {
                    x: x,
                    y: y
                  }
                };
                if (clipLine(l)) {
                  if (!v_) {
                    listener.lineStart();
                    listener.point(l.a.x, l.a.y);
                  }
                  listener.point(l.b.x, l.b.y);
                  if (!v)
                    listener.lineEnd();
                  clean = false;
                } else if (v) {
                  listener.lineStart();
                  listener.point(x, y);
                  clean = false;
                }
              }
            }
            x_ = x, y_ = y, v_ = v;
          }
          return clip;
        };
        function corner(p, direction) {
          return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
        }
        function compare(a, b) {
          return comparePoints(a.x, b.x);
        }
        function comparePoints(a, b) {
          var ca = corner(a, 1),
              cb = corner(b, 1);
          return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
        }
      }
      function d3_geo_conic(projectAt) {
        var φ0 = 0,
            φ1 = π / 3,
            m = d3_geo_projectionMutator(projectAt),
            p = m(φ0, φ1);
        p.parallels = function(_) {
          if (!arguments.length)
            return [φ0 / π * 180, φ1 / π * 180];
          return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
        };
        return p;
      }
      function d3_geo_conicEqualArea(φ0, φ1) {
        var sinφ0 = Math.sin(φ0),
            n = (sinφ0 + Math.sin(φ1)) / 2,
            C = 1 + sinφ0 * (2 * n - sinφ0),
            ρ0 = Math.sqrt(C) / n;
        function forward(λ, φ) {
          var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
          return [ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ)];
        }
        forward.invert = function(x, y) {
          var ρ0_y = ρ0 - y;
          return [Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n))];
        };
        return forward;
      }
      (d3.geo.conicEqualArea = function() {
        return d3_geo_conic(d3_geo_conicEqualArea);
      }).raw = d3_geo_conicEqualArea;
      d3.geo.albers = function() {
        return d3.geo.conicEqualArea().rotate([96, 0]).center([-.6, 38.7]).parallels([29.5, 45.5]).scale(1070);
      };
      d3.geo.albersUsa = function() {
        var lower48 = d3.geo.albers();
        var alaska = d3.geo.conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]);
        var hawaii = d3.geo.conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]);
        var point,
            pointStream = {point: function(x, y) {
                point = [x, y];
              }},
            lower48Point,
            alaskaPoint,
            hawaiiPoint;
        function albersUsa(coordinates) {
          var x = coordinates[0],
              y = coordinates[1];
          point = null;
          (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
          return point;
        }
        albersUsa.invert = function(coordinates) {
          var k = lower48.scale(),
              t = lower48.translate(),
              x = (coordinates[0] - t[0]) / k,
              y = (coordinates[1] - t[1]) / k;
          return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
        };
        albersUsa.stream = function(stream) {
          var lower48Stream = lower48.stream(stream),
              alaskaStream = alaska.stream(stream),
              hawaiiStream = hawaii.stream(stream);
          return {
            point: function(x, y) {
              lower48Stream.point(x, y);
              alaskaStream.point(x, y);
              hawaiiStream.point(x, y);
            },
            sphere: function() {
              lower48Stream.sphere();
              alaskaStream.sphere();
              hawaiiStream.sphere();
            },
            lineStart: function() {
              lower48Stream.lineStart();
              alaskaStream.lineStart();
              hawaiiStream.lineStart();
            },
            lineEnd: function() {
              lower48Stream.lineEnd();
              alaskaStream.lineEnd();
              hawaiiStream.lineEnd();
            },
            polygonStart: function() {
              lower48Stream.polygonStart();
              alaskaStream.polygonStart();
              hawaiiStream.polygonStart();
            },
            polygonEnd: function() {
              lower48Stream.polygonEnd();
              alaskaStream.polygonEnd();
              hawaiiStream.polygonEnd();
            }
          };
        };
        albersUsa.precision = function(_) {
          if (!arguments.length)
            return lower48.precision();
          lower48.precision(_);
          alaska.precision(_);
          hawaii.precision(_);
          return albersUsa;
        };
        albersUsa.scale = function(_) {
          if (!arguments.length)
            return lower48.scale();
          lower48.scale(_);
          alaska.scale(_ * .35);
          hawaii.scale(_);
          return albersUsa.translate(lower48.translate());
        };
        albersUsa.translate = function(_) {
          if (!arguments.length)
            return lower48.translate();
          var k = lower48.scale(),
              x = +_[0],
              y = +_[1];
          lower48Point = lower48.translate(_).clipExtent([[x - .455 * k, y - .238 * k], [x + .455 * k, y + .238 * k]]).stream(pointStream).point;
          alaskaPoint = alaska.translate([x - .307 * k, y + .201 * k]).clipExtent([[x - .425 * k + ε, y + .12 * k + ε], [x - .214 * k - ε, y + .234 * k - ε]]).stream(pointStream).point;
          hawaiiPoint = hawaii.translate([x - .205 * k, y + .212 * k]).clipExtent([[x - .214 * k + ε, y + .166 * k + ε], [x - .115 * k - ε, y + .234 * k - ε]]).stream(pointStream).point;
          return albersUsa;
        };
        return albersUsa.scale(1070);
      };
      var d3_geo_pathAreaSum,
          d3_geo_pathAreaPolygon,
          d3_geo_pathArea = {
            point: d3_noop,
            lineStart: d3_noop,
            lineEnd: d3_noop,
            polygonStart: function() {
              d3_geo_pathAreaPolygon = 0;
              d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
            },
            polygonEnd: function() {
              d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
              d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
            }
          };
      function d3_geo_pathAreaRingStart() {
        var x00,
            y00,
            x0,
            y0;
        d3_geo_pathArea.point = function(x, y) {
          d3_geo_pathArea.point = nextPoint;
          x00 = x0 = x, y00 = y0 = y;
        };
        function nextPoint(x, y) {
          d3_geo_pathAreaPolygon += y0 * x - x0 * y;
          x0 = x, y0 = y;
        }
        d3_geo_pathArea.lineEnd = function() {
          nextPoint(x00, y00);
        };
      }
      var d3_geo_pathBoundsX0,
          d3_geo_pathBoundsY0,
          d3_geo_pathBoundsX1,
          d3_geo_pathBoundsY1;
      var d3_geo_pathBounds = {
        point: d3_geo_pathBoundsPoint,
        lineStart: d3_noop,
        lineEnd: d3_noop,
        polygonStart: d3_noop,
        polygonEnd: d3_noop
      };
      function d3_geo_pathBoundsPoint(x, y) {
        if (x < d3_geo_pathBoundsX0)
          d3_geo_pathBoundsX0 = x;
        if (x > d3_geo_pathBoundsX1)
          d3_geo_pathBoundsX1 = x;
        if (y < d3_geo_pathBoundsY0)
          d3_geo_pathBoundsY0 = y;
        if (y > d3_geo_pathBoundsY1)
          d3_geo_pathBoundsY1 = y;
      }
      function d3_geo_pathBuffer() {
        var pointCircle = d3_geo_pathBufferCircle(4.5),
            buffer = [];
        var stream = {
          point: point,
          lineStart: function() {
            stream.point = pointLineStart;
          },
          lineEnd: lineEnd,
          polygonStart: function() {
            stream.lineEnd = lineEndPolygon;
          },
          polygonEnd: function() {
            stream.lineEnd = lineEnd;
            stream.point = point;
          },
          pointRadius: function(_) {
            pointCircle = d3_geo_pathBufferCircle(_);
            return stream;
          },
          result: function() {
            if (buffer.length) {
              var result = buffer.join("");
              buffer = [];
              return result;
            }
          }
        };
        function point(x, y) {
          buffer.push("M", x, ",", y, pointCircle);
        }
        function pointLineStart(x, y) {
          buffer.push("M", x, ",", y);
          stream.point = pointLine;
        }
        function pointLine(x, y) {
          buffer.push("L", x, ",", y);
        }
        function lineEnd() {
          stream.point = point;
        }
        function lineEndPolygon() {
          buffer.push("Z");
        }
        return stream;
      }
      function d3_geo_pathBufferCircle(radius) {
        return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
      }
      var d3_geo_pathCentroid = {
        point: d3_geo_pathCentroidPoint,
        lineStart: d3_geo_pathCentroidLineStart,
        lineEnd: d3_geo_pathCentroidLineEnd,
        polygonStart: function() {
          d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
        },
        polygonEnd: function() {
          d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
          d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
          d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
        }
      };
      function d3_geo_pathCentroidPoint(x, y) {
        d3_geo_centroidX0 += x;
        d3_geo_centroidY0 += y;
        ++d3_geo_centroidZ0;
      }
      function d3_geo_pathCentroidLineStart() {
        var x0,
            y0;
        d3_geo_pathCentroid.point = function(x, y) {
          d3_geo_pathCentroid.point = nextPoint;
          d3_geo_pathCentroidPoint(x0 = x, y0 = y);
        };
        function nextPoint(x, y) {
          var dx = x - x0,
              dy = y - y0,
              z = Math.sqrt(dx * dx + dy * dy);
          d3_geo_centroidX1 += z * (x0 + x) / 2;
          d3_geo_centroidY1 += z * (y0 + y) / 2;
          d3_geo_centroidZ1 += z;
          d3_geo_pathCentroidPoint(x0 = x, y0 = y);
        }
      }
      function d3_geo_pathCentroidLineEnd() {
        d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
      }
      function d3_geo_pathCentroidRingStart() {
        var x00,
            y00,
            x0,
            y0;
        d3_geo_pathCentroid.point = function(x, y) {
          d3_geo_pathCentroid.point = nextPoint;
          d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
        };
        function nextPoint(x, y) {
          var dx = x - x0,
              dy = y - y0,
              z = Math.sqrt(dx * dx + dy * dy);
          d3_geo_centroidX1 += z * (x0 + x) / 2;
          d3_geo_centroidY1 += z * (y0 + y) / 2;
          d3_geo_centroidZ1 += z;
          z = y0 * x - x0 * y;
          d3_geo_centroidX2 += z * (x0 + x);
          d3_geo_centroidY2 += z * (y0 + y);
          d3_geo_centroidZ2 += z * 3;
          d3_geo_pathCentroidPoint(x0 = x, y0 = y);
        }
        d3_geo_pathCentroid.lineEnd = function() {
          nextPoint(x00, y00);
        };
      }
      function d3_geo_pathContext(context) {
        var pointRadius = 4.5;
        var stream = {
          point: point,
          lineStart: function() {
            stream.point = pointLineStart;
          },
          lineEnd: lineEnd,
          polygonStart: function() {
            stream.lineEnd = lineEndPolygon;
          },
          polygonEnd: function() {
            stream.lineEnd = lineEnd;
            stream.point = point;
          },
          pointRadius: function(_) {
            pointRadius = _;
            return stream;
          },
          result: d3_noop
        };
        function point(x, y) {
          context.moveTo(x + pointRadius, y);
          context.arc(x, y, pointRadius, 0, τ);
        }
        function pointLineStart(x, y) {
          context.moveTo(x, y);
          stream.point = pointLine;
        }
        function pointLine(x, y) {
          context.lineTo(x, y);
        }
        function lineEnd() {
          stream.point = point;
        }
        function lineEndPolygon() {
          context.closePath();
        }
        return stream;
      }
      function d3_geo_resample(project) {
        var δ2 = .5,
            cosMinDistance = Math.cos(30 * d3_radians),
            maxDepth = 16;
        function resample(stream) {
          return (maxDepth ? resampleRecursive : resampleNone)(stream);
        }
        function resampleNone(stream) {
          return d3_geo_transformPoint(stream, function(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
          });
        }
        function resampleRecursive(stream) {
          var λ00,
              φ00,
              x00,
              y00,
              a00,
              b00,
              c00,
              λ0,
              x0,
              y0,
              a0,
              b0,
              c0;
          var resample = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
              stream.polygonStart();
              resample.lineStart = ringStart;
            },
            polygonEnd: function() {
              stream.polygonEnd();
              resample.lineStart = lineStart;
            }
          };
          function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
          }
          function lineStart() {
            x0 = NaN;
            resample.point = linePoint;
            stream.lineStart();
          }
          function linePoint(λ, φ) {
            var c = d3_geo_cartesian([λ, φ]),
                p = project(λ, φ);
            resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
            stream.point(x0, y0);
          }
          function lineEnd() {
            resample.point = point;
            stream.lineEnd();
          }
          function ringStart() {
            lineStart();
            resample.point = ringPoint;
            resample.lineEnd = ringEnd;
          }
          function ringPoint(λ, φ) {
            linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resample.point = linePoint;
          }
          function ringEnd() {
            resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
            resample.lineEnd = lineEnd;
            lineEnd();
          }
          return resample;
        }
        function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
          var dx = x1 - x0,
              dy = y1 - y0,
              d2 = dx * dx + dy * dy;
          if (d2 > 4 * δ2 && depth--) {
            var a = a0 + a1,
                b = b0 + b1,
                c = c0 + c1,
                m = Math.sqrt(a * a + b * b + c * c),
                φ2 = Math.asin(c /= m),
                λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a),
                p = project(λ2, φ2),
                x2 = p[0],
                y2 = p[1],
                dx2 = x2 - x0,
                dy2 = y2 - y0,
                dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
              resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
              stream.point(x2, y2);
              resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
            }
          }
        }
        resample.precision = function(_) {
          if (!arguments.length)
            return Math.sqrt(δ2);
          maxDepth = (δ2 = _ * _) > 0 && 16;
          return resample;
        };
        return resample;
      }
      d3.geo.path = function() {
        var pointRadius = 4.5,
            projection,
            context,
            projectStream,
            contextStream,
            cacheStream;
        function path(object) {
          if (object) {
            if (typeof pointRadius === "function")
              contextStream.pointRadius(+pointRadius.apply(this, arguments));
            if (!cacheStream || !cacheStream.valid)
              cacheStream = projectStream(contextStream);
            d3.geo.stream(object, cacheStream);
          }
          return contextStream.result();
        }
        path.area = function(object) {
          d3_geo_pathAreaSum = 0;
          d3.geo.stream(object, projectStream(d3_geo_pathArea));
          return d3_geo_pathAreaSum;
        };
        path.centroid = function(object) {
          d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
          d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
          return d3_geo_centroidZ2 ? [d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2] : d3_geo_centroidZ1 ? [d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1] : d3_geo_centroidZ0 ? [d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0] : [NaN, NaN];
        };
        path.bounds = function(object) {
          d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
          d3.geo.stream(object, projectStream(d3_geo_pathBounds));
          return [[d3_geo_pathBoundsX0, d3_geo_pathBoundsY0], [d3_geo_pathBoundsX1, d3_geo_pathBoundsY1]];
        };
        path.projection = function(_) {
          if (!arguments.length)
            return projection;
          projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
          return reset();
        };
        path.context = function(_) {
          if (!arguments.length)
            return context;
          contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
          if (typeof pointRadius !== "function")
            contextStream.pointRadius(pointRadius);
          return reset();
        };
        path.pointRadius = function(_) {
          if (!arguments.length)
            return pointRadius;
          pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
          return path;
        };
        function reset() {
          cacheStream = null;
          return path;
        }
        return path.projection(d3.geo.albersUsa()).context(null);
      };
      function d3_geo_pathProjectStream(project) {
        var resample = d3_geo_resample(function(x, y) {
          return project([x * d3_degrees, y * d3_degrees]);
        });
        return function(stream) {
          return d3_geo_projectionRadians(resample(stream));
        };
      }
      d3.geo.transform = function(methods) {
        return {stream: function(stream) {
            var transform = new d3_geo_transform(stream);
            for (var k in methods)
              transform[k] = methods[k];
            return transform;
          }};
      };
      function d3_geo_transform(stream) {
        this.stream = stream;
      }
      d3_geo_transform.prototype = {
        point: function(x, y) {
          this.stream.point(x, y);
        },
        sphere: function() {
          this.stream.sphere();
        },
        lineStart: function() {
          this.stream.lineStart();
        },
        lineEnd: function() {
          this.stream.lineEnd();
        },
        polygonStart: function() {
          this.stream.polygonStart();
        },
        polygonEnd: function() {
          this.stream.polygonEnd();
        }
      };
      function d3_geo_transformPoint(stream, point) {
        return {
          point: point,
          sphere: function() {
            stream.sphere();
          },
          lineStart: function() {
            stream.lineStart();
          },
          lineEnd: function() {
            stream.lineEnd();
          },
          polygonStart: function() {
            stream.polygonStart();
          },
          polygonEnd: function() {
            stream.polygonEnd();
          }
        };
      }
      d3.geo.projection = d3_geo_projection;
      d3.geo.projectionMutator = d3_geo_projectionMutator;
      function d3_geo_projection(project) {
        return d3_geo_projectionMutator(function() {
          return project;
        })();
      }
      function d3_geo_projectionMutator(projectAt) {
        var project,
            rotate,
            projectRotate,
            projectResample = d3_geo_resample(function(x, y) {
              x = project(x, y);
              return [x[0] * k + δx, δy - x[1] * k];
            }),
            k = 150,
            x = 480,
            y = 250,
            λ = 0,
            φ = 0,
            δλ = 0,
            δφ = 0,
            δγ = 0,
            δx,
            δy,
            preclip = d3_geo_clipAntimeridian,
            postclip = d3_identity,
            clipAngle = null,
            clipExtent = null,
            stream;
        function projection(point) {
          point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
          return [point[0] * k + δx, δy - point[1] * k];
        }
        function invert(point) {
          point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
          return point && [point[0] * d3_degrees, point[1] * d3_degrees];
        }
        projection.stream = function(output) {
          if (stream)
            stream.valid = false;
          stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
          stream.valid = true;
          return stream;
        };
        projection.clipAngle = function(_) {
          if (!arguments.length)
            return clipAngle;
          preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
          return invalidate();
        };
        projection.clipExtent = function(_) {
          if (!arguments.length)
            return clipExtent;
          clipExtent = _;
          postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
          return invalidate();
        };
        projection.scale = function(_) {
          if (!arguments.length)
            return k;
          k = +_;
          return reset();
        };
        projection.translate = function(_) {
          if (!arguments.length)
            return [x, y];
          x = +_[0];
          y = +_[1];
          return reset();
        };
        projection.center = function(_) {
          if (!arguments.length)
            return [λ * d3_degrees, φ * d3_degrees];
          λ = _[0] % 360 * d3_radians;
          φ = _[1] % 360 * d3_radians;
          return reset();
        };
        projection.rotate = function(_) {
          if (!arguments.length)
            return [δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees];
          δλ = _[0] % 360 * d3_radians;
          δφ = _[1] % 360 * d3_radians;
          δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
          return reset();
        };
        d3.rebind(projection, projectResample, "precision");
        function reset() {
          projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
          var center = project(λ, φ);
          δx = x - center[0] * k;
          δy = y + center[1] * k;
          return invalidate();
        }
        function invalidate() {
          if (stream)
            stream.valid = false, stream = null;
          return projection;
        }
        return function() {
          project = projectAt.apply(this, arguments);
          projection.invert = project.invert && invert;
          return reset();
        };
      }
      function d3_geo_projectionRadians(stream) {
        return d3_geo_transformPoint(stream, function(x, y) {
          stream.point(x * d3_radians, y * d3_radians);
        });
      }
      function d3_geo_equirectangular(λ, φ) {
        return [λ, φ];
      }
      (d3.geo.equirectangular = function() {
        return d3_geo_projection(d3_geo_equirectangular);
      }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
      d3.geo.rotation = function(rotate) {
        rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
        function forward(coordinates) {
          coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
          return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
        }
        forward.invert = function(coordinates) {
          coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
          return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
        };
        return forward;
      };
      function d3_geo_identityRotation(λ, φ) {
        return [λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ];
      }
      d3_geo_identityRotation.invert = d3_geo_equirectangular;
      function d3_geo_rotation(δλ, δφ, δγ) {
        return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
      }
      function d3_geo_forwardRotationλ(δλ) {
        return function(λ, φ) {
          return λ += δλ, [λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ];
        };
      }
      function d3_geo_rotationλ(δλ) {
        var rotation = d3_geo_forwardRotationλ(δλ);
        rotation.invert = d3_geo_forwardRotationλ(-δλ);
        return rotation;
      }
      function d3_geo_rotationφγ(δφ, δγ) {
        var cosδφ = Math.cos(δφ),
            sinδφ = Math.sin(δφ),
            cosδγ = Math.cos(δγ),
            sinδγ = Math.sin(δγ);
        function rotation(λ, φ) {
          var cosφ = Math.cos(φ),
              x = Math.cos(λ) * cosφ,
              y = Math.sin(λ) * cosφ,
              z = Math.sin(φ),
              k = z * cosδφ + x * sinδφ;
          return [Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ)];
        }
        rotation.invert = function(λ, φ) {
          var cosφ = Math.cos(φ),
              x = Math.cos(λ) * cosφ,
              y = Math.sin(λ) * cosφ,
              z = Math.sin(φ),
              k = z * cosδγ - y * sinδγ;
          return [Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ)];
        };
        return rotation;
      }
      d3.geo.circle = function() {
        var origin = [0, 0],
            angle,
            precision = 6,
            interpolate;
        function circle() {
          var center = typeof origin === "function" ? origin.apply(this, arguments) : origin,
              rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert,
              ring = [];
          interpolate(null, null, 1, {point: function(x, y) {
              ring.push(x = rotate(x, y));
              x[0] *= d3_degrees, x[1] *= d3_degrees;
            }});
          return {
            type: "Polygon",
            coordinates: [ring]
          };
        }
        circle.origin = function(x) {
          if (!arguments.length)
            return origin;
          origin = x;
          return circle;
        };
        circle.angle = function(x) {
          if (!arguments.length)
            return angle;
          interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
          return circle;
        };
        circle.precision = function(_) {
          if (!arguments.length)
            return precision;
          interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
          return circle;
        };
        return circle.angle(90);
      };
      function d3_geo_circleInterpolate(radius, precision) {
        var cr = Math.cos(radius),
            sr = Math.sin(radius);
        return function(from, to, direction, listener) {
          var step = direction * precision;
          if (from != null) {
            from = d3_geo_circleAngle(cr, from);
            to = d3_geo_circleAngle(cr, to);
            if (direction > 0 ? from < to : from > to)
              from += direction * τ;
          } else {
            from = radius + direction * τ;
            to = radius - .5 * step;
          }
          for (var point,
              t = from; direction > 0 ? t > to : t < to; t -= step) {
            listener.point((point = d3_geo_spherical([cr, -sr * Math.cos(t), -sr * Math.sin(t)]))[0], point[1]);
          }
        };
      }
      function d3_geo_circleAngle(cr, point) {
        var a = d3_geo_cartesian(point);
        a[0] -= cr;
        d3_geo_cartesianNormalize(a);
        var angle = d3_acos(-a[1]);
        return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
      }
      d3.geo.distance = function(a, b) {
        var Δλ = (b[0] - a[0]) * d3_radians,
            φ0 = a[1] * d3_radians,
            φ1 = b[1] * d3_radians,
            sinΔλ = Math.sin(Δλ),
            cosΔλ = Math.cos(Δλ),
            sinφ0 = Math.sin(φ0),
            cosφ0 = Math.cos(φ0),
            sinφ1 = Math.sin(φ1),
            cosφ1 = Math.cos(φ1),
            t;
        return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
      };
      d3.geo.graticule = function() {
        var x1,
            x0,
            X1,
            X0,
            y1,
            y0,
            Y1,
            Y0,
            dx = 10,
            dy = dx,
            DX = 90,
            DY = 360,
            x,
            y,
            X,
            Y,
            precision = 2.5;
        function graticule() {
          return {
            type: "MultiLineString",
            coordinates: lines()
          };
        }
        function lines() {
          return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
            return abs(x % DX) > ε;
          }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
            return abs(y % DY) > ε;
          }).map(y));
        }
        graticule.lines = function() {
          return lines().map(function(coordinates) {
            return {
              type: "LineString",
              coordinates: coordinates
            };
          });
        };
        graticule.outline = function() {
          return {
            type: "Polygon",
            coordinates: [X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))]
          };
        };
        graticule.extent = function(_) {
          if (!arguments.length)
            return graticule.minorExtent();
          return graticule.majorExtent(_).minorExtent(_);
        };
        graticule.majorExtent = function(_) {
          if (!arguments.length)
            return [[X0, Y0], [X1, Y1]];
          X0 = +_[0][0], X1 = +_[1][0];
          Y0 = +_[0][1], Y1 = +_[1][1];
          if (X0 > X1)
            _ = X0, X0 = X1, X1 = _;
          if (Y0 > Y1)
            _ = Y0, Y0 = Y1, Y1 = _;
          return graticule.precision(precision);
        };
        graticule.minorExtent = function(_) {
          if (!arguments.length)
            return [[x0, y0], [x1, y1]];
          x0 = +_[0][0], x1 = +_[1][0];
          y0 = +_[0][1], y1 = +_[1][1];
          if (x0 > x1)
            _ = x0, x0 = x1, x1 = _;
          if (y0 > y1)
            _ = y0, y0 = y1, y1 = _;
          return graticule.precision(precision);
        };
        graticule.step = function(_) {
          if (!arguments.length)
            return graticule.minorStep();
          return graticule.majorStep(_).minorStep(_);
        };
        graticule.majorStep = function(_) {
          if (!arguments.length)
            return [DX, DY];
          DX = +_[0], DY = +_[1];
          return graticule;
        };
        graticule.minorStep = function(_) {
          if (!arguments.length)
            return [dx, dy];
          dx = +_[0], dy = +_[1];
          return graticule;
        };
        graticule.precision = function(_) {
          if (!arguments.length)
            return precision;
          precision = +_;
          x = d3_geo_graticuleX(y0, y1, 90);
          y = d3_geo_graticuleY(x0, x1, precision);
          X = d3_geo_graticuleX(Y0, Y1, 90);
          Y = d3_geo_graticuleY(X0, X1, precision);
          return graticule;
        };
        return graticule.majorExtent([[-180, -90 + ε], [180, 90 - ε]]).minorExtent([[-180, -80 - ε], [180, 80 + ε]]);
      };
      function d3_geo_graticuleX(y0, y1, dy) {
        var y = d3.range(y0, y1 - ε, dy).concat(y1);
        return function(x) {
          return y.map(function(y) {
            return [x, y];
          });
        };
      }
      function d3_geo_graticuleY(x0, x1, dx) {
        var x = d3.range(x0, x1 - ε, dx).concat(x1);
        return function(y) {
          return x.map(function(x) {
            return [x, y];
          });
        };
      }
      function d3_source(d) {
        return d.source;
      }
      function d3_target(d) {
        return d.target;
      }
      d3.geo.greatArc = function() {
        var source = d3_source,
            source_,
            target = d3_target,
            target_;
        function greatArc() {
          return {
            type: "LineString",
            coordinates: [source_ || source.apply(this, arguments), target_ || target.apply(this, arguments)]
          };
        }
        greatArc.distance = function() {
          return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
        };
        greatArc.source = function(_) {
          if (!arguments.length)
            return source;
          source = _, source_ = typeof _ === "function" ? null : _;
          return greatArc;
        };
        greatArc.target = function(_) {
          if (!arguments.length)
            return target;
          target = _, target_ = typeof _ === "function" ? null : _;
          return greatArc;
        };
        greatArc.precision = function() {
          return arguments.length ? greatArc : 0;
        };
        return greatArc;
      };
      d3.geo.interpolate = function(source, target) {
        return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
      };
      function d3_geo_interpolate(x0, y0, x1, y1) {
        var cy0 = Math.cos(y0),
            sy0 = Math.sin(y0),
            cy1 = Math.cos(y1),
            sy1 = Math.sin(y1),
            kx0 = cy0 * Math.cos(x0),
            ky0 = cy0 * Math.sin(x0),
            kx1 = cy1 * Math.cos(x1),
            ky1 = cy1 * Math.sin(x1),
            d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))),
            k = 1 / Math.sin(d);
        var interpolate = d ? function(t) {
          var B = Math.sin(t *= d) * k,
              A = Math.sin(d - t) * k,
              x = A * kx0 + B * kx1,
              y = A * ky0 + B * ky1,
              z = A * sy0 + B * sy1;
          return [Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees];
        } : function() {
          return [x0 * d3_degrees, y0 * d3_degrees];
        };
        interpolate.distance = d;
        return interpolate;
      }
      d3.geo.length = function(object) {
        d3_geo_lengthSum = 0;
        d3.geo.stream(object, d3_geo_length);
        return d3_geo_lengthSum;
      };
      var d3_geo_lengthSum;
      var d3_geo_length = {
        sphere: d3_noop,
        point: d3_noop,
        lineStart: d3_geo_lengthLineStart,
        lineEnd: d3_noop,
        polygonStart: d3_noop,
        polygonEnd: d3_noop
      };
      function d3_geo_lengthLineStart() {
        var λ0,
            sinφ0,
            cosφ0;
        d3_geo_length.point = function(λ, φ) {
          λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
          d3_geo_length.point = nextPoint;
        };
        d3_geo_length.lineEnd = function() {
          d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
        };
        function nextPoint(λ, φ) {
          var sinφ = Math.sin(φ *= d3_radians),
              cosφ = Math.cos(φ),
              t = abs((λ *= d3_radians) - λ0),
              cosΔλ = Math.cos(t);
          d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
          λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
        }
      }
      function d3_geo_azimuthal(scale, angle) {
        function azimuthal(λ, φ) {
          var cosλ = Math.cos(λ),
              cosφ = Math.cos(φ),
              k = scale(cosλ * cosφ);
          return [k * cosφ * Math.sin(λ), k * Math.sin(φ)];
        }
        azimuthal.invert = function(x, y) {
          var ρ = Math.sqrt(x * x + y * y),
              c = angle(ρ),
              sinc = Math.sin(c),
              cosc = Math.cos(c);
          return [Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ)];
        };
        return azimuthal;
      }
      var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
        return Math.sqrt(2 / (1 + cosλcosφ));
      }, function(ρ) {
        return 2 * Math.asin(ρ / 2);
      });
      (d3.geo.azimuthalEqualArea = function() {
        return d3_geo_projection(d3_geo_azimuthalEqualArea);
      }).raw = d3_geo_azimuthalEqualArea;
      var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
        var c = Math.acos(cosλcosφ);
        return c && c / Math.sin(c);
      }, d3_identity);
      (d3.geo.azimuthalEquidistant = function() {
        return d3_geo_projection(d3_geo_azimuthalEquidistant);
      }).raw = d3_geo_azimuthalEquidistant;
      function d3_geo_conicConformal(φ0, φ1) {
        var cosφ0 = Math.cos(φ0),
            t = function(φ) {
              return Math.tan(π / 4 + φ / 2);
            },
            n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)),
            F = cosφ0 * Math.pow(t(φ0), n) / n;
        if (!n)
          return d3_geo_mercator;
        function forward(λ, φ) {
          if (F > 0) {
            if (φ < -halfπ + ε)
              φ = -halfπ + ε;
          } else {
            if (φ > halfπ - ε)
              φ = halfπ - ε;
          }
          var ρ = F / Math.pow(t(φ), n);
          return [ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ)];
        }
        forward.invert = function(x, y) {
          var ρ0_y = F - y,
              ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
          return [Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ];
        };
        return forward;
      }
      (d3.geo.conicConformal = function() {
        return d3_geo_conic(d3_geo_conicConformal);
      }).raw = d3_geo_conicConformal;
      function d3_geo_conicEquidistant(φ0, φ1) {
        var cosφ0 = Math.cos(φ0),
            n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0),
            G = cosφ0 / n + φ0;
        if (abs(n) < ε)
          return d3_geo_equirectangular;
        function forward(λ, φ) {
          var ρ = G - φ;
          return [ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ)];
        }
        forward.invert = function(x, y) {
          var ρ0_y = G - y;
          return [Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y)];
        };
        return forward;
      }
      (d3.geo.conicEquidistant = function() {
        return d3_geo_conic(d3_geo_conicEquidistant);
      }).raw = d3_geo_conicEquidistant;
      var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
        return 1 / cosλcosφ;
      }, Math.atan);
      (d3.geo.gnomonic = function() {
        return d3_geo_projection(d3_geo_gnomonic);
      }).raw = d3_geo_gnomonic;
      function d3_geo_mercator(λ, φ) {
        return [λ, Math.log(Math.tan(π / 4 + φ / 2))];
      }
      d3_geo_mercator.invert = function(x, y) {
        return [x, 2 * Math.atan(Math.exp(y)) - halfπ];
      };
      function d3_geo_mercatorProjection(project) {
        var m = d3_geo_projection(project),
            scale = m.scale,
            translate = m.translate,
            clipExtent = m.clipExtent,
            clipAuto;
        m.scale = function() {
          var v = scale.apply(m, arguments);
          return v === m ? clipAuto ? m.clipExtent(null) : m : v;
        };
        m.translate = function() {
          var v = translate.apply(m, arguments);
          return v === m ? clipAuto ? m.clipExtent(null) : m : v;
        };
        m.clipExtent = function(_) {
          var v = clipExtent.apply(m, arguments);
          if (v === m) {
            if (clipAuto = _ == null) {
              var k = π * scale(),
                  t = translate();
              clipExtent([[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]]);
            }
          } else if (clipAuto) {
            v = null;
          }
          return v;
        };
        return m.clipExtent(null);
      }
      (d3.geo.mercator = function() {
        return d3_geo_mercatorProjection(d3_geo_mercator);
      }).raw = d3_geo_mercator;
      var d3_geo_orthographic = d3_geo_azimuthal(function() {
        return 1;
      }, Math.asin);
      (d3.geo.orthographic = function() {
        return d3_geo_projection(d3_geo_orthographic);
      }).raw = d3_geo_orthographic;
      var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
        return 1 / (1 + cosλcosφ);
      }, function(ρ) {
        return 2 * Math.atan(ρ);
      });
      (d3.geo.stereographic = function() {
        return d3_geo_projection(d3_geo_stereographic);
      }).raw = d3_geo_stereographic;
      function d3_geo_transverseMercator(λ, φ) {
        return [Math.log(Math.tan(π / 4 + φ / 2)), -λ];
      }
      d3_geo_transverseMercator.invert = function(x, y) {
        return [-y, 2 * Math.atan(Math.exp(x)) - halfπ];
      };
      (d3.geo.transverseMercator = function() {
        var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator),
            center = projection.center,
            rotate = projection.rotate;
        projection.center = function(_) {
          return _ ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
        };
        projection.rotate = function(_) {
          return _ ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
        };
        return rotate([0, 0, 90]);
      }).raw = d3_geo_transverseMercator;
      d3.geom = {};
      function d3_geom_pointX(d) {
        return d[0];
      }
      function d3_geom_pointY(d) {
        return d[1];
      }
      d3.geom.hull = function(vertices) {
        var x = d3_geom_pointX,
            y = d3_geom_pointY;
        if (arguments.length)
          return hull(vertices);
        function hull(data) {
          if (data.length < 3)
            return [];
          var fx = d3_functor(x),
              fy = d3_functor(y),
              i,
              n = data.length,
              points = [],
              flippedPoints = [];
          for (i = 0; i < n; i++) {
            points.push([+fx.call(this, data[i], i), +fy.call(this, data[i], i), i]);
          }
          points.sort(d3_geom_hullOrder);
          for (i = 0; i < n; i++)
            flippedPoints.push([points[i][0], -points[i][1]]);
          var upper = d3_geom_hullUpper(points),
              lower = d3_geom_hullUpper(flippedPoints);
          var skipLeft = lower[0] === upper[0],
              skipRight = lower[lower.length - 1] === upper[upper.length - 1],
              polygon = [];
          for (i = upper.length - 1; i >= 0; --i)
            polygon.push(data[points[upper[i]][2]]);
          for (i = +skipLeft; i < lower.length - skipRight; ++i)
            polygon.push(data[points[lower[i]][2]]);
          return polygon;
        }
        hull.x = function(_) {
          return arguments.length ? (x = _, hull) : x;
        };
        hull.y = function(_) {
          return arguments.length ? (y = _, hull) : y;
        };
        return hull;
      };
      function d3_geom_hullUpper(points) {
        var n = points.length,
            hull = [0, 1],
            hs = 2;
        for (var i = 2; i < n; i++) {
          while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0)
            --hs;
          hull[hs++] = i;
        }
        return hull.slice(0, hs);
      }
      function d3_geom_hullOrder(a, b) {
        return a[0] - b[0] || a[1] - b[1];
      }
      d3.geom.polygon = function(coordinates) {
        d3_subclass(coordinates, d3_geom_polygonPrototype);
        return coordinates;
      };
      var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
      d3_geom_polygonPrototype.area = function() {
        var i = -1,
            n = this.length,
            a,
            b = this[n - 1],
            area = 0;
        while (++i < n) {
          a = b;
          b = this[i];
          area += a[1] * b[0] - a[0] * b[1];
        }
        return area * .5;
      };
      d3_geom_polygonPrototype.centroid = function(k) {
        var i = -1,
            n = this.length,
            x = 0,
            y = 0,
            a,
            b = this[n - 1],
            c;
        if (!arguments.length)
          k = -1 / (6 * this.area());
        while (++i < n) {
          a = b;
          b = this[i];
          c = a[0] * b[1] - b[0] * a[1];
          x += (a[0] + b[0]) * c;
          y += (a[1] + b[1]) * c;
        }
        return [x * k, y * k];
      };
      d3_geom_polygonPrototype.clip = function(subject) {
        var input,
            closed = d3_geom_polygonClosed(subject),
            i = -1,
            n = this.length - d3_geom_polygonClosed(this),
            j,
            m,
            a = this[n - 1],
            b,
            c,
            d;
        while (++i < n) {
          input = subject.slice();
          subject.length = 0;
          b = this[i];
          c = input[(m = input.length - closed) - 1];
          j = -1;
          while (++j < m) {
            d = input[j];
            if (d3_geom_polygonInside(d, a, b)) {
              if (!d3_geom_polygonInside(c, a, b)) {
                subject.push(d3_geom_polygonIntersect(c, d, a, b));
              }
              subject.push(d);
            } else if (d3_geom_polygonInside(c, a, b)) {
              subject.push(d3_geom_polygonIntersect(c, d, a, b));
            }
            c = d;
          }
          if (closed)
            subject.push(subject[0]);
          a = b;
        }
        return subject;
      };
      function d3_geom_polygonInside(p, a, b) {
        return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
      }
      function d3_geom_polygonIntersect(c, d, a, b) {
        var x1 = c[0],
            x3 = a[0],
            x21 = d[0] - x1,
            x43 = b[0] - x3,
            y1 = c[1],
            y3 = a[1],
            y21 = d[1] - y1,
            y43 = b[1] - y3,
            ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
        return [x1 + ua * x21, y1 + ua * y21];
      }
      function d3_geom_polygonClosed(coordinates) {
        var a = coordinates[0],
            b = coordinates[coordinates.length - 1];
        return !(a[0] - b[0] || a[1] - b[1]);
      }
      var d3_geom_voronoiEdges,
          d3_geom_voronoiCells,
          d3_geom_voronoiBeaches,
          d3_geom_voronoiBeachPool = [],
          d3_geom_voronoiFirstCircle,
          d3_geom_voronoiCircles,
          d3_geom_voronoiCirclePool = [];
      function d3_geom_voronoiBeach() {
        d3_geom_voronoiRedBlackNode(this);
        this.edge = this.site = this.circle = null;
      }
      function d3_geom_voronoiCreateBeach(site) {
        var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
        beach.site = site;
        return beach;
      }
      function d3_geom_voronoiDetachBeach(beach) {
        d3_geom_voronoiDetachCircle(beach);
        d3_geom_voronoiBeaches.remove(beach);
        d3_geom_voronoiBeachPool.push(beach);
        d3_geom_voronoiRedBlackNode(beach);
      }
      function d3_geom_voronoiRemoveBeach(beach) {
        var circle = beach.circle,
            x = circle.x,
            y = circle.cy,
            vertex = {
              x: x,
              y: y
            },
            previous = beach.P,
            next = beach.N,
            disappearing = [beach];
        d3_geom_voronoiDetachBeach(beach);
        var lArc = previous;
        while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
          previous = lArc.P;
          disappearing.unshift(lArc);
          d3_geom_voronoiDetachBeach(lArc);
          lArc = previous;
        }
        disappearing.unshift(lArc);
        d3_geom_voronoiDetachCircle(lArc);
        var rArc = next;
        while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
          next = rArc.N;
          disappearing.push(rArc);
          d3_geom_voronoiDetachBeach(rArc);
          rArc = next;
        }
        disappearing.push(rArc);
        d3_geom_voronoiDetachCircle(rArc);
        var nArcs = disappearing.length,
            iArc;
        for (iArc = 1; iArc < nArcs; ++iArc) {
          rArc = disappearing[iArc];
          lArc = disappearing[iArc - 1];
          d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
        }
        lArc = disappearing[0];
        rArc = disappearing[nArcs - 1];
        rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
        d3_geom_voronoiAttachCircle(lArc);
        d3_geom_voronoiAttachCircle(rArc);
      }
      function d3_geom_voronoiAddBeach(site) {
        var x = site.x,
            directrix = site.y,
            lArc,
            rArc,
            dxl,
            dxr,
            node = d3_geom_voronoiBeaches._;
        while (node) {
          dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
          if (dxl > ε)
            node = node.L;
          else {
            dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
            if (dxr > ε) {
              if (!node.R) {
                lArc = node;
                break;
              }
              node = node.R;
            } else {
              if (dxl > -ε) {
                lArc = node.P;
                rArc = node;
              } else if (dxr > -ε) {
                lArc = node;
                rArc = node.N;
              } else {
                lArc = rArc = node;
              }
              break;
            }
          }
        }
        var newArc = d3_geom_voronoiCreateBeach(site);
        d3_geom_voronoiBeaches.insert(lArc, newArc);
        if (!lArc && !rArc)
          return;
        if (lArc === rArc) {
          d3_geom_voronoiDetachCircle(lArc);
          rArc = d3_geom_voronoiCreateBeach(lArc.site);
          d3_geom_voronoiBeaches.insert(newArc, rArc);
          newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
          d3_geom_voronoiAttachCircle(lArc);
          d3_geom_voronoiAttachCircle(rArc);
          return;
        }
        if (!rArc) {
          newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
          return;
        }
        d3_geom_voronoiDetachCircle(lArc);
        d3_geom_voronoiDetachCircle(rArc);
        var lSite = lArc.site,
            ax = lSite.x,
            ay = lSite.y,
            bx = site.x - ax,
            by = site.y - ay,
            rSite = rArc.site,
            cx = rSite.x - ax,
            cy = rSite.y - ay,
            d = 2 * (bx * cy - by * cx),
            hb = bx * bx + by * by,
            hc = cx * cx + cy * cy,
            vertex = {
              x: (cy * hb - by * hc) / d + ax,
              y: (bx * hc - cx * hb) / d + ay
            };
        d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
        newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
        rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
        d3_geom_voronoiAttachCircle(lArc);
        d3_geom_voronoiAttachCircle(rArc);
      }
      function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
        var site = arc.site,
            rfocx = site.x,
            rfocy = site.y,
            pby2 = rfocy - directrix;
        if (!pby2)
          return rfocx;
        var lArc = arc.P;
        if (!lArc)
          return -Infinity;
        site = lArc.site;
        var lfocx = site.x,
            lfocy = site.y,
            plby2 = lfocy - directrix;
        if (!plby2)
          return lfocx;
        var hl = lfocx - rfocx,
            aby2 = 1 / pby2 - 1 / plby2,
            b = hl / plby2;
        if (aby2)
          return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
        return (rfocx + lfocx) / 2;
      }
      function d3_geom_voronoiRightBreakPoint(arc, directrix) {
        var rArc = arc.N;
        if (rArc)
          return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
        var site = arc.site;
        return site.y === directrix ? site.x : Infinity;
      }
      function d3_geom_voronoiCell(site) {
        this.site = site;
        this.edges = [];
      }
      d3_geom_voronoiCell.prototype.prepare = function() {
        var halfEdges = this.edges,
            iHalfEdge = halfEdges.length,
            edge;
        while (iHalfEdge--) {
          edge = halfEdges[iHalfEdge].edge;
          if (!edge.b || !edge.a)
            halfEdges.splice(iHalfEdge, 1);
        }
        halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
        return halfEdges.length;
      };
      function d3_geom_voronoiCloseCells(extent) {
        var x0 = extent[0][0],
            x1 = extent[1][0],
            y0 = extent[0][1],
            y1 = extent[1][1],
            x2,
            y2,
            x3,
            y3,
            cells = d3_geom_voronoiCells,
            iCell = cells.length,
            cell,
            iHalfEdge,
            halfEdges,
            nHalfEdges,
            start,
            end;
        while (iCell--) {
          cell = cells[iCell];
          if (!cell || !cell.prepare())
            continue;
          halfEdges = cell.edges;
          nHalfEdges = halfEdges.length;
          iHalfEdge = 0;
          while (iHalfEdge < nHalfEdges) {
            end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
            start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
            if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
              halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
                x: x0,
                y: abs(x2 - x0) < ε ? y2 : y1
              } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
                x: abs(y2 - y1) < ε ? x2 : x1,
                y: y1
              } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
                x: x1,
                y: abs(x2 - x1) < ε ? y2 : y0
              } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
                x: abs(y2 - y0) < ε ? x2 : x0,
                y: y0
              } : null), cell.site, null));
              ++nHalfEdges;
            }
          }
        }
      }
      function d3_geom_voronoiHalfEdgeOrder(a, b) {
        return b.angle - a.angle;
      }
      function d3_geom_voronoiCircle() {
        d3_geom_voronoiRedBlackNode(this);
        this.x = this.y = this.arc = this.site = this.cy = null;
      }
      function d3_geom_voronoiAttachCircle(arc) {
        var lArc = arc.P,
            rArc = arc.N;
        if (!lArc || !rArc)
          return;
        var lSite = lArc.site,
            cSite = arc.site,
            rSite = rArc.site;
        if (lSite === rSite)
          return;
        var bx = cSite.x,
            by = cSite.y,
            ax = lSite.x - bx,
            ay = lSite.y - by,
            cx = rSite.x - bx,
            cy = rSite.y - by;
        var d = 2 * (ax * cy - ay * cx);
        if (d >= -ε2)
          return;
        var ha = ax * ax + ay * ay,
            hc = cx * cx + cy * cy,
            x = (cy * ha - ay * hc) / d,
            y = (ax * hc - cx * ha) / d,
            cy = y + by;
        var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
        circle.arc = arc;
        circle.site = cSite;
        circle.x = x + bx;
        circle.y = cy + Math.sqrt(x * x + y * y);
        circle.cy = cy;
        arc.circle = circle;
        var before = null,
            node = d3_geom_voronoiCircles._;
        while (node) {
          if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
            if (node.L)
              node = node.L;
            else {
              before = node.P;
              break;
            }
          } else {
            if (node.R)
              node = node.R;
            else {
              before = node;
              break;
            }
          }
        }
        d3_geom_voronoiCircles.insert(before, circle);
        if (!before)
          d3_geom_voronoiFirstCircle = circle;
      }
      function d3_geom_voronoiDetachCircle(arc) {
        var circle = arc.circle;
        if (circle) {
          if (!circle.P)
            d3_geom_voronoiFirstCircle = circle.N;
          d3_geom_voronoiCircles.remove(circle);
          d3_geom_voronoiCirclePool.push(circle);
          d3_geom_voronoiRedBlackNode(circle);
          arc.circle = null;
        }
      }
      function d3_geom_voronoiClipEdges(extent) {
        var edges = d3_geom_voronoiEdges,
            clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]),
            i = edges.length,
            e;
        while (i--) {
          e = edges[i];
          if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
            e.a = e.b = null;
            edges.splice(i, 1);
          }
        }
      }
      function d3_geom_voronoiConnectEdge(edge, extent) {
        var vb = edge.b;
        if (vb)
          return true;
        var va = edge.a,
            x0 = extent[0][0],
            x1 = extent[1][0],
            y0 = extent[0][1],
            y1 = extent[1][1],
            lSite = edge.l,
            rSite = edge.r,
            lx = lSite.x,
            ly = lSite.y,
            rx = rSite.x,
            ry = rSite.y,
            fx = (lx + rx) / 2,
            fy = (ly + ry) / 2,
            fm,
            fb;
        if (ry === ly) {
          if (fx < x0 || fx >= x1)
            return;
          if (lx > rx) {
            if (!va)
              va = {
                x: fx,
                y: y0
              };
            else if (va.y >= y1)
              return;
            vb = {
              x: fx,
              y: y1
            };
          } else {
            if (!va)
              va = {
                x: fx,
                y: y1
              };
            else if (va.y < y0)
              return;
            vb = {
              x: fx,
              y: y0
            };
          }
        } else {
          fm = (lx - rx) / (ry - ly);
          fb = fy - fm * fx;
          if (fm < -1 || fm > 1) {
            if (lx > rx) {
              if (!va)
                va = {
                  x: (y0 - fb) / fm,
                  y: y0
                };
              else if (va.y >= y1)
                return;
              vb = {
                x: (y1 - fb) / fm,
                y: y1
              };
            } else {
              if (!va)
                va = {
                  x: (y1 - fb) / fm,
                  y: y1
                };
              else if (va.y < y0)
                return;
              vb = {
                x: (y0 - fb) / fm,
                y: y0
              };
            }
          } else {
            if (ly < ry) {
              if (!va)
                va = {
                  x: x0,
                  y: fm * x0 + fb
                };
              else if (va.x >= x1)
                return;
              vb = {
                x: x1,
                y: fm * x1 + fb
              };
            } else {
              if (!va)
                va = {
                  x: x1,
                  y: fm * x1 + fb
                };
              else if (va.x < x0)
                return;
              vb = {
                x: x0,
                y: fm * x0 + fb
              };
            }
          }
        }
        edge.a = va;
        edge.b = vb;
        return true;
      }
      function d3_geom_voronoiEdge(lSite, rSite) {
        this.l = lSite;
        this.r = rSite;
        this.a = this.b = null;
      }
      function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
        var edge = new d3_geom_voronoiEdge(lSite, rSite);
        d3_geom_voronoiEdges.push(edge);
        if (va)
          d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
        if (vb)
          d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
        d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
        d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
        return edge;
      }
      function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
        var edge = new d3_geom_voronoiEdge(lSite, null);
        edge.a = va;
        edge.b = vb;
        d3_geom_voronoiEdges.push(edge);
        return edge;
      }
      function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
        if (!edge.a && !edge.b) {
          edge.a = vertex;
          edge.l = lSite;
          edge.r = rSite;
        } else if (edge.l === rSite) {
          edge.b = vertex;
        } else {
          edge.a = vertex;
        }
      }
      function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
        var va = edge.a,
            vb = edge.b;
        this.edge = edge;
        this.site = lSite;
        this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
      }
      d3_geom_voronoiHalfEdge.prototype = {
        start: function() {
          return this.edge.l === this.site ? this.edge.a : this.edge.b;
        },
        end: function() {
          return this.edge.l === this.site ? this.edge.b : this.edge.a;
        }
      };
      function d3_geom_voronoiRedBlackTree() {
        this._ = null;
      }
      function d3_geom_voronoiRedBlackNode(node) {
        node.U = node.C = node.L = node.R = node.P = node.N = null;
      }
      d3_geom_voronoiRedBlackTree.prototype = {
        insert: function(after, node) {
          var parent,
              grandpa,
              uncle;
          if (after) {
            node.P = after;
            node.N = after.N;
            if (after.N)
              after.N.P = node;
            after.N = node;
            if (after.R) {
              after = after.R;
              while (after.L)
                after = after.L;
              after.L = node;
            } else {
              after.R = node;
            }
            parent = after;
          } else if (this._) {
            after = d3_geom_voronoiRedBlackFirst(this._);
            node.P = null;
            node.N = after;
            after.P = after.L = node;
            parent = after;
          } else {
            node.P = node.N = null;
            this._ = node;
            parent = null;
          }
          node.L = node.R = null;
          node.U = parent;
          node.C = true;
          after = node;
          while (parent && parent.C) {
            grandpa = parent.U;
            if (parent === grandpa.L) {
              uncle = grandpa.R;
              if (uncle && uncle.C) {
                parent.C = uncle.C = false;
                grandpa.C = true;
                after = grandpa;
              } else {
                if (after === parent.R) {
                  d3_geom_voronoiRedBlackRotateLeft(this, parent);
                  after = parent;
                  parent = after.U;
                }
                parent.C = false;
                grandpa.C = true;
                d3_geom_voronoiRedBlackRotateRight(this, grandpa);
              }
            } else {
              uncle = grandpa.L;
              if (uncle && uncle.C) {
                parent.C = uncle.C = false;
                grandpa.C = true;
                after = grandpa;
              } else {
                if (after === parent.L) {
                  d3_geom_voronoiRedBlackRotateRight(this, parent);
                  after = parent;
                  parent = after.U;
                }
                parent.C = false;
                grandpa.C = true;
                d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
              }
            }
            parent = after.U;
          }
          this._.C = false;
        },
        remove: function(node) {
          if (node.N)
            node.N.P = node.P;
          if (node.P)
            node.P.N = node.N;
          node.N = node.P = null;
          var parent = node.U,
              sibling,
              left = node.L,
              right = node.R,
              next,
              red;
          if (!left)
            next = right;
          else if (!right)
            next = left;
          else
            next = d3_geom_voronoiRedBlackFirst(right);
          if (parent) {
            if (parent.L === node)
              parent.L = next;
            else
              parent.R = next;
          } else {
            this._ = next;
          }
          if (left && right) {
            red = next.C;
            next.C = node.C;
            next.L = left;
            left.U = next;
            if (next !== right) {
              parent = next.U;
              next.U = node.U;
              node = next.R;
              parent.L = node;
              next.R = right;
              right.U = next;
            } else {
              next.U = parent;
              parent = next;
              node = next.R;
            }
          } else {
            red = node.C;
            node = next;
          }
          if (node)
            node.U = parent;
          if (red)
            return;
          if (node && node.C) {
            node.C = false;
            return;
          }
          do {
            if (node === this._)
              break;
            if (node === parent.L) {
              sibling = parent.R;
              if (sibling.C) {
                sibling.C = false;
                parent.C = true;
                d3_geom_voronoiRedBlackRotateLeft(this, parent);
                sibling = parent.R;
              }
              if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                if (!sibling.R || !sibling.R.C) {
                  sibling.L.C = false;
                  sibling.C = true;
                  d3_geom_voronoiRedBlackRotateRight(this, sibling);
                  sibling = parent.R;
                }
                sibling.C = parent.C;
                parent.C = sibling.R.C = false;
                d3_geom_voronoiRedBlackRotateLeft(this, parent);
                node = this._;
                break;
              }
            } else {
              sibling = parent.L;
              if (sibling.C) {
                sibling.C = false;
                parent.C = true;
                d3_geom_voronoiRedBlackRotateRight(this, parent);
                sibling = parent.L;
              }
              if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                if (!sibling.L || !sibling.L.C) {
                  sibling.R.C = false;
                  sibling.C = true;
                  d3_geom_voronoiRedBlackRotateLeft(this, sibling);
                  sibling = parent.L;
                }
                sibling.C = parent.C;
                parent.C = sibling.L.C = false;
                d3_geom_voronoiRedBlackRotateRight(this, parent);
                node = this._;
                break;
              }
            }
            sibling.C = true;
            node = parent;
            parent = parent.U;
          } while (!node.C);
          if (node)
            node.C = false;
        }
      };
      function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
        var p = node,
            q = node.R,
            parent = p.U;
        if (parent) {
          if (parent.L === p)
            parent.L = q;
          else
            parent.R = q;
        } else {
          tree._ = q;
        }
        q.U = parent;
        p.U = q;
        p.R = q.L;
        if (p.R)
          p.R.U = p;
        q.L = p;
      }
      function d3_geom_voronoiRedBlackRotateRight(tree, node) {
        var p = node,
            q = node.L,
            parent = p.U;
        if (parent) {
          if (parent.L === p)
            parent.L = q;
          else
            parent.R = q;
        } else {
          tree._ = q;
        }
        q.U = parent;
        p.U = q;
        p.L = q.R;
        if (p.L)
          p.L.U = p;
        q.R = p;
      }
      function d3_geom_voronoiRedBlackFirst(node) {
        while (node.L)
          node = node.L;
        return node;
      }
      function d3_geom_voronoi(sites, bbox) {
        var site = sites.sort(d3_geom_voronoiVertexOrder).pop(),
            x0,
            y0,
            circle;
        d3_geom_voronoiEdges = [];
        d3_geom_voronoiCells = new Array(sites.length);
        d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
        d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
        while (true) {
          circle = d3_geom_voronoiFirstCircle;
          if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
            if (site.x !== x0 || site.y !== y0) {
              d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
              d3_geom_voronoiAddBeach(site);
              x0 = site.x, y0 = site.y;
            }
            site = sites.pop();
          } else if (circle) {
            d3_geom_voronoiRemoveBeach(circle.arc);
          } else {
            break;
          }
        }
        if (bbox)
          d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
        var diagram = {
          cells: d3_geom_voronoiCells,
          edges: d3_geom_voronoiEdges
        };
        d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
        return diagram;
      }
      function d3_geom_voronoiVertexOrder(a, b) {
        return b.y - a.y || b.x - a.x;
      }
      d3.geom.voronoi = function(points) {
        var x = d3_geom_pointX,
            y = d3_geom_pointY,
            fx = x,
            fy = y,
            clipExtent = d3_geom_voronoiClipExtent;
        if (points)
          return voronoi(points);
        function voronoi(data) {
          var polygons = new Array(data.length),
              x0 = clipExtent[0][0],
              y0 = clipExtent[0][1],
              x1 = clipExtent[1][0],
              y1 = clipExtent[1][1];
          d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
            var edges = cell.edges,
                site = cell.site,
                polygon = polygons[i] = edges.length ? edges.map(function(e) {
                  var s = e.start();
                  return [s.x, s.y];
                }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [[x0, y1], [x1, y1], [x1, y0], [x0, y0]] : [];
            polygon.point = data[i];
          });
          return polygons;
        }
        function sites(data) {
          return data.map(function(d, i) {
            return {
              x: Math.round(fx(d, i) / ε) * ε,
              y: Math.round(fy(d, i) / ε) * ε,
              i: i
            };
          });
        }
        voronoi.links = function(data) {
          return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
            return edge.l && edge.r;
          }).map(function(edge) {
            return {
              source: data[edge.l.i],
              target: data[edge.r.i]
            };
          });
        };
        voronoi.triangles = function(data) {
          var triangles = [];
          d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
            var site = cell.site,
                edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder),
                j = -1,
                m = edges.length,
                e0,
                s0,
                e1 = edges[m - 1].edge,
                s1 = e1.l === site ? e1.r : e1.l;
            while (++j < m) {
              e0 = e1;
              s0 = s1;
              e1 = edges[j].edge;
              s1 = e1.l === site ? e1.r : e1.l;
              if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
                triangles.push([data[i], data[s0.i], data[s1.i]]);
              }
            }
          });
          return triangles;
        };
        voronoi.x = function(_) {
          return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
        };
        voronoi.y = function(_) {
          return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
        };
        voronoi.clipExtent = function(_) {
          if (!arguments.length)
            return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
          clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
          return voronoi;
        };
        voronoi.size = function(_) {
          if (!arguments.length)
            return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
          return voronoi.clipExtent(_ && [[0, 0], _]);
        };
        return voronoi;
      };
      var d3_geom_voronoiClipExtent = [[-1e6, -1e6], [1e6, 1e6]];
      function d3_geom_voronoiTriangleArea(a, b, c) {
        return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
      }
      d3.geom.delaunay = function(vertices) {
        return d3.geom.voronoi().triangles(vertices);
      };
      d3.geom.quadtree = function(points, x1, y1, x2, y2) {
        var x = d3_geom_pointX,
            y = d3_geom_pointY,
            compat;
        if (compat = arguments.length) {
          x = d3_geom_quadtreeCompatX;
          y = d3_geom_quadtreeCompatY;
          if (compat === 3) {
            y2 = y1;
            x2 = x1;
            y1 = x1 = 0;
          }
          return quadtree(points);
        }
        function quadtree(data) {
          var d,
              fx = d3_functor(x),
              fy = d3_functor(y),
              xs,
              ys,
              i,
              n,
              x1_,
              y1_,
              x2_,
              y2_;
          if (x1 != null) {
            x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
          } else {
            x2_ = y2_ = -(x1_ = y1_ = Infinity);
            xs = [], ys = [];
            n = data.length;
            if (compat)
              for (i = 0; i < n; ++i) {
                d = data[i];
                if (d.x < x1_)
                  x1_ = d.x;
                if (d.y < y1_)
                  y1_ = d.y;
                if (d.x > x2_)
                  x2_ = d.x;
                if (d.y > y2_)
                  y2_ = d.y;
                xs.push(d.x);
                ys.push(d.y);
              }
            else
              for (i = 0; i < n; ++i) {
                var x_ = +fx(d = data[i], i),
                    y_ = +fy(d, i);
                if (x_ < x1_)
                  x1_ = x_;
                if (y_ < y1_)
                  y1_ = y_;
                if (x_ > x2_)
                  x2_ = x_;
                if (y_ > y2_)
                  y2_ = y_;
                xs.push(x_);
                ys.push(y_);
              }
          }
          var dx = x2_ - x1_,
              dy = y2_ - y1_;
          if (dx > dy)
            y2_ = y1_ + dx;
          else
            x2_ = x1_ + dy;
          function insert(n, d, x, y, x1, y1, x2, y2) {
            if (isNaN(x) || isNaN(y))
              return;
            if (n.leaf) {
              var nx = n.x,
                  ny = n.y;
              if (nx != null) {
                if (abs(nx - x) + abs(ny - y) < .01) {
                  insertChild(n, d, x, y, x1, y1, x2, y2);
                } else {
                  var nPoint = n.point;
                  n.x = n.y = n.point = null;
                  insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
                  insertChild(n, d, x, y, x1, y1, x2, y2);
                }
              } else {
                n.x = x, n.y = y, n.point = d;
              }
            } else {
              insertChild(n, d, x, y, x1, y1, x2, y2);
            }
          }
          function insertChild(n, d, x, y, x1, y1, x2, y2) {
            var xm = (x1 + x2) * .5,
                ym = (y1 + y2) * .5,
                right = x >= xm,
                below = y >= ym,
                i = below << 1 | right;
            n.leaf = false;
            n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
            if (right)
              x1 = xm;
            else
              x2 = xm;
            if (below)
              y1 = ym;
            else
              y2 = ym;
            insert(n, d, x, y, x1, y1, x2, y2);
          }
          var root = d3_geom_quadtreeNode();
          root.add = function(d) {
            insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
          };
          root.visit = function(f) {
            d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
          };
          root.find = function(point) {
            return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
          };
          i = -1;
          if (x1 == null) {
            while (++i < n) {
              insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
            }
            --i;
          } else
            data.forEach(root.add);
          xs = ys = data = d = null;
          return root;
        }
        quadtree.x = function(_) {
          return arguments.length ? (x = _, quadtree) : x;
        };
        quadtree.y = function(_) {
          return arguments.length ? (y = _, quadtree) : y;
        };
        quadtree.extent = function(_) {
          if (!arguments.length)
            return x1 == null ? null : [[x1, y1], [x2, y2]];
          if (_ == null)
            x1 = y1 = x2 = y2 = null;
          else
            x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], y2 = +_[1][1];
          return quadtree;
        };
        quadtree.size = function(_) {
          if (!arguments.length)
            return x1 == null ? null : [x2 - x1, y2 - y1];
          if (_ == null)
            x1 = y1 = x2 = y2 = null;
          else
            x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
          return quadtree;
        };
        return quadtree;
      };
      function d3_geom_quadtreeCompatX(d) {
        return d.x;
      }
      function d3_geom_quadtreeCompatY(d) {
        return d.y;
      }
      function d3_geom_quadtreeNode() {
        return {
          leaf: true,
          nodes: [],
          point: null,
          x: null,
          y: null
        };
      }
      function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
        if (!f(node, x1, y1, x2, y2)) {
          var sx = (x1 + x2) * .5,
              sy = (y1 + y2) * .5,
              children = node.nodes;
          if (children[0])
            d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
          if (children[1])
            d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
          if (children[2])
            d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
          if (children[3])
            d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
        }
      }
      function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
        var minDistance2 = Infinity,
            closestPoint;
        (function find(node, x1, y1, x2, y2) {
          if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0)
            return;
          if (point = node.point) {
            var point,
                dx = x - node.x,
                dy = y - node.y,
                distance2 = dx * dx + dy * dy;
            if (distance2 < minDistance2) {
              var distance = Math.sqrt(minDistance2 = distance2);
              x0 = x - distance, y0 = y - distance;
              x3 = x + distance, y3 = y + distance;
              closestPoint = point;
            }
          }
          var children = node.nodes,
              xm = (x1 + x2) * .5,
              ym = (y1 + y2) * .5,
              right = x >= xm,
              below = y >= ym;
          for (var i = below << 1 | right,
              j = i + 4; i < j; ++i) {
            if (node = children[i & 3])
              switch (i & 3) {
                case 0:
                  find(node, x1, y1, xm, ym);
                  break;
                case 1:
                  find(node, xm, y1, x2, ym);
                  break;
                case 2:
                  find(node, x1, ym, xm, y2);
                  break;
                case 3:
                  find(node, xm, ym, x2, y2);
                  break;
              }
          }
        })(root, x0, y0, x3, y3);
        return closestPoint;
      }
      d3.interpolateRgb = d3_interpolateRgb;
      function d3_interpolateRgb(a, b) {
        a = d3.rgb(a);
        b = d3.rgb(b);
        var ar = a.r,
            ag = a.g,
            ab = a.b,
            br = b.r - ar,
            bg = b.g - ag,
            bb = b.b - ab;
        return function(t) {
          return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
        };
      }
      d3.interpolateObject = d3_interpolateObject;
      function d3_interpolateObject(a, b) {
        var i = {},
            c = {},
            k;
        for (k in a) {
          if (k in b) {
            i[k] = d3_interpolate(a[k], b[k]);
          } else {
            c[k] = a[k];
          }
        }
        for (k in b) {
          if (!(k in a)) {
            c[k] = b[k];
          }
        }
        return function(t) {
          for (k in i)
            c[k] = i[k](t);
          return c;
        };
      }
      d3.interpolateNumber = d3_interpolateNumber;
      function d3_interpolateNumber(a, b) {
        a = +a, b = +b;
        return function(t) {
          return a * (1 - t) + b * t;
        };
      }
      d3.interpolateString = d3_interpolateString;
      function d3_interpolateString(a, b) {
        var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0,
            am,
            bm,
            bs,
            i = -1,
            s = [],
            q = [];
        a = a + "", b = b + "";
        while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
          if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i])
              s[i] += bs;
            else
              s[++i] = bs;
          }
          if ((am = am[0]) === (bm = bm[0])) {
            if (s[i])
              s[i] += bm;
            else
              s[++i] = bm;
          } else {
            s[++i] = null;
            q.push({
              i: i,
              x: d3_interpolateNumber(am, bm)
            });
          }
          bi = d3_interpolate_numberB.lastIndex;
        }
        if (bi < b.length) {
          bs = b.slice(bi);
          if (s[i])
            s[i] += bs;
          else
            s[++i] = bs;
        }
        return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
          return b(t) + "";
        }) : function() {
          return b;
        } : (b = q.length, function(t) {
          for (var i = 0,
              o; i < b; ++i)
            s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
      }
      var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
          d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
      d3.interpolate = d3_interpolate;
      function d3_interpolate(a, b) {
        var i = d3.interpolators.length,
            f;
        while (--i >= 0 && !(f = d3.interpolators[i](a, b)))
          ;
        return f;
      }
      d3.interpolators = [function(a, b) {
        var t = typeof b;
        return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
      }];
      d3.interpolateArray = d3_interpolateArray;
      function d3_interpolateArray(a, b) {
        var x = [],
            c = [],
            na = a.length,
            nb = b.length,
            n0 = Math.min(a.length, b.length),
            i;
        for (i = 0; i < n0; ++i)
          x.push(d3_interpolate(a[i], b[i]));
        for (; i < na; ++i)
          c[i] = a[i];
        for (; i < nb; ++i)
          c[i] = b[i];
        return function(t) {
          for (i = 0; i < n0; ++i)
            c[i] = x[i](t);
          return c;
        };
      }
      var d3_ease_default = function() {
        return d3_identity;
      };
      var d3_ease = d3.map({
        linear: d3_ease_default,
        poly: d3_ease_poly,
        quad: function() {
          return d3_ease_quad;
        },
        cubic: function() {
          return d3_ease_cubic;
        },
        sin: function() {
          return d3_ease_sin;
        },
        exp: function() {
          return d3_ease_exp;
        },
        circle: function() {
          return d3_ease_circle;
        },
        elastic: d3_ease_elastic,
        back: d3_ease_back,
        bounce: function() {
          return d3_ease_bounce;
        }
      });
      var d3_ease_mode = d3.map({
        "in": d3_identity,
        out: d3_ease_reverse,
        "in-out": d3_ease_reflect,
        "out-in": function(f) {
          return d3_ease_reflect(d3_ease_reverse(f));
        }
      });
      d3.ease = function(name) {
        var i = name.indexOf("-"),
            t = i >= 0 ? name.slice(0, i) : name,
            m = i >= 0 ? name.slice(i + 1) : "in";
        t = d3_ease.get(t) || d3_ease_default;
        m = d3_ease_mode.get(m) || d3_identity;
        return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
      };
      function d3_ease_clamp(f) {
        return function(t) {
          return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
        };
      }
      function d3_ease_reverse(f) {
        return function(t) {
          return 1 - f(1 - t);
        };
      }
      function d3_ease_reflect(f) {
        return function(t) {
          return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
        };
      }
      function d3_ease_quad(t) {
        return t * t;
      }
      function d3_ease_cubic(t) {
        return t * t * t;
      }
      function d3_ease_cubicInOut(t) {
        if (t <= 0)
          return 0;
        if (t >= 1)
          return 1;
        var t2 = t * t,
            t3 = t2 * t;
        return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
      }
      function d3_ease_poly(e) {
        return function(t) {
          return Math.pow(t, e);
        };
      }
      function d3_ease_sin(t) {
        return 1 - Math.cos(t * halfπ);
      }
      function d3_ease_exp(t) {
        return Math.pow(2, 10 * (t - 1));
      }
      function d3_ease_circle(t) {
        return 1 - Math.sqrt(1 - t * t);
      }
      function d3_ease_elastic(a, p) {
        var s;
        if (arguments.length < 2)
          p = .45;
        if (arguments.length)
          s = p / τ * Math.asin(1 / a);
        else
          a = 1, s = p / 4;
        return function(t) {
          return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
        };
      }
      function d3_ease_back(s) {
        if (!s)
          s = 1.70158;
        return function(t) {
          return t * t * ((s + 1) * t - s);
        };
      }
      function d3_ease_bounce(t) {
        return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
      }
      d3.interpolateHcl = d3_interpolateHcl;
      function d3_interpolateHcl(a, b) {
        a = d3.hcl(a);
        b = d3.hcl(b);
        var ah = a.h,
            ac = a.c,
            al = a.l,
            bh = b.h - ah,
            bc = b.c - ac,
            bl = b.l - al;
        if (isNaN(bc))
          bc = 0, ac = isNaN(ac) ? b.c : ac;
        if (isNaN(bh))
          bh = 0, ah = isNaN(ah) ? b.h : ah;
        else if (bh > 180)
          bh -= 360;
        else if (bh < -180)
          bh += 360;
        return function(t) {
          return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
        };
      }
      d3.interpolateHsl = d3_interpolateHsl;
      function d3_interpolateHsl(a, b) {
        a = d3.hsl(a);
        b = d3.hsl(b);
        var ah = a.h,
            as = a.s,
            al = a.l,
            bh = b.h - ah,
            bs = b.s - as,
            bl = b.l - al;
        if (isNaN(bs))
          bs = 0, as = isNaN(as) ? b.s : as;
        if (isNaN(bh))
          bh = 0, ah = isNaN(ah) ? b.h : ah;
        else if (bh > 180)
          bh -= 360;
        else if (bh < -180)
          bh += 360;
        return function(t) {
          return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
        };
      }
      d3.interpolateLab = d3_interpolateLab;
      function d3_interpolateLab(a, b) {
        a = d3.lab(a);
        b = d3.lab(b);
        var al = a.l,
            aa = a.a,
            ab = a.b,
            bl = b.l - al,
            ba = b.a - aa,
            bb = b.b - ab;
        return function(t) {
          return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
        };
      }
      d3.interpolateRound = d3_interpolateRound;
      function d3_interpolateRound(a, b) {
        b -= a;
        return function(t) {
          return Math.round(a + b * t);
        };
      }
      d3.transform = function(string) {
        var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
        return (d3.transform = function(string) {
          if (string != null) {
            g.setAttribute("transform", string);
            var t = g.transform.baseVal.consolidate();
          }
          return new d3_transform(t ? t.matrix : d3_transformIdentity);
        })(string);
      };
      function d3_transform(m) {
        var r0 = [m.a, m.b],
            r1 = [m.c, m.d],
            kx = d3_transformNormalize(r0),
            kz = d3_transformDot(r0, r1),
            ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
        if (r0[0] * r1[1] < r1[0] * r0[1]) {
          r0[0] *= -1;
          r0[1] *= -1;
          kx *= -1;
          kz *= -1;
        }
        this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
        this.translate = [m.e, m.f];
        this.scale = [kx, ky];
        this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
      }
      d3_transform.prototype.toString = function() {
        return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
      };
      function d3_transformDot(a, b) {
        return a[0] * b[0] + a[1] * b[1];
      }
      function d3_transformNormalize(a) {
        var k = Math.sqrt(d3_transformDot(a, a));
        if (k) {
          a[0] /= k;
          a[1] /= k;
        }
        return k;
      }
      function d3_transformCombine(a, b, k) {
        a[0] += k * b[0];
        a[1] += k * b[1];
        return a;
      }
      var d3_transformIdentity = {
        a: 1,
        b: 0,
        c: 0,
        d: 1,
        e: 0,
        f: 0
      };
      d3.interpolateTransform = d3_interpolateTransform;
      function d3_interpolateTransformPop(s) {
        return s.length ? s.pop() + "," : "";
      }
      function d3_interpolateTranslate(ta, tb, s, q) {
        if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
          var i = s.push("translate(", null, ",", null, ")");
          q.push({
            i: i - 4,
            x: d3_interpolateNumber(ta[0], tb[0])
          }, {
            i: i - 2,
            x: d3_interpolateNumber(ta[1], tb[1])
          });
        } else if (tb[0] || tb[1]) {
          s.push("translate(" + tb + ")");
        }
      }
      function d3_interpolateRotate(ra, rb, s, q) {
        if (ra !== rb) {
          if (ra - rb > 180)
            rb += 360;
          else if (rb - ra > 180)
            ra += 360;
          q.push({
            i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
            x: d3_interpolateNumber(ra, rb)
          });
        } else if (rb) {
          s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
        }
      }
      function d3_interpolateSkew(wa, wb, s, q) {
        if (wa !== wb) {
          q.push({
            i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
            x: d3_interpolateNumber(wa, wb)
          });
        } else if (wb) {
          s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
        }
      }
      function d3_interpolateScale(ka, kb, s, q) {
        if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
          var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
          q.push({
            i: i - 4,
            x: d3_interpolateNumber(ka[0], kb[0])
          }, {
            i: i - 2,
            x: d3_interpolateNumber(ka[1], kb[1])
          });
        } else if (kb[0] !== 1 || kb[1] !== 1) {
          s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
        }
      }
      function d3_interpolateTransform(a, b) {
        var s = [],
            q = [];
        a = d3.transform(a), b = d3.transform(b);
        d3_interpolateTranslate(a.translate, b.translate, s, q);
        d3_interpolateRotate(a.rotate, b.rotate, s, q);
        d3_interpolateSkew(a.skew, b.skew, s, q);
        d3_interpolateScale(a.scale, b.scale, s, q);
        a = b = null;
        return function(t) {
          var i = -1,
              n = q.length,
              o;
          while (++i < n)
            s[(o = q[i]).i] = o.x(t);
          return s.join("");
        };
      }
      function d3_uninterpolateNumber(a, b) {
        b = (b -= a = +a) || 1 / b;
        return function(x) {
          return (x - a) / b;
        };
      }
      function d3_uninterpolateClamp(a, b) {
        b = (b -= a = +a) || 1 / b;
        return function(x) {
          return Math.max(0, Math.min(1, (x - a) / b));
        };
      }
      d3.layout = {};
      d3.layout.bundle = function() {
        return function(links) {
          var paths = [],
              i = -1,
              n = links.length;
          while (++i < n)
            paths.push(d3_layout_bundlePath(links[i]));
          return paths;
        };
      };
      function d3_layout_bundlePath(link) {
        var start = link.source,
            end = link.target,
            lca = d3_layout_bundleLeastCommonAncestor(start, end),
            points = [start];
        while (start !== lca) {
          start = start.parent;
          points.push(start);
        }
        var k = points.length;
        while (end !== lca) {
          points.splice(k, 0, end);
          end = end.parent;
        }
        return points;
      }
      function d3_layout_bundleAncestors(node) {
        var ancestors = [],
            parent = node.parent;
        while (parent != null) {
          ancestors.push(node);
          node = parent;
          parent = parent.parent;
        }
        ancestors.push(node);
        return ancestors;
      }
      function d3_layout_bundleLeastCommonAncestor(a, b) {
        if (a === b)
          return a;
        var aNodes = d3_layout_bundleAncestors(a),
            bNodes = d3_layout_bundleAncestors(b),
            aNode = aNodes.pop(),
            bNode = bNodes.pop(),
            sharedNode = null;
        while (aNode === bNode) {
          sharedNode = aNode;
          aNode = aNodes.pop();
          bNode = bNodes.pop();
        }
        return sharedNode;
      }
      d3.layout.chord = function() {
        var chord = {},
            chords,
            groups,
            matrix,
            n,
            padding = 0,
            sortGroups,
            sortSubgroups,
            sortChords;
        function relayout() {
          var subgroups = {},
              groupSums = [],
              groupIndex = d3.range(n),
              subgroupIndex = [],
              k,
              x,
              x0,
              i,
              j;
          chords = [];
          groups = [];
          k = 0, i = -1;
          while (++i < n) {
            x = 0, j = -1;
            while (++j < n) {
              x += matrix[i][j];
            }
            groupSums.push(x);
            subgroupIndex.push(d3.range(n));
            k += x;
          }
          if (sortGroups) {
            groupIndex.sort(function(a, b) {
              return sortGroups(groupSums[a], groupSums[b]);
            });
          }
          if (sortSubgroups) {
            subgroupIndex.forEach(function(d, i) {
              d.sort(function(a, b) {
                return sortSubgroups(matrix[i][a], matrix[i][b]);
              });
            });
          }
          k = (τ - padding * n) / k;
          x = 0, i = -1;
          while (++i < n) {
            x0 = x, j = -1;
            while (++j < n) {
              var di = groupIndex[i],
                  dj = subgroupIndex[di][j],
                  v = matrix[di][dj],
                  a0 = x,
                  a1 = x += v * k;
              subgroups[di + "-" + dj] = {
                index: di,
                subindex: dj,
                startAngle: a0,
                endAngle: a1,
                value: v
              };
            }
            groups[di] = {
              index: di,
              startAngle: x0,
              endAngle: x,
              value: groupSums[di]
            };
            x += padding;
          }
          i = -1;
          while (++i < n) {
            j = i - 1;
            while (++j < n) {
              var source = subgroups[i + "-" + j],
                  target = subgroups[j + "-" + i];
              if (source.value || target.value) {
                chords.push(source.value < target.value ? {
                  source: target,
                  target: source
                } : {
                  source: source,
                  target: target
                });
              }
            }
          }
          if (sortChords)
            resort();
        }
        function resort() {
          chords.sort(function(a, b) {
            return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
          });
        }
        chord.matrix = function(x) {
          if (!arguments.length)
            return matrix;
          n = (matrix = x) && matrix.length;
          chords = groups = null;
          return chord;
        };
        chord.padding = function(x) {
          if (!arguments.length)
            return padding;
          padding = x;
          chords = groups = null;
          return chord;
        };
        chord.sortGroups = function(x) {
          if (!arguments.length)
            return sortGroups;
          sortGroups = x;
          chords = groups = null;
          return chord;
        };
        chord.sortSubgroups = function(x) {
          if (!arguments.length)
            return sortSubgroups;
          sortSubgroups = x;
          chords = null;
          return chord;
        };
        chord.sortChords = function(x) {
          if (!arguments.length)
            return sortChords;
          sortChords = x;
          if (chords)
            resort();
          return chord;
        };
        chord.chords = function() {
          if (!chords)
            relayout();
          return chords;
        };
        chord.groups = function() {
          if (!groups)
            relayout();
          return groups;
        };
        return chord;
      };
      d3.layout.force = function() {
        var force = {},
            event = d3.dispatch("start", "tick", "end"),
            timer,
            size = [1, 1],
            drag,
            alpha,
            friction = .9,
            linkDistance = d3_layout_forceLinkDistance,
            linkStrength = d3_layout_forceLinkStrength,
            charge = -30,
            chargeDistance2 = d3_layout_forceChargeDistance2,
            gravity = .1,
            theta2 = .64,
            nodes = [],
            links = [],
            distances,
            strengths,
            charges;
        function repulse(node) {
          return function(quad, x1, _, x2) {
            if (quad.point !== node) {
              var dx = quad.cx - node.x,
                  dy = quad.cy - node.y,
                  dw = x2 - x1,
                  dn = dx * dx + dy * dy;
              if (dw * dw / theta2 < dn) {
                if (dn < chargeDistance2) {
                  var k = quad.charge / dn;
                  node.px -= dx * k;
                  node.py -= dy * k;
                }
                return true;
              }
              if (quad.point && dn && dn < chargeDistance2) {
                var k = quad.pointCharge / dn;
                node.px -= dx * k;
                node.py -= dy * k;
              }
            }
            return !quad.charge;
          };
        }
        force.tick = function() {
          if ((alpha *= .99) < .005) {
            timer = null;
            event.end({
              type: "end",
              alpha: alpha = 0
            });
            return true;
          }
          var n = nodes.length,
              m = links.length,
              q,
              i,
              o,
              s,
              t,
              l,
              k,
              x,
              y;
          for (i = 0; i < m; ++i) {
            o = links[i];
            s = o.source;
            t = o.target;
            x = t.x - s.x;
            y = t.y - s.y;
            if (l = x * x + y * y) {
              l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
              x *= l;
              y *= l;
              t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
              t.y -= y * k;
              s.x += x * (k = 1 - k);
              s.y += y * k;
            }
          }
          if (k = alpha * gravity) {
            x = size[0] / 2;
            y = size[1] / 2;
            i = -1;
            if (k)
              while (++i < n) {
                o = nodes[i];
                o.x += (x - o.x) * k;
                o.y += (y - o.y) * k;
              }
          }
          if (charge) {
            d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
            i = -1;
            while (++i < n) {
              if (!(o = nodes[i]).fixed) {
                q.visit(repulse(o));
              }
            }
          }
          i = -1;
          while (++i < n) {
            o = nodes[i];
            if (o.fixed) {
              o.x = o.px;
              o.y = o.py;
            } else {
              o.x -= (o.px - (o.px = o.x)) * friction;
              o.y -= (o.py - (o.py = o.y)) * friction;
            }
          }
          event.tick({
            type: "tick",
            alpha: alpha
          });
        };
        force.nodes = function(x) {
          if (!arguments.length)
            return nodes;
          nodes = x;
          return force;
        };
        force.links = function(x) {
          if (!arguments.length)
            return links;
          links = x;
          return force;
        };
        force.size = function(x) {
          if (!arguments.length)
            return size;
          size = x;
          return force;
        };
        force.linkDistance = function(x) {
          if (!arguments.length)
            return linkDistance;
          linkDistance = typeof x === "function" ? x : +x;
          return force;
        };
        force.distance = force.linkDistance;
        force.linkStrength = function(x) {
          if (!arguments.length)
            return linkStrength;
          linkStrength = typeof x === "function" ? x : +x;
          return force;
        };
        force.friction = function(x) {
          if (!arguments.length)
            return friction;
          friction = +x;
          return force;
        };
        force.charge = function(x) {
          if (!arguments.length)
            return charge;
          charge = typeof x === "function" ? x : +x;
          return force;
        };
        force.chargeDistance = function(x) {
          if (!arguments.length)
            return Math.sqrt(chargeDistance2);
          chargeDistance2 = x * x;
          return force;
        };
        force.gravity = function(x) {
          if (!arguments.length)
            return gravity;
          gravity = +x;
          return force;
        };
        force.theta = function(x) {
          if (!arguments.length)
            return Math.sqrt(theta2);
          theta2 = x * x;
          return force;
        };
        force.alpha = function(x) {
          if (!arguments.length)
            return alpha;
          x = +x;
          if (alpha) {
            if (x > 0) {
              alpha = x;
            } else {
              timer.c = null, timer.t = NaN, timer = null;
              event.end({
                type: "end",
                alpha: alpha = 0
              });
            }
          } else if (x > 0) {
            event.start({
              type: "start",
              alpha: alpha = x
            });
            timer = d3_timer(force.tick);
          }
          return force;
        };
        force.start = function() {
          var i,
              n = nodes.length,
              m = links.length,
              w = size[0],
              h = size[1],
              neighbors,
              o;
          for (i = 0; i < n; ++i) {
            (o = nodes[i]).index = i;
            o.weight = 0;
          }
          for (i = 0; i < m; ++i) {
            o = links[i];
            if (typeof o.source == "number")
              o.source = nodes[o.source];
            if (typeof o.target == "number")
              o.target = nodes[o.target];
            ++o.source.weight;
            ++o.target.weight;
          }
          for (i = 0; i < n; ++i) {
            o = nodes[i];
            if (isNaN(o.x))
              o.x = position("x", w);
            if (isNaN(o.y))
              o.y = position("y", h);
            if (isNaN(o.px))
              o.px = o.x;
            if (isNaN(o.py))
              o.py = o.y;
          }
          distances = [];
          if (typeof linkDistance === "function")
            for (i = 0; i < m; ++i)
              distances[i] = +linkDistance.call(this, links[i], i);
          else
            for (i = 0; i < m; ++i)
              distances[i] = linkDistance;
          strengths = [];
          if (typeof linkStrength === "function")
            for (i = 0; i < m; ++i)
              strengths[i] = +linkStrength.call(this, links[i], i);
          else
            for (i = 0; i < m; ++i)
              strengths[i] = linkStrength;
          charges = [];
          if (typeof charge === "function")
            for (i = 0; i < n; ++i)
              charges[i] = +charge.call(this, nodes[i], i);
          else
            for (i = 0; i < n; ++i)
              charges[i] = charge;
          function position(dimension, size) {
            if (!neighbors) {
              neighbors = new Array(n);
              for (j = 0; j < n; ++j) {
                neighbors[j] = [];
              }
              for (j = 0; j < m; ++j) {
                var o = links[j];
                neighbors[o.source.index].push(o.target);
                neighbors[o.target.index].push(o.source);
              }
            }
            var candidates = neighbors[i],
                j = -1,
                l = candidates.length,
                x;
            while (++j < l)
              if (!isNaN(x = candidates[j][dimension]))
                return x;
            return Math.random() * size;
          }
          return force.resume();
        };
        force.resume = function() {
          return force.alpha(.1);
        };
        force.stop = function() {
          return force.alpha(0);
        };
        force.drag = function() {
          if (!drag)
            drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
          if (!arguments.length)
            return drag;
          this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
        };
        function dragmove(d) {
          d.px = d3.event.x, d.py = d3.event.y;
          force.resume();
        }
        return d3.rebind(force, event, "on");
      };
      function d3_layout_forceDragstart(d) {
        d.fixed |= 2;
      }
      function d3_layout_forceDragend(d) {
        d.fixed &= ~6;
      }
      function d3_layout_forceMouseover(d) {
        d.fixed |= 4;
        d.px = d.x, d.py = d.y;
      }
      function d3_layout_forceMouseout(d) {
        d.fixed &= ~4;
      }
      function d3_layout_forceAccumulate(quad, alpha, charges) {
        var cx = 0,
            cy = 0;
        quad.charge = 0;
        if (!quad.leaf) {
          var nodes = quad.nodes,
              n = nodes.length,
              i = -1,
              c;
          while (++i < n) {
            c = nodes[i];
            if (c == null)
              continue;
            d3_layout_forceAccumulate(c, alpha, charges);
            quad.charge += c.charge;
            cx += c.charge * c.cx;
            cy += c.charge * c.cy;
          }
        }
        if (quad.point) {
          if (!quad.leaf) {
            quad.point.x += Math.random() - .5;
            quad.point.y += Math.random() - .5;
          }
          var k = alpha * charges[quad.point.index];
          quad.charge += quad.pointCharge = k;
          cx += k * quad.point.x;
          cy += k * quad.point.y;
        }
        quad.cx = cx / quad.charge;
        quad.cy = cy / quad.charge;
      }
      var d3_layout_forceLinkDistance = 20,
          d3_layout_forceLinkStrength = 1,
          d3_layout_forceChargeDistance2 = Infinity;
      d3.layout.hierarchy = function() {
        var sort = d3_layout_hierarchySort,
            children = d3_layout_hierarchyChildren,
            value = d3_layout_hierarchyValue;
        function hierarchy(root) {
          var stack = [root],
              nodes = [],
              node;
          root.depth = 0;
          while ((node = stack.pop()) != null) {
            nodes.push(node);
            if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
              var n,
                  childs,
                  child;
              while (--n >= 0) {
                stack.push(child = childs[n]);
                child.parent = node;
                child.depth = node.depth + 1;
              }
              if (value)
                node.value = 0;
              node.children = childs;
            } else {
              if (value)
                node.value = +value.call(hierarchy, node, node.depth) || 0;
              delete node.children;
            }
          }
          d3_layout_hierarchyVisitAfter(root, function(node) {
            var childs,
                parent;
            if (sort && (childs = node.children))
              childs.sort(sort);
            if (value && (parent = node.parent))
              parent.value += node.value;
          });
          return nodes;
        }
        hierarchy.sort = function(x) {
          if (!arguments.length)
            return sort;
          sort = x;
          return hierarchy;
        };
        hierarchy.children = function(x) {
          if (!arguments.length)
            return children;
          children = x;
          return hierarchy;
        };
        hierarchy.value = function(x) {
          if (!arguments.length)
            return value;
          value = x;
          return hierarchy;
        };
        hierarchy.revalue = function(root) {
          if (value) {
            d3_layout_hierarchyVisitBefore(root, function(node) {
              if (node.children)
                node.value = 0;
            });
            d3_layout_hierarchyVisitAfter(root, function(node) {
              var parent;
              if (!node.children)
                node.value = +value.call(hierarchy, node, node.depth) || 0;
              if (parent = node.parent)
                parent.value += node.value;
            });
          }
          return root;
        };
        return hierarchy;
      };
      function d3_layout_hierarchyRebind(object, hierarchy) {
        d3.rebind(object, hierarchy, "sort", "children", "value");
        object.nodes = object;
        object.links = d3_layout_hierarchyLinks;
        return object;
      }
      function d3_layout_hierarchyVisitBefore(node, callback) {
        var nodes = [node];
        while ((node = nodes.pop()) != null) {
          callback(node);
          if ((children = node.children) && (n = children.length)) {
            var n,
                children;
            while (--n >= 0)
              nodes.push(children[n]);
          }
        }
      }
      function d3_layout_hierarchyVisitAfter(node, callback) {
        var nodes = [node],
            nodes2 = [];
        while ((node = nodes.pop()) != null) {
          nodes2.push(node);
          if ((children = node.children) && (n = children.length)) {
            var i = -1,
                n,
                children;
            while (++i < n)
              nodes.push(children[i]);
          }
        }
        while ((node = nodes2.pop()) != null) {
          callback(node);
        }
      }
      function d3_layout_hierarchyChildren(d) {
        return d.children;
      }
      function d3_layout_hierarchyValue(d) {
        return d.value;
      }
      function d3_layout_hierarchySort(a, b) {
        return b.value - a.value;
      }
      function d3_layout_hierarchyLinks(nodes) {
        return d3.merge(nodes.map(function(parent) {
          return (parent.children || []).map(function(child) {
            return {
              source: parent,
              target: child
            };
          });
        }));
      }
      d3.layout.partition = function() {
        var hierarchy = d3.layout.hierarchy(),
            size = [1, 1];
        function position(node, x, dx, dy) {
          var children = node.children;
          node.x = x;
          node.y = node.depth * dy;
          node.dx = dx;
          node.dy = dy;
          if (children && (n = children.length)) {
            var i = -1,
                n,
                c,
                d;
            dx = node.value ? dx / node.value : 0;
            while (++i < n) {
              position(c = children[i], x, d = c.value * dx, dy);
              x += d;
            }
          }
        }
        function depth(node) {
          var children = node.children,
              d = 0;
          if (children && (n = children.length)) {
            var i = -1,
                n;
            while (++i < n)
              d = Math.max(d, depth(children[i]));
          }
          return 1 + d;
        }
        function partition(d, i) {
          var nodes = hierarchy.call(this, d, i);
          position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
          return nodes;
        }
        partition.size = function(x) {
          if (!arguments.length)
            return size;
          size = x;
          return partition;
        };
        return d3_layout_hierarchyRebind(partition, hierarchy);
      };
      d3.layout.pie = function() {
        var value = Number,
            sort = d3_layout_pieSortByValue,
            startAngle = 0,
            endAngle = τ,
            padAngle = 0;
        function pie(data) {
          var n = data.length,
              values = data.map(function(d, i) {
                return +value.call(pie, d, i);
              }),
              a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle),
              da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a,
              p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)),
              pa = p * (da < 0 ? -1 : 1),
              sum = d3.sum(values),
              k = sum ? (da - n * pa) / sum : 0,
              index = d3.range(n),
              arcs = [],
              v;
          if (sort != null)
            index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
              return values[j] - values[i];
            } : function(i, j) {
              return sort(data[i], data[j]);
            });
          index.forEach(function(i) {
            arcs[i] = {
              data: data[i],
              value: v = values[i],
              startAngle: a,
              endAngle: a += v * k + pa,
              padAngle: p
            };
          });
          return arcs;
        }
        pie.value = function(_) {
          if (!arguments.length)
            return value;
          value = _;
          return pie;
        };
        pie.sort = function(_) {
          if (!arguments.length)
            return sort;
          sort = _;
          return pie;
        };
        pie.startAngle = function(_) {
          if (!arguments.length)
            return startAngle;
          startAngle = _;
          return pie;
        };
        pie.endAngle = function(_) {
          if (!arguments.length)
            return endAngle;
          endAngle = _;
          return pie;
        };
        pie.padAngle = function(_) {
          if (!arguments.length)
            return padAngle;
          padAngle = _;
          return pie;
        };
        return pie;
      };
      var d3_layout_pieSortByValue = {};
      d3.layout.stack = function() {
        var values = d3_identity,
            order = d3_layout_stackOrderDefault,
            offset = d3_layout_stackOffsetZero,
            out = d3_layout_stackOut,
            x = d3_layout_stackX,
            y = d3_layout_stackY;
        function stack(data, index) {
          if (!(n = data.length))
            return data;
          var series = data.map(function(d, i) {
            return values.call(stack, d, i);
          });
          var points = series.map(function(d) {
            return d.map(function(v, i) {
              return [x.call(stack, v, i), y.call(stack, v, i)];
            });
          });
          var orders = order.call(stack, points, index);
          series = d3.permute(series, orders);
          points = d3.permute(points, orders);
          var offsets = offset.call(stack, points, index);
          var m = series[0].length,
              n,
              i,
              j,
              o;
          for (j = 0; j < m; ++j) {
            out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
            for (i = 1; i < n; ++i) {
              out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
            }
          }
          return data;
        }
        stack.values = function(x) {
          if (!arguments.length)
            return values;
          values = x;
          return stack;
        };
        stack.order = function(x) {
          if (!arguments.length)
            return order;
          order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
          return stack;
        };
        stack.offset = function(x) {
          if (!arguments.length)
            return offset;
          offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
          return stack;
        };
        stack.x = function(z) {
          if (!arguments.length)
            return x;
          x = z;
          return stack;
        };
        stack.y = function(z) {
          if (!arguments.length)
            return y;
          y = z;
          return stack;
        };
        stack.out = function(z) {
          if (!arguments.length)
            return out;
          out = z;
          return stack;
        };
        return stack;
      };
      function d3_layout_stackX(d) {
        return d.x;
      }
      function d3_layout_stackY(d) {
        return d.y;
      }
      function d3_layout_stackOut(d, y0, y) {
        d.y0 = y0;
        d.y = y;
      }
      var d3_layout_stackOrders = d3.map({
        "inside-out": function(data) {
          var n = data.length,
              i,
              j,
              max = data.map(d3_layout_stackMaxIndex),
              sums = data.map(d3_layout_stackReduceSum),
              index = d3.range(n).sort(function(a, b) {
                return max[a] - max[b];
              }),
              top = 0,
              bottom = 0,
              tops = [],
              bottoms = [];
          for (i = 0; i < n; ++i) {
            j = index[i];
            if (top < bottom) {
              top += sums[j];
              tops.push(j);
            } else {
              bottom += sums[j];
              bottoms.push(j);
            }
          }
          return bottoms.reverse().concat(tops);
        },
        reverse: function(data) {
          return d3.range(data.length).reverse();
        },
        "default": d3_layout_stackOrderDefault
      });
      var d3_layout_stackOffsets = d3.map({
        silhouette: function(data) {
          var n = data.length,
              m = data[0].length,
              sums = [],
              max = 0,
              i,
              j,
              o,
              y0 = [];
          for (j = 0; j < m; ++j) {
            for (i = 0, o = 0; i < n; i++)
              o += data[i][j][1];
            if (o > max)
              max = o;
            sums.push(o);
          }
          for (j = 0; j < m; ++j) {
            y0[j] = (max - sums[j]) / 2;
          }
          return y0;
        },
        wiggle: function(data) {
          var n = data.length,
              x = data[0],
              m = x.length,
              i,
              j,
              k,
              s1,
              s2,
              s3,
              dx,
              o,
              o0,
              y0 = [];
          y0[0] = o = o0 = 0;
          for (j = 1; j < m; ++j) {
            for (i = 0, s1 = 0; i < n; ++i)
              s1 += data[i][j][1];
            for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
              for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
                s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
              }
              s2 += s3 * data[i][j][1];
            }
            y0[j] = o -= s1 ? s2 / s1 * dx : 0;
            if (o < o0)
              o0 = o;
          }
          for (j = 0; j < m; ++j)
            y0[j] -= o0;
          return y0;
        },
        expand: function(data) {
          var n = data.length,
              m = data[0].length,
              k = 1 / n,
              i,
              j,
              o,
              y0 = [];
          for (j = 0; j < m; ++j) {
            for (i = 0, o = 0; i < n; i++)
              o += data[i][j][1];
            if (o)
              for (i = 0; i < n; i++)
                data[i][j][1] /= o;
            else
              for (i = 0; i < n; i++)
                data[i][j][1] = k;
          }
          for (j = 0; j < m; ++j)
            y0[j] = 0;
          return y0;
        },
        zero: d3_layout_stackOffsetZero
      });
      function d3_layout_stackOrderDefault(data) {
        return d3.range(data.length);
      }
      function d3_layout_stackOffsetZero(data) {
        var j = -1,
            m = data[0].length,
            y0 = [];
        while (++j < m)
          y0[j] = 0;
        return y0;
      }
      function d3_layout_stackMaxIndex(array) {
        var i = 1,
            j = 0,
            v = array[0][1],
            k,
            n = array.length;
        for (; i < n; ++i) {
          if ((k = array[i][1]) > v) {
            j = i;
            v = k;
          }
        }
        return j;
      }
      function d3_layout_stackReduceSum(d) {
        return d.reduce(d3_layout_stackSum, 0);
      }
      function d3_layout_stackSum(p, d) {
        return p + d[1];
      }
      d3.layout.histogram = function() {
        var frequency = true,
            valuer = Number,
            ranger = d3_layout_histogramRange,
            binner = d3_layout_histogramBinSturges;
        function histogram(data, i) {
          var bins = [],
              values = data.map(valuer, this),
              range = ranger.call(this, values, i),
              thresholds = binner.call(this, range, values, i),
              bin,
              i = -1,
              n = values.length,
              m = thresholds.length - 1,
              k = frequency ? 1 : 1 / n,
              x;
          while (++i < m) {
            bin = bins[i] = [];
            bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
            bin.y = 0;
          }
          if (m > 0) {
            i = -1;
            while (++i < n) {
              x = values[i];
              if (x >= range[0] && x <= range[1]) {
                bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
                bin.y += k;
                bin.push(data[i]);
              }
            }
          }
          return bins;
        }
        histogram.value = function(x) {
          if (!arguments.length)
            return valuer;
          valuer = x;
          return histogram;
        };
        histogram.range = function(x) {
          if (!arguments.length)
            return ranger;
          ranger = d3_functor(x);
          return histogram;
        };
        histogram.bins = function(x) {
          if (!arguments.length)
            return binner;
          binner = typeof x === "number" ? function(range) {
            return d3_layout_histogramBinFixed(range, x);
          } : d3_functor(x);
          return histogram;
        };
        histogram.frequency = function(x) {
          if (!arguments.length)
            return frequency;
          frequency = !!x;
          return histogram;
        };
        return histogram;
      };
      function d3_layout_histogramBinSturges(range, values) {
        return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
      }
      function d3_layout_histogramBinFixed(range, n) {
        var x = -1,
            b = +range[0],
            m = (range[1] - b) / n,
            f = [];
        while (++x <= n)
          f[x] = m * x + b;
        return f;
      }
      function d3_layout_histogramRange(values) {
        return [d3.min(values), d3.max(values)];
      }
      d3.layout.pack = function() {
        var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort),
            padding = 0,
            size = [1, 1],
            radius;
        function pack(d, i) {
          var nodes = hierarchy.call(this, d, i),
              root = nodes[0],
              w = size[0],
              h = size[1],
              r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
                return radius;
              };
          root.x = root.y = 0;
          d3_layout_hierarchyVisitAfter(root, function(d) {
            d.r = +r(d.value);
          });
          d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
          if (padding) {
            var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
            d3_layout_hierarchyVisitAfter(root, function(d) {
              d.r += dr;
            });
            d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
            d3_layout_hierarchyVisitAfter(root, function(d) {
              d.r -= dr;
            });
          }
          d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
          return nodes;
        }
        pack.size = function(_) {
          if (!arguments.length)
            return size;
          size = _;
          return pack;
        };
        pack.radius = function(_) {
          if (!arguments.length)
            return radius;
          radius = _ == null || typeof _ === "function" ? _ : +_;
          return pack;
        };
        pack.padding = function(_) {
          if (!arguments.length)
            return padding;
          padding = +_;
          return pack;
        };
        return d3_layout_hierarchyRebind(pack, hierarchy);
      };
      function d3_layout_packSort(a, b) {
        return a.value - b.value;
      }
      function d3_layout_packInsert(a, b) {
        var c = a._pack_next;
        a._pack_next = b;
        b._pack_prev = a;
        b._pack_next = c;
        c._pack_prev = b;
      }
      function d3_layout_packSplice(a, b) {
        a._pack_next = b;
        b._pack_prev = a;
      }
      function d3_layout_packIntersects(a, b) {
        var dx = b.x - a.x,
            dy = b.y - a.y,
            dr = a.r + b.r;
        return .999 * dr * dr > dx * dx + dy * dy;
      }
      function d3_layout_packSiblings(node) {
        if (!(nodes = node.children) || !(n = nodes.length))
          return;
        var nodes,
            xMin = Infinity,
            xMax = -Infinity,
            yMin = Infinity,
            yMax = -Infinity,
            a,
            b,
            c,
            i,
            j,
            k,
            n;
        function bound(node) {
          xMin = Math.min(node.x - node.r, xMin);
          xMax = Math.max(node.x + node.r, xMax);
          yMin = Math.min(node.y - node.r, yMin);
          yMax = Math.max(node.y + node.r, yMax);
        }
        nodes.forEach(d3_layout_packLink);
        a = nodes[0];
        a.x = -a.r;
        a.y = 0;
        bound(a);
        if (n > 1) {
          b = nodes[1];
          b.x = b.r;
          b.y = 0;
          bound(b);
          if (n > 2) {
            c = nodes[2];
            d3_layout_packPlace(a, b, c);
            bound(c);
            d3_layout_packInsert(a, c);
            a._pack_prev = c;
            d3_layout_packInsert(c, b);
            b = a._pack_next;
            for (i = 3; i < n; i++) {
              d3_layout_packPlace(a, b, c = nodes[i]);
              var isect = 0,
                  s1 = 1,
                  s2 = 1;
              for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
                if (d3_layout_packIntersects(j, c)) {
                  isect = 1;
                  break;
                }
              }
              if (isect == 1) {
                for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
                  if (d3_layout_packIntersects(k, c)) {
                    break;
                  }
                }
              }
              if (isect) {
                if (s1 < s2 || s1 == s2 && b.r < a.r)
                  d3_layout_packSplice(a, b = j);
                else
                  d3_layout_packSplice(a = k, b);
                i--;
              } else {
                d3_layout_packInsert(a, c);
                b = c;
                bound(c);
              }
            }
          }
        }
        var cx = (xMin + xMax) / 2,
            cy = (yMin + yMax) / 2,
            cr = 0;
        for (i = 0; i < n; i++) {
          c = nodes[i];
          c.x -= cx;
          c.y -= cy;
          cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
        }
        node.r = cr;
        nodes.forEach(d3_layout_packUnlink);
      }
      function d3_layout_packLink(node) {
        node._pack_next = node._pack_prev = node;
      }
      function d3_layout_packUnlink(node) {
        delete node._pack_next;
        delete node._pack_prev;
      }
      function d3_layout_packTransform(node, x, y, k) {
        var children = node.children;
        node.x = x += k * node.x;
        node.y = y += k * node.y;
        node.r *= k;
        if (children) {
          var i = -1,
              n = children.length;
          while (++i < n)
            d3_layout_packTransform(children[i], x, y, k);
        }
      }
      function d3_layout_packPlace(a, b, c) {
        var db = a.r + c.r,
            dx = b.x - a.x,
            dy = b.y - a.y;
        if (db && (dx || dy)) {
          var da = b.r + c.r,
              dc = dx * dx + dy * dy;
          da *= da;
          db *= db;
          var x = .5 + (db - da) / (2 * dc),
              y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
          c.x = a.x + x * dx + y * dy;
          c.y = a.y + x * dy - y * dx;
        } else {
          c.x = a.x + db;
          c.y = a.y;
        }
      }
      d3.layout.tree = function() {
        var hierarchy = d3.layout.hierarchy().sort(null).value(null),
            separation = d3_layout_treeSeparation,
            size = [1, 1],
            nodeSize = null;
        function tree(d, i) {
          var nodes = hierarchy.call(this, d, i),
              root0 = nodes[0],
              root1 = wrapTree(root0);
          d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
          d3_layout_hierarchyVisitBefore(root1, secondWalk);
          if (nodeSize)
            d3_layout_hierarchyVisitBefore(root0, sizeNode);
          else {
            var left = root0,
                right = root0,
                bottom = root0;
            d3_layout_hierarchyVisitBefore(root0, function(node) {
              if (node.x < left.x)
                left = node;
              if (node.x > right.x)
                right = node;
              if (node.depth > bottom.depth)
                bottom = node;
            });
            var tx = separation(left, right) / 2 - left.x,
                kx = size[0] / (right.x + separation(right, left) / 2 + tx),
                ky = size[1] / (bottom.depth || 1);
            d3_layout_hierarchyVisitBefore(root0, function(node) {
              node.x = (node.x + tx) * kx;
              node.y = node.depth * ky;
            });
          }
          return nodes;
        }
        function wrapTree(root0) {
          var root1 = {
            A: null,
            children: [root0]
          },
              queue = [root1],
              node1;
          while ((node1 = queue.pop()) != null) {
            for (var children = node1.children,
                child,
                i = 0,
                n = children.length; i < n; ++i) {
              queue.push((children[i] = child = {
                _: children[i],
                parent: node1,
                children: (child = children[i].children) && child.slice() || [],
                A: null,
                a: null,
                z: 0,
                m: 0,
                c: 0,
                s: 0,
                t: null,
                i: i
              }).a = child);
            }
          }
          return root1.children[0];
        }
        function firstWalk(v) {
          var children = v.children,
              siblings = v.parent.children,
              w = v.i ? siblings[v.i - 1] : null;
          if (children.length) {
            d3_layout_treeShift(v);
            var midpoint = (children[0].z + children[children.length - 1].z) / 2;
            if (w) {
              v.z = w.z + separation(v._, w._);
              v.m = v.z - midpoint;
            } else {
              v.z = midpoint;
            }
          } else if (w) {
            v.z = w.z + separation(v._, w._);
          }
          v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
        }
        function secondWalk(v) {
          v._.x = v.z + v.parent.m;
          v.m += v.parent.m;
        }
        function apportion(v, w, ancestor) {
          if (w) {
            var vip = v,
                vop = v,
                vim = w,
                vom = vip.parent.children[0],
                sip = vip.m,
                sop = vop.m,
                sim = vim.m,
                som = vom.m,
                shift;
            while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
              vom = d3_layout_treeLeft(vom);
              vop = d3_layout_treeRight(vop);
              vop.a = v;
              shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
              if (shift > 0) {
                d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
                sip += shift;
                sop += shift;
              }
              sim += vim.m;
              sip += vip.m;
              som += vom.m;
              sop += vop.m;
            }
            if (vim && !d3_layout_treeRight(vop)) {
              vop.t = vim;
              vop.m += sim - sop;
            }
            if (vip && !d3_layout_treeLeft(vom)) {
              vom.t = vip;
              vom.m += sip - som;
              ancestor = v;
            }
          }
          return ancestor;
        }
        function sizeNode(node) {
          node.x *= size[0];
          node.y = node.depth * size[1];
        }
        tree.separation = function(x) {
          if (!arguments.length)
            return separation;
          separation = x;
          return tree;
        };
        tree.size = function(x) {
          if (!arguments.length)
            return nodeSize ? null : size;
          nodeSize = (size = x) == null ? sizeNode : null;
          return tree;
        };
        tree.nodeSize = function(x) {
          if (!arguments.length)
            return nodeSize ? size : null;
          nodeSize = (size = x) == null ? null : sizeNode;
          return tree;
        };
        return d3_layout_hierarchyRebind(tree, hierarchy);
      };
      function d3_layout_treeSeparation(a, b) {
        return a.parent == b.parent ? 1 : 2;
      }
      function d3_layout_treeLeft(v) {
        var children = v.children;
        return children.length ? children[0] : v.t;
      }
      function d3_layout_treeRight(v) {
        var children = v.children,
            n;
        return (n = children.length) ? children[n - 1] : v.t;
      }
      function d3_layout_treeMove(wm, wp, shift) {
        var change = shift / (wp.i - wm.i);
        wp.c -= change;
        wp.s += shift;
        wm.c += change;
        wp.z += shift;
        wp.m += shift;
      }
      function d3_layout_treeShift(v) {
        var shift = 0,
            change = 0,
            children = v.children,
            i = children.length,
            w;
        while (--i >= 0) {
          w = children[i];
          w.z += shift;
          w.m += shift;
          shift += w.s + (change += w.c);
        }
      }
      function d3_layout_treeAncestor(vim, v, ancestor) {
        return vim.a.parent === v.parent ? vim.a : ancestor;
      }
      d3.layout.cluster = function() {
        var hierarchy = d3.layout.hierarchy().sort(null).value(null),
            separation = d3_layout_treeSeparation,
            size = [1, 1],
            nodeSize = false;
        function cluster(d, i) {
          var nodes = hierarchy.call(this, d, i),
              root = nodes[0],
              previousNode,
              x = 0;
          d3_layout_hierarchyVisitAfter(root, function(node) {
            var children = node.children;
            if (children && children.length) {
              node.x = d3_layout_clusterX(children);
              node.y = d3_layout_clusterY(children);
            } else {
              node.x = previousNode ? x += separation(node, previousNode) : 0;
              node.y = 0;
              previousNode = node;
            }
          });
          var left = d3_layout_clusterLeft(root),
              right = d3_layout_clusterRight(root),
              x0 = left.x - separation(left, right) / 2,
              x1 = right.x + separation(right, left) / 2;
          d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
            node.x = (node.x - root.x) * size[0];
            node.y = (root.y - node.y) * size[1];
          } : function(node) {
            node.x = (node.x - x0) / (x1 - x0) * size[0];
            node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
          });
          return nodes;
        }
        cluster.separation = function(x) {
          if (!arguments.length)
            return separation;
          separation = x;
          return cluster;
        };
        cluster.size = function(x) {
          if (!arguments.length)
            return nodeSize ? null : size;
          nodeSize = (size = x) == null;
          return cluster;
        };
        cluster.nodeSize = function(x) {
          if (!arguments.length)
            return nodeSize ? size : null;
          nodeSize = (size = x) != null;
          return cluster;
        };
        return d3_layout_hierarchyRebind(cluster, hierarchy);
      };
      function d3_layout_clusterY(children) {
        return 1 + d3.max(children, function(child) {
          return child.y;
        });
      }
      function d3_layout_clusterX(children) {
        return children.reduce(function(x, child) {
          return x + child.x;
        }, 0) / children.length;
      }
      function d3_layout_clusterLeft(node) {
        var children = node.children;
        return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
      }
      function d3_layout_clusterRight(node) {
        var children = node.children,
            n;
        return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
      }
      d3.layout.treemap = function() {
        var hierarchy = d3.layout.hierarchy(),
            round = Math.round,
            size = [1, 1],
            padding = null,
            pad = d3_layout_treemapPadNull,
            sticky = false,
            stickies,
            mode = "squarify",
            ratio = .5 * (1 + Math.sqrt(5));
        function scale(children, k) {
          var i = -1,
              n = children.length,
              child,
              area;
          while (++i < n) {
            area = (child = children[i]).value * (k < 0 ? 0 : k);
            child.area = isNaN(area) || area <= 0 ? 0 : area;
          }
        }
        function squarify(node) {
          var children = node.children;
          if (children && children.length) {
            var rect = pad(node),
                row = [],
                remaining = children.slice(),
                child,
                best = Infinity,
                score,
                u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy),
                n;
            scale(remaining, rect.dx * rect.dy / node.value);
            row.area = 0;
            while ((n = remaining.length) > 0) {
              row.push(child = remaining[n - 1]);
              row.area += child.area;
              if (mode !== "squarify" || (score = worst(row, u)) <= best) {
                remaining.pop();
                best = score;
              } else {
                row.area -= row.pop().area;
                position(row, u, rect, false);
                u = Math.min(rect.dx, rect.dy);
                row.length = row.area = 0;
                best = Infinity;
              }
            }
            if (row.length) {
              position(row, u, rect, true);
              row.length = row.area = 0;
            }
            children.forEach(squarify);
          }
        }
        function stickify(node) {
          var children = node.children;
          if (children && children.length) {
            var rect = pad(node),
                remaining = children.slice(),
                child,
                row = [];
            scale(remaining, rect.dx * rect.dy / node.value);
            row.area = 0;
            while (child = remaining.pop()) {
              row.push(child);
              row.area += child.area;
              if (child.z != null) {
                position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
                row.length = row.area = 0;
              }
            }
            children.forEach(stickify);
          }
        }
        function worst(row, u) {
          var s = row.area,
              r,
              rmax = 0,
              rmin = Infinity,
              i = -1,
              n = row.length;
          while (++i < n) {
            if (!(r = row[i].area))
              continue;
            if (r < rmin)
              rmin = r;
            if (r > rmax)
              rmax = r;
          }
          s *= s;
          u *= u;
          return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
        }
        function position(row, u, rect, flush) {
          var i = -1,
              n = row.length,
              x = rect.x,
              y = rect.y,
              v = u ? round(row.area / u) : 0,
              o;
          if (u == rect.dx) {
            if (flush || v > rect.dy)
              v = rect.dy;
            while (++i < n) {
              o = row[i];
              o.x = x;
              o.y = y;
              o.dy = v;
              x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
            }
            o.z = true;
            o.dx += rect.x + rect.dx - x;
            rect.y += v;
            rect.dy -= v;
          } else {
            if (flush || v > rect.dx)
              v = rect.dx;
            while (++i < n) {
              o = row[i];
              o.x = x;
              o.y = y;
              o.dx = v;
              y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
            }
            o.z = false;
            o.dy += rect.y + rect.dy - y;
            rect.x += v;
            rect.dx -= v;
          }
        }
        function treemap(d) {
          var nodes = stickies || hierarchy(d),
              root = nodes[0];
          root.x = root.y = 0;
          if (root.value)
            root.dx = size[0], root.dy = size[1];
          else
            root.dx = root.dy = 0;
          if (stickies)
            hierarchy.revalue(root);
          scale([root], root.dx * root.dy / root.value);
          (stickies ? stickify : squarify)(root);
          if (sticky)
            stickies = nodes;
          return nodes;
        }
        treemap.size = function(x) {
          if (!arguments.length)
            return size;
          size = x;
          return treemap;
        };
        treemap.padding = function(x) {
          if (!arguments.length)
            return padding;
          function padFunction(node) {
            var p = x.call(treemap, node, node.depth);
            return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [p, p, p, p] : p);
          }
          function padConstant(node) {
            return d3_layout_treemapPad(node, x);
          }
          var type;
          pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [x, x, x, x], padConstant) : padConstant;
          return treemap;
        };
        treemap.round = function(x) {
          if (!arguments.length)
            return round != Number;
          round = x ? Math.round : Number;
          return treemap;
        };
        treemap.sticky = function(x) {
          if (!arguments.length)
            return sticky;
          sticky = x;
          stickies = null;
          return treemap;
        };
        treemap.ratio = function(x) {
          if (!arguments.length)
            return ratio;
          ratio = x;
          return treemap;
        };
        treemap.mode = function(x) {
          if (!arguments.length)
            return mode;
          mode = x + "";
          return treemap;
        };
        return d3_layout_hierarchyRebind(treemap, hierarchy);
      };
      function d3_layout_treemapPadNull(node) {
        return {
          x: node.x,
          y: node.y,
          dx: node.dx,
          dy: node.dy
        };
      }
      function d3_layout_treemapPad(node, padding) {
        var x = node.x + padding[3],
            y = node.y + padding[0],
            dx = node.dx - padding[1] - padding[3],
            dy = node.dy - padding[0] - padding[2];
        if (dx < 0) {
          x += dx / 2;
          dx = 0;
        }
        if (dy < 0) {
          y += dy / 2;
          dy = 0;
        }
        return {
          x: x,
          y: y,
          dx: dx,
          dy: dy
        };
      }
      d3.random = {
        normal: function(µ, σ) {
          var n = arguments.length;
          if (n < 2)
            σ = 1;
          if (n < 1)
            µ = 0;
          return function() {
            var x,
                y,
                r;
            do {
              x = Math.random() * 2 - 1;
              y = Math.random() * 2 - 1;
              r = x * x + y * y;
            } while (!r || r > 1);
            return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
          };
        },
        logNormal: function() {
          var random = d3.random.normal.apply(d3, arguments);
          return function() {
            return Math.exp(random());
          };
        },
        bates: function(m) {
          var random = d3.random.irwinHall(m);
          return function() {
            return random() / m;
          };
        },
        irwinHall: function(m) {
          return function() {
            for (var s = 0,
                j = 0; j < m; j++)
              s += Math.random();
            return s;
          };
        }
      };
      d3.scale = {};
      function d3_scaleExtent(domain) {
        var start = domain[0],
            stop = domain[domain.length - 1];
        return start < stop ? [start, stop] : [stop, start];
      }
      function d3_scaleRange(scale) {
        return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
      }
      function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
        var u = uninterpolate(domain[0], domain[1]),
            i = interpolate(range[0], range[1]);
        return function(x) {
          return i(u(x));
        };
      }
      function d3_scale_nice(domain, nice) {
        var i0 = 0,
            i1 = domain.length - 1,
            x0 = domain[i0],
            x1 = domain[i1],
            dx;
        if (x1 < x0) {
          dx = i0, i0 = i1, i1 = dx;
          dx = x0, x0 = x1, x1 = dx;
        }
        domain[i0] = nice.floor(x0);
        domain[i1] = nice.ceil(x1);
        return domain;
      }
      function d3_scale_niceStep(step) {
        return step ? {
          floor: function(x) {
            return Math.floor(x / step) * step;
          },
          ceil: function(x) {
            return Math.ceil(x / step) * step;
          }
        } : d3_scale_niceIdentity;
      }
      var d3_scale_niceIdentity = {
        floor: d3_identity,
        ceil: d3_identity
      };
      function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
        var u = [],
            i = [],
            j = 0,
            k = Math.min(domain.length, range.length) - 1;
        if (domain[k] < domain[0]) {
          domain = domain.slice().reverse();
          range = range.slice().reverse();
        }
        while (++j <= k) {
          u.push(uninterpolate(domain[j - 1], domain[j]));
          i.push(interpolate(range[j - 1], range[j]));
        }
        return function(x) {
          var j = d3.bisect(domain, x, 1, k) - 1;
          return i[j](u[j](x));
        };
      }
      d3.scale.linear = function() {
        return d3_scale_linear([0, 1], [0, 1], d3_interpolate, false);
      };
      function d3_scale_linear(domain, range, interpolate, clamp) {
        var output,
            input;
        function rescale() {
          var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear,
              uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
          output = linear(domain, range, uninterpolate, interpolate);
          input = linear(range, domain, uninterpolate, d3_interpolate);
          return scale;
        }
        function scale(x) {
          return output(x);
        }
        scale.invert = function(y) {
          return input(y);
        };
        scale.domain = function(x) {
          if (!arguments.length)
            return domain;
          domain = x.map(Number);
          return rescale();
        };
        scale.range = function(x) {
          if (!arguments.length)
            return range;
          range = x;
          return rescale();
        };
        scale.rangeRound = function(x) {
          return scale.range(x).interpolate(d3_interpolateRound);
        };
        scale.clamp = function(x) {
          if (!arguments.length)
            return clamp;
          clamp = x;
          return rescale();
        };
        scale.interpolate = function(x) {
          if (!arguments.length)
            return interpolate;
          interpolate = x;
          return rescale();
        };
        scale.ticks = function(m) {
          return d3_scale_linearTicks(domain, m);
        };
        scale.tickFormat = function(m, format) {
          return d3_scale_linearTickFormat(domain, m, format);
        };
        scale.nice = function(m) {
          d3_scale_linearNice(domain, m);
          return rescale();
        };
        scale.copy = function() {
          return d3_scale_linear(domain, range, interpolate, clamp);
        };
        return rescale();
      }
      function d3_scale_linearRebind(scale, linear) {
        return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
      }
      function d3_scale_linearNice(domain, m) {
        d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
        d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
        return domain;
      }
      function d3_scale_linearTickRange(domain, m) {
        if (m == null)
          m = 10;
        var extent = d3_scaleExtent(domain),
            span = extent[1] - extent[0],
            step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)),
            err = m / span * step;
        if (err <= .15)
          step *= 10;
        else if (err <= .35)
          step *= 5;
        else if (err <= .75)
          step *= 2;
        extent[0] = Math.ceil(extent[0] / step) * step;
        extent[1] = Math.floor(extent[1] / step) * step + step * .5;
        extent[2] = step;
        return extent;
      }
      function d3_scale_linearTicks(domain, m) {
        return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
      }
      function d3_scale_linearTickFormat(domain, m, format) {
        var range = d3_scale_linearTickRange(domain, m);
        if (format) {
          var match = d3_format_re.exec(format);
          match.shift();
          if (match[8] === "s") {
            var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
            if (!match[7])
              match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
            match[8] = "f";
            format = d3.format(match.join(""));
            return function(d) {
              return format(prefix.scale(d)) + prefix.symbol;
            };
          }
          if (!match[7])
            match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
          format = match.join("");
        } else {
          format = ",." + d3_scale_linearPrecision(range[2]) + "f";
        }
        return d3.format(format);
      }
      var d3_scale_linearFormatSignificant = {
        s: 1,
        g: 1,
        p: 1,
        r: 1,
        e: 1
      };
      function d3_scale_linearPrecision(value) {
        return -Math.floor(Math.log(value) / Math.LN10 + .01);
      }
      function d3_scale_linearFormatPrecision(type, range) {
        var p = d3_scale_linearPrecision(range[2]);
        return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
      }
      d3.scale.log = function() {
        return d3_scale_log(d3.scale.linear().domain([0, 1]), 10, true, [1, 10]);
      };
      function d3_scale_log(linear, base, positive, domain) {
        function log(x) {
          return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
        }
        function pow(x) {
          return positive ? Math.pow(base, x) : -Math.pow(base, -x);
        }
        function scale(x) {
          return linear(log(x));
        }
        scale.invert = function(x) {
          return pow(linear.invert(x));
        };
        scale.domain = function(x) {
          if (!arguments.length)
            return domain;
          positive = x[0] >= 0;
          linear.domain((domain = x.map(Number)).map(log));
          return scale;
        };
        scale.base = function(_) {
          if (!arguments.length)
            return base;
          base = +_;
          linear.domain(domain.map(log));
          return scale;
        };
        scale.nice = function() {
          var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
          linear.domain(niced);
          domain = niced.map(pow);
          return scale;
        };
        scale.ticks = function() {
          var extent = d3_scaleExtent(domain),
              ticks = [],
              u = extent[0],
              v = extent[1],
              i = Math.floor(log(u)),
              j = Math.ceil(log(v)),
              n = base % 1 ? 2 : base;
          if (isFinite(j - i)) {
            if (positive) {
              for (; i < j; i++)
                for (var k = 1; k < n; k++)
                  ticks.push(pow(i) * k);
              ticks.push(pow(i));
            } else {
              ticks.push(pow(i));
              for (; i++ < j; )
                for (var k = n - 1; k > 0; k--)
                  ticks.push(pow(i) * k);
            }
            for (i = 0; ticks[i] < u; i++) {}
            for (j = ticks.length; ticks[j - 1] > v; j--) {}
            ticks = ticks.slice(i, j);
          }
          return ticks;
        };
        scale.tickFormat = function(n, format) {
          if (!arguments.length)
            return d3_scale_logFormat;
          if (arguments.length < 2)
            format = d3_scale_logFormat;
          else if (typeof format !== "function")
            format = d3.format(format);
          var k = Math.max(1, base * n / scale.ticks().length);
          return function(d) {
            var i = d / pow(Math.round(log(d)));
            if (i * base < base - .5)
              i *= base;
            return i <= k ? format(d) : "";
          };
        };
        scale.copy = function() {
          return d3_scale_log(linear.copy(), base, positive, domain);
        };
        return d3_scale_linearRebind(scale, linear);
      }
      var d3_scale_logFormat = d3.format(".0e"),
          d3_scale_logNiceNegative = {
            floor: function(x) {
              return -Math.ceil(-x);
            },
            ceil: function(x) {
              return -Math.floor(-x);
            }
          };
      d3.scale.pow = function() {
        return d3_scale_pow(d3.scale.linear(), 1, [0, 1]);
      };
      function d3_scale_pow(linear, exponent, domain) {
        var powp = d3_scale_powPow(exponent),
            powb = d3_scale_powPow(1 / exponent);
        function scale(x) {
          return linear(powp(x));
        }
        scale.invert = function(x) {
          return powb(linear.invert(x));
        };
        scale.domain = function(x) {
          if (!arguments.length)
            return domain;
          linear.domain((domain = x.map(Number)).map(powp));
          return scale;
        };
        scale.ticks = function(m) {
          return d3_scale_linearTicks(domain, m);
        };
        scale.tickFormat = function(m, format) {
          return d3_scale_linearTickFormat(domain, m, format);
        };
        scale.nice = function(m) {
          return scale.domain(d3_scale_linearNice(domain, m));
        };
        scale.exponent = function(x) {
          if (!arguments.length)
            return exponent;
          powp = d3_scale_powPow(exponent = x);
          powb = d3_scale_powPow(1 / exponent);
          linear.domain(domain.map(powp));
          return scale;
        };
        scale.copy = function() {
          return d3_scale_pow(linear.copy(), exponent, domain);
        };
        return d3_scale_linearRebind(scale, linear);
      }
      function d3_scale_powPow(e) {
        return function(x) {
          return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
        };
      }
      d3.scale.sqrt = function() {
        return d3.scale.pow().exponent(.5);
      };
      d3.scale.ordinal = function() {
        return d3_scale_ordinal([], {
          t: "range",
          a: [[]]
        });
      };
      function d3_scale_ordinal(domain, ranger) {
        var index,
            range,
            rangeBand;
        function scale(x) {
          return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
        }
        function steps(start, step) {
          return d3.range(domain.length).map(function(i) {
            return start + step * i;
          });
        }
        scale.domain = function(x) {
          if (!arguments.length)
            return domain;
          domain = [];
          index = new d3_Map();
          var i = -1,
              n = x.length,
              xi;
          while (++i < n)
            if (!index.has(xi = x[i]))
              index.set(xi, domain.push(xi));
          return scale[ranger.t].apply(scale, ranger.a);
        };
        scale.range = function(x) {
          if (!arguments.length)
            return range;
          range = x;
          rangeBand = 0;
          ranger = {
            t: "range",
            a: arguments
          };
          return scale;
        };
        scale.rangePoints = function(x, padding) {
          if (arguments.length < 2)
            padding = 0;
          var start = x[0],
              stop = x[1],
              step = domain.length < 2 ? (start = (start + stop) / 2, 0) : (stop - start) / (domain.length - 1 + padding);
          range = steps(start + step * padding / 2, step);
          rangeBand = 0;
          ranger = {
            t: "rangePoints",
            a: arguments
          };
          return scale;
        };
        scale.rangeRoundPoints = function(x, padding) {
          if (arguments.length < 2)
            padding = 0;
          var start = x[0],
              stop = x[1],
              step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 0) : (stop - start) / (domain.length - 1 + padding) | 0;
          range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
          rangeBand = 0;
          ranger = {
            t: "rangeRoundPoints",
            a: arguments
          };
          return scale;
        };
        scale.rangeBands = function(x, padding, outerPadding) {
          if (arguments.length < 2)
            padding = 0;
          if (arguments.length < 3)
            outerPadding = padding;
          var reverse = x[1] < x[0],
              start = x[reverse - 0],
              stop = x[1 - reverse],
              step = (stop - start) / (domain.length - padding + 2 * outerPadding);
          range = steps(start + step * outerPadding, step);
          if (reverse)
            range.reverse();
          rangeBand = step * (1 - padding);
          ranger = {
            t: "rangeBands",
            a: arguments
          };
          return scale;
        };
        scale.rangeRoundBands = function(x, padding, outerPadding) {
          if (arguments.length < 2)
            padding = 0;
          if (arguments.length < 3)
            outerPadding = padding;
          var reverse = x[1] < x[0],
              start = x[reverse - 0],
              stop = x[1 - reverse],
              step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
          range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
          if (reverse)
            range.reverse();
          rangeBand = Math.round(step * (1 - padding));
          ranger = {
            t: "rangeRoundBands",
            a: arguments
          };
          return scale;
        };
        scale.rangeBand = function() {
          return rangeBand;
        };
        scale.rangeExtent = function() {
          return d3_scaleExtent(ranger.a[0]);
        };
        scale.copy = function() {
          return d3_scale_ordinal(domain, ranger);
        };
        return scale.domain(domain);
      }
      d3.scale.category10 = function() {
        return d3.scale.ordinal().range(d3_category10);
      };
      d3.scale.category20 = function() {
        return d3.scale.ordinal().range(d3_category20);
      };
      d3.scale.category20b = function() {
        return d3.scale.ordinal().range(d3_category20b);
      };
      d3.scale.category20c = function() {
        return d3.scale.ordinal().range(d3_category20c);
      };
      var d3_category10 = [2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175].map(d3_rgbString);
      var d3_category20 = [2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725].map(d3_rgbString);
      var d3_category20b = [3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654].map(d3_rgbString);
      var d3_category20c = [3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081].map(d3_rgbString);
      d3.scale.quantile = function() {
        return d3_scale_quantile([], []);
      };
      function d3_scale_quantile(domain, range) {
        var thresholds;
        function rescale() {
          var k = 0,
              q = range.length;
          thresholds = [];
          while (++k < q)
            thresholds[k - 1] = d3.quantile(domain, k / q);
          return scale;
        }
        function scale(x) {
          if (!isNaN(x = +x))
            return range[d3.bisect(thresholds, x)];
        }
        scale.domain = function(x) {
          if (!arguments.length)
            return domain;
          domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
          return rescale();
        };
        scale.range = function(x) {
          if (!arguments.length)
            return range;
          range = x;
          return rescale();
        };
        scale.quantiles = function() {
          return thresholds;
        };
        scale.invertExtent = function(y) {
          y = range.indexOf(y);
          return y < 0 ? [NaN, NaN] : [y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1]];
        };
        scale.copy = function() {
          return d3_scale_quantile(domain, range);
        };
        return rescale();
      }
      d3.scale.quantize = function() {
        return d3_scale_quantize(0, 1, [0, 1]);
      };
      function d3_scale_quantize(x0, x1, range) {
        var kx,
            i;
        function scale(x) {
          return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
        }
        function rescale() {
          kx = range.length / (x1 - x0);
          i = range.length - 1;
          return scale;
        }
        scale.domain = function(x) {
          if (!arguments.length)
            return [x0, x1];
          x0 = +x[0];
          x1 = +x[x.length - 1];
          return rescale();
        };
        scale.range = function(x) {
          if (!arguments.length)
            return range;
          range = x;
          return rescale();
        };
        scale.invertExtent = function(y) {
          y = range.indexOf(y);
          y = y < 0 ? NaN : y / kx + x0;
          return [y, y + 1 / kx];
        };
        scale.copy = function() {
          return d3_scale_quantize(x0, x1, range);
        };
        return rescale();
      }
      d3.scale.threshold = function() {
        return d3_scale_threshold([.5], [0, 1]);
      };
      function d3_scale_threshold(domain, range) {
        function scale(x) {
          if (x <= x)
            return range[d3.bisect(domain, x)];
        }
        scale.domain = function(_) {
          if (!arguments.length)
            return domain;
          domain = _;
          return scale;
        };
        scale.range = function(_) {
          if (!arguments.length)
            return range;
          range = _;
          return scale;
        };
        scale.invertExtent = function(y) {
          y = range.indexOf(y);
          return [domain[y - 1], domain[y]];
        };
        scale.copy = function() {
          return d3_scale_threshold(domain, range);
        };
        return scale;
      }
      d3.scale.identity = function() {
        return d3_scale_identity([0, 1]);
      };
      function d3_scale_identity(domain) {
        function identity(x) {
          return +x;
        }
        identity.invert = identity;
        identity.domain = identity.range = function(x) {
          if (!arguments.length)
            return domain;
          domain = x.map(identity);
          return identity;
        };
        identity.ticks = function(m) {
          return d3_scale_linearTicks(domain, m);
        };
        identity.tickFormat = function(m, format) {
          return d3_scale_linearTickFormat(domain, m, format);
        };
        identity.copy = function() {
          return d3_scale_identity(domain);
        };
        return identity;
      }
      d3.svg = {};
      function d3_zero() {
        return 0;
      }
      d3.svg.arc = function() {
        var innerRadius = d3_svg_arcInnerRadius,
            outerRadius = d3_svg_arcOuterRadius,
            cornerRadius = d3_zero,
            padRadius = d3_svg_arcAuto,
            startAngle = d3_svg_arcStartAngle,
            endAngle = d3_svg_arcEndAngle,
            padAngle = d3_svg_arcPadAngle;
        function arc() {
          var r0 = Math.max(0, +innerRadius.apply(this, arguments)),
              r1 = Math.max(0, +outerRadius.apply(this, arguments)),
              a0 = startAngle.apply(this, arguments) - halfπ,
              a1 = endAngle.apply(this, arguments) - halfπ,
              da = Math.abs(a1 - a0),
              cw = a0 > a1 ? 0 : 1;
          if (r1 < r0)
            rc = r1, r1 = r0, r0 = rc;
          if (da >= τε)
            return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
          var rc,
              cr,
              rp,
              ap,
              p0 = 0,
              p1 = 0,
              x0,
              y0,
              x1,
              y1,
              x2,
              y2,
              x3,
              y3,
              path = [];
          if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
            rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
            if (!cw)
              p1 *= -1;
            if (r1)
              p1 = d3_asin(rp / r1 * Math.sin(ap));
            if (r0)
              p0 = d3_asin(rp / r0 * Math.sin(ap));
          }
          if (r1) {
            x0 = r1 * Math.cos(a0 + p1);
            y0 = r1 * Math.sin(a0 + p1);
            x1 = r1 * Math.cos(a1 - p1);
            y1 = r1 * Math.sin(a1 - p1);
            var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
            if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
              var h1 = (a0 + a1) / 2;
              x0 = r1 * Math.cos(h1);
              y0 = r1 * Math.sin(h1);
              x1 = y1 = null;
            }
          } else {
            x0 = y0 = 0;
          }
          if (r0) {
            x2 = r0 * Math.cos(a1 - p0);
            y2 = r0 * Math.sin(a1 - p0);
            x3 = r0 * Math.cos(a0 + p0);
            y3 = r0 * Math.sin(a0 + p0);
            var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
            if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
              var h0 = (a0 + a1) / 2;
              x2 = r0 * Math.cos(h0);
              y2 = r0 * Math.sin(h0);
              x3 = y3 = null;
            }
          } else {
            x2 = y2 = 0;
          }
          if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
            cr = r0 < r1 ^ cw ? 0 : 1;
            var rc1 = rc,
                rc0 = rc;
            if (da < π) {
              var oc = x3 == null ? [x2, y2] : x1 == null ? [x0, y0] : d3_geom_polygonIntersect([x0, y0], [x3, y3], [x1, y1], [x2, y2]),
                  ax = x0 - oc[0],
                  ay = y0 - oc[1],
                  bx = x1 - oc[0],
                  by = y1 - oc[1],
                  kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2),
                  lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
              rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
              rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
            }
            if (x1 != null) {
              var t30 = d3_svg_arcCornerTangents(x3 == null ? [x2, y2] : [x3, y3], [x0, y0], r1, rc1, cw),
                  t12 = d3_svg_arcCornerTangents([x1, y1], [x2, y2], r1, rc1, cw);
              if (rc === rc1) {
                path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
              } else {
                path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
              }
            } else {
              path.push("M", x0, ",", y0);
            }
            if (x3 != null) {
              var t03 = d3_svg_arcCornerTangents([x0, y0], [x3, y3], r0, -rc0, cw),
                  t21 = d3_svg_arcCornerTangents([x2, y2], x1 == null ? [x0, y0] : [x1, y1], r0, -rc0, cw);
              if (rc === rc0) {
                path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
              } else {
                path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
              }
            } else {
              path.push("L", x2, ",", y2);
            }
          } else {
            path.push("M", x0, ",", y0);
            if (x1 != null)
              path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
            path.push("L", x2, ",", y2);
            if (x3 != null)
              path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
          }
          path.push("Z");
          return path.join("");
        }
        function circleSegment(r1, cw) {
          return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
        }
        arc.innerRadius = function(v) {
          if (!arguments.length)
            return innerRadius;
          innerRadius = d3_functor(v);
          return arc;
        };
        arc.outerRadius = function(v) {
          if (!arguments.length)
            return outerRadius;
          outerRadius = d3_functor(v);
          return arc;
        };
        arc.cornerRadius = function(v) {
          if (!arguments.length)
            return cornerRadius;
          cornerRadius = d3_functor(v);
          return arc;
        };
        arc.padRadius = function(v) {
          if (!arguments.length)
            return padRadius;
          padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
          return arc;
        };
        arc.startAngle = function(v) {
          if (!arguments.length)
            return startAngle;
          startAngle = d3_functor(v);
          return arc;
        };
        arc.endAngle = function(v) {
          if (!arguments.length)
            return endAngle;
          endAngle = d3_functor(v);
          return arc;
        };
        arc.padAngle = function(v) {
          if (!arguments.length)
            return padAngle;
          padAngle = d3_functor(v);
          return arc;
        };
        arc.centroid = function() {
          var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
              a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
          return [Math.cos(a) * r, Math.sin(a) * r];
        };
        return arc;
      };
      var d3_svg_arcAuto = "auto";
      function d3_svg_arcInnerRadius(d) {
        return d.innerRadius;
      }
      function d3_svg_arcOuterRadius(d) {
        return d.outerRadius;
      }
      function d3_svg_arcStartAngle(d) {
        return d.startAngle;
      }
      function d3_svg_arcEndAngle(d) {
        return d.endAngle;
      }
      function d3_svg_arcPadAngle(d) {
        return d && d.padAngle;
      }
      function d3_svg_arcSweep(x0, y0, x1, y1) {
        return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
      }
      function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
        var x01 = p0[0] - p1[0],
            y01 = p0[1] - p1[1],
            lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01),
            ox = lo * y01,
            oy = -lo * x01,
            x1 = p0[0] + ox,
            y1 = p0[1] + oy,
            x2 = p1[0] + ox,
            y2 = p1[1] + oy,
            x3 = (x1 + x2) / 2,
            y3 = (y1 + y2) / 2,
            dx = x2 - x1,
            dy = y2 - y1,
            d2 = dx * dx + dy * dy,
            r = r1 - rc,
            D = x1 * y2 - x2 * y1,
            d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)),
            cx0 = (D * dy - dx * d) / d2,
            cy0 = (-D * dx - dy * d) / d2,
            cx1 = (D * dy + dx * d) / d2,
            cy1 = (-D * dx + dy * d) / d2,
            dx0 = cx0 - x3,
            dy0 = cy0 - y3,
            dx1 = cx1 - x3,
            dy1 = cy1 - y3;
        if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1)
          cx0 = cx1, cy0 = cy1;
        return [[cx0 - ox, cy0 - oy], [cx0 * r1 / r, cy0 * r1 / r]];
      }
      function d3_svg_line(projection) {
        var x = d3_geom_pointX,
            y = d3_geom_pointY,
            defined = d3_true,
            interpolate = d3_svg_lineLinear,
            interpolateKey = interpolate.key,
            tension = .7;
        function line(data) {
          var segments = [],
              points = [],
              i = -1,
              n = data.length,
              d,
              fx = d3_functor(x),
              fy = d3_functor(y);
          function segment() {
            segments.push("M", interpolate(projection(points), tension));
          }
          while (++i < n) {
            if (defined.call(this, d = data[i], i)) {
              points.push([+fx.call(this, d, i), +fy.call(this, d, i)]);
            } else if (points.length) {
              segment();
              points = [];
            }
          }
          if (points.length)
            segment();
          return segments.length ? segments.join("") : null;
        }
        line.x = function(_) {
          if (!arguments.length)
            return x;
          x = _;
          return line;
        };
        line.y = function(_) {
          if (!arguments.length)
            return y;
          y = _;
          return line;
        };
        line.defined = function(_) {
          if (!arguments.length)
            return defined;
          defined = _;
          return line;
        };
        line.interpolate = function(_) {
          if (!arguments.length)
            return interpolateKey;
          if (typeof _ === "function")
            interpolateKey = interpolate = _;
          else
            interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
          return line;
        };
        line.tension = function(_) {
          if (!arguments.length)
            return tension;
          tension = _;
          return line;
        };
        return line;
      }
      d3.svg.line = function() {
        return d3_svg_line(d3_identity);
      };
      var d3_svg_lineInterpolators = d3.map({
        linear: d3_svg_lineLinear,
        "linear-closed": d3_svg_lineLinearClosed,
        step: d3_svg_lineStep,
        "step-before": d3_svg_lineStepBefore,
        "step-after": d3_svg_lineStepAfter,
        basis: d3_svg_lineBasis,
        "basis-open": d3_svg_lineBasisOpen,
        "basis-closed": d3_svg_lineBasisClosed,
        bundle: d3_svg_lineBundle,
        cardinal: d3_svg_lineCardinal,
        "cardinal-open": d3_svg_lineCardinalOpen,
        "cardinal-closed": d3_svg_lineCardinalClosed,
        monotone: d3_svg_lineMonotone
      });
      d3_svg_lineInterpolators.forEach(function(key, value) {
        value.key = key;
        value.closed = /-closed$/.test(key);
      });
      function d3_svg_lineLinear(points) {
        return points.length > 1 ? points.join("L") : points + "Z";
      }
      function d3_svg_lineLinearClosed(points) {
        return points.join("L") + "Z";
      }
      function d3_svg_lineStep(points) {
        var i = 0,
            n = points.length,
            p = points[0],
            path = [p[0], ",", p[1]];
        while (++i < n)
          path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
        if (n > 1)
          path.push("H", p[0]);
        return path.join("");
      }
      function d3_svg_lineStepBefore(points) {
        var i = 0,
            n = points.length,
            p = points[0],
            path = [p[0], ",", p[1]];
        while (++i < n)
          path.push("V", (p = points[i])[1], "H", p[0]);
        return path.join("");
      }
      function d3_svg_lineStepAfter(points) {
        var i = 0,
            n = points.length,
            p = points[0],
            path = [p[0], ",", p[1]];
        while (++i < n)
          path.push("H", (p = points[i])[0], "V", p[1]);
        return path.join("");
      }
      function d3_svg_lineCardinalOpen(points, tension) {
        return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
      }
      function d3_svg_lineCardinalClosed(points, tension) {
        return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), points), d3_svg_lineCardinalTangents([points[points.length - 2]].concat(points, [points[1]]), tension));
      }
      function d3_svg_lineCardinal(points, tension) {
        return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
      }
      function d3_svg_lineHermite(points, tangents) {
        if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
          return d3_svg_lineLinear(points);
        }
        var quad = points.length != tangents.length,
            path = "",
            p0 = points[0],
            p = points[1],
            t0 = tangents[0],
            t = t0,
            pi = 1;
        if (quad) {
          path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
          p0 = points[1];
          pi = 2;
        }
        if (tangents.length > 1) {
          t = tangents[1];
          p = points[pi];
          pi++;
          path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
          for (var i = 2; i < tangents.length; i++, pi++) {
            p = points[pi];
            t = tangents[i];
            path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
          }
        }
        if (quad) {
          var lp = points[pi];
          path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
        }
        return path;
      }
      function d3_svg_lineCardinalTangents(points, tension) {
        var tangents = [],
            a = (1 - tension) / 2,
            p0,
            p1 = points[0],
            p2 = points[1],
            i = 1,
            n = points.length;
        while (++i < n) {
          p0 = p1;
          p1 = p2;
          p2 = points[i];
          tangents.push([a * (p2[0] - p0[0]), a * (p2[1] - p0[1])]);
        }
        return tangents;
      }
      function d3_svg_lineBasis(points) {
        if (points.length < 3)
          return d3_svg_lineLinear(points);
        var i = 1,
            n = points.length,
            pi = points[0],
            x0 = pi[0],
            y0 = pi[1],
            px = [x0, x0, x0, (pi = points[1])[0]],
            py = [y0, y0, y0, pi[1]],
            path = [x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py)];
        points.push(points[n - 1]);
        while (++i <= n) {
          pi = points[i];
          px.shift();
          px.push(pi[0]);
          py.shift();
          py.push(pi[1]);
          d3_svg_lineBasisBezier(path, px, py);
        }
        points.pop();
        path.push("L", pi);
        return path.join("");
      }
      function d3_svg_lineBasisOpen(points) {
        if (points.length < 4)
          return d3_svg_lineLinear(points);
        var path = [],
            i = -1,
            n = points.length,
            pi,
            px = [0],
            py = [0];
        while (++i < 3) {
          pi = points[i];
          px.push(pi[0]);
          py.push(pi[1]);
        }
        path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
        --i;
        while (++i < n) {
          pi = points[i];
          px.shift();
          px.push(pi[0]);
          py.shift();
          py.push(pi[1]);
          d3_svg_lineBasisBezier(path, px, py);
        }
        return path.join("");
      }
      function d3_svg_lineBasisClosed(points) {
        var path,
            i = -1,
            n = points.length,
            m = n + 4,
            pi,
            px = [],
            py = [];
        while (++i < 4) {
          pi = points[i % n];
          px.push(pi[0]);
          py.push(pi[1]);
        }
        path = [d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py)];
        --i;
        while (++i < m) {
          pi = points[i % n];
          px.shift();
          px.push(pi[0]);
          py.shift();
          py.push(pi[1]);
          d3_svg_lineBasisBezier(path, px, py);
        }
        return path.join("");
      }
      function d3_svg_lineBundle(points, tension) {
        var n = points.length - 1;
        if (n) {
          var x0 = points[0][0],
              y0 = points[0][1],
              dx = points[n][0] - x0,
              dy = points[n][1] - y0,
              i = -1,
              p,
              t;
          while (++i <= n) {
            p = points[i];
            t = i / n;
            p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
            p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
          }
        }
        return d3_svg_lineBasis(points);
      }
      function d3_svg_lineDot4(a, b) {
        return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
      }
      var d3_svg_lineBasisBezier1 = [0, 2 / 3, 1 / 3, 0],
          d3_svg_lineBasisBezier2 = [0, 1 / 3, 2 / 3, 0],
          d3_svg_lineBasisBezier3 = [0, 1 / 6, 2 / 3, 1 / 6];
      function d3_svg_lineBasisBezier(path, x, y) {
        path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
      }
      function d3_svg_lineSlope(p0, p1) {
        return (p1[1] - p0[1]) / (p1[0] - p0[0]);
      }
      function d3_svg_lineFiniteDifferences(points) {
        var i = 0,
            j = points.length - 1,
            m = [],
            p0 = points[0],
            p1 = points[1],
            d = m[0] = d3_svg_lineSlope(p0, p1);
        while (++i < j) {
          m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
        }
        m[i] = d;
        return m;
      }
      function d3_svg_lineMonotoneTangents(points) {
        var tangents = [],
            d,
            a,
            b,
            s,
            m = d3_svg_lineFiniteDifferences(points),
            i = -1,
            j = points.length - 1;
        while (++i < j) {
          d = d3_svg_lineSlope(points[i], points[i + 1]);
          if (abs(d) < ε) {
            m[i] = m[i + 1] = 0;
          } else {
            a = m[i] / d;
            b = m[i + 1] / d;
            s = a * a + b * b;
            if (s > 9) {
              s = d * 3 / Math.sqrt(s);
              m[i] = s * a;
              m[i + 1] = s * b;
            }
          }
        }
        i = -1;
        while (++i <= j) {
          s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
          tangents.push([s || 0, m[i] * s || 0]);
        }
        return tangents;
      }
      function d3_svg_lineMonotone(points) {
        return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
      }
      d3.svg.line.radial = function() {
        var line = d3_svg_line(d3_svg_lineRadial);
        line.radius = line.x, delete line.x;
        line.angle = line.y, delete line.y;
        return line;
      };
      function d3_svg_lineRadial(points) {
        var point,
            i = -1,
            n = points.length,
            r,
            a;
        while (++i < n) {
          point = points[i];
          r = point[0];
          a = point[1] - halfπ;
          point[0] = r * Math.cos(a);
          point[1] = r * Math.sin(a);
        }
        return points;
      }
      function d3_svg_area(projection) {
        var x0 = d3_geom_pointX,
            x1 = d3_geom_pointX,
            y0 = 0,
            y1 = d3_geom_pointY,
            defined = d3_true,
            interpolate = d3_svg_lineLinear,
            interpolateKey = interpolate.key,
            interpolateReverse = interpolate,
            L = "L",
            tension = .7;
        function area(data) {
          var segments = [],
              points0 = [],
              points1 = [],
              i = -1,
              n = data.length,
              d,
              fx0 = d3_functor(x0),
              fy0 = d3_functor(y0),
              fx1 = x0 === x1 ? function() {
                return x;
              } : d3_functor(x1),
              fy1 = y0 === y1 ? function() {
                return y;
              } : d3_functor(y1),
              x,
              y;
          function segment() {
            segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
          }
          while (++i < n) {
            if (defined.call(this, d = data[i], i)) {
              points0.push([x = +fx0.call(this, d, i), y = +fy0.call(this, d, i)]);
              points1.push([+fx1.call(this, d, i), +fy1.call(this, d, i)]);
            } else if (points0.length) {
              segment();
              points0 = [];
              points1 = [];
            }
          }
          if (points0.length)
            segment();
          return segments.length ? segments.join("") : null;
        }
        area.x = function(_) {
          if (!arguments.length)
            return x1;
          x0 = x1 = _;
          return area;
        };
        area.x0 = function(_) {
          if (!arguments.length)
            return x0;
          x0 = _;
          return area;
        };
        area.x1 = function(_) {
          if (!arguments.length)
            return x1;
          x1 = _;
          return area;
        };
        area.y = function(_) {
          if (!arguments.length)
            return y1;
          y0 = y1 = _;
          return area;
        };
        area.y0 = function(_) {
          if (!arguments.length)
            return y0;
          y0 = _;
          return area;
        };
        area.y1 = function(_) {
          if (!arguments.length)
            return y1;
          y1 = _;
          return area;
        };
        area.defined = function(_) {
          if (!arguments.length)
            return defined;
          defined = _;
          return area;
        };
        area.interpolate = function(_) {
          if (!arguments.length)
            return interpolateKey;
          if (typeof _ === "function")
            interpolateKey = interpolate = _;
          else
            interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
          interpolateReverse = interpolate.reverse || interpolate;
          L = interpolate.closed ? "M" : "L";
          return area;
        };
        area.tension = function(_) {
          if (!arguments.length)
            return tension;
          tension = _;
          return area;
        };
        return area;
      }
      d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
      d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
      d3.svg.area = function() {
        return d3_svg_area(d3_identity);
      };
      d3.svg.area.radial = function() {
        var area = d3_svg_area(d3_svg_lineRadial);
        area.radius = area.x, delete area.x;
        area.innerRadius = area.x0, delete area.x0;
        area.outerRadius = area.x1, delete area.x1;
        area.angle = area.y, delete area.y;
        area.startAngle = area.y0, delete area.y0;
        area.endAngle = area.y1, delete area.y1;
        return area;
      };
      d3.svg.chord = function() {
        var source = d3_source,
            target = d3_target,
            radius = d3_svg_chordRadius,
            startAngle = d3_svg_arcStartAngle,
            endAngle = d3_svg_arcEndAngle;
        function chord(d, i) {
          var s = subgroup(this, source, d, i),
              t = subgroup(this, target, d, i);
          return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
        }
        function subgroup(self, f, d, i) {
          var subgroup = f.call(self, d, i),
              r = radius.call(self, subgroup, i),
              a0 = startAngle.call(self, subgroup, i) - halfπ,
              a1 = endAngle.call(self, subgroup, i) - halfπ;
          return {
            r: r,
            a0: a0,
            a1: a1,
            p0: [r * Math.cos(a0), r * Math.sin(a0)],
            p1: [r * Math.cos(a1), r * Math.sin(a1)]
          };
        }
        function equals(a, b) {
          return a.a0 == b.a0 && a.a1 == b.a1;
        }
        function arc(r, p, a) {
          return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
        }
        function curve(r0, p0, r1, p1) {
          return "Q 0,0 " + p1;
        }
        chord.radius = function(v) {
          if (!arguments.length)
            return radius;
          radius = d3_functor(v);
          return chord;
        };
        chord.source = function(v) {
          if (!arguments.length)
            return source;
          source = d3_functor(v);
          return chord;
        };
        chord.target = function(v) {
          if (!arguments.length)
            return target;
          target = d3_functor(v);
          return chord;
        };
        chord.startAngle = function(v) {
          if (!arguments.length)
            return startAngle;
          startAngle = d3_functor(v);
          return chord;
        };
        chord.endAngle = function(v) {
          if (!arguments.length)
            return endAngle;
          endAngle = d3_functor(v);
          return chord;
        };
        return chord;
      };
      function d3_svg_chordRadius(d) {
        return d.radius;
      }
      d3.svg.diagonal = function() {
        var source = d3_source,
            target = d3_target,
            projection = d3_svg_diagonalProjection;
        function diagonal(d, i) {
          var p0 = source.call(this, d, i),
              p3 = target.call(this, d, i),
              m = (p0.y + p3.y) / 2,
              p = [p0, {
                x: p0.x,
                y: m
              }, {
                x: p3.x,
                y: m
              }, p3];
          p = p.map(projection);
          return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
        }
        diagonal.source = function(x) {
          if (!arguments.length)
            return source;
          source = d3_functor(x);
          return diagonal;
        };
        diagonal.target = function(x) {
          if (!arguments.length)
            return target;
          target = d3_functor(x);
          return diagonal;
        };
        diagonal.projection = function(x) {
          if (!arguments.length)
            return projection;
          projection = x;
          return diagonal;
        };
        return diagonal;
      };
      function d3_svg_diagonalProjection(d) {
        return [d.x, d.y];
      }
      d3.svg.diagonal.radial = function() {
        var diagonal = d3.svg.diagonal(),
            projection = d3_svg_diagonalProjection,
            projection_ = diagonal.projection;
        diagonal.projection = function(x) {
          return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
        };
        return diagonal;
      };
      function d3_svg_diagonalRadialProjection(projection) {
        return function() {
          var d = projection.apply(this, arguments),
              r = d[0],
              a = d[1] - halfπ;
          return [r * Math.cos(a), r * Math.sin(a)];
        };
      }
      d3.svg.symbol = function() {
        var type = d3_svg_symbolType,
            size = d3_svg_symbolSize;
        function symbol(d, i) {
          return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
        }
        symbol.type = function(x) {
          if (!arguments.length)
            return type;
          type = d3_functor(x);
          return symbol;
        };
        symbol.size = function(x) {
          if (!arguments.length)
            return size;
          size = d3_functor(x);
          return symbol;
        };
        return symbol;
      };
      function d3_svg_symbolSize() {
        return 64;
      }
      function d3_svg_symbolType() {
        return "circle";
      }
      function d3_svg_symbolCircle(size) {
        var r = Math.sqrt(size / π);
        return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
      }
      var d3_svg_symbols = d3.map({
        circle: d3_svg_symbolCircle,
        cross: function(size) {
          var r = Math.sqrt(size / 5) / 2;
          return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
        },
        diamond: function(size) {
          var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)),
              rx = ry * d3_svg_symbolTan30;
          return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
        },
        square: function(size) {
          var r = Math.sqrt(size) / 2;
          return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
        },
        "triangle-down": function(size) {
          var rx = Math.sqrt(size / d3_svg_symbolSqrt3),
              ry = rx * d3_svg_symbolSqrt3 / 2;
          return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
        },
        "triangle-up": function(size) {
          var rx = Math.sqrt(size / d3_svg_symbolSqrt3),
              ry = rx * d3_svg_symbolSqrt3 / 2;
          return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
        }
      });
      d3.svg.symbolTypes = d3_svg_symbols.keys();
      var d3_svg_symbolSqrt3 = Math.sqrt(3),
          d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
      d3_selectionPrototype.transition = function(name) {
        var id = d3_transitionInheritId || ++d3_transitionId,
            ns = d3_transitionNamespace(name),
            subgroups = [],
            subgroup,
            node,
            transition = d3_transitionInherit || {
              time: Date.now(),
              ease: d3_ease_cubicInOut,
              delay: 0,
              duration: 250
            };
        for (var j = -1,
            m = this.length; ++j < m; ) {
          subgroups.push(subgroup = []);
          for (var group = this[j],
              i = -1,
              n = group.length; ++i < n; ) {
            if (node = group[i])
              d3_transitionNode(node, i, ns, id, transition);
            subgroup.push(node);
          }
        }
        return d3_transition(subgroups, ns, id);
      };
      d3_selectionPrototype.interrupt = function(name) {
        return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
      };
      var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
      function d3_selection_interruptNS(ns) {
        return function() {
          var lock,
              activeId,
              active;
          if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
            active.timer.c = null;
            active.timer.t = NaN;
            if (--lock.count)
              delete lock[activeId];
            else
              delete this[ns];
            lock.active += .5;
            active.event && active.event.interrupt.call(this, this.__data__, active.index);
          }
        };
      }
      function d3_transition(groups, ns, id) {
        d3_subclass(groups, d3_transitionPrototype);
        groups.namespace = ns;
        groups.id = id;
        return groups;
      }
      var d3_transitionPrototype = [],
          d3_transitionId = 0,
          d3_transitionInheritId,
          d3_transitionInherit;
      d3_transitionPrototype.call = d3_selectionPrototype.call;
      d3_transitionPrototype.empty = d3_selectionPrototype.empty;
      d3_transitionPrototype.node = d3_selectionPrototype.node;
      d3_transitionPrototype.size = d3_selectionPrototype.size;
      d3.transition = function(selection, name) {
        return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
      };
      d3.transition.prototype = d3_transitionPrototype;
      d3_transitionPrototype.select = function(selector) {
        var id = this.id,
            ns = this.namespace,
            subgroups = [],
            subgroup,
            subnode,
            node;
        selector = d3_selection_selector(selector);
        for (var j = -1,
            m = this.length; ++j < m; ) {
          subgroups.push(subgroup = []);
          for (var group = this[j],
              i = -1,
              n = group.length; ++i < n; ) {
            if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
              if ("__data__" in node)
                subnode.__data__ = node.__data__;
              d3_transitionNode(subnode, i, ns, id, node[ns][id]);
              subgroup.push(subnode);
            } else {
              subgroup.push(null);
            }
          }
        }
        return d3_transition(subgroups, ns, id);
      };
      d3_transitionPrototype.selectAll = function(selector) {
        var id = this.id,
            ns = this.namespace,
            subgroups = [],
            subgroup,
            subnodes,
            node,
            subnode,
            transition;
        selector = d3_selection_selectorAll(selector);
        for (var j = -1,
            m = this.length; ++j < m; ) {
          for (var group = this[j],
              i = -1,
              n = group.length; ++i < n; ) {
            if (node = group[i]) {
              transition = node[ns][id];
              subnodes = selector.call(node, node.__data__, i, j);
              subgroups.push(subgroup = []);
              for (var k = -1,
                  o = subnodes.length; ++k < o; ) {
                if (subnode = subnodes[k])
                  d3_transitionNode(subnode, k, ns, id, transition);
                subgroup.push(subnode);
              }
            }
          }
        }
        return d3_transition(subgroups, ns, id);
      };
      d3_transitionPrototype.filter = function(filter) {
        var subgroups = [],
            subgroup,
            group,
            node;
        if (typeof filter !== "function")
          filter = d3_selection_filter(filter);
        for (var j = 0,
            m = this.length; j < m; j++) {
          subgroups.push(subgroup = []);
          for (var group = this[j],
              i = 0,
              n = group.length; i < n; i++) {
            if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
              subgroup.push(node);
            }
          }
        }
        return d3_transition(subgroups, this.namespace, this.id);
      };
      d3_transitionPrototype.tween = function(name, tween) {
        var id = this.id,
            ns = this.namespace;
        if (arguments.length < 2)
          return this.node()[ns][id].tween.get(name);
        return d3_selection_each(this, tween == null ? function(node) {
          node[ns][id].tween.remove(name);
        } : function(node) {
          node[ns][id].tween.set(name, tween);
        });
      };
      function d3_transition_tween(groups, name, value, tween) {
        var id = groups.id,
            ns = groups.namespace;
        return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
          node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
        } : (value = tween(value), function(node) {
          node[ns][id].tween.set(name, value);
        }));
      }
      d3_transitionPrototype.attr = function(nameNS, value) {
        if (arguments.length < 2) {
          for (value in nameNS)
            this.attr(value, nameNS[value]);
          return this;
        }
        var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate,
            name = d3.ns.qualify(nameNS);
        function attrNull() {
          this.removeAttribute(name);
        }
        function attrNullNS() {
          this.removeAttributeNS(name.space, name.local);
        }
        function attrTween(b) {
          return b == null ? attrNull : (b += "", function() {
            var a = this.getAttribute(name),
                i;
            return a !== b && (i = interpolate(a, b), function(t) {
              this.setAttribute(name, i(t));
            });
          });
        }
        function attrTweenNS(b) {
          return b == null ? attrNullNS : (b += "", function() {
            var a = this.getAttributeNS(name.space, name.local),
                i;
            return a !== b && (i = interpolate(a, b), function(t) {
              this.setAttributeNS(name.space, name.local, i(t));
            });
          });
        }
        return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
      };
      d3_transitionPrototype.attrTween = function(nameNS, tween) {
        var name = d3.ns.qualify(nameNS);
        function attrTween(d, i) {
          var f = tween.call(this, d, i, this.getAttribute(name));
          return f && function(t) {
            this.setAttribute(name, f(t));
          };
        }
        function attrTweenNS(d, i) {
          var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
          return f && function(t) {
            this.setAttributeNS(name.space, name.local, f(t));
          };
        }
        return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
      };
      d3_transitionPrototype.style = function(name, value, priority) {
        var n = arguments.length;
        if (n < 3) {
          if (typeof name !== "string") {
            if (n < 2)
              value = "";
            for (priority in name)
              this.style(priority, name[priority], value);
            return this;
          }
          priority = "";
        }
        function styleNull() {
          this.style.removeProperty(name);
        }
        function styleString(b) {
          return b == null ? styleNull : (b += "", function() {
            var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name),
                i;
            return a !== b && (i = d3_interpolate(a, b), function(t) {
              this.style.setProperty(name, i(t), priority);
            });
          });
        }
        return d3_transition_tween(this, "style." + name, value, styleString);
      };
      d3_transitionPrototype.styleTween = function(name, tween, priority) {
        if (arguments.length < 3)
          priority = "";
        function styleTween(d, i) {
          var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
          return f && function(t) {
            this.style.setProperty(name, f(t), priority);
          };
        }
        return this.tween("style." + name, styleTween);
      };
      d3_transitionPrototype.text = function(value) {
        return d3_transition_tween(this, "text", value, d3_transition_text);
      };
      function d3_transition_text(b) {
        if (b == null)
          b = "";
        return function() {
          this.textContent = b;
        };
      }
      d3_transitionPrototype.remove = function() {
        var ns = this.namespace;
        return this.each("end.transition", function() {
          var p;
          if (this[ns].count < 2 && (p = this.parentNode))
            p.removeChild(this);
        });
      };
      d3_transitionPrototype.ease = function(value) {
        var id = this.id,
            ns = this.namespace;
        if (arguments.length < 1)
          return this.node()[ns][id].ease;
        if (typeof value !== "function")
          value = d3.ease.apply(d3, arguments);
        return d3_selection_each(this, function(node) {
          node[ns][id].ease = value;
        });
      };
      d3_transitionPrototype.delay = function(value) {
        var id = this.id,
            ns = this.namespace;
        if (arguments.length < 1)
          return this.node()[ns][id].delay;
        return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
          node[ns][id].delay = +value.call(node, node.__data__, i, j);
        } : (value = +value, function(node) {
          node[ns][id].delay = value;
        }));
      };
      d3_transitionPrototype.duration = function(value) {
        var id = this.id,
            ns = this.namespace;
        if (arguments.length < 1)
          return this.node()[ns][id].duration;
        return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
          node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
        } : (value = Math.max(1, value), function(node) {
          node[ns][id].duration = value;
        }));
      };
      d3_transitionPrototype.each = function(type, listener) {
        var id = this.id,
            ns = this.namespace;
        if (arguments.length < 2) {
          var inherit = d3_transitionInherit,
              inheritId = d3_transitionInheritId;
          try {
            d3_transitionInheritId = id;
            d3_selection_each(this, function(node, i, j) {
              d3_transitionInherit = node[ns][id];
              type.call(node, node.__data__, i, j);
            });
          } finally {
            d3_transitionInherit = inherit;
            d3_transitionInheritId = inheritId;
          }
        } else {
          d3_selection_each(this, function(node) {
            var transition = node[ns][id];
            (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
          });
        }
        return this;
      };
      d3_transitionPrototype.transition = function() {
        var id0 = this.id,
            id1 = ++d3_transitionId,
            ns = this.namespace,
            subgroups = [],
            subgroup,
            group,
            node,
            transition;
        for (var j = 0,
            m = this.length; j < m; j++) {
          subgroups.push(subgroup = []);
          for (var group = this[j],
              i = 0,
              n = group.length; i < n; i++) {
            if (node = group[i]) {
              transition = node[ns][id0];
              d3_transitionNode(node, i, ns, id1, {
                time: transition.time,
                ease: transition.ease,
                delay: transition.delay + transition.duration,
                duration: transition.duration
              });
            }
            subgroup.push(node);
          }
        }
        return d3_transition(subgroups, ns, id1);
      };
      function d3_transitionNamespace(name) {
        return name == null ? "__transition__" : "__transition_" + name + "__";
      }
      function d3_transitionNode(node, i, ns, id, inherit) {
        var lock = node[ns] || (node[ns] = {
          active: 0,
          count: 0
        }),
            transition = lock[id],
            time,
            timer,
            duration,
            ease,
            tweens;
        function schedule(elapsed) {
          var delay = transition.delay;
          timer.t = delay + time;
          if (delay <= elapsed)
            return start(elapsed - delay);
          timer.c = start;
        }
        function start(elapsed) {
          var activeId = lock.active,
              active = lock[activeId];
          if (active) {
            active.timer.c = null;
            active.timer.t = NaN;
            --lock.count;
            delete lock[activeId];
            active.event && active.event.interrupt.call(node, node.__data__, active.index);
          }
          for (var cancelId in lock) {
            if (+cancelId < id) {
              var cancel = lock[cancelId];
              cancel.timer.c = null;
              cancel.timer.t = NaN;
              --lock.count;
              delete lock[cancelId];
            }
          }
          timer.c = tick;
          d3_timer(function() {
            if (timer.c && tick(elapsed || 1)) {
              timer.c = null;
              timer.t = NaN;
            }
            return 1;
          }, 0, time);
          lock.active = id;
          transition.event && transition.event.start.call(node, node.__data__, i);
          tweens = [];
          transition.tween.forEach(function(key, value) {
            if (value = value.call(node, node.__data__, i)) {
              tweens.push(value);
            }
          });
          ease = transition.ease;
          duration = transition.duration;
        }
        function tick(elapsed) {
          var t = elapsed / duration,
              e = ease(t),
              n = tweens.length;
          while (n > 0) {
            tweens[--n].call(node, e);
          }
          if (t >= 1) {
            transition.event && transition.event.end.call(node, node.__data__, i);
            if (--lock.count)
              delete lock[id];
            else
              delete node[ns];
            return 1;
          }
        }
        if (!transition) {
          time = inherit.time;
          timer = d3_timer(schedule, 0, time);
          transition = lock[id] = {
            tween: new d3_Map(),
            time: time,
            timer: timer,
            delay: inherit.delay,
            duration: inherit.duration,
            ease: inherit.ease,
            index: i
          };
          inherit = null;
          ++lock.count;
        }
      }
      d3.svg.axis = function() {
        var scale = d3.scale.linear(),
            orient = d3_svg_axisDefaultOrient,
            innerTickSize = 6,
            outerTickSize = 6,
            tickPadding = 3,
            tickArguments_ = [10],
            tickValues = null,
            tickFormat_;
        function axis(g) {
          g.each(function() {
            var g = d3.select(this);
            var scale0 = this.__chart__ || scale,
                scale1 = this.__chart__ = scale.copy();
            var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues,
                tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_,
                tick = g.selectAll(".tick").data(ticks, scale1),
                tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε),
                tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(),
                tickUpdate = d3.transition(tick.order()).style("opacity", 1),
                tickSpacing = Math.max(innerTickSize, 0) + tickPadding,
                tickTransform;
            var range = d3_scaleRange(scale1),
                path = g.selectAll(".domain").data([0]),
                pathUpdate = (path.enter().append("path").attr("class", "domain"), d3.transition(path));
            tickEnter.append("line");
            tickEnter.append("text");
            var lineEnter = tickEnter.select("line"),
                lineUpdate = tickUpdate.select("line"),
                text = tick.select("text").text(tickFormat),
                textEnter = tickEnter.select("text"),
                textUpdate = tickUpdate.select("text"),
                sign = orient === "top" || orient === "left" ? -1 : 1,
                x1,
                x2,
                y1,
                y2;
            if (orient === "bottom" || orient === "top") {
              tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
              text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
              pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
            } else {
              tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
              text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
              pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
            }
            lineEnter.attr(y2, sign * innerTickSize);
            textEnter.attr(y1, sign * tickSpacing);
            lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
            textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
            if (scale1.rangeBand) {
              var x = scale1,
                  dx = x.rangeBand() / 2;
              scale0 = scale1 = function(d) {
                return x(d) + dx;
              };
            } else if (scale0.rangeBand) {
              scale0 = scale1;
            } else {
              tickExit.call(tickTransform, scale1, scale0);
            }
            tickEnter.call(tickTransform, scale0, scale1);
            tickUpdate.call(tickTransform, scale1, scale1);
          });
        }
        axis.scale = function(x) {
          if (!arguments.length)
            return scale;
          scale = x;
          return axis;
        };
        axis.orient = function(x) {
          if (!arguments.length)
            return orient;
          orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
          return axis;
        };
        axis.ticks = function() {
          if (!arguments.length)
            return tickArguments_;
          tickArguments_ = d3_array(arguments);
          return axis;
        };
        axis.tickValues = function(x) {
          if (!arguments.length)
            return tickValues;
          tickValues = x;
          return axis;
        };
        axis.tickFormat = function(x) {
          if (!arguments.length)
            return tickFormat_;
          tickFormat_ = x;
          return axis;
        };
        axis.tickSize = function(x) {
          var n = arguments.length;
          if (!n)
            return innerTickSize;
          innerTickSize = +x;
          outerTickSize = +arguments[n - 1];
          return axis;
        };
        axis.innerTickSize = function(x) {
          if (!arguments.length)
            return innerTickSize;
          innerTickSize = +x;
          return axis;
        };
        axis.outerTickSize = function(x) {
          if (!arguments.length)
            return outerTickSize;
          outerTickSize = +x;
          return axis;
        };
        axis.tickPadding = function(x) {
          if (!arguments.length)
            return tickPadding;
          tickPadding = +x;
          return axis;
        };
        axis.tickSubdivide = function() {
          return arguments.length && axis;
        };
        return axis;
      };
      var d3_svg_axisDefaultOrient = "bottom",
          d3_svg_axisOrients = {
            top: 1,
            right: 1,
            bottom: 1,
            left: 1
          };
      function d3_svg_axisX(selection, x0, x1) {
        selection.attr("transform", function(d) {
          var v0 = x0(d);
          return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
        });
      }
      function d3_svg_axisY(selection, y0, y1) {
        selection.attr("transform", function(d) {
          var v0 = y0(d);
          return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
        });
      }
      d3.svg.brush = function() {
        var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"),
            x = null,
            y = null,
            xExtent = [0, 0],
            yExtent = [0, 0],
            xExtentDomain,
            yExtentDomain,
            xClamp = true,
            yClamp = true,
            resizes = d3_svg_brushResizes[0];
        function brush(g) {
          g.each(function() {
            var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
            var background = g.selectAll(".background").data([0]);
            background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
            g.selectAll(".extent").data([0]).enter().append("rect").attr("class", "extent").style("cursor", "move");
            var resize = g.selectAll(".resize").data(resizes, d3_identity);
            resize.exit().remove();
            resize.enter().append("g").attr("class", function(d) {
              return "resize " + d;
            }).style("cursor", function(d) {
              return d3_svg_brushCursor[d];
            }).append("rect").attr("x", function(d) {
              return /[ew]$/.test(d) ? -3 : null;
            }).attr("y", function(d) {
              return /^[ns]/.test(d) ? -3 : null;
            }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
            resize.style("display", brush.empty() ? "none" : null);
            var gUpdate = d3.transition(g),
                backgroundUpdate = d3.transition(background),
                range;
            if (x) {
              range = d3_scaleRange(x);
              backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
              redrawX(gUpdate);
            }
            if (y) {
              range = d3_scaleRange(y);
              backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
              redrawY(gUpdate);
            }
            redraw(gUpdate);
          });
        }
        brush.event = function(g) {
          g.each(function() {
            var event_ = event.of(this, arguments),
                extent1 = {
                  x: xExtent,
                  y: yExtent,
                  i: xExtentDomain,
                  j: yExtentDomain
                },
                extent0 = this.__chart__ || extent1;
            this.__chart__ = extent1;
            if (d3_transitionInheritId) {
              d3.select(this).transition().each("start.brush", function() {
                xExtentDomain = extent0.i;
                yExtentDomain = extent0.j;
                xExtent = extent0.x;
                yExtent = extent0.y;
                event_({type: "brushstart"});
              }).tween("brush:brush", function() {
                var xi = d3_interpolateArray(xExtent, extent1.x),
                    yi = d3_interpolateArray(yExtent, extent1.y);
                xExtentDomain = yExtentDomain = null;
                return function(t) {
                  xExtent = extent1.x = xi(t);
                  yExtent = extent1.y = yi(t);
                  event_({
                    type: "brush",
                    mode: "resize"
                  });
                };
              }).each("end.brush", function() {
                xExtentDomain = extent1.i;
                yExtentDomain = extent1.j;
                event_({
                  type: "brush",
                  mode: "resize"
                });
                event_({type: "brushend"});
              });
            } else {
              event_({type: "brushstart"});
              event_({
                type: "brush",
                mode: "resize"
              });
              event_({type: "brushend"});
            }
          });
        };
        function redraw(g) {
          g.selectAll(".resize").attr("transform", function(d) {
            return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
          });
        }
        function redrawX(g) {
          g.select(".extent").attr("x", xExtent[0]);
          g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
        }
        function redrawY(g) {
          g.select(".extent").attr("y", yExtent[0]);
          g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
        }
        function brushstart() {
          var target = this,
              eventTarget = d3.select(d3.event.target),
              event_ = event.of(target, arguments),
              g = d3.select(target),
              resizing = eventTarget.datum(),
              resizingX = !/^(n|s)$/.test(resizing) && x,
              resizingY = !/^(e|w)$/.test(resizing) && y,
              dragging = eventTarget.classed("extent"),
              dragRestore = d3_event_dragSuppress(target),
              center,
              origin = d3.mouse(target),
              offset;
          var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
          if (d3.event.changedTouches) {
            w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
          } else {
            w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
          }
          g.interrupt().selectAll("*").interrupt();
          if (dragging) {
            origin[0] = xExtent[0] - origin[0];
            origin[1] = yExtent[0] - origin[1];
          } else if (resizing) {
            var ex = +/w$/.test(resizing),
                ey = +/^n/.test(resizing);
            offset = [xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1]];
            origin[0] = xExtent[ex];
            origin[1] = yExtent[ey];
          } else if (d3.event.altKey)
            center = origin.slice();
          g.style("pointer-events", "none").selectAll(".resize").style("display", null);
          d3.select("body").style("cursor", eventTarget.style("cursor"));
          event_({type: "brushstart"});
          brushmove();
          function keydown() {
            if (d3.event.keyCode == 32) {
              if (!dragging) {
                center = null;
                origin[0] -= xExtent[1];
                origin[1] -= yExtent[1];
                dragging = 2;
              }
              d3_eventPreventDefault();
            }
          }
          function keyup() {
            if (d3.event.keyCode == 32 && dragging == 2) {
              origin[0] += xExtent[1];
              origin[1] += yExtent[1];
              dragging = 0;
              d3_eventPreventDefault();
            }
          }
          function brushmove() {
            var point = d3.mouse(target),
                moved = false;
            if (offset) {
              point[0] += offset[0];
              point[1] += offset[1];
            }
            if (!dragging) {
              if (d3.event.altKey) {
                if (!center)
                  center = [(xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2];
                origin[0] = xExtent[+(point[0] < center[0])];
                origin[1] = yExtent[+(point[1] < center[1])];
              } else
                center = null;
            }
            if (resizingX && move1(point, x, 0)) {
              redrawX(g);
              moved = true;
            }
            if (resizingY && move1(point, y, 1)) {
              redrawY(g);
              moved = true;
            }
            if (moved) {
              redraw(g);
              event_({
                type: "brush",
                mode: dragging ? "move" : "resize"
              });
            }
          }
          function move1(point, scale, i) {
            var range = d3_scaleRange(scale),
                r0 = range[0],
                r1 = range[1],
                position = origin[i],
                extent = i ? yExtent : xExtent,
                size = extent[1] - extent[0],
                min,
                max;
            if (dragging) {
              r0 -= position;
              r1 -= size + position;
            }
            min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
            if (dragging) {
              max = (min += position) + size;
            } else {
              if (center)
                position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
              if (position < min) {
                max = min;
                min = position;
              } else {
                max = position;
              }
            }
            if (extent[0] != min || extent[1] != max) {
              if (i)
                yExtentDomain = null;
              else
                xExtentDomain = null;
              extent[0] = min;
              extent[1] = max;
              return true;
            }
          }
          function brushend() {
            brushmove();
            g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
            d3.select("body").style("cursor", null);
            w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
            dragRestore();
            event_({type: "brushend"});
          }
        }
        brush.x = function(z) {
          if (!arguments.length)
            return x;
          x = z;
          resizes = d3_svg_brushResizes[!x << 1 | !y];
          return brush;
        };
        brush.y = function(z) {
          if (!arguments.length)
            return y;
          y = z;
          resizes = d3_svg_brushResizes[!x << 1 | !y];
          return brush;
        };
        brush.clamp = function(z) {
          if (!arguments.length)
            return x && y ? [xClamp, yClamp] : x ? xClamp : y ? yClamp : null;
          if (x && y)
            xClamp = !!z[0], yClamp = !!z[1];
          else if (x)
            xClamp = !!z;
          else if (y)
            yClamp = !!z;
          return brush;
        };
        brush.extent = function(z) {
          var x0,
              x1,
              y0,
              y1,
              t;
          if (!arguments.length) {
            if (x) {
              if (xExtentDomain) {
                x0 = xExtentDomain[0], x1 = xExtentDomain[1];
              } else {
                x0 = xExtent[0], x1 = xExtent[1];
                if (x.invert)
                  x0 = x.invert(x0), x1 = x.invert(x1);
                if (x1 < x0)
                  t = x0, x0 = x1, x1 = t;
              }
            }
            if (y) {
              if (yExtentDomain) {
                y0 = yExtentDomain[0], y1 = yExtentDomain[1];
              } else {
                y0 = yExtent[0], y1 = yExtent[1];
                if (y.invert)
                  y0 = y.invert(y0), y1 = y.invert(y1);
                if (y1 < y0)
                  t = y0, y0 = y1, y1 = t;
              }
            }
            return x && y ? [[x0, y0], [x1, y1]] : x ? [x0, x1] : y && [y0, y1];
          }
          if (x) {
            x0 = z[0], x1 = z[1];
            if (y)
              x0 = x0[0], x1 = x1[0];
            xExtentDomain = [x0, x1];
            if (x.invert)
              x0 = x(x0), x1 = x(x1);
            if (x1 < x0)
              t = x0, x0 = x1, x1 = t;
            if (x0 != xExtent[0] || x1 != xExtent[1])
              xExtent = [x0, x1];
          }
          if (y) {
            y0 = z[0], y1 = z[1];
            if (x)
              y0 = y0[1], y1 = y1[1];
            yExtentDomain = [y0, y1];
            if (y.invert)
              y0 = y(y0), y1 = y(y1);
            if (y1 < y0)
              t = y0, y0 = y1, y1 = t;
            if (y0 != yExtent[0] || y1 != yExtent[1])
              yExtent = [y0, y1];
          }
          return brush;
        };
        brush.clear = function() {
          if (!brush.empty()) {
            xExtent = [0, 0], yExtent = [0, 0];
            xExtentDomain = yExtentDomain = null;
          }
          return brush;
        };
        brush.empty = function() {
          return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
        };
        return d3.rebind(brush, event, "on");
      };
      var d3_svg_brushCursor = {
        n: "ns-resize",
        e: "ew-resize",
        s: "ns-resize",
        w: "ew-resize",
        nw: "nwse-resize",
        ne: "nesw-resize",
        se: "nwse-resize",
        sw: "nesw-resize"
      };
      var d3_svg_brushResizes = [["n", "e", "s", "w", "nw", "ne", "se", "sw"], ["e", "w"], ["n", "s"], []];
      var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
      var d3_time_formatUtc = d3_time_format.utc;
      var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
      d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
      function d3_time_formatIsoNative(date) {
        return date.toISOString();
      }
      d3_time_formatIsoNative.parse = function(string) {
        var date = new Date(string);
        return isNaN(date) ? null : date;
      };
      d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
      d3_time.second = d3_time_interval(function(date) {
        return new d3_date(Math.floor(date / 1e3) * 1e3);
      }, function(date, offset) {
        date.setTime(date.getTime() + Math.floor(offset) * 1e3);
      }, function(date) {
        return date.getSeconds();
      });
      d3_time.seconds = d3_time.second.range;
      d3_time.seconds.utc = d3_time.second.utc.range;
      d3_time.minute = d3_time_interval(function(date) {
        return new d3_date(Math.floor(date / 6e4) * 6e4);
      }, function(date, offset) {
        date.setTime(date.getTime() + Math.floor(offset) * 6e4);
      }, function(date) {
        return date.getMinutes();
      });
      d3_time.minutes = d3_time.minute.range;
      d3_time.minutes.utc = d3_time.minute.utc.range;
      d3_time.hour = d3_time_interval(function(date) {
        var timezone = date.getTimezoneOffset() / 60;
        return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
      }, function(date, offset) {
        date.setTime(date.getTime() + Math.floor(offset) * 36e5);
      }, function(date) {
        return date.getHours();
      });
      d3_time.hours = d3_time.hour.range;
      d3_time.hours.utc = d3_time.hour.utc.range;
      d3_time.month = d3_time_interval(function(date) {
        date = d3_time.day(date);
        date.setDate(1);
        return date;
      }, function(date, offset) {
        date.setMonth(date.getMonth() + offset);
      }, function(date) {
        return date.getMonth();
      });
      d3_time.months = d3_time.month.range;
      d3_time.months.utc = d3_time.month.utc.range;
      function d3_time_scale(linear, methods, format) {
        function scale(x) {
          return linear(x);
        }
        scale.invert = function(x) {
          return d3_time_scaleDate(linear.invert(x));
        };
        scale.domain = function(x) {
          if (!arguments.length)
            return linear.domain().map(d3_time_scaleDate);
          linear.domain(x);
          return scale;
        };
        function tickMethod(extent, count) {
          var span = extent[1] - extent[0],
              target = span / count,
              i = d3.bisect(d3_time_scaleSteps, target);
          return i == d3_time_scaleSteps.length ? [methods.year, d3_scale_linearTickRange(extent.map(function(d) {
            return d / 31536e6;
          }), count)[2]] : !i ? [d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2]] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
        }
        scale.nice = function(interval, skip) {
          var domain = scale.domain(),
              extent = d3_scaleExtent(domain),
              method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
          if (method)
            interval = method[0], skip = method[1];
          function skipped(date) {
            return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
          }
          return scale.domain(d3_scale_nice(domain, skip > 1 ? {
            floor: function(date) {
              while (skipped(date = interval.floor(date)))
                date = d3_time_scaleDate(date - 1);
              return date;
            },
            ceil: function(date) {
              while (skipped(date = interval.ceil(date)))
                date = d3_time_scaleDate(+date + 1);
              return date;
            }
          } : interval));
        };
        scale.ticks = function(interval, skip) {
          var extent = d3_scaleExtent(scale.domain()),
              method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [{range: interval}, skip];
          if (method)
            interval = method[0], skip = method[1];
          return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
        };
        scale.tickFormat = function() {
          return format;
        };
        scale.copy = function() {
          return d3_time_scale(linear.copy(), methods, format);
        };
        return d3_scale_linearRebind(scale, linear);
      }
      function d3_time_scaleDate(t) {
        return new Date(t);
      }
      var d3_time_scaleSteps = [1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6];
      var d3_time_scaleLocalMethods = [[d3_time.second, 1], [d3_time.second, 5], [d3_time.second, 15], [d3_time.second, 30], [d3_time.minute, 1], [d3_time.minute, 5], [d3_time.minute, 15], [d3_time.minute, 30], [d3_time.hour, 1], [d3_time.hour, 3], [d3_time.hour, 6], [d3_time.hour, 12], [d3_time.day, 1], [d3_time.day, 2], [d3_time.week, 1], [d3_time.month, 1], [d3_time.month, 3], [d3_time.year, 1]];
      var d3_time_scaleLocalFormat = d3_time_format.multi([[".%L", function(d) {
        return d.getMilliseconds();
      }], [":%S", function(d) {
        return d.getSeconds();
      }], ["%I:%M", function(d) {
        return d.getMinutes();
      }], ["%I %p", function(d) {
        return d.getHours();
      }], ["%a %d", function(d) {
        return d.getDay() && d.getDate() != 1;
      }], ["%b %d", function(d) {
        return d.getDate() != 1;
      }], ["%B", function(d) {
        return d.getMonth();
      }], ["%Y", d3_true]]);
      var d3_time_scaleMilliseconds = {
        range: function(start, stop, step) {
          return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
        },
        floor: d3_identity,
        ceil: d3_identity
      };
      d3_time_scaleLocalMethods.year = d3_time.year;
      d3_time.scale = function() {
        return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
      };
      var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
        return [m[0].utc, m[1]];
      });
      var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([[".%L", function(d) {
        return d.getUTCMilliseconds();
      }], [":%S", function(d) {
        return d.getUTCSeconds();
      }], ["%I:%M", function(d) {
        return d.getUTCMinutes();
      }], ["%I %p", function(d) {
        return d.getUTCHours();
      }], ["%a %d", function(d) {
        return d.getUTCDay() && d.getUTCDate() != 1;
      }], ["%b %d", function(d) {
        return d.getUTCDate() != 1;
      }], ["%B", function(d) {
        return d.getUTCMonth();
      }], ["%Y", d3_true]]);
      d3_time_scaleUtcMethods.year = d3_time.year.utc;
      d3_time.scale.utc = function() {
        return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
      };
      d3.text = d3_xhrType(function(request) {
        return request.responseText;
      });
      d3.json = function(url, callback) {
        return d3_xhr(url, "application/json", d3_json, callback);
      };
      function d3_json(request) {
        return JSON.parse(request.responseText);
      }
      d3.html = function(url, callback) {
        return d3_xhr(url, "text/html", d3_html, callback);
      };
      function d3_html(request) {
        var range = d3_document.createRange();
        range.selectNode(d3_document.body);
        return range.createContextualFragment(request.responseText);
      }
      d3.xml = d3_xhrType(function(request) {
        return request.responseXML;
      });
      if (typeof define === "function" && define.amd)
        this.d3 = d3, define(d3);
      else if (typeof module === "object" && module.exports)
        module.exports = d3;
      else
        this.d3 = d3;
    }();
  })();
  return _retrieveGlobal();
});

$__System.registerDynamic("3", ["56"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = $__require('56');
  return module.exports;
});

$__System.registerDynamic("57", ["11", "3d"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var $ = $__require('11'),
      toIObject = $__require('3d');
  module.exports = function(object, el) {
    var O = toIObject(object),
        keys = $.getKeys(O),
        length = keys.length,
        index = 0,
        key;
    while (length > index)
      if (O[key = keys[index++]] === el)
        return key;
  };
  return module.exports;
});

$__System.registerDynamic("58", ["3d", "11"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var toIObject = $__require('3d'),
      getNames = $__require('11').getNames,
      toString = {}.toString;
  var windowNames = typeof window == 'object' && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
  var getWindowNames = function(it) {
    try {
      return getNames(it);
    } catch (e) {
      return windowNames.slice();
    }
  };
  module.exports.get = function getOwnPropertyNames(it) {
    if (windowNames && toString.call(it) == '[object Window]')
      return getWindowNames(it);
    return getNames(toIObject(it));
  };
  return module.exports;
});

$__System.registerDynamic("59", ["11"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var $ = $__require('11');
  module.exports = function(it) {
    var keys = $.getKeys(it),
        getSymbols = $.getSymbols;
    if (getSymbols) {
      var symbols = getSymbols(it),
          isEnum = $.isEnum,
          i = 0,
          key;
      while (symbols.length > i)
        if (isEnum.call(it, key = symbols[i++]))
          keys.push(key);
    }
    return keys;
  };
  return module.exports;
});

$__System.registerDynamic("5a", ["5b"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var cof = $__require('5b');
  module.exports = Array.isArray || function(arg) {
    return cof(arg) == 'Array';
  };
  return module.exports;
});

$__System.registerDynamic("5c", ["11", "5d", "5e", "5f", "16", "60", "14", "61", "62", "63", "64", "57", "58", "59", "5a", "65", "3d", "66", "67"], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  var $ = $__require('11'),
      global = $__require('5d'),
      has = $__require('5e'),
      DESCRIPTORS = $__require('5f'),
      $export = $__require('16'),
      redefine = $__require('60'),
      $fails = $__require('14'),
      shared = $__require('61'),
      setToStringTag = $__require('62'),
      uid = $__require('63'),
      wks = $__require('64'),
      keyOf = $__require('57'),
      $names = $__require('58'),
      enumKeys = $__require('59'),
      isArray = $__require('5a'),
      anObject = $__require('65'),
      toIObject = $__require('3d'),
      createDesc = $__require('66'),
      getDesc = $.getDesc,
      setDesc = $.setDesc,
      _create = $.create,
      getNames = $names.get,
      $Symbol = global.Symbol,
      $JSON = global.JSON,
      _stringify = $JSON && $JSON.stringify,
      setter = false,
      HIDDEN = wks('_hidden'),
      isEnum = $.isEnum,
      SymbolRegistry = shared('symbol-registry'),
      AllSymbols = shared('symbols'),
      useNative = typeof $Symbol == 'function',
      ObjectProto = Object.prototype;
  var setSymbolDesc = DESCRIPTORS && $fails(function() {
    return _create(setDesc({}, 'a', {get: function() {
        return setDesc(this, 'a', {value: 7}).a;
      }})).a != 7;
  }) ? function(it, key, D) {
    var protoDesc = getDesc(ObjectProto, key);
    if (protoDesc)
      delete ObjectProto[key];
    setDesc(it, key, D);
    if (protoDesc && it !== ObjectProto)
      setDesc(ObjectProto, key, protoDesc);
  } : setDesc;
  var wrap = function(tag) {
    var sym = AllSymbols[tag] = _create($Symbol.prototype);
    sym._k = tag;
    DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
      configurable: true,
      set: function(value) {
        if (has(this, HIDDEN) && has(this[HIDDEN], tag))
          this[HIDDEN][tag] = false;
        setSymbolDesc(this, tag, createDesc(1, value));
      }
    });
    return sym;
  };
  var isSymbol = function(it) {
    return typeof it == 'symbol';
  };
  var $defineProperty = function defineProperty(it, key, D) {
    if (D && has(AllSymbols, key)) {
      if (!D.enumerable) {
        if (!has(it, HIDDEN))
          setDesc(it, HIDDEN, createDesc(1, {}));
        it[HIDDEN][key] = true;
      } else {
        if (has(it, HIDDEN) && it[HIDDEN][key])
          it[HIDDEN][key] = false;
        D = _create(D, {enumerable: createDesc(0, false)});
      }
      return setSymbolDesc(it, key, D);
    }
    return setDesc(it, key, D);
  };
  var $defineProperties = function defineProperties(it, P) {
    anObject(it);
    var keys = enumKeys(P = toIObject(P)),
        i = 0,
        l = keys.length,
        key;
    while (l > i)
      $defineProperty(it, key = keys[i++], P[key]);
    return it;
  };
  var $create = function create(it, P) {
    return P === undefined ? _create(it) : $defineProperties(_create(it), P);
  };
  var $propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = isEnum.call(this, key);
    return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
  };
  var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    var D = getDesc(it = toIObject(it), key);
    if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))
      D.enumerable = true;
    return D;
  };
  var $getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = getNames(toIObject(it)),
        result = [],
        i = 0,
        key;
    while (names.length > i)
      if (!has(AllSymbols, key = names[i++]) && key != HIDDEN)
        result.push(key);
    return result;
  };
  var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var names = getNames(toIObject(it)),
        result = [],
        i = 0,
        key;
    while (names.length > i)
      if (has(AllSymbols, key = names[i++]))
        result.push(AllSymbols[key]);
    return result;
  };
  var $stringify = function stringify(it) {
    if (it === undefined || isSymbol(it))
      return;
    var args = [it],
        i = 1,
        $$ = arguments,
        replacer,
        $replacer;
    while ($$.length > i)
      args.push($$[i++]);
    replacer = args[1];
    if (typeof replacer == 'function')
      $replacer = replacer;
    if ($replacer || !isArray(replacer))
      replacer = function(key, value) {
        if ($replacer)
          value = $replacer.call(this, key, value);
        if (!isSymbol(value))
          return value;
      };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  };
  var buggyJSON = $fails(function() {
    var S = $Symbol();
    return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
  });
  if (!useNative) {
    $Symbol = function Symbol() {
      if (isSymbol(this))
        throw TypeError('Symbol is not a constructor');
      return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
    };
    redefine($Symbol.prototype, 'toString', function toString() {
      return this._k;
    });
    isSymbol = function(it) {
      return it instanceof $Symbol;
    };
    $.create = $create;
    $.isEnum = $propertyIsEnumerable;
    $.getDesc = $getOwnPropertyDescriptor;
    $.setDesc = $defineProperty;
    $.setDescs = $defineProperties;
    $.getNames = $names.get = $getOwnPropertyNames;
    $.getSymbols = $getOwnPropertySymbols;
    if (DESCRIPTORS && !$__require('67')) {
      redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
    }
  }
  var symbolStatics = {
    'for': function(key) {
      return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
    },
    keyFor: function keyFor(key) {
      return keyOf(SymbolRegistry, key);
    },
    useSetter: function() {
      setter = true;
    },
    useSimple: function() {
      setter = false;
    }
  };
  $.each.call(('hasInstance,isConcatSpreadable,iterator,match,replace,search,' + 'species,split,toPrimitive,toStringTag,unscopables').split(','), function(it) {
    var sym = wks(it);
    symbolStatics[it] = useNative ? sym : wrap(sym);
  });
  setter = true;
  $export($export.G + $export.W, {Symbol: $Symbol});
  $export($export.S, 'Symbol', symbolStatics);
  $export($export.S + $export.F * !useNative, 'Object', {
    create: $create,
    defineProperty: $defineProperty,
    defineProperties: $defineProperties,
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
    getOwnPropertyNames: $getOwnPropertyNames,
    getOwnPropertySymbols: $getOwnPropertySymbols
  });
  $JSON && $export($export.S + $export.F * (!useNative || buggyJSON), 'JSON', {stringify: $stringify});
  setToStringTag($Symbol, 'Symbol');
  setToStringTag(Math, 'Math', true);
  setToStringTag(global.JSON, 'JSON', true);
  return module.exports;
});

$__System.registerDynamic("68", ["5c", "69", "18"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  $__require('5c');
  $__require('69');
  module.exports = $__require('18').Symbol;
  return module.exports;
});

$__System.registerDynamic("6a", ["68"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = $__require('68');
  return module.exports;
});

$__System.registerDynamic("6b", ["6a"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = {
    "default": $__require('6a'),
    __esModule: true
  };
  return module.exports;
});

$__System.registerDynamic("6c", ["11"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var $ = $__require('11');
  module.exports = function create(P, D) {
    return $.create(P, D);
  };
  return module.exports;
});

$__System.registerDynamic("41", ["6c"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = {
    "default": $__require('6c'),
    __esModule: true
  };
  return module.exports;
});

$__System.registerDynamic("6d", ["16", "6e"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var $export = $__require('16');
  $export($export.S, 'Object', {setPrototypeOf: $__require('6e').set});
  return module.exports;
});

$__System.registerDynamic("6f", ["6d", "18"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  $__require('6d');
  module.exports = $__require('18').Object.setPrototypeOf;
  return module.exports;
});

$__System.registerDynamic("42", ["6f"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = {
    "default": $__require('6f'),
    __esModule: true
  };
  return module.exports;
});

$__System.registerDynamic("70", ["6b", "41", "42", "20", "4c"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  (function(process) {
    "use strict";
    var _Symbol = $__require('6b')["default"];
    var _Object$create = $__require('41')["default"];
    var _Object$setPrototypeOf = $__require('42')["default"];
    var _Promise = $__require('20')["default"];
    !(function(global) {
      "use strict";
      var hasOwn = Object.prototype.hasOwnProperty;
      var undefined;
      var $Symbol = typeof _Symbol === "function" ? _Symbol : {};
      var iteratorSymbol = $Symbol.iterator || "@@iterator";
      var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
      var inModule = typeof module === "object";
      var runtime = global.regeneratorRuntime;
      if (runtime) {
        if (inModule) {
          module.exports = runtime;
        }
        return;
      }
      runtime = global.regeneratorRuntime = inModule ? module.exports : {};
      function wrap(innerFn, outerFn, self, tryLocsList) {
        var generator = _Object$create((outerFn || Generator).prototype);
        var context = new Context(tryLocsList || []);
        generator._invoke = makeInvokeMethod(innerFn, self, context);
        return generator;
      }
      runtime.wrap = wrap;
      function tryCatch(fn, obj, arg) {
        try {
          return {
            type: "normal",
            arg: fn.call(obj, arg)
          };
        } catch (err) {
          return {
            type: "throw",
            arg: err
          };
        }
      }
      var GenStateSuspendedStart = "suspendedStart";
      var GenStateSuspendedYield = "suspendedYield";
      var GenStateExecuting = "executing";
      var GenStateCompleted = "completed";
      var ContinueSentinel = {};
      function Generator() {}
      function GeneratorFunction() {}
      function GeneratorFunctionPrototype() {}
      var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
      GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
      GeneratorFunctionPrototype.constructor = GeneratorFunction;
      GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
      function defineIteratorMethods(prototype) {
        ["next", "throw", "return"].forEach(function(method) {
          prototype[method] = function(arg) {
            return this._invoke(method, arg);
          };
        });
      }
      runtime.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
      };
      runtime.mark = function(genFun) {
        if (_Object$setPrototypeOf) {
          _Object$setPrototypeOf(genFun, GeneratorFunctionPrototype);
        } else {
          genFun.__proto__ = GeneratorFunctionPrototype;
          if (!(toStringTagSymbol in genFun)) {
            genFun[toStringTagSymbol] = "GeneratorFunction";
          }
        }
        genFun.prototype = _Object$create(Gp);
        return genFun;
      };
      runtime.awrap = function(arg) {
        return new AwaitArgument(arg);
      };
      function AwaitArgument(arg) {
        this.arg = arg;
      }
      function AsyncIterator(generator) {
        function invoke(method, arg, resolve, reject) {
          var record = tryCatch(generator[method], generator, arg);
          if (record.type === "throw") {
            reject(record.arg);
          } else {
            var result = record.arg;
            var value = result.value;
            if (value instanceof AwaitArgument) {
              return _Promise.resolve(value.arg).then(function(value) {
                invoke("next", value, resolve, reject);
              }, function(err) {
                invoke("throw", err, resolve, reject);
              });
            }
            return _Promise.resolve(value).then(function(unwrapped) {
              result.value = unwrapped;
              resolve(result);
            }, reject);
          }
        }
        if (typeof process === "object" && process.domain) {
          invoke = process.domain.bind(invoke);
        }
        var previousPromise;
        function enqueue(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new _Promise(function(resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }
          return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        this._invoke = enqueue;
      }
      defineIteratorMethods(AsyncIterator.prototype);
      runtime.async = function(innerFn, outerFn, self, tryLocsList) {
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
        return runtime.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
      };
      function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
          if (state === GenStateExecuting) {
            throw new Error("Generator is already running");
          }
          if (state === GenStateCompleted) {
            if (method === "throw") {
              throw arg;
            }
            return doneResult();
          }
          while (true) {
            var delegate = context.delegate;
            if (delegate) {
              if (method === "return" || method === "throw" && delegate.iterator[method] === undefined) {
                context.delegate = null;
                var returnMethod = delegate.iterator["return"];
                if (returnMethod) {
                  var record = tryCatch(returnMethod, delegate.iterator, arg);
                  if (record.type === "throw") {
                    method = "throw";
                    arg = record.arg;
                    continue;
                  }
                }
                if (method === "return") {
                  continue;
                }
              }
              var record = tryCatch(delegate.iterator[method], delegate.iterator, arg);
              if (record.type === "throw") {
                context.delegate = null;
                method = "throw";
                arg = record.arg;
                continue;
              }
              method = "next";
              arg = undefined;
              var info = record.arg;
              if (info.done) {
                context[delegate.resultName] = info.value;
                context.next = delegate.nextLoc;
              } else {
                state = GenStateSuspendedYield;
                return info;
              }
              context.delegate = null;
            }
            if (method === "next") {
              if (state === GenStateSuspendedYield) {
                context.sent = arg;
              } else {
                context.sent = undefined;
              }
            } else if (method === "throw") {
              if (state === GenStateSuspendedStart) {
                state = GenStateCompleted;
                throw arg;
              }
              if (context.dispatchException(arg)) {
                method = "next";
                arg = undefined;
              }
            } else if (method === "return") {
              context.abrupt("return", arg);
            }
            state = GenStateExecuting;
            var record = tryCatch(innerFn, self, context);
            if (record.type === "normal") {
              state = context.done ? GenStateCompleted : GenStateSuspendedYield;
              var info = {
                value: record.arg,
                done: context.done
              };
              if (record.arg === ContinueSentinel) {
                if (context.delegate && method === "next") {
                  arg = undefined;
                }
              } else {
                return info;
              }
            } else if (record.type === "throw") {
              state = GenStateCompleted;
              method = "throw";
              arg = record.arg;
            }
          }
        };
      }
      defineIteratorMethods(Gp);
      Gp[iteratorSymbol] = function() {
        return this;
      };
      Gp[toStringTagSymbol] = "Generator";
      Gp.toString = function() {
        return "[object Generator]";
      };
      function pushTryEntry(locs) {
        var entry = {tryLoc: locs[0]};
        if (1 in locs) {
          entry.catchLoc = locs[1];
        }
        if (2 in locs) {
          entry.finallyLoc = locs[2];
          entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
      }
      function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
      }
      function Context(tryLocsList) {
        this.tryEntries = [{tryLoc: "root"}];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
      }
      runtime.keys = function(object) {
        var keys = [];
        for (var key in object) {
          keys.push(key);
        }
        keys.reverse();
        return function next() {
          while (keys.length) {
            var key = keys.pop();
            if (key in object) {
              next.value = key;
              next.done = false;
              return next;
            }
          }
          next.done = true;
          return next;
        };
      };
      function values(iterable) {
        if (iterable) {
          var iteratorMethod = iterable[iteratorSymbol];
          if (iteratorMethod) {
            return iteratorMethod.call(iterable);
          }
          if (typeof iterable.next === "function") {
            return iterable;
          }
          if (!isNaN(iterable.length)) {
            var i = -1,
                next = function next() {
                  while (++i < iterable.length) {
                    if (hasOwn.call(iterable, i)) {
                      next.value = iterable[i];
                      next.done = false;
                      return next;
                    }
                  }
                  next.value = undefined;
                  next.done = true;
                  return next;
                };
            return next.next = next;
          }
        }
        return {next: doneResult};
      }
      runtime.values = values;
      function doneResult() {
        return {
          value: undefined,
          done: true
        };
      }
      Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
          this.prev = 0;
          this.next = 0;
          this.sent = undefined;
          this.done = false;
          this.delegate = null;
          this.tryEntries.forEach(resetTryEntry);
          if (!skipTempReset) {
            for (var name in this) {
              if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                this[name] = undefined;
              }
            }
          }
        },
        stop: function stop() {
          this.done = true;
          var rootEntry = this.tryEntries[0];
          var rootRecord = rootEntry.completion;
          if (rootRecord.type === "throw") {
            throw rootRecord.arg;
          }
          return this.rval;
        },
        dispatchException: function dispatchException(exception) {
          if (this.done) {
            throw exception;
          }
          var context = this;
          function handle(loc, caught) {
            record.type = "throw";
            record.arg = exception;
            context.next = loc;
            return !!caught;
          }
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            var record = entry.completion;
            if (entry.tryLoc === "root") {
              return handle("end");
            }
            if (entry.tryLoc <= this.prev) {
              var hasCatch = hasOwn.call(entry, "catchLoc");
              var hasFinally = hasOwn.call(entry, "finallyLoc");
              if (hasCatch && hasFinally) {
                if (this.prev < entry.catchLoc) {
                  return handle(entry.catchLoc, true);
                } else if (this.prev < entry.finallyLoc) {
                  return handle(entry.finallyLoc);
                }
              } else if (hasCatch) {
                if (this.prev < entry.catchLoc) {
                  return handle(entry.catchLoc, true);
                }
              } else if (hasFinally) {
                if (this.prev < entry.finallyLoc) {
                  return handle(entry.finallyLoc);
                }
              } else {
                throw new Error("try statement without catch or finally");
              }
            }
          }
        },
        abrupt: function abrupt(type, arg) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
              var finallyEntry = entry;
              break;
            }
          }
          if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
            finallyEntry = null;
          }
          var record = finallyEntry ? finallyEntry.completion : {};
          record.type = type;
          record.arg = arg;
          if (finallyEntry) {
            this.next = finallyEntry.finallyLoc;
          } else {
            this.complete(record);
          }
          return ContinueSentinel;
        },
        complete: function complete(record, afterLoc) {
          if (record.type === "throw") {
            throw record.arg;
          }
          if (record.type === "break" || record.type === "continue") {
            this.next = record.arg;
          } else if (record.type === "return") {
            this.rval = record.arg;
            this.next = "end";
          } else if (record.type === "normal" && afterLoc) {
            this.next = afterLoc;
          }
        },
        finish: function finish(finallyLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            if (entry.finallyLoc === finallyLoc) {
              this.complete(entry.completion, entry.afterLoc);
              resetTryEntry(entry);
              return ContinueSentinel;
            }
          }
        },
        "catch": function _catch(tryLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            if (entry.tryLoc === tryLoc) {
              var record = entry.completion;
              if (record.type === "throw") {
                var thrown = record.arg;
                resetTryEntry(entry);
              }
              return thrown;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
          this.delegate = {
            iterator: values(iterable),
            resultName: resultName,
            nextLoc: nextLoc
          };
          return ContinueSentinel;
        }
      };
    })(typeof global === "object" ? global : typeof window === "object" ? window : typeof self === "object" ? self : undefined);
  })($__require('4c'));
  return module.exports;
});

$__System.registerDynamic("71", ["70"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var g = typeof global === "object" ? global : typeof window === "object" ? window : typeof self === "object" ? self : this;
  var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
  var oldRuntime = hadRuntime && g.regeneratorRuntime;
  g.regeneratorRuntime = undefined;
  module.exports = $__require('70');
  if (hadRuntime) {
    g.regeneratorRuntime = oldRuntime;
  } else {
    try {
      delete g.regeneratorRuntime;
    } catch (e) {
      g.regeneratorRuntime = undefined;
    }
  }
  module.exports = {
    "default": module.exports,
    __esModule: true
  };
  return module.exports;
});

$__System.registerDynamic("72", ["71"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = $__require('71');
  return module.exports;
});

$__System.register('73', ['20', '72'], function (_export) {
  var _Promise, _regeneratorRuntime, campaignsEndpoint, industryQuery;

  function getCampaignsByIndustry(industry) {
    return _regeneratorRuntime.async(function getCampaignsByIndustry$(context$1$0) {
      while (1) switch (context$1$0.prev = context$1$0.next) {
        case 0:
          return context$1$0.abrupt('return', new _Promise(function (res, rej) {
            var url = '' + campaignsEndpoint + industryQuery + industry;
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
              if (xhr.readyState === XMLHttpRequest.DONE) {
                res(JSON.parse(xhr.response));
              }
            };

            xhr.addEventListener('error', function (err) {
              return rej(err);
            });
            xhr.open('GET', url, true);
            xhr.setRequestHeader('Accept', 'application/json');
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.send();
          }));

        case 1:
        case 'end':
          return context$1$0.stop();
      }
    }, null, this);
  }

  return {
    setters: [function (_2) {
      _Promise = _2['default'];
    }, function (_) {
      _regeneratorRuntime = _['default'];
    }],
    execute: function () {
      'use strict';

      _export('getCampaignsByIndustry', getCampaignsByIndustry);

      campaignsEndpoint = '/cmsapi/v1/campaigns/';
      industryQuery = '?industry=';
    }
  };
});
$__System.register('74', ['4'], function (_export) {
  'use strict';
  var bootstrap;

  _export('attachFilterEvents', attachFilterEvents);

  function attachFilterEvents(filterDropdowns) {
    filterDropdowns.forEach(function (filter) {
      bootstrap(filter, function (filter) {
        filter.addEventListener('change', function () {
          var dropdownType = filter.getAttribute('data-name');
          var dropdownSelector = '.dropdown__ui[data-name="' + dropdownType + '"] span';
          var dropdown = document.querySelector(dropdownSelector);
          dropdown.innerText = filter.options[filter.options.selectedIndex].value;
        });
        filter.addEventListener('blur', function () {
          var dropdownType = filter.getAttribute('data-name');
          var dropdownSelector = '.dropdown__ui[data-name="' + dropdownType + '"] span';
          var dropdown = document.querySelector(dropdownSelector);
          dropdown.innerText = filter.options[filter.options.selectedIndex].value;
        });
      });
    });
  }

  return {
    setters: [function (_) {
      bootstrap = _.bootstrap;
    }],
    execute: function () {}
  };
});
$__System.register('75', ['3b', '1f'], function (_export) {
  var _createClass, _classCallCheck, Margin;

  return {
    setters: [function (_b) {
      _createClass = _b['default'];
    }, function (_f) {
      _classCallCheck = _f['default'];
    }],
    execute: function () {
      'use strict';

      Margin = (function () {
        function Margin(container) {
          _classCallCheck(this, Margin);

          var contianerWidth = container.getBoundingClientRect().width;
          var contianerHeight = container.getBoundingClientRect().height;

          this.top = this.calculateTopMargin(contianerHeight);
          this.bottom = this.calculateBottomMargin(contianerHeight);
          this.height = this.calculateHeight(contianerHeight);

          this.left = this.calculateLeftMargin(contianerWidth);
          this.right = this.calculateRightMargin(contianerWidth);
          this.width = this.calculateWidth(contianerWidth);
        }

        _createClass(Margin, [{
          key: 'calculateTopMargin',
          value: function calculateTopMargin(height) {
            return height * 0.075757;
          }
        }, {
          key: 'calculateBottomMargin',
          value: function calculateBottomMargin(height) {
            return height * 0.196969;
          }
        }, {
          key: 'calculateHeight',
          value: function calculateHeight(height) {
            return height - this.top - this.bottom;
          }
        }, {
          key: 'calculateLeftMargin',
          value: function calculateLeftMargin(width) {
            return width * 0.0625;
          }
        }, {
          key: 'calculateRightMargin',
          value: function calculateRightMargin(width) {
            return width * 0.0227272727;
          }
        }, {
          key: 'calculateWidth',
          value: function calculateWidth(width) {
            return width - this.left - this.right;
          }
        }]);

        return Margin;
      })();

      _export('Margin', Margin);
    }
  };
});
$__System.register('76', ['75', '3b', '1f'], function (_export) {
  var Margin, _createClass, _classCallCheck, AttributionChart;

  return {
    setters: [function (_) {
      Margin = _.Margin;
    }, function (_b) {
      _createClass = _b['default'];
    }, function (_f) {
      _classCallCheck = _f['default'];
    }],
    execute: function () {
      'use strict';

      AttributionChart = (function () {
        function AttributionChart(d3, selector) {
          _classCallCheck(this, AttributionChart);

          this._d3 = d3;
          this.container = this._d3.select(selector);
          this.line = this._d3.svg.line().interpolate('monotone');

          this.x = this._d3.scale.linear();
          this.y = this._d3.scale.linear();
          this.xAxisScale = this._d3.svg.axis();
          this.yAxisScale = this._d3.svg.axis();

          this.svg = this.container.append('svg');
          this.chart = this.svg.append('g');
          this.xAxis = this.chart.append('g').attr('class', 'x axis');
          this.yAxis = this.chart.append('g').attr('class', 'y axis');

          this.visitTypes = this._d3.scale.ordinal().domain([0, 1]).range(['line--control', 'line--exposed']);

          this.calibrateChartDimensions();
          window.onresize = this.calibrateChartDimensions.bind(this);
        }

        _createClass(AttributionChart, [{
          key: 'calibrateChartDimensions',
          value: function calibrateChartDimensions() {
            var _this = this;

            var margin = new Margin(this.container.node());
            var width = margin.width;
            var height = margin.height;

            this.x.range([0, width]);

            this.y.range([height, 0]);

            this.xAxisScale.scale(this.x).tickPadding(20).tickFormat(function (d) {
              return 'DAY ' + d;
            }).orient('bottom');

            this.yAxisScale.scale(this.y).tickSize(width).tickFormat(this._d3.format('.2%')).orient('left');

            this.line.x(function (d) {
              return _this.x(d.day);
            }).y(function (d) {
              return _this.y(d.rate);
            });

            this.svg.attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom);

            this.chart.attr('transform', 'translate(' + margin.left + ', ' + margin.top + ')');

            this.xAxis.attr('transform', 'translate(0, ' + height + ')').call(this.xAxisScale);

            this.yAxis.attr('transform', 'translate(' + width + ')').call(this.yAxisScale);

            this.chart.selectAll('.line').attr('d', function (d) {
              return _this.line(d);
            });
          }
        }, {
          key: 'renderChart',
          value: function renderChart(campaign) {
            var _this2 = this;

            var allVisits = [campaign.control_visits, campaign.exposed_visits];

            this.x.domain([1, this._d3.max(allVisits, function (visitType) {
              return visitType.length;
            })]);

            this.y.domain([this._d3.min(allVisits, function (visits) {
              return _this2._d3.min(visits, function (visit) {
                return visit.rate;
              });
            }), this._d3.max(allVisits, function (visits) {
              return _this2._d3.max(visits, function (visit) {
                return visit.rate;
              });
            })]);

            this.xAxis.transition().duration(750).call(this.xAxisScale);

            this.yAxis.transition().duration(750).call(this.yAxisScale);

            this.chart.selectAll('.line').data(allVisits).transition().duration(750).attr('d', function (d) {
              return _this2.line(d);
            });

            var visits = this.chart.selectAll('.visits').data(allVisits).enter().append('g').attr('class', 'visits');

            var _d3 = this._d3;
            visits.append('path').attr('class', function (d, i) {
              return 'line ' + _this2.visitTypes(i);
            }).attr('d', function (d) {
              return _this2.line(d);
            }).attr('fill', 'none').attr('stroke-dasharray', function () {
              var lineLength = _d3.select(this).node().getTotalLength();
              return lineLength + ' ' + lineLength;
            }).attr('stroke-dashoffset', function () {
              return _d3.select(this).node().getTotalLength();
            }).transition().duration(1800).attr('stroke-dashoffset', 0).each('end', function () {
              this.removeAttribute('stroke-dasharray');
              this.removeAttribute('stroke-dashoffset');
            });
          }
        }]);

        return AttributionChart;
      })();

      _export('AttributionChart', AttributionChart);
    }
  };
});
$__System.register('77', ['3', '4', '8', '72', '73', '74', '76'], function (_export) {
  var d3, bootstrap, _Array$from, _regeneratorRuntime, getCampaignsByIndustry, attachFilterEvents, AttributionChart, attribution, campaignsPerIndustry, attributionChart, attributionElements;

  function getCampaignObject(campaignName, industryName, cb) {
    var data, campaignObject;
    return _regeneratorRuntime.async(function getCampaignObject$(context$1$0) {
      while (1) switch (context$1$0.prev = context$1$0.next) {
        case 0:
          if (!(campaignsPerIndustry[industryName] === undefined)) {
            context$1$0.next = 5;
            break;
          }

          context$1$0.next = 3;
          return _regeneratorRuntime.awrap(getCampaignsByIndustry(industryName));

        case 3:
          data = context$1$0.sent;

          campaignsPerIndustry[industryName] = data.results;

        case 5:
          campaignObject = campaignsPerIndustry[industryName].find(function (campaignObject) {
            return campaignObject.name === campaignName;
          });

          cb(campaignObject);

        case 7:
        case 'end':
          return context$1$0.stop();
      }
    }, null, this);
  }

  function updateCampaigns(campaigns) {
    var campaignDropdownItems = _Array$from(attributionElements.campaignDropdown.querySelectorAll('option'));

    campaignDropdownItems.forEach(function (selectOption) {
      return selectOption.remove();
    });

    campaigns.forEach(function (campaign) {
      var option = document.createElement('option');
      option.value = campaign.name;
      option.innerHTML = campaign.name;
      attributionElements.campaignDropdown.appendChild(option);
    });

    attributionElements.campaignDropdownUI.innerHTML = attributionElements.campaignDropdown.options.length > 0 ? '<span>' + attributionElements.campaignDropdown.options[attributionElements.campaignDropdown.options.selectedIndex].value + '</span> ⌵' : '';

    var currentCampaign = campaigns[0];
    updateCampaignData(currentCampaign);
  }

  function updateCampaignData(campaign) {
    if (!campaign) {
      console.error(new Error('campaign is not valid!, ' + campaign));
    }

    attributionChart.renderChart(campaign);

    attributionElements.incrementalVisitLift.innerText = campaign.incremental_visit_lift + '%';
    attributionElements.adType.innerText = '' + campaign.ad_type;
    attributionElements.device.innerText = '' + campaign.device;
    attributionElements.duration.innerText = campaign.duration + ' Days';
    attributionElements.quarter.innerText = '' + campaign.quarter;
    attributionElements.cost.innerText = '$' + campaign.cost + 'K';
    attributionElements.impressions.innerText = campaign.impressions + 'MM';

    if (campaign.pdf === null) {
      attributionElements.downloadButton.style.display = 'none';
      return;
    }

    attributionElements.downloadButton.setAttribute('href', campaign.pdf);
    attributionElements.downloadButton.style.display = 'inline-block';
  }
  return {
    setters: [function (_3) {
      d3 = _3['default'];
    }, function (_4) {
      bootstrap = _4.bootstrap;
    }, function (_) {
      _Array$from = _['default'];
    }, function (_2) {
      _regeneratorRuntime = _2['default'];
    }, function (_5) {
      getCampaignsByIndustry = _5.getCampaignsByIndustry;
    }, function (_6) {
      attachFilterEvents = _6.attachFilterEvents;
    }, function (_7) {
      AttributionChart = _7.AttributionChart;
    }],
    execute: function () {
      /* eslint-disable no-negated-condition */

      'use strict';
      attribution = document.querySelector('.attribution');
      campaignsPerIndustry = {};
      attributionChart = undefined;
      attributionElements = undefined;

      bootstrap(attribution, function (attribution) {
        attributionChart = new AttributionChart(d3, '.attribution .graph');
        attributionElements = {
          campaignDropdown: attribution.querySelector('select[data-name="campaign"]'),
          campaignDropdownUI: attribution.querySelector('.dropdown__ui[data-name="campaign"]'),
          industryDropdown: attribution.querySelector('select[data-name="industry"]'),
          downloadButton: attribution.querySelector('.download.button'),
          incrementalVisitLift: attribution.querySelector('.stat[data-stat="incremental-visit-lift"] h1'),
          adType: attribution.querySelector('.stat[data-stat="ad-type"] h1'),
          device: attribution.querySelector('.stat[data-stat="device"] h1'),
          duration: attribution.querySelector('.stat[data-stat="duration"] h1'),
          quarter: attribution.querySelector('.stat[data-stat="quarter"] h1'),
          cost: attribution.querySelector('.stat[data-stat="cost"] h1'),
          impressions: attribution.querySelector('.stat[data-stat="impressions"] h1')
        };
      });

      bootstrap(attribution, function (attribution) {
        var filterDropdowns = _Array$from(attribution.querySelectorAll('select[data-type="filter"]'));
        attachFilterEvents(filterDropdowns);

        attributionElements.industryDropdown.addEventListener('change', function () {
          var industryName = attributionElements.industryDropdown.options[attributionElements.industryDropdown.options.selectedIndex].value;
          if (campaignsPerIndustry[industryName] === undefined) {
            return getCampaignsByIndustry(industryName).then(function (data) {
              campaignsPerIndustry[industryName] = data.results;
              updateCampaigns(data.results);
            });
          }
          updateCampaigns(campaignsPerIndustry[industryName]);
        });

        attributionElements.campaignDropdown.addEventListener('change', function () {
          var campaignName = attributionElements.campaignDropdown.options[attributionElements.campaignDropdown.options.selectedIndex].value;
          var industryName = attributionElements.industryDropdown[attributionElements.industryDropdown.selectedIndex].value;
          getCampaignObject(campaignName, industryName, function (campaignObject) {
            updateCampaignData(campaignObject);
          });
        });

        // render first chart on load
        var industryName = attributionElements.industryDropdown[attributionElements.industryDropdown.selectedIndex].value;
        var campaignName = attributionElements.campaignDropdown.options[attributionElements.campaignDropdown.options.selectedIndex].value;
        getCampaignObject(campaignName, industryName, function (campaignObject) {
          updateCampaignData(campaignObject);
        });
      });
    }
  };
});
$__System.register('78', ['4', '8'], function (_export) {
  var bootstrap, _Array$from, tabbedCarousels;

  function updateNav(tab, tabbedCarousel) {
    tabbedCarousel.querySelector('.tabbed-carousel__nav .tab--current').classList.remove('tab--current');
    tabbedCarousel.querySelector('.tabbed-carousel__nav a[data-tab=\'' + tab + '\']').classList.add('tab--current');
    tabbedCarousel.querySelector('.dropdown__ui span').innerHTML = document.querySelector('.tabbed-carousel__nav--dropdown select option[value="' + tab + '"]').innerText;
  }

  function attachMobileNavHandlers(select, tabbedCarousel) {
    select.addEventListener('blur', function () {
      updateContent(select.options[select.options.selectedIndex].value, tabbedCarousel);
    });
    select.addEventListener('change', function () {
      updateContent(select.options[select.options.selectedIndex].value, tabbedCarousel);
    });
  }

  function attachNavHandlers(anchor, tabbedCarousel) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      if (!anchor.classList.contains('tab--current')) {
        updateContent(anchor.getAttribute('data-tab'), tabbedCarousel);
      }
    });
  }

  function hideContent(callback, tabbedCarousel) {
    var currentContent = tabbedCarousel.querySelector('.content-block--current');
    currentContent.classList.remove('content-block--current');
    window.setTimeout(function () {
      currentContent.style.display = 'none';
      callback();
    }, 800);
  }

  function updateContent(tabContent, tabbedCarousel) {
    var content = tabbedCarousel.querySelector('.content-block[data-content="' + tabContent + '"]');

    updateNav(tabContent, tabbedCarousel);
    hideContent(function () {
      content.style.display = 'flex';
      window.setTimeout(function () {
        content.classList.add('content-block--current');
      }, 100);
    }, tabbedCarousel);
  }

  return {
    setters: [function (_2) {
      bootstrap = _2.bootstrap;
    }, function (_) {
      _Array$from = _['default'];
    }],
    execute: function () {
      'use strict';

      _export('updateNav', updateNav);

      _export('attachMobileNavHandlers', attachMobileNavHandlers);

      _export('attachNavHandlers', attachNavHandlers);

      tabbedCarousels = _Array$from(document.querySelectorAll('.tabbed-carousel'));
      bootstrap(tabbedCarousels, function (tabbedCarousel) {
        var tabbedCarouselMobileNavDropdown = document.querySelector('.tabbed-carousel__nav--dropdown select');
        var tabbedCarouselNavAnchors = _Array$from(tabbedCarousel.querySelectorAll('a.tab'));
        bootstrap(tabbedCarouselNavAnchors, attachNavHandlers, tabbedCarousel);
        bootstrap(tabbedCarouselMobileNavDropdown, attachMobileNavHandlers, tabbedCarousel);
      });
    }
  };
});
$__System.register('4', ['20'], function (_export) {
  var _Promise;

  /**
   * A utility function to workon elements if they exist.
   * @param {node} or {[nodes]} -- dom element or elements
   * @param {function} callback
   * @param {args} optional comma separated argument values for callback
   * @returns {promise}
   */

  function bootstrap(element, callback) {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    var _this = this;

    return new _Promise(function (res, rej) {
      if (!element) {
        return res(null);
      }

      // recursively call bootstrap on each element provided
      if (Array.isArray(element)) {
        var promises = _Promise.all(element.map(function (el) {
          return bootstrap.apply(undefined, [el, callback].concat(args));
        }));
        return promises.then(res)['catch'](rej);
      }

      var params = args.splice(0);
      params.unshift(element);
      res(callback.apply(_this, params));
    });
  }

  return {
    setters: [function (_) {
      _Promise = _['default'];
    }],
    execute: function () {
      'use strict';
      _export('bootstrap', bootstrap);
    }
  };
});
$__System.register('d', ['4', '8'], function (_export) {
  var bootstrap, _Array$from, anchorEvents;

  function trackEvent(category, action) {
    var label = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];
    var value = arguments.length <= 3 || arguments[3] === undefined ? '' : arguments[3];

    if (typeof ga === 'function') {
      // eslint-disable-line no-undef
      ga('send', 'event', category, action, label, value); // eslint-disable-line no-undef
    }
  }

  return {
    setters: [function (_2) {
      bootstrap = _2.bootstrap;
    }, function (_) {
      _Array$from = _['default'];
    }],
    execute: function () {
      'use strict';

      _export('trackEvent', trackEvent);

      anchorEvents = _Array$from(document.querySelectorAll('[data-ga-event="true"]'));

      bootstrap(anchorEvents, function (anchorTest) {
        var category = anchorTest.getAttribute('data-ga-category');
        var action = anchorTest.getAttribute('data-ga-action');
        var label = anchorTest.getAttribute('data-ga-label') === null ? '' : anchorTest.getAttribute('data-ga-label');
        var value = anchorTest.getAttribute('data-ga-value') === null ? '' : anchorTest.getAttribute('data-ga-value');

        if (category && action) {
          anchorTest.addEventListener('click', function () {
            trackEvent(category, action, label, value);
          });
        }
      });
    }
  };
});
$__System.register('79', ['7a', 'd'], function (_export) {
  'use strict';

  var loadInsight, trackEvent;

  _export('attachHandlers', attachHandlers);

  function attachHandlers(el, insightsDataCache) {
    var card = el.querySelector('.card');
    var intro = el.querySelector('.intro');
    var anchorShow = el.querySelector('a[data-action="show"]');
    var anchorMore = el.querySelector('a[data-action="more"]');
    var insightsType = insightsDataCache.insightsType === 'segments--consumers' ? 'Consumer Insights' : 'Trend Insights';

    anchorShow.addEventListener('click', function (e) {
      e.preventDefault();
      card.classList.remove('card--bounce');
      card.classList.add('card--loaded');
      intro.classList.add('intro--hide');
      trackEvent(insightsType, 'Click', 'Button', 'Show Me!');
      window.setTimeout(function () {
        card.classList.add('card--faster');
      }, 2000);
    });

    anchorMore.addEventListener('click', function (e) {
      e.preventDefault();

      if (insightsDataCache.isGettingData) {
        return;
      }

      card.classList.add('card--throw-away');
      card.classList.add('card--hide-lines');
      trackEvent(insightsType, 'Click', 'Button', 'What else?');

      window.setTimeout(function () {
        loadInsight(insightsDataCache);
        card.classList.remove('card--throw-away');
      }, 600);

      window.setTimeout(function () {
        card.classList.remove('card--hide-lines');
      }, 1100);
    });
  }

  return {
    setters: [function (_a) {
      loadInsight = _a.loadInsight;
    }, function (_d) {
      trackEvent = _d.trackEvent;
    }],
    execute: function () {}
  };
});
$__System.registerDynamic("12", ["7b"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var defined = $__require('7b');
  module.exports = function(it) {
    return Object(defined(it));
  };
  return module.exports;
});

$__System.registerDynamic("7c", ["7d", "16", "12", "7e", "7f", "80", "81", "82"], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  var ctx = $__require('7d'),
      $export = $__require('16'),
      toObject = $__require('12'),
      call = $__require('7e'),
      isArrayIter = $__require('7f'),
      toLength = $__require('80'),
      getIterFn = $__require('81');
  $export($export.S + $export.F * !$__require('82')(function(iter) {
    Array.from(iter);
  }), 'Array', {from: function from(arrayLike) {
      var O = toObject(arrayLike),
          C = typeof this == 'function' ? this : Array,
          $$ = arguments,
          $$len = $$.length,
          mapfn = $$len > 1 ? $$[1] : undefined,
          mapping = mapfn !== undefined,
          index = 0,
          iterFn = getIterFn(O),
          length,
          result,
          step,
          iterator;
      if (mapping)
        mapfn = ctx(mapfn, $$len > 2 ? $$[2] : undefined, 2);
      if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
        for (iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++) {
          result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
        }
      } else {
        length = toLength(O.length);
        for (result = new C(length); length > index; index++) {
          result[index] = mapping ? mapfn(O[index], index) : O[index];
        }
      }
      result.length = index;
      return result;
    }});
  return module.exports;
});

$__System.registerDynamic("83", ["84", "7c", "18"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  $__require('84');
  $__require('7c');
  module.exports = $__require('18').Array.from;
  return module.exports;
});

$__System.registerDynamic("8", ["83"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = {
    "default": $__require('83'),
    __esModule: true
  };
  return module.exports;
});

$__System.register('7a', ['8'], function (_export) {
  var _Array$from;

  function addFactorUnderline(insight, insightsType) {
    var lineThree = document.querySelector('.line--three');
    var lineTwo = document.querySelector('.line--two');

    if (insightsType === 'segments--consumers') {
      lineThree.innerHTML = lineThree.innerHTML.replace(insight.highlight, function (match) {
        return '<span>' + match + '</span>';
      });
    } else {
      lineTwo.innerHTML = lineTwo.innerHTML.replace(insight.highlight, function (match) {
        return '<span>' + match + '</span>';
      });
    }
  }

  function loadInsight(insightsDataCache) {
    var insightsSegments = document.querySelectorAll('.insights-segments')[0];
    var card = insightsSegments.querySelector('.card');
    var lineOne = card.querySelector('.line--one');
    var lineTwo = card.querySelector('.line--two');
    var lineThree = card.querySelector('.line--three');
    var lineFour = card.querySelector('.line--four');
    var lineFive = card.querySelector('.line--five');
    var insight = insightsDataCache.next();
    var insightsType = insightsDataCache.insightsType;
    var twitterShareAnchors = _Array$from(insightsSegments.querySelectorAll('.twitter-share'));

    if (insightsType === 'segments--consumers') {
      lineOne.innerHTML = insight.segment;
      lineTwo.innerHTML = insight.conjunction + ' ' + (insight.icon !== '' ? '<img src="' + insight.icon + '" />' : '') + ' ' + insight.preposition + ' ' + insight.location; // eslint-disable-line
      lineThree.innerHTML = insight.likelihood;
      lineFour.innerHTML = insight.emphasis_modifer;
      lineFive.innerHTML = insight.insight;
      twitterShareAnchors.forEach(function (twitterShareAnchor) {
        twitterShareAnchor.setAttribute('href', 'https://twitter.com/intent/tweet?text=Check out other audience insights with @foursquare\'s location intelligence ' + (insight.shareable_image ? insight.shareable_image : '') + ' &url=' + location.href);
      });
    } else {
      lineOne.innerHTML = insight.place;
      lineTwo.innerHTML = insight.likelihood;
      lineThree.innerHTML = insight.action;
      lineFour.innerHTML = insight.bound;
      lineFive.innerHTML = insight.comparison;
      twitterShareAnchors.forEach(function (twitterShareAnchor) {
        twitterShareAnchor.setAttribute('href', 'https://twitter.com/intent/tweet?text=Check out other place insights with @foursquare\'s location intelligence ' + (insight.shareable_image ? insight.shareable_image : '') + ' &url=' + location.href);
      });
    }

    if (insight.emphasis_modifer === '' || insight.insight === '') {
      card.classList.add('card--loaded__4');
    } else {
      card.classList.remove('card--loaded__4');
    }

    addFactorUnderline(insight, insightsType);
  }

  return {
    setters: [function (_) {
      _Array$from = _['default'];
    }],
    execute: function () {
      'use strict';
      _export('loadInsight', loadInsight);
    }
  };
});
$__System.registerDynamic("85", ["11"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var $ = $__require('11');
  module.exports = function defineProperty(it, key, desc) {
    return $.setDesc(it, key, desc);
  };
  return module.exports;
});

$__System.registerDynamic("f", ["85"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = {
    "default": $__require('85'),
    __esModule: true
  };
  return module.exports;
});

$__System.registerDynamic("3b", ["f"], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  var _Object$defineProperty = $__require('f')["default"];
  exports["default"] = (function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor)
          descriptor.writable = true;
        _Object$defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps)
        defineProperties(Constructor.prototype, protoProps);
      if (staticProps)
        defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  exports.__esModule = true;
  return module.exports;
});

$__System.registerDynamic("1f", [], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  exports["default"] = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };
  exports.__esModule = true;
  return module.exports;
});

$__System.registerDynamic("69", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  "format cjs";
  return module.exports;
});

$__System.registerDynamic("86", ["87", "7b"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var toInteger = $__require('87'),
      defined = $__require('7b');
  module.exports = function(TO_STRING) {
    return function(that, pos) {
      var s = String(defined(that)),
          i = toInteger(pos),
          l = s.length,
          a,
          b;
      if (i < 0 || i >= l)
        return TO_STRING ? '' : undefined;
      a = s.charCodeAt(i);
      return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
  };
  return module.exports;
});

$__System.registerDynamic("84", ["86", "88"], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  var $at = $__require('86')(true);
  $__require('88')(String, 'String', function(iterated) {
    this._t = String(iterated);
    this._i = 0;
  }, function() {
    var O = this._t,
        index = this._i,
        point;
    if (index >= O.length)
      return {
        value: undefined,
        done: true
      };
    point = $at(O, index);
    this._i += point.length;
    return {
      value: point,
      done: false
    };
  });
  return module.exports;
});

$__System.registerDynamic("89", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = function() {};
  return module.exports;
});

$__System.registerDynamic("8a", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = function(done, value) {
    return {
      value: value,
      done: !!done
    };
  };
  return module.exports;
});

$__System.registerDynamic("13", ["5b"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var cof = $__require('5b');
  module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return cof(it) == 'String' ? it.split('') : Object(it);
  };
  return module.exports;
});

$__System.registerDynamic("7b", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = function(it) {
    if (it == undefined)
      throw TypeError("Can't call method on  " + it);
    return it;
  };
  return module.exports;
});

$__System.registerDynamic("3d", ["13", "7b"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var IObject = $__require('13'),
      defined = $__require('7b');
  module.exports = function(it) {
    return IObject(defined(it));
  };
  return module.exports;
});

$__System.registerDynamic("8b", ["11", "66", "62", "8c", "64"], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  var $ = $__require('11'),
      descriptor = $__require('66'),
      setToStringTag = $__require('62'),
      IteratorPrototype = {};
  $__require('8c')(IteratorPrototype, $__require('64')('iterator'), function() {
    return this;
  });
  module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
    setToStringTag(Constructor, NAME + ' Iterator');
  };
  return module.exports;
});

$__System.registerDynamic("88", ["67", "16", "60", "8c", "5e", "8d", "8b", "62", "11", "64"], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  var LIBRARY = $__require('67'),
      $export = $__require('16'),
      redefine = $__require('60'),
      hide = $__require('8c'),
      has = $__require('5e'),
      Iterators = $__require('8d'),
      $iterCreate = $__require('8b'),
      setToStringTag = $__require('62'),
      getProto = $__require('11').getProto,
      ITERATOR = $__require('64')('iterator'),
      BUGGY = !([].keys && 'next' in [].keys()),
      FF_ITERATOR = '@@iterator',
      KEYS = 'keys',
      VALUES = 'values';
  var returnThis = function() {
    return this;
  };
  module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $iterCreate(Constructor, NAME, next);
    var getMethod = function(kind) {
      if (!BUGGY && kind in proto)
        return proto[kind];
      switch (kind) {
        case KEYS:
          return function keys() {
            return new Constructor(this, kind);
          };
        case VALUES:
          return function values() {
            return new Constructor(this, kind);
          };
      }
      return function entries() {
        return new Constructor(this, kind);
      };
    };
    var TAG = NAME + ' Iterator',
        DEF_VALUES = DEFAULT == VALUES,
        VALUES_BUG = false,
        proto = Base.prototype,
        $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT],
        $default = $native || getMethod(DEFAULT),
        methods,
        key;
    if ($native) {
      var IteratorPrototype = getProto($default.call(new Base));
      setToStringTag(IteratorPrototype, TAG, true);
      if (!LIBRARY && has(proto, FF_ITERATOR))
        hide(IteratorPrototype, ITERATOR, returnThis);
      if (DEF_VALUES && $native.name !== VALUES) {
        VALUES_BUG = true;
        $default = function values() {
          return $native.call(this);
        };
      }
    }
    if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
      hide(proto, ITERATOR, $default);
    }
    Iterators[NAME] = $default;
    Iterators[TAG] = returnThis;
    if (DEFAULT) {
      methods = {
        values: DEF_VALUES ? $default : getMethod(VALUES),
        keys: IS_SET ? $default : getMethod(KEYS),
        entries: !DEF_VALUES ? $default : getMethod('entries')
      };
      if (FORCED)
        for (key in methods) {
          if (!(key in proto))
            redefine(proto, key, methods[key]);
        }
      else
        $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
  };
  return module.exports;
});

$__System.registerDynamic("8e", ["89", "8a", "8d", "3d", "88"], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  var addToUnscopables = $__require('89'),
      step = $__require('8a'),
      Iterators = $__require('8d'),
      toIObject = $__require('3d');
  module.exports = $__require('88')(Array, 'Array', function(iterated, kind) {
    this._t = toIObject(iterated);
    this._i = 0;
    this._k = kind;
  }, function() {
    var O = this._t,
        kind = this._k,
        index = this._i++;
    if (!O || index >= O.length) {
      this._t = undefined;
      return step(1);
    }
    if (kind == 'keys')
      return step(0, index);
    if (kind == 'values')
      return step(0, O[index]);
    return step(0, [index, O[index]]);
  }, 'values');
  Iterators.Arguments = Iterators.Array;
  addToUnscopables('keys');
  addToUnscopables('values');
  addToUnscopables('entries');
  return module.exports;
});

$__System.registerDynamic("8f", ["8e", "8d"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  $__require('8e');
  var Iterators = $__require('8d');
  Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;
  return module.exports;
});

$__System.registerDynamic("67", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = true;
  return module.exports;
});

$__System.registerDynamic("16", ["5d", "18", "7d"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var global = $__require('5d'),
      core = $__require('18'),
      ctx = $__require('7d'),
      PROTOTYPE = 'prototype';
  var $export = function(type, name, source) {
    var IS_FORCED = type & $export.F,
        IS_GLOBAL = type & $export.G,
        IS_STATIC = type & $export.S,
        IS_PROTO = type & $export.P,
        IS_BIND = type & $export.B,
        IS_WRAP = type & $export.W,
        exports = IS_GLOBAL ? core : core[name] || (core[name] = {}),
        target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE],
        key,
        own,
        out;
    if (IS_GLOBAL)
      source = name;
    for (key in source) {
      own = !IS_FORCED && target && key in target;
      if (own && key in exports)
        continue;
      out = own ? target[key] : source[key];
      exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? ctx(out, global) : IS_WRAP && target[key] == out ? (function(C) {
        var F = function(param) {
          return this instanceof C ? new C(param) : C(param);
        };
        F[PROTOTYPE] = C[PROTOTYPE];
        return F;
      })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
      if (IS_PROTO)
        (exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
    }
  };
  $export.F = 1;
  $export.G = 2;
  $export.S = 4;
  $export.P = 8;
  $export.B = 16;
  $export.W = 32;
  module.exports = $export;
  return module.exports;
});

$__System.registerDynamic("90", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = function(it, Constructor, name) {
    if (!(it instanceof Constructor))
      throw TypeError(name + ": use the 'new' operator!");
    return it;
  };
  return module.exports;
});

$__System.registerDynamic("7e", ["65"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var anObject = $__require('65');
  module.exports = function(iterator, fn, value, entries) {
    try {
      return entries ? fn(anObject(value)[0], value[1]) : fn(value);
    } catch (e) {
      var ret = iterator['return'];
      if (ret !== undefined)
        anObject(ret.call(iterator));
      throw e;
    }
  };
  return module.exports;
});

$__System.registerDynamic("7f", ["8d", "64"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var Iterators = $__require('8d'),
      ITERATOR = $__require('64')('iterator'),
      ArrayProto = Array.prototype;
  module.exports = function(it) {
    return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
  };
  return module.exports;
});

$__System.registerDynamic("87", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var ceil = Math.ceil,
      floor = Math.floor;
  module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
  };
  return module.exports;
});

$__System.registerDynamic("80", ["87"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var toInteger = $__require('87'),
      min = Math.min;
  module.exports = function(it) {
    return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0;
  };
  return module.exports;
});

$__System.registerDynamic("91", ["5b", "64"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var cof = $__require('5b'),
      TAG = $__require('64')('toStringTag'),
      ARG = cof(function() {
        return arguments;
      }()) == 'Arguments';
  module.exports = function(it) {
    var O,
        T,
        B;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof(T = (O = Object(it))[TAG]) == 'string' ? T : ARG ? cof(O) : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
  };
  return module.exports;
});

$__System.registerDynamic("8d", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = {};
  return module.exports;
});

$__System.registerDynamic("81", ["91", "64", "8d", "18"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var classof = $__require('91'),
      ITERATOR = $__require('64')('iterator'),
      Iterators = $__require('8d');
  module.exports = $__require('18').getIteratorMethod = function(it) {
    if (it != undefined)
      return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
  };
  return module.exports;
});

$__System.registerDynamic("92", ["7d", "7e", "7f", "65", "80", "81"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var ctx = $__require('7d'),
      call = $__require('7e'),
      isArrayIter = $__require('7f'),
      anObject = $__require('65'),
      toLength = $__require('80'),
      getIterFn = $__require('81');
  module.exports = function(iterable, entries, fn, that) {
    var iterFn = getIterFn(iterable),
        f = ctx(fn, that, entries ? 2 : 1),
        index = 0,
        length,
        step,
        iterator;
    if (typeof iterFn != 'function')
      throw TypeError(iterable + ' is not iterable!');
    if (isArrayIter(iterFn))
      for (length = toLength(iterable.length); length > index; index++) {
        entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
      }
    else
      for (iterator = iterFn.call(iterable); !(step = iterator.next()).done; ) {
        call(iterator, f, step.value, entries);
      }
  };
  return module.exports;
});

$__System.registerDynamic("6e", ["11", "93", "65", "7d"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var getDesc = $__require('11').getDesc,
      isObject = $__require('93'),
      anObject = $__require('65');
  var check = function(O, proto) {
    anObject(O);
    if (!isObject(proto) && proto !== null)
      throw TypeError(proto + ": can't set as prototype!");
  };
  module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
      try {
        set = $__require('7d')(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) {
        buggy = true;
      }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy)
          O.__proto__ = proto;
        else
          set(O, proto);
        return O;
      };
    }({}, false) : undefined),
    check: check
  };
  return module.exports;
});

$__System.registerDynamic("94", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = Object.is || function is(x, y) {
    return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
  };
  return module.exports;
});

$__System.registerDynamic("65", ["93"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var isObject = $__require('93');
  module.exports = function(it) {
    if (!isObject(it))
      throw TypeError(it + ' is not an object!');
    return it;
  };
  return module.exports;
});

$__System.registerDynamic("95", ["65", "96", "64"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var anObject = $__require('65'),
      aFunction = $__require('96'),
      SPECIES = $__require('64')('species');
  module.exports = function(O, D) {
    var C = anObject(O).constructor,
        S;
    return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
  };
  return module.exports;
});

$__System.registerDynamic("96", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = function(it) {
    if (typeof it != 'function')
      throw TypeError(it + ' is not a function!');
    return it;
  };
  return module.exports;
});

$__System.registerDynamic("7d", ["96"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var aFunction = $__require('96');
  module.exports = function(fn, that, length) {
    aFunction(fn);
    if (that === undefined)
      return fn;
    switch (length) {
      case 1:
        return function(a) {
          return fn.call(that, a);
        };
      case 2:
        return function(a, b) {
          return fn.call(that, a, b);
        };
      case 3:
        return function(a, b, c) {
          return fn.call(that, a, b, c);
        };
    }
    return function() {
      return fn.apply(that, arguments);
    };
  };
  return module.exports;
});

$__System.registerDynamic("97", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = function(fn, args, that) {
    var un = that === undefined;
    switch (args.length) {
      case 0:
        return un ? fn() : fn.call(that);
      case 1:
        return un ? fn(args[0]) : fn.call(that, args[0]);
      case 2:
        return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
      case 3:
        return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
      case 4:
        return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
    }
    return fn.apply(that, args);
  };
  return module.exports;
});

$__System.registerDynamic("98", ["5d"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = $__require('5d').document && document.documentElement;
  return module.exports;
});

$__System.registerDynamic("93", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
  };
  return module.exports;
});

$__System.registerDynamic("99", ["93", "5d"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var isObject = $__require('93'),
      document = $__require('5d').document,
      is = isObject(document) && isObject(document.createElement);
  module.exports = function(it) {
    return is ? document.createElement(it) : {};
  };
  return module.exports;
});

$__System.registerDynamic("9a", ["7d", "97", "98", "99", "5d", "5b", "4c"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  (function(process) {
    var ctx = $__require('7d'),
        invoke = $__require('97'),
        html = $__require('98'),
        cel = $__require('99'),
        global = $__require('5d'),
        process = global.process,
        setTask = global.setImmediate,
        clearTask = global.clearImmediate,
        MessageChannel = global.MessageChannel,
        counter = 0,
        queue = {},
        ONREADYSTATECHANGE = 'onreadystatechange',
        defer,
        channel,
        port;
    var run = function() {
      var id = +this;
      if (queue.hasOwnProperty(id)) {
        var fn = queue[id];
        delete queue[id];
        fn();
      }
    };
    var listner = function(event) {
      run.call(event.data);
    };
    if (!setTask || !clearTask) {
      setTask = function setImmediate(fn) {
        var args = [],
            i = 1;
        while (arguments.length > i)
          args.push(arguments[i++]);
        queue[++counter] = function() {
          invoke(typeof fn == 'function' ? fn : Function(fn), args);
        };
        defer(counter);
        return counter;
      };
      clearTask = function clearImmediate(id) {
        delete queue[id];
      };
      if ($__require('5b')(process) == 'process') {
        defer = function(id) {
          process.nextTick(ctx(run, id, 1));
        };
      } else if (MessageChannel) {
        channel = new MessageChannel;
        port = channel.port2;
        channel.port1.onmessage = listner;
        defer = ctx(port.postMessage, port, 1);
      } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
        defer = function(id) {
          global.postMessage(id + '', '*');
        };
        global.addEventListener('message', listner, false);
      } else if (ONREADYSTATECHANGE in cel('script')) {
        defer = function(id) {
          html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function() {
            html.removeChild(this);
            run.call(id);
          };
        };
      } else {
        defer = function(id) {
          setTimeout(ctx(run, id, 1), 0);
        };
      }
    }
    module.exports = {
      set: setTask,
      clear: clearTask
    };
  })($__require('4c'));
  return module.exports;
});

$__System.registerDynamic("5b", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var toString = {}.toString;
  module.exports = function(it) {
    return toString.call(it).slice(8, -1);
  };
  return module.exports;
});

$__System.registerDynamic("9b", ["5d", "9a", "5b", "4c"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  (function(process) {
    var global = $__require('5d'),
        macrotask = $__require('9a').set,
        Observer = global.MutationObserver || global.WebKitMutationObserver,
        process = global.process,
        Promise = global.Promise,
        isNode = $__require('5b')(process) == 'process',
        head,
        last,
        notify;
    var flush = function() {
      var parent,
          domain,
          fn;
      if (isNode && (parent = process.domain)) {
        process.domain = null;
        parent.exit();
      }
      while (head) {
        domain = head.domain;
        fn = head.fn;
        if (domain)
          domain.enter();
        fn();
        if (domain)
          domain.exit();
        head = head.next;
      }
      last = undefined;
      if (parent)
        parent.enter();
    };
    if (isNode) {
      notify = function() {
        process.nextTick(flush);
      };
    } else if (Observer) {
      var toggle = 1,
          node = document.createTextNode('');
      new Observer(flush).observe(node, {characterData: true});
      notify = function() {
        node.data = toggle = -toggle;
      };
    } else if (Promise && Promise.resolve) {
      notify = function() {
        Promise.resolve().then(flush);
      };
    } else {
      notify = function() {
        macrotask.call(global, flush);
      };
    }
    module.exports = function asap(fn) {
      var task = {
        fn: fn,
        next: undefined,
        domain: isNode && process.domain
      };
      if (last)
        last.next = task;
      if (!head) {
        head = task;
        notify();
      }
      last = task;
    };
  })($__require('4c'));
  return module.exports;
});

$__System.registerDynamic("66", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = function(bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value: value
    };
  };
  return module.exports;
});

$__System.registerDynamic("8c", ["11", "66", "5f"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var $ = $__require('11'),
      createDesc = $__require('66');
  module.exports = $__require('5f') ? function(object, key, value) {
    return $.setDesc(object, key, createDesc(1, value));
  } : function(object, key, value) {
    object[key] = value;
    return object;
  };
  return module.exports;
});

$__System.registerDynamic("60", ["8c"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = $__require('8c');
  return module.exports;
});

$__System.registerDynamic("9c", ["60"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var redefine = $__require('60');
  module.exports = function(target, src) {
    for (var key in src)
      redefine(target, key, src[key]);
    return target;
  };
  return module.exports;
});

$__System.registerDynamic("5e", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var hasOwnProperty = {}.hasOwnProperty;
  module.exports = function(it, key) {
    return hasOwnProperty.call(it, key);
  };
  return module.exports;
});

$__System.registerDynamic("62", ["11", "5e", "64"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var def = $__require('11').setDesc,
      has = $__require('5e'),
      TAG = $__require('64')('toStringTag');
  module.exports = function(it, tag, stat) {
    if (it && !has(it = stat ? it : it.prototype, TAG))
      def(it, TAG, {
        configurable: true,
        value: tag
      });
  };
  return module.exports;
});

$__System.registerDynamic("11", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var $Object = Object;
  module.exports = {
    create: $Object.create,
    getProto: $Object.getPrototypeOf,
    isEnum: {}.propertyIsEnumerable,
    getDesc: $Object.getOwnPropertyDescriptor,
    setDesc: $Object.defineProperty,
    setDescs: $Object.defineProperties,
    getKeys: $Object.keys,
    getNames: $Object.getOwnPropertyNames,
    getSymbols: $Object.getOwnPropertySymbols,
    each: [].forEach
  };
  return module.exports;
});

$__System.registerDynamic("14", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = function(exec) {
    try {
      return !!exec();
    } catch (e) {
      return true;
    }
  };
  return module.exports;
});

$__System.registerDynamic("5f", ["14"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = !$__require('14')(function() {
    return Object.defineProperty({}, 'a', {get: function() {
        return 7;
      }}).a != 7;
  });
  return module.exports;
});

$__System.registerDynamic("9d", ["18", "11", "5f", "64"], true, function($__require, exports, module) {
  "use strict";
  ;
  var define,
      global = this,
      GLOBAL = this;
  var core = $__require('18'),
      $ = $__require('11'),
      DESCRIPTORS = $__require('5f'),
      SPECIES = $__require('64')('species');
  module.exports = function(KEY) {
    var C = core[KEY];
    if (DESCRIPTORS && C && !C[SPECIES])
      $.setDesc(C, SPECIES, {
        configurable: true,
        get: function() {
          return this;
        }
      });
  };
  return module.exports;
});

$__System.registerDynamic("61", ["5d"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var global = $__require('5d'),
      SHARED = '__core-js_shared__',
      store = global[SHARED] || (global[SHARED] = {});
  module.exports = function(key) {
    return store[key] || (store[key] = {});
  };
  return module.exports;
});

$__System.registerDynamic("63", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var id = 0,
      px = Math.random();
  module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
  };
  return module.exports;
});

$__System.registerDynamic("5d", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
  if (typeof __g == 'number')
    __g = global;
  return module.exports;
});

$__System.registerDynamic("64", ["61", "63", "5d"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var store = $__require('61')('wks'),
      uid = $__require('63'),
      Symbol = $__require('5d').Symbol;
  module.exports = function(name) {
    return store[name] || (store[name] = Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
  };
  return module.exports;
});

$__System.registerDynamic("82", ["64"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var ITERATOR = $__require('64')('iterator'),
      SAFE_CLOSING = false;
  try {
    var riter = [7][ITERATOR]();
    riter['return'] = function() {
      SAFE_CLOSING = true;
    };
    Array.from(riter, function() {
      throw 2;
    });
  } catch (e) {}
  module.exports = function(exec, skipClosing) {
    if (!skipClosing && !SAFE_CLOSING)
      return false;
    var safe = false;
    try {
      var arr = [7],
          iter = arr[ITERATOR]();
      iter.next = function() {
        safe = true;
      };
      arr[ITERATOR] = function() {
        return iter;
      };
      exec(arr);
    } catch (e) {}
    return safe;
  };
  return module.exports;
});

$__System.registerDynamic("9e", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var process = module.exports = {};
  var cachedSetTimeout;
  var cachedClearTimeout;
  (function() {
    try {
      cachedSetTimeout = setTimeout;
    } catch (e) {
      cachedSetTimeout = function() {
        throw new Error('setTimeout is not defined');
      };
    }
    try {
      cachedClearTimeout = clearTimeout;
    } catch (e) {
      cachedClearTimeout = function() {
        throw new Error('clearTimeout is not defined');
      };
    }
  }());
  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;
  function cleanUpNextTick() {
    if (!draining || !currentQueue) {
      return;
    }
    draining = false;
    if (currentQueue.length) {
      queue = currentQueue.concat(queue);
    } else {
      queueIndex = -1;
    }
    if (queue.length) {
      drainQueue();
    }
  }
  function drainQueue() {
    if (draining) {
      return;
    }
    var timeout = cachedSetTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while (len) {
      currentQueue = queue;
      queue = [];
      while (++queueIndex < len) {
        if (currentQueue) {
          currentQueue[queueIndex].run();
        }
      }
      queueIndex = -1;
      len = queue.length;
    }
    currentQueue = null;
    draining = false;
    cachedClearTimeout(timeout);
  }
  process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
      cachedSetTimeout(drainQueue, 0);
    }
  };
  function Item(fun, array) {
    this.fun = fun;
    this.array = array;
  }
  Item.prototype.run = function() {
    this.fun.apply(null, this.array);
  };
  process.title = 'browser';
  process.browser = true;
  process.env = {};
  process.argv = [];
  process.version = '';
  process.versions = {};
  function noop() {}
  process.on = noop;
  process.addListener = noop;
  process.once = noop;
  process.off = noop;
  process.removeListener = noop;
  process.removeAllListeners = noop;
  process.emit = noop;
  process.binding = function(name) {
    throw new Error('process.binding is not supported');
  };
  process.cwd = function() {
    return '/';
  };
  process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
  };
  process.umask = function() {
    return 0;
  };
  return module.exports;
});

$__System.registerDynamic("9f", ["9e"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = $__require('9e');
  return module.exports;
});

$__System.registerDynamic("a0", ["9f"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = $__System._nodeRequire ? process : $__require('9f');
  return module.exports;
});

$__System.registerDynamic("4c", ["a0"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = $__require('a0');
  return module.exports;
});

$__System.registerDynamic("a1", ["11", "67", "5d", "7d", "91", "16", "93", "65", "96", "90", "92", "6e", "94", "64", "95", "9b", "5f", "9c", "62", "9d", "18", "82", "4c"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  (function(process) {
    'use strict';
    var $ = $__require('11'),
        LIBRARY = $__require('67'),
        global = $__require('5d'),
        ctx = $__require('7d'),
        classof = $__require('91'),
        $export = $__require('16'),
        isObject = $__require('93'),
        anObject = $__require('65'),
        aFunction = $__require('96'),
        strictNew = $__require('90'),
        forOf = $__require('92'),
        setProto = $__require('6e').set,
        same = $__require('94'),
        SPECIES = $__require('64')('species'),
        speciesConstructor = $__require('95'),
        asap = $__require('9b'),
        PROMISE = 'Promise',
        process = global.process,
        isNode = classof(process) == 'process',
        P = global[PROMISE],
        Wrapper;
    var testResolve = function(sub) {
      var test = new P(function() {});
      if (sub)
        test.constructor = Object;
      return P.resolve(test) === test;
    };
    var USE_NATIVE = function() {
      var works = false;
      function P2(x) {
        var self = new P(x);
        setProto(self, P2.prototype);
        return self;
      }
      try {
        works = P && P.resolve && testResolve();
        setProto(P2, P);
        P2.prototype = $.create(P.prototype, {constructor: {value: P2}});
        if (!(P2.resolve(5).then(function() {}) instanceof P2)) {
          works = false;
        }
        if (works && $__require('5f')) {
          var thenableThenGotten = false;
          P.resolve($.setDesc({}, 'then', {get: function() {
              thenableThenGotten = true;
            }}));
          works = thenableThenGotten;
        }
      } catch (e) {
        works = false;
      }
      return works;
    }();
    var sameConstructor = function(a, b) {
      if (LIBRARY && a === P && b === Wrapper)
        return true;
      return same(a, b);
    };
    var getConstructor = function(C) {
      var S = anObject(C)[SPECIES];
      return S != undefined ? S : C;
    };
    var isThenable = function(it) {
      var then;
      return isObject(it) && typeof(then = it.then) == 'function' ? then : false;
    };
    var PromiseCapability = function(C) {
      var resolve,
          reject;
      this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined)
          throw TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
      });
      this.resolve = aFunction(resolve), this.reject = aFunction(reject);
    };
    var perform = function(exec) {
      try {
        exec();
      } catch (e) {
        return {error: e};
      }
    };
    var notify = function(record, isReject) {
      if (record.n)
        return;
      record.n = true;
      var chain = record.c;
      asap(function() {
        var value = record.v,
            ok = record.s == 1,
            i = 0;
        var run = function(reaction) {
          var handler = ok ? reaction.ok : reaction.fail,
              resolve = reaction.resolve,
              reject = reaction.reject,
              result,
              then;
          try {
            if (handler) {
              if (!ok)
                record.h = true;
              result = handler === true ? value : handler(value);
              if (result === reaction.promise) {
                reject(TypeError('Promise-chain cycle'));
              } else if (then = isThenable(result)) {
                then.call(result, resolve, reject);
              } else
                resolve(result);
            } else
              reject(value);
          } catch (e) {
            reject(e);
          }
        };
        while (chain.length > i)
          run(chain[i++]);
        chain.length = 0;
        record.n = false;
        if (isReject)
          setTimeout(function() {
            var promise = record.p,
                handler,
                console;
            if (isUnhandled(promise)) {
              if (isNode) {
                process.emit('unhandledRejection', value, promise);
              } else if (handler = global.onunhandledrejection) {
                handler({
                  promise: promise,
                  reason: value
                });
              } else if ((console = global.console) && console.error) {
                console.error('Unhandled promise rejection', value);
              }
            }
            record.a = undefined;
          }, 1);
      });
    };
    var isUnhandled = function(promise) {
      var record = promise._d,
          chain = record.a || record.c,
          i = 0,
          reaction;
      if (record.h)
        return false;
      while (chain.length > i) {
        reaction = chain[i++];
        if (reaction.fail || !isUnhandled(reaction.promise))
          return false;
      }
      return true;
    };
    var $reject = function(value) {
      var record = this;
      if (record.d)
        return;
      record.d = true;
      record = record.r || record;
      record.v = value;
      record.s = 2;
      record.a = record.c.slice();
      notify(record, true);
    };
    var $resolve = function(value) {
      var record = this,
          then;
      if (record.d)
        return;
      record.d = true;
      record = record.r || record;
      try {
        if (record.p === value)
          throw TypeError("Promise can't be resolved itself");
        if (then = isThenable(value)) {
          asap(function() {
            var wrapper = {
              r: record,
              d: false
            };
            try {
              then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
            } catch (e) {
              $reject.call(wrapper, e);
            }
          });
        } else {
          record.v = value;
          record.s = 1;
          notify(record, false);
        }
      } catch (e) {
        $reject.call({
          r: record,
          d: false
        }, e);
      }
    };
    if (!USE_NATIVE) {
      P = function Promise(executor) {
        aFunction(executor);
        var record = this._d = {
          p: strictNew(this, P, PROMISE),
          c: [],
          a: undefined,
          s: 0,
          d: false,
          v: undefined,
          h: false,
          n: false
        };
        try {
          executor(ctx($resolve, record, 1), ctx($reject, record, 1));
        } catch (err) {
          $reject.call(record, err);
        }
      };
      $__require('9c')(P.prototype, {
        then: function then(onFulfilled, onRejected) {
          var reaction = new PromiseCapability(speciesConstructor(this, P)),
              promise = reaction.promise,
              record = this._d;
          reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
          reaction.fail = typeof onRejected == 'function' && onRejected;
          record.c.push(reaction);
          if (record.a)
            record.a.push(reaction);
          if (record.s)
            notify(record, false);
          return promise;
        },
        'catch': function(onRejected) {
          return this.then(undefined, onRejected);
        }
      });
    }
    $export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: P});
    $__require('62')(P, PROMISE);
    $__require('9d')(PROMISE);
    Wrapper = $__require('18')[PROMISE];
    $export($export.S + $export.F * !USE_NATIVE, PROMISE, {reject: function reject(r) {
        var capability = new PromiseCapability(this),
            $$reject = capability.reject;
        $$reject(r);
        return capability.promise;
      }});
    $export($export.S + $export.F * (!USE_NATIVE || testResolve(true)), PROMISE, {resolve: function resolve(x) {
        if (x instanceof P && sameConstructor(x.constructor, this))
          return x;
        var capability = new PromiseCapability(this),
            $$resolve = capability.resolve;
        $$resolve(x);
        return capability.promise;
      }});
    $export($export.S + $export.F * !(USE_NATIVE && $__require('82')(function(iter) {
      P.all(iter)['catch'](function() {});
    })), PROMISE, {
      all: function all(iterable) {
        var C = getConstructor(this),
            capability = new PromiseCapability(C),
            resolve = capability.resolve,
            reject = capability.reject,
            values = [];
        var abrupt = perform(function() {
          forOf(iterable, false, values.push, values);
          var remaining = values.length,
              results = Array(remaining);
          if (remaining)
            $.each.call(values, function(promise, index) {
              var alreadyCalled = false;
              C.resolve(promise).then(function(value) {
                if (alreadyCalled)
                  return;
                alreadyCalled = true;
                results[index] = value;
                --remaining || resolve(results);
              }, reject);
            });
          else
            resolve(results);
        });
        if (abrupt)
          reject(abrupt.error);
        return capability.promise;
      },
      race: function race(iterable) {
        var C = getConstructor(this),
            capability = new PromiseCapability(C),
            reject = capability.reject;
        var abrupt = perform(function() {
          forOf(iterable, false, function(promise) {
            C.resolve(promise).then(capability.resolve, reject);
          });
        });
        if (abrupt)
          reject(abrupt.error);
        return capability.promise;
      }
    });
  })($__require('4c'));
  return module.exports;
});

$__System.registerDynamic("18", [], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  var core = module.exports = {version: '1.2.6'};
  if (typeof __e == 'number')
    __e = core;
  return module.exports;
});

$__System.registerDynamic("a2", ["69", "84", "8f", "a1", "18"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  $__require('69');
  $__require('84');
  $__require('8f');
  $__require('a1');
  module.exports = $__require('18').Promise;
  return module.exports;
});

$__System.registerDynamic("20", ["a2"], true, function($__require, exports, module) {
  ;
  var define,
      global = this,
      GLOBAL = this;
  module.exports = {
    "default": $__require('a2'),
    __esModule: true
  };
  return module.exports;
});

$__System.register('a3', ['20'], function (_export) {
  var _Promise;

  function getInsigts(url) {
    var xhr = new XMLHttpRequest();

    return new _Promise(function (res, rej) {
      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          return res(JSON.parse(xhr.response));
        }
      };

      xhr.addEventListener('error', function (err) {
        return rej(err);
      });
      xhr.open('GET', url, true);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send();
    });
  }

  return {
    setters: [function (_) {
      _Promise = _['default'];
    }],
    execute: function () {
      'use strict';

      _export('getInsigts', getInsigts);
    }
  };
});
$__System.register('a4', ['20', '3b', '1f', 'a3'], function (_export) {
  var _Promise, _createClass, _classCallCheck, getInsigts, InsightsDataCache;

  return {
    setters: [function (_) {
      _Promise = _['default'];
    }, function (_b) {
      _createClass = _b['default'];
    }, function (_f) {
      _classCallCheck = _f['default'];
    }, function (_a3) {
      getInsigts = _a3.getInsigts;
    }],
    execute: function () {
      'use strict';

      InsightsDataCache = (function () {
        function InsightsDataCache(insightsType) {
          _classCallCheck(this, InsightsDataCache);

          this.insightsType = insightsType;
          this.items = [];
          this.nextUrl = null;
          this.resources = {
            'segments--consumers': 'consumer-insights',
            'segments--trends': 'trend-insights'
          };
          this.endpoint = '/cmsapi/v1/' + this.resources[insightsType] + '/';
          this.isGettingData = false;
        }

        _createClass(InsightsDataCache, [{
          key: 'next',
          value: function next() {
            var item = this.items.splice(Math.floor(Math.random() * this.items.length), 1)[0];

            if (!this.items.length) {
              this.getItems();
            }

            return item;
          }
        }, {
          key: 'getItems',
          value: function getItems() {
            var _this = this;

            var url = this.nextUrl ? this.nextUrl : this.endpoint;
            this.isGettingData = true;

            return new _Promise(function (res) {
              getInsigts(url).then(function (data) {
                _this.items = data.results;
                _this.nextUrl = data.next;
                _this.isGettingData = false;
                res(_this.items);
              });
            });
          }
        }]);

        return InsightsDataCache;
      })();

      _export('InsightsDataCache', InsightsDataCache);
    }
  };
});
$__System.register('a5', ['4', '79', '7a', 'a4'], function (_export) {
  'use strict';

  var bootstrap, attachHandlers, loadInsight, InsightsDataCache, insightsSegments;
  return {
    setters: [function (_) {
      bootstrap = _.bootstrap;
    }, function (_2) {
      attachHandlers = _2.attachHandlers;
    }, function (_a) {
      loadInsight = _a.loadInsight;
    }, function (_a4) {
      InsightsDataCache = _a4.InsightsDataCache;
    }],
    execute: function () {
      insightsSegments = document.querySelectorAll('.insights-segments')[0];

      bootstrap(insightsSegments, function (insightsSegments) {
        var insightsType = insightsSegments.getAttribute('data-insights-type');
        var card = insightsSegments.querySelector('.card');

        card.classList.add('card--bounce');
        card.classList.add(insightsType);

        if (insightsType === 'segments--trends') {
          document.querySelector('.line--two').classList.add('line--red');
          document.querySelector('.line--three').classList.remove('line--red');
        }

        var insightsDataCache = new InsightsDataCache(insightsType);
        insightsDataCache.getItems().then(function () {
          loadInsight(insightsDataCache);
          attachHandlers(insightsSegments, insightsDataCache);
        });
      });
    }
  };
});
$__System.register('1', ['2', '22', '25', '27', '29', '37', '55', '77', '78', 'a5'], function (_export) {
  'use strict';

  return {
    setters: [function (_) {}, function (_2) {}, function (_3) {}, function (_4) {}, function (_5) {}, function (_6) {}, function (_7) {}, function (_8) {}, function (_9) {}, function (_a5) {}],
    execute: function () {}
  };
});
})
(function(factory) {
  factory();
});